var Sw = Object.defineProperty;
var mw = (e, t, n) => t in e ? Sw(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var hi = (e, t, n) => mw(e, typeof t != "symbol" ? t + "" : t, n);
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function ww(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const fn = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {};
process.env.NODE_ENV !== "production" && Object.freeze([]);
const Fi = () => {
}, yw = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), rn = Object.assign, Tw = Object.prototype.hasOwnProperty, it = (e, t) => Tw.call(e, t), qe = Array.isArray, aa = (e) => Rf(e) === "[object Map]", bw = (e) => Rf(e) === "[object Set]", Et = (e) => typeof e == "function", Nn = (e) => typeof e == "string", lc = (e) => typeof e == "symbol", Gt = (e) => e !== null && typeof e == "object", Cw = (e) => (Gt(e) || Et(e)) && Et(e.then) && Et(e.catch), Nw = Object.prototype.toString, Rf = (e) => Nw.call(e), Ag = (e) => Rf(e).slice(8, -1), Iw = (e) => Rf(e) === "[object Object]", sh = (e) => Nn(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Dw = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, Rw = Dw((e) => e.charAt(0).toUpperCase() + e.slice(1)), jr = (e, t) => !Object.is(e, t), Pw = (e, t, n, r = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: r,
    value: n
  });
};
let b_;
const Pf = () => b_ || (b_ = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function ch(e) {
  if (qe(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], i = Nn(r) ? xw(r) : ch(r);
      if (i)
        for (const o in i)
          t[o] = i[o];
    }
    return t;
  } else if (Nn(e) || Gt(e))
    return e;
}
const Aw = /;(?![^(]*\))/g, Ow = /:([^]+)/, kw = /\/\*[^]*?\*\//g;
function xw(e) {
  const t = {};
  return e.replace(kw, "").split(Aw).forEach((n) => {
    if (n) {
      const r = n.split(Ow);
      r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
}
function uh(e) {
  let t = "";
  if (Nn(e))
    t = e;
  else if (qe(e))
    for (let n = 0; n < e.length; n++) {
      const r = uh(e[n]);
      r && (t += r + " ");
    }
  else if (Gt(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function vr(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Me;
const ol = /* @__PURE__ */ new WeakSet();
class Lw {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0;
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, ol.has(this) && (ol.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || kg(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, C_(this), xg(this);
    const t = Me, n = Cn;
    Me = this, Cn = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && Me !== this && vr(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), Lg(this), Me = t, Cn = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        dh(t);
      this.deps = this.depsTail = void 0, C_(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? ol.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Wd(this) && this.run();
  }
  get dirty() {
    return Wd(this);
  }
}
let Og = 0, Ns, Is;
function kg(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = Is, Is = e;
    return;
  }
  e.next = Ns, Ns = e;
}
function fh() {
  Og++;
}
function lh() {
  if (--Og > 0)
    return;
  if (Is) {
    let t = Is;
    for (Is = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; Ns; ) {
    let t = Ns;
    for (Ns = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (r) {
          e || (e = r);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function xg(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Lg(e) {
  let t, n = e.depsTail, r = n;
  for (; r; ) {
    const i = r.prevDep;
    r.version === -1 ? (r === n && (n = i), dh(r), Mw(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = i;
  }
  e.deps = t, e.depsTail = n;
}
function Wd(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (Mg(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function Mg(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === Vs))
    return;
  e.globalVersion = Vs;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && e.deps && !Wd(e)) {
    e.flags &= -3;
    return;
  }
  const n = Me, r = Cn;
  Me = e, Cn = !0;
  try {
    xg(e);
    const i = e.fn(e._value);
    (t.version === 0 || jr(i, e._value)) && (e._value = i, t.version++);
  } catch (i) {
    throw t.version++, i;
  } finally {
    Me = n, Cn = r, Lg(e), e.flags &= -3;
  }
}
function dh(e, t = !1) {
  const { dep: n, prevSub: r, nextSub: i } = e;
  if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
    n.computed.flags &= -5;
    for (let o = n.computed.deps; o; o = o.nextDep)
      dh(o, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function Mw(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let Cn = !0;
const Ug = [];
function Af() {
  Ug.push(Cn), Cn = !1;
}
function Of() {
  const e = Ug.pop();
  Cn = e === void 0 ? !0 : e;
}
function C_(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = Me;
    Me = void 0;
    try {
      t();
    } finally {
      Me = n;
    }
  }
}
let Vs = 0;
class Uw {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class vh {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!Me || !Cn || Me === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== Me)
      n = this.activeLink = new Uw(Me, this), Me.deps ? (n.prevDep = Me.depsTail, Me.depsTail.nextDep = n, Me.depsTail = n) : Me.deps = Me.depsTail = n, $g(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const r = n.nextDep;
      r.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = r), n.prevDep = Me.depsTail, n.nextDep = void 0, Me.depsTail.nextDep = n, Me.depsTail = n, Me.deps === n && (Me.deps = r);
    }
    return process.env.NODE_ENV !== "production" && Me.onTrack && Me.onTrack(
      rn(
        {
          effect: Me
        },
        t
      )
    ), n;
  }
  trigger(t) {
    this.version++, Vs++, this.notify(t);
  }
  notify(t) {
    fh();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let n = this.subsHead; n; n = n.nextSub)
          n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
            rn(
              {
                effect: n.sub
              },
              t
            )
          );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      lh();
    }
  }
}
function $g(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let r = t.deps; r; r = r.nextDep)
        $g(r);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const qd = /* @__PURE__ */ new WeakMap(), Hi = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), jd = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), Bs = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function pt(e, t, n) {
  if (Cn && Me) {
    let r = qd.get(e);
    r || qd.set(e, r = /* @__PURE__ */ new Map());
    let i = r.get(n);
    i || (r.set(n, i = new vh()), i.map = r, i.key = n), process.env.NODE_ENV !== "production" ? i.track({
      target: e,
      type: t,
      key: n
    }) : i.track();
  }
}
function Mr(e, t, n, r, i, o) {
  const a = qd.get(e);
  if (!a) {
    Vs++;
    return;
  }
  const s = (c) => {
    c && (process.env.NODE_ENV !== "production" ? c.trigger({
      target: e,
      type: t,
      key: n,
      newValue: r,
      oldValue: i,
      oldTarget: o
    }) : c.trigger());
  };
  if (fh(), t === "clear")
    a.forEach(s);
  else {
    const c = qe(e), u = c && sh(n);
    if (c && n === "length") {
      const f = Number(r);
      a.forEach((l, v) => {
        (v === "length" || v === Bs || !lc(v) && v >= f) && s(l);
      });
    } else
      switch ((n !== void 0 || a.has(void 0)) && s(a.get(n)), u && s(a.get(Bs)), t) {
        case "add":
          c ? u && s(a.get("length")) : (s(a.get(Hi)), aa(e) && s(a.get(jd)));
          break;
        case "delete":
          c || (s(a.get(Hi)), aa(e) && s(a.get(jd)));
          break;
        case "set":
          aa(e) && s(a.get(Hi));
          break;
      }
  }
  lh();
}
function bo(e) {
  const t = Ie(e);
  return t === e ? t : (pt(t, "iterate", Bs), Kt(e) ? t : t.map(xt));
}
function hh(e) {
  return pt(e = Ie(e), "iterate", Bs), e;
}
const $w = {
  __proto__: null,
  [Symbol.iterator]() {
    return al(this, Symbol.iterator, xt);
  },
  concat(...e) {
    return bo(this).concat(
      ...e.map((t) => qe(t) ? bo(t) : t)
    );
  },
  entries() {
    return al(this, "entries", (e) => (e[1] = xt(e[1]), e));
  },
  every(e, t) {
    return er(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return er(this, "filter", e, t, (n) => n.map(xt), arguments);
  },
  find(e, t) {
    return er(this, "find", e, t, xt, arguments);
  },
  findIndex(e, t) {
    return er(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return er(this, "findLast", e, t, xt, arguments);
  },
  findLastIndex(e, t) {
    return er(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return er(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return sl(this, "includes", e);
  },
  indexOf(...e) {
    return sl(this, "indexOf", e);
  },
  join(e) {
    return bo(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return sl(this, "lastIndexOf", e);
  },
  map(e, t) {
    return er(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Va(this, "pop");
  },
  push(...e) {
    return Va(this, "push", e);
  },
  reduce(e, ...t) {
    return N_(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return N_(this, "reduceRight", e, t);
  },
  shift() {
    return Va(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return er(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Va(this, "splice", e);
  },
  toReversed() {
    return bo(this).toReversed();
  },
  toSorted(e) {
    return bo(this).toSorted(e);
  },
  toSpliced(...e) {
    return bo(this).toSpliced(...e);
  },
  unshift(...e) {
    return Va(this, "unshift", e);
  },
  values() {
    return al(this, "values", xt);
  }
};
function al(e, t, n) {
  const r = hh(e), i = r[t]();
  return r !== e && !Kt(e) && (i._next = i.next, i.next = () => {
    const o = i._next();
    return o.value && (o.value = n(o.value)), o;
  }), i;
}
const Fw = Array.prototype;
function er(e, t, n, r, i, o) {
  const a = hh(e), s = a !== e && !Kt(e), c = a[t];
  if (c !== Fw[t]) {
    const l = c.apply(e, o);
    return s ? xt(l) : l;
  }
  let u = n;
  a !== e && (s ? u = function(l, v) {
    return n.call(this, xt(l), v, e);
  } : n.length > 2 && (u = function(l, v) {
    return n.call(this, l, v, e);
  }));
  const f = c.call(a, u, r);
  return s && i ? i(f) : f;
}
function N_(e, t, n, r) {
  const i = hh(e);
  let o = n;
  return i !== e && (Kt(e) ? n.length > 3 && (o = function(a, s, c) {
    return n.call(this, a, s, c, e);
  }) : o = function(a, s, c) {
    return n.call(this, a, xt(s), c, e);
  }), i[t](o, ...r);
}
function sl(e, t, n) {
  const r = Ie(e);
  pt(r, "iterate", Bs);
  const i = r[t](...n);
  return (i === -1 || i === !1) && Nu(n[0]) ? (n[0] = Ie(n[0]), r[t](...n)) : i;
}
function Va(e, t, n = []) {
  Af(), fh();
  const r = Ie(e)[t].apply(e, n);
  return lh(), Of(), r;
}
const Hw = /* @__PURE__ */ ww("__proto__,__v_isRef,__isVue"), Fg = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(lc)
);
function Yw(e) {
  lc(e) || (e = String(e));
  const t = Ie(this);
  return pt(t, "has", e), t.hasOwnProperty(e);
}
class Hg {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, r) {
    if (n === "__v_skip") return t.__v_skip;
    const i = this._isReadonly, o = this._isShallow;
    if (n === "__v_isReactive")
      return !i;
    if (n === "__v_isReadonly")
      return i;
    if (n === "__v_isShallow")
      return o;
    if (n === "__v_raw")
      return r === (i ? o ? zg : Bg : o ? Jw : Vg).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(r) ? t : void 0;
    const a = qe(t);
    if (!i) {
      let c;
      if (a && (c = $w[n]))
        return c;
      if (n === "hasOwnProperty")
        return Yw;
    }
    const s = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      Ht(t) ? t : r
    );
    return (lc(n) ? Fg.has(n) : Hw(n)) || (i || pt(t, "get", n), o) ? s : Ht(s) ? a && sh(n) ? s : s.value : Gt(s) ? i ? Gg(s) : kf(s) : s;
  }
}
class Vw extends Hg {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, r, i) {
    let o = t[n];
    if (!this._isShallow) {
      const c = hr(o);
      if (!Kt(r) && !hr(r) && (o = Ie(o), r = Ie(r)), !qe(t) && Ht(o) && !Ht(r))
        return c ? !1 : (o.value = r, !0);
    }
    const a = qe(t) && sh(n) ? Number(n) < t.length : it(t, n), s = Reflect.set(
      t,
      n,
      r,
      Ht(t) ? t : i
    );
    return t === Ie(i) && (a ? jr(r, o) && Mr(t, "set", n, r, o) : Mr(t, "add", n, r)), s;
  }
  deleteProperty(t, n) {
    const r = it(t, n), i = t[n], o = Reflect.deleteProperty(t, n);
    return o && r && Mr(t, "delete", n, void 0, i), o;
  }
  has(t, n) {
    const r = Reflect.has(t, n);
    return (!lc(n) || !Fg.has(n)) && pt(t, "has", n), r;
  }
  ownKeys(t) {
    return pt(
      t,
      "iterate",
      qe(t) ? "length" : Hi
    ), Reflect.ownKeys(t);
  }
}
class Yg extends Hg {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && vr(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && vr(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const Bw = /* @__PURE__ */ new Vw(), zw = /* @__PURE__ */ new Yg(), Gw = /* @__PURE__ */ new Yg(!0), Xd = (e) => e, bc = (e) => Reflect.getPrototypeOf(e);
function Kw(e, t, n) {
  return function(...r) {
    const i = this.__v_raw, o = Ie(i), a = aa(o), s = e === "entries" || e === Symbol.iterator && a, c = e === "keys" && a, u = i[e](...r), f = n ? Xd : t ? Jd : xt;
    return !t && pt(
      o,
      "iterate",
      c ? jd : Hi
    ), {
      // iterator protocol
      next() {
        const { value: l, done: v } = u.next();
        return v ? { value: l, done: v } : {
          value: s ? [f(l[0]), f(l[1])] : f(l),
          done: v
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Cc(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      vr(
        `${Rw(e)} operation ${n}failed: target is readonly.`,
        Ie(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function Ww(e, t) {
  const n = {
    get(i) {
      const o = this.__v_raw, a = Ie(o), s = Ie(i);
      e || (jr(i, s) && pt(a, "get", i), pt(a, "get", s));
      const { has: c } = bc(a), u = t ? Xd : e ? Jd : xt;
      if (c.call(a, i))
        return u(o.get(i));
      if (c.call(a, s))
        return u(o.get(s));
      o !== a && o.get(i);
    },
    get size() {
      const i = this.__v_raw;
      return !e && pt(Ie(i), "iterate", Hi), Reflect.get(i, "size", i);
    },
    has(i) {
      const o = this.__v_raw, a = Ie(o), s = Ie(i);
      return e || (jr(i, s) && pt(a, "has", i), pt(a, "has", s)), i === s ? o.has(i) : o.has(i) || o.has(s);
    },
    forEach(i, o) {
      const a = this, s = a.__v_raw, c = Ie(s), u = t ? Xd : e ? Jd : xt;
      return !e && pt(c, "iterate", Hi), s.forEach((f, l) => i.call(o, u(f), u(l), a));
    }
  };
  return rn(
    n,
    e ? {
      add: Cc("add"),
      set: Cc("set"),
      delete: Cc("delete"),
      clear: Cc("clear")
    } : {
      add(i) {
        !t && !Kt(i) && !hr(i) && (i = Ie(i));
        const o = Ie(this);
        return bc(o).has.call(o, i) || (o.add(i), Mr(o, "add", i, i)), this;
      },
      set(i, o) {
        !t && !Kt(o) && !hr(o) && (o = Ie(o));
        const a = Ie(this), { has: s, get: c } = bc(a);
        let u = s.call(a, i);
        u ? process.env.NODE_ENV !== "production" && I_(a, s, i) : (i = Ie(i), u = s.call(a, i));
        const f = c.call(a, i);
        return a.set(i, o), u ? jr(o, f) && Mr(a, "set", i, o, f) : Mr(a, "add", i, o), this;
      },
      delete(i) {
        const o = Ie(this), { has: a, get: s } = bc(o);
        let c = a.call(o, i);
        c ? process.env.NODE_ENV !== "production" && I_(o, a, i) : (i = Ie(i), c = a.call(o, i));
        const u = s ? s.call(o, i) : void 0, f = o.delete(i);
        return c && Mr(o, "delete", i, void 0, u), f;
      },
      clear() {
        const i = Ie(this), o = i.size !== 0, a = process.env.NODE_ENV !== "production" ? aa(i) ? new Map(i) : new Set(i) : void 0, s = i.clear();
        return o && Mr(
          i,
          "clear",
          void 0,
          void 0,
          a
        ), s;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((i) => {
    n[i] = Kw(i, e, t);
  }), n;
}
function _h(e, t) {
  const n = Ww(e, t);
  return (r, i, o) => i === "__v_isReactive" ? !e : i === "__v_isReadonly" ? e : i === "__v_raw" ? r : Reflect.get(
    it(n, i) && i in r ? n : r,
    i,
    o
  );
}
const qw = {
  get: /* @__PURE__ */ _h(!1, !1)
}, jw = {
  get: /* @__PURE__ */ _h(!0, !1)
}, Xw = {
  get: /* @__PURE__ */ _h(!0, !0)
};
function I_(e, t, n) {
  const r = Ie(n);
  if (r !== n && t.call(e, r)) {
    const i = Ag(e);
    vr(
      `Reactive ${i} contains both the raw and reactive versions of the same object${i === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const Vg = /* @__PURE__ */ new WeakMap(), Jw = /* @__PURE__ */ new WeakMap(), Bg = /* @__PURE__ */ new WeakMap(), zg = /* @__PURE__ */ new WeakMap();
function Qw(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Zw(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Qw(Ag(e));
}
function kf(e) {
  return hr(e) ? e : ph(
    e,
    !1,
    Bw,
    qw,
    Vg
  );
}
function Gg(e) {
  return ph(
    e,
    !0,
    zw,
    jw,
    Bg
  );
}
function Nc(e) {
  return ph(
    e,
    !0,
    Gw,
    Xw,
    zg
  );
}
function ph(e, t, n, r, i) {
  if (!Gt(e))
    return process.env.NODE_ENV !== "production" && vr(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const o = i.get(e);
  if (o)
    return o;
  const a = Zw(e);
  if (a === 0)
    return e;
  const s = new Proxy(
    e,
    a === 2 ? r : n
  );
  return i.set(e, s), s;
}
function sa(e) {
  return hr(e) ? sa(e.__v_raw) : !!(e && e.__v_isReactive);
}
function hr(e) {
  return !!(e && e.__v_isReadonly);
}
function Kt(e) {
  return !!(e && e.__v_isShallow);
}
function Nu(e) {
  return e ? !!e.__v_raw : !1;
}
function Ie(e) {
  const t = e && e.__v_raw;
  return t ? Ie(t) : e;
}
function ey(e) {
  return !it(e, "__v_skip") && Object.isExtensible(e) && Pw(e, "__v_skip", !0), e;
}
const xt = (e) => Gt(e) ? kf(e) : e, Jd = (e) => Gt(e) ? Gg(e) : e;
function Ht(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function cl(e) {
  return ty(e, !1);
}
function ty(e, t) {
  return Ht(e) ? e : new ny(e, t);
}
class ny {
  constructor(t, n) {
    this.dep = new vh(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : Ie(t), this._value = n ? t : xt(t), this.__v_isShallow = n;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, r = this.__v_isShallow || Kt(t) || hr(t);
    t = r ? t : Ie(t), jr(t, n) && (this._rawValue = t, this._value = r ? t : xt(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: n
    }) : this.dep.trigger());
  }
}
function ry(e) {
  return Ht(e) ? e.value : e;
}
const iy = {
  get: (e, t, n) => t === "__v_raw" ? e : ry(Reflect.get(e, t, n)),
  set: (e, t, n, r) => {
    const i = e[t];
    return Ht(i) && !Ht(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
  }
};
function oy(e) {
  return sa(e) ? e : new Proxy(e, iy);
}
class ay {
  constructor(t, n, r) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new vh(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = Vs - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = r;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Me !== this)
      return kg(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return Mg(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && vr("Write operation failed: computed value is readonly");
  }
}
function sy(e, t, n = !1) {
  let r, i;
  Et(e) ? r = e : (r = e.get, i = e.set);
  const o = new ay(r, i, n);
  return process.env.NODE_ENV !== "production" && t && !n && (o.onTrack = t.onTrack, o.onTrigger = t.onTrigger), o;
}
const Ic = {}, Iu = /* @__PURE__ */ new WeakMap();
let Ci;
function cy(e, t = !1, n = Ci) {
  if (n) {
    let r = Iu.get(n);
    r || Iu.set(n, r = []), r.push(e);
  } else process.env.NODE_ENV !== "production" && !t && vr(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function uy(e, t, n = fn) {
  const { immediate: r, deep: i, once: o, scheduler: a, augmentJob: s, call: c } = n, u = (I) => {
    (n.onWarn || vr)(
      "Invalid watch source: ",
      I,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, f = (I) => i ? I : Kt(I) || i === !1 || i === 0 ? Ur(I, 1) : Ur(I);
  let l, v, d, h, _ = !1, m = !1;
  if (Ht(e) ? (v = () => e.value, _ = Kt(e)) : sa(e) ? (v = () => f(e), _ = !0) : qe(e) ? (m = !0, _ = e.some((I) => sa(I) || Kt(I)), v = () => e.map((I) => {
    if (Ht(I))
      return I.value;
    if (sa(I))
      return f(I);
    if (Et(I))
      return c ? c(I, 2) : I();
    process.env.NODE_ENV !== "production" && u(I);
  })) : Et(e) ? t ? v = c ? () => c(e, 2) : e : v = () => {
    if (d) {
      Af();
      try {
        d();
      } finally {
        Of();
      }
    }
    const I = Ci;
    Ci = l;
    try {
      return c ? c(e, 3, [h]) : e(h);
    } finally {
      Ci = I;
    }
  } : (v = Fi, process.env.NODE_ENV !== "production" && u(e)), t && i) {
    const I = v, P = i === !0 ? 1 / 0 : i;
    v = () => Ur(I(), P);
  }
  const E = () => {
    l.stop();
  };
  if (o && t) {
    const I = t;
    t = (...P) => {
      I(...P), E();
    };
  }
  let y = m ? new Array(e.length).fill(Ic) : Ic;
  const O = (I) => {
    if (!(!(l.flags & 1) || !l.dirty && !I))
      if (t) {
        const P = l.run();
        if (i || _ || (m ? P.some((B, D) => jr(B, y[D])) : jr(P, y))) {
          d && d();
          const B = Ci;
          Ci = l;
          try {
            const D = [
              P,
              // pass undefined as the old value when it's changed for the first time
              y === Ic ? void 0 : m && y[0] === Ic ? [] : y,
              h
            ];
            c ? c(t, 3, D) : (
              // @ts-expect-error
              t(...D)
            ), y = P;
          } finally {
            Ci = B;
          }
        }
      } else
        l.run();
  };
  return s && s(O), l = new Lw(v), l.scheduler = a ? () => a(O, !1) : O, h = (I) => cy(I, !1, l), d = l.onStop = () => {
    const I = Iu.get(l);
    if (I) {
      if (c)
        c(I, 4);
      else
        for (const P of I) P();
      Iu.delete(l);
    }
  }, process.env.NODE_ENV !== "production" && (l.onTrack = n.onTrack, l.onTrigger = n.onTrigger), t ? r ? O(!0) : y = l.run() : a ? a(O.bind(null, !0), !0) : l.run(), E.pause = l.pause.bind(l), E.resume = l.resume.bind(l), E.stop = E, E;
}
function Ur(e, t = 1 / 0, n) {
  if (t <= 0 || !Gt(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, Ht(e))
    Ur(e.value, t, n);
  else if (qe(e))
    for (let r = 0; r < e.length; r++)
      Ur(e[r], t, n);
  else if (bw(e) || aa(e))
    e.forEach((r) => {
      Ur(r, t, n);
    });
  else if (Iw(e)) {
    for (const r in e)
      Ur(e[r], t, n);
    for (const r of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, r) && Ur(e[r], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Yi = [];
function fy(e) {
  Yi.push(e);
}
function ly() {
  Yi.pop();
}
let ul = !1;
function Qe(e, ...t) {
  if (ul) return;
  ul = !0, Af();
  const n = Yi.length ? Yi[Yi.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = dy();
  if (r)
    xf(
      r,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((o) => {
          var a, s;
          return (s = (a = o.toString) == null ? void 0 : a.call(o)) != null ? s : JSON.stringify(o);
        }).join(""),
        n && n.proxy,
        i.map(
          ({ vnode: o }) => `at <${cE(n, o.type)}>`
        ).join(`
`),
        i
      ]
    );
  else {
    const o = [`[Vue warn]: ${e}`, ...t];
    i.length && o.push(`
`, ...vy(i)), console.warn(...o);
  }
  Of(), ul = !1;
}
function dy() {
  let e = Yi[Yi.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const r = e.component && e.component.parent;
    e = r && r.vnode;
  }
  return t;
}
function vy(e) {
  const t = [];
  return e.forEach((n, r) => {
    t.push(...r === 0 ? [] : [`
`], ...hy(n));
  }), t;
}
function hy({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${cE(
    e.component,
    e.type,
    r
  )}`, o = ">" + n;
  return e.props ? [i, ..._y(e.props), o] : [i + o];
}
function _y(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((r) => {
    t.push(...Kg(r, e[r]));
  }), n.length > 3 && t.push(" ..."), t;
}
function Kg(e, t, n) {
  return Nn(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : Ht(t) ? (t = Kg(e, Ie(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : Et(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = Ie(t), n ? t : [`${e}=`, t]);
}
const Wg = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function xf(e, t, n, r) {
  try {
    return r ? e(...r) : e();
  } catch (i) {
    gh(i, t, n);
  }
}
function qg(e, t, n, r) {
  if (Et(e)) {
    const i = xf(e, t, n, r);
    return i && Cw(i) && i.catch((o) => {
      gh(o, t, n);
    }), i;
  }
  if (qe(e)) {
    const i = [];
    for (let o = 0; o < e.length; o++)
      i.push(qg(e[o], t, n, r));
    return i;
  } else process.env.NODE_ENV !== "production" && Qe(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function gh(e, t, n, r = !0) {
  const i = t ? t.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: a } = t && t.appContext.config || fn;
  if (t) {
    let s = t.parent;
    const c = t.proxy, u = process.env.NODE_ENV !== "production" ? Wg[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; s; ) {
      const f = s.ec;
      if (f) {
        for (let l = 0; l < f.length; l++)
          if (f[l](e, c, u) === !1)
            return;
      }
      s = s.parent;
    }
    if (o) {
      Af(), xf(o, null, 10, [
        e,
        c,
        u
      ]), Of();
      return;
    }
  }
  py(e, n, i, r, a);
}
function py(e, t, n, r = !0, i = !1) {
  if (process.env.NODE_ENV !== "production") {
    const o = Wg[t];
    if (n && fy(n), Qe(`Unhandled error${o ? ` during execution of ${o}` : ""}`), n && ly(), r)
      throw e;
    console.error(e);
  } else {
    if (i)
      throw e;
    console.error(e);
  }
}
const ln = [];
let rr = -1;
const ca = [];
let xr = null, Uo = 0;
const jg = /* @__PURE__ */ Promise.resolve();
let Du = null;
const gy = 100;
function Ey(e) {
  const t = Du || jg;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Sy(e) {
  let t = rr + 1, n = ln.length;
  for (; t < n; ) {
    const r = t + n >>> 1, i = ln[r], o = zs(i);
    o < e || o === e && i.flags & 2 ? t = r + 1 : n = r;
  }
  return t;
}
function Eh(e) {
  if (!(e.flags & 1)) {
    const t = zs(e), n = ln[ln.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= zs(n) ? ln.push(e) : ln.splice(Sy(t), 0, e), e.flags |= 1, Xg();
  }
}
function Xg() {
  Du || (Du = jg.then(Qg));
}
function Jg(e) {
  qe(e) ? ca.push(...e) : xr && e.id === -1 ? xr.splice(Uo + 1, 0, e) : e.flags & 1 || (ca.push(e), e.flags |= 1), Xg();
}
function my(e) {
  if (ca.length) {
    const t = [...new Set(ca)].sort(
      (n, r) => zs(n) - zs(r)
    );
    if (ca.length = 0, xr) {
      xr.push(...t);
      return;
    }
    for (xr = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), Uo = 0; Uo < xr.length; Uo++) {
      const n = xr[Uo];
      process.env.NODE_ENV !== "production" && Zg(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    xr = null, Uo = 0;
  }
}
const zs = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Qg(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => Zg(e, n) : Fi;
  try {
    for (rr = 0; rr < ln.length; rr++) {
      const n = ln[rr];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), xf(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; rr < ln.length; rr++) {
      const n = ln[rr];
      n && (n.flags &= -2);
    }
    rr = -1, ln.length = 0, my(e), Du = null, (ln.length || ca.length) && Qg(e);
  }
}
function Zg(e, t) {
  const n = e.get(t) || 0;
  if (n > gy) {
    const r = t.i, i = r && sE(r.type);
    return gh(
      `Maximum recursive updates exceeded${i ? ` in component <${i}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
const fl = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (Pf().__VUE_HMR_RUNTIME__ = {
  createRecord: ll(wy),
  rerender: ll(yy),
  reload: ll(Ty)
});
const Ru = /* @__PURE__ */ new Map();
function wy(e, t) {
  return Ru.has(e) ? !1 : (Ru.set(e, {
    initialDef: Pu(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Pu(e) {
  return uE(e) ? e.__vccOpts : e;
}
function yy(e, t) {
  const n = Ru.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((r) => {
    t && (r.render = t, Pu(r.type).render = t), r.renderCache = [], r.update();
  }));
}
function Ty(e, t) {
  const n = Ru.get(e);
  if (!n) return;
  t = Pu(t), D_(n.initialDef, t);
  const r = [...n.instances];
  for (let i = 0; i < r.length; i++) {
    const o = r[i], a = Pu(o.type);
    let s = fl.get(a);
    s || (a !== n.initialDef && D_(a, t), fl.set(a, s = /* @__PURE__ */ new Set())), s.add(o), o.appContext.propsCache.delete(o.type), o.appContext.emitsCache.delete(o.type), o.appContext.optionsCache.delete(o.type), o.ceReload ? (s.add(o), o.ceReload(t.styles), s.delete(o)) : o.parent ? Eh(() => {
      o.parent.update(), s.delete(o);
    }) : o.appContext.reload ? o.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), o.root.ce && o !== o.root && o.root.ce._removeChildStyle(a);
  }
  Jg(() => {
    fl.clear();
  });
}
function D_(e, t) {
  rn(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function ll(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (r) {
      console.error(r), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let $o, Dc = [];
function eE(e, t) {
  var n, r;
  $o = e, $o ? ($o.enabled = !0, Dc.forEach(({ event: i, args: o }) => $o.emit(i, ...o)), Dc = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((r = (n = window.navigator) == null ? void 0 : n.userAgent) != null && r.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((o) => {
    eE(o, t);
  }), setTimeout(() => {
    $o || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Dc = []);
  }, 3e3)) : Dc = [];
}
let $n = null, by = null;
const Cy = (e) => e.__isTeleport;
function tE(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, tE(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
Pf().requestIdleCallback;
Pf().cancelIdleCallback;
const Ny = Symbol.for("v-ndc"), Qd = (e) => e ? nT(e) ? rT(e) : Qd(e.parent) : null, Ds = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ rn(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? Nc(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? Nc(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? Nc(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? Nc(e.refs) : e.refs,
    $parent: (e) => Qd(e.parent),
    $root: (e) => Qd(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => __VUE_OPTIONS_API__ ? Py(e) : e.type,
    $forceUpdate: (e) => e.f || (e.f = () => {
      Eh(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = Ey.bind(e.proxy)),
    $watch: (e) => __VUE_OPTIONS_API__ ? Yy.bind(e) : Fi
  })
), Iy = (e) => e === "_" || e === "$", dl = (e, t) => e !== fn && !e.__isScriptSetup && it(e, t), Dy = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: r, data: i, props: o, accessCache: a, type: s, appContext: c } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let u;
    if (t[0] !== "$") {
      const d = a[t];
      if (d !== void 0)
        switch (d) {
          case 1:
            return r[t];
          case 2:
            return i[t];
          case 4:
            return n[t];
          case 3:
            return o[t];
        }
      else {
        if (dl(r, t))
          return a[t] = 1, r[t];
        if (i !== fn && it(i, t))
          return a[t] = 2, i[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (u = e.propsOptions[0]) && it(u, t)
        )
          return a[t] = 3, o[t];
        if (n !== fn && it(n, t))
          return a[t] = 4, n[t];
        (!__VUE_OPTIONS_API__ || Ry) && (a[t] = 0);
      }
    }
    const f = Ds[t];
    let l, v;
    if (f)
      return t === "$attrs" ? (pt(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && void 0) : process.env.NODE_ENV !== "production" && t === "$slots" && pt(e, "get", t), f(e);
    if (
      // css module (injected by vue-loader)
      (l = s.__cssModules) && (l = l[t])
    )
      return l;
    if (n !== fn && it(n, t))
      return a[t] = 4, n[t];
    if (
      // global properties
      v = c.config.globalProperties, it(v, t)
    )
      return v[t];
    process.env.NODE_ENV !== "production" && $n && (!Nn(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (i !== fn && Iy(t[0]) && it(i, t) ? Qe(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === $n && Qe(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, n) {
    const { data: r, setupState: i, ctx: o } = e;
    return dl(i, t) ? (i[t] = n, !0) : process.env.NODE_ENV !== "production" && i.__isScriptSetup && it(i, t) ? (Qe(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : r !== fn && it(r, t) ? (r[t] = n, !0) : it(e.props, t) ? (process.env.NODE_ENV !== "production" && Qe(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && Qe(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(o, t, {
      enumerable: !0,
      configurable: !0,
      value: n
    }) : o[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, propsOptions: o }
  }, a) {
    let s;
    return !!n[a] || e !== fn && it(e, a) || dl(t, a) || (s = o[0]) && it(s, a) || it(r, a) || it(Ds, a) || it(i.config.globalProperties, a);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : it(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
process.env.NODE_ENV !== "production" && (Dy.ownKeys = (e) => (Qe(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function R_(e) {
  return qe(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
let Ry = !0;
function Py(e) {
  const t = e.type, { mixins: n, extends: r } = t, {
    mixins: i,
    optionsCache: o,
    config: { optionMergeStrategies: a }
  } = e.appContext, s = o.get(t);
  let c;
  return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach(
    (u) => Au(c, u, a, !0)
  ), Au(c, t, a)), Gt(t) && o.set(t, c), c;
}
function Au(e, t, n, r = !1) {
  const { mixins: i, extends: o } = t;
  o && Au(e, o, n, !0), i && i.forEach(
    (a) => Au(e, a, n, !0)
  );
  for (const a in t)
    if (r && a === "expose")
      process.env.NODE_ENV !== "production" && Qe(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const s = Ay[a] || n && n[a];
      e[a] = s ? s(e[a], t[a]) : t[a];
    }
  return e;
}
const Ay = {
  data: P_,
  props: O_,
  emits: O_,
  // objects
  methods: vs,
  computed: vs,
  // lifecycle
  beforeCreate: Ot,
  created: Ot,
  beforeMount: Ot,
  mounted: Ot,
  beforeUpdate: Ot,
  updated: Ot,
  beforeDestroy: Ot,
  beforeUnmount: Ot,
  destroyed: Ot,
  unmounted: Ot,
  activated: Ot,
  deactivated: Ot,
  errorCaptured: Ot,
  serverPrefetch: Ot,
  // assets
  components: vs,
  directives: vs,
  // watch
  watch: ky,
  // provide / inject
  provide: P_,
  inject: Oy
};
function P_(e, t) {
  return t ? e ? function() {
    return rn(
      Et(e) ? e.call(this, this) : e,
      Et(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function Oy(e, t) {
  return vs(A_(e), A_(t));
}
function A_(e) {
  if (qe(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function Ot(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function vs(e, t) {
  return e ? rn(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function O_(e, t) {
  return e ? qe(e) && qe(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : rn(
    /* @__PURE__ */ Object.create(null),
    R_(e),
    R_(t ?? {})
  ) : t;
}
function ky(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = rn(/* @__PURE__ */ Object.create(null), e);
  for (const r in t)
    n[r] = Ot(e[r], t[r]);
  return n;
}
let xy = null;
function Ly(e, t, n = !1) {
  const r = dc || $n;
  if (r || xy) {
    const i = r ? r.parent == null ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
    if (i && e in i)
      return i[e];
    if (arguments.length > 1)
      return n && Et(t) ? t.call(r && r.proxy) : t;
    process.env.NODE_ENV !== "production" && Qe(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && Qe("inject() can only be used inside setup() or functional components.");
}
const My = {}, nE = (e) => Object.getPrototypeOf(e) === My, Uy = zy, $y = Symbol.for("v-scx"), Fy = () => {
  {
    const e = Ly($y);
    return e || process.env.NODE_ENV !== "production" && Qe(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function Hy(e, t, n = fn) {
  const { immediate: r, deep: i, flush: o, once: a } = n;
  process.env.NODE_ENV !== "production" && !t && (r !== void 0 && Qe(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), i !== void 0 && Qe(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), a !== void 0 && Qe(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const s = rn({}, n);
  process.env.NODE_ENV !== "production" && (s.onWarn = Qe);
  const c = t && r || !t && o !== "post";
  let u;
  if (ku) {
    if (o === "sync") {
      const d = Fy();
      u = d.__watcherHandles || (d.__watcherHandles = []);
    } else if (!c) {
      const d = () => {
      };
      return d.stop = Fi, d.resume = Fi, d.pause = Fi, d;
    }
  }
  const f = dc;
  s.call = (d, h, _) => qg(d, f, h, _);
  let l = !1;
  o === "post" ? s.scheduler = (d) => {
    Uy(d, f && f.suspense);
  } : o !== "sync" && (l = !0, s.scheduler = (d, h) => {
    h ? d() : Eh(d);
  }), s.augmentJob = (d) => {
    t && (d.flags |= 4), l && (d.flags |= 2, f && (d.id = f.uid, d.i = f));
  };
  const v = uy(e, t, s);
  return ku && (u ? u.push(v) : c && v()), v;
}
function Yy(e, t, n) {
  const r = this.proxy, i = Nn(e) ? e.includes(".") ? Vy(r, e) : () => r[e] : e.bind(r, r);
  let o;
  Et(t) ? o = t : (o = t.handler, n = t);
  const a = tT(this), s = Hy(i, o.bind(r), n);
  return a(), s;
}
function Vy(e, t) {
  const n = t.split(".");
  return () => {
    let r = e;
    for (let i = 0; i < n.length && r; i++)
      r = r[n[i]];
    return r;
  };
}
const By = (e) => e.__isSuspense;
function zy(e, t) {
  t && t.pendingBranch ? qe(e) ? t.effects.push(...e) : t.effects.push(e) : Jg(e);
}
const rE = Symbol.for("v-fgt"), Gy = Symbol.for("v-txt"), Ky = Symbol.for("v-cmt");
let Jo = null;
function Wy(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
const qy = (...e) => oE(
  ...e
), iE = ({ key: e }) => e ?? null, cu = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? Nn(e) || Ht(e) || Et(e) ? { i: $n, r: e, k: t, f: !!n } : e : null);
function jy(e, t = null, n = null, r = 0, i = null, o = e === rE ? 0 : 1, a = !1, s = !1) {
  const c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && iE(t),
    ref: t && cu(t),
    scopeId: by,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: o,
    patchFlag: r,
    dynamicProps: i,
    dynamicChildren: null,
    appContext: null,
    ctx: $n
  };
  return s ? (Sh(c, n), o & 128 && e.normalize(c)) : n && (c.shapeFlag |= Nn(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && Qe("VNode created with invalid key (NaN). VNode type:", c.type), // avoid a block node from tracking itself
  !a && // has current parent block
  Jo && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (c.patchFlag > 0 || o & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  c.patchFlag !== 32 && Jo.push(c), c;
}
const Xy = process.env.NODE_ENV !== "production" ? qy : oE;
function oE(e, t = null, n = null, r = 0, i = null, o = !1) {
  if ((!e || e === Ny) && (process.env.NODE_ENV !== "production" && !e && Qe(`Invalid vnode type when creating vnode: ${e}.`), e = Ky), Wy(e)) {
    const s = Ou(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && Sh(s, n), !o && Jo && (s.shapeFlag & 6 ? Jo[Jo.indexOf(e)] = s : Jo.push(s)), s.patchFlag = -2, s;
  }
  if (uE(e) && (e = e.__vccOpts), t) {
    t = Jy(t);
    let { class: s, style: c } = t;
    s && !Nn(s) && (t.class = uh(s)), Gt(c) && (Nu(c) && !qe(c) && (c = rn({}, c)), t.style = ch(c));
  }
  const a = Nn(e) ? 1 : By(e) ? 128 : Cy(e) ? 64 : Gt(e) ? 4 : Et(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && a & 4 && Nu(e) && (e = Ie(e), Qe(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), jy(
    e,
    t,
    n,
    r,
    i,
    a,
    o,
    !0
  );
}
function Jy(e) {
  return e ? Nu(e) || nE(e) ? rn({}, e) : e : null;
}
function Ou(e, t, n = !1, r = !1) {
  const { props: i, ref: o, patchFlag: a, children: s, transition: c } = e, u = t ? Zy(i || {}, t) : i, f = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: u,
    key: u && iE(u),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && o ? qe(o) ? o.concat(cu(t)) : [o, cu(t)] : cu(t)
    ) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && a === -1 && qe(s) ? s.map(aE) : s,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== rE ? a === -1 ? 16 : a | 16 : a,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: c,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Ou(e.ssContent),
    ssFallback: e.ssFallback && Ou(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return c && r && tE(
    f,
    c.clone(f)
  ), f;
}
function aE(e) {
  const t = Ou(e);
  return qe(e.children) && (t.children = e.children.map(aE)), t;
}
function Qy(e = " ", t = 0) {
  return Xy(Gy, null, e, t);
}
function Sh(e, t) {
  let n = 0;
  const { shapeFlag: r } = e;
  if (t == null)
    t = null;
  else if (qe(t))
    n = 16;
  else if (typeof t == "object")
    if (r & 65) {
      const i = t.default;
      i && (i._c && (i._d = !1), Sh(e, i()), i._c && (i._d = !0));
      return;
    } else {
      n = 32;
      const i = t._;
      !i && !nE(t) ? t._ctx = $n : i === 3 && $n && ($n.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else Et(t) ? (t = { default: t, _ctx: $n }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [Qy(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Zy(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (const i in r)
      if (i === "class")
        t.class !== r.class && (t.class = uh([t.class, r.class]));
      else if (i === "style")
        t.style = ch([t.style, r.style]);
      else if (yw(i)) {
        const o = t[i], a = r[i];
        a && o !== a && !(qe(o) && o.includes(a)) && (t[i] = o ? [].concat(o, a) : a);
      } else i !== "" && (t[i] = r[i]);
  }
  return t;
}
let dc = null;
const eT = () => dc || $n;
let Zd;
{
  const e = Pf(), t = (n, r) => {
    let i;
    return (i = e[n]) || (i = e[n] = []), i.push(r), (o) => {
      i.length > 1 ? i.forEach((a) => a(o)) : i[0](o);
    };
  };
  Zd = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => dc = n
  ), t(
    "__VUE_SSR_SETTERS__",
    (n) => ku = n
  );
}
const tT = (e) => {
  const t = dc;
  return Zd(e), e.scope.on(), () => {
    e.scope.off(), Zd(t);
  };
};
function nT(e) {
  return e.vnode.shapeFlag & 4;
}
let ku = !1;
process.env.NODE_ENV;
function rT(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(oy(ey(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in Ds)
        return Ds[n](e);
    },
    has(t, n) {
      return n in t || n in Ds;
    }
  })) : e.proxy;
}
const iT = /(?:^|[-_])(\w)/g, oT = (e) => e.replace(iT, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function sE(e, t = !0) {
  return Et(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function cE(e, t, n = !1) {
  let r = sE(t);
  if (!r && t.__file) {
    const i = t.__file.match(/([^/\\]+)\.\w+$/);
    i && (r = i[1]);
  }
  if (!r && e && e.parent) {
    const i = (o) => {
      for (const a in o)
        if (o[a] === t)
          return a;
    };
    r = i(
      e.components || e.parent.type.components
    ) || i(e.appContext.components);
  }
  return r ? oT(r) : n ? "App" : "Anonymous";
}
function uE(e) {
  return Et(e) && "__vccOpts" in e;
}
const Ke = (e, t) => {
  const n = sy(e, t, ku);
  if (process.env.NODE_ENV !== "production") {
    const r = eT();
    r && r.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function aT() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
    __vue_custom_formatter: !0,
    header(l) {
      return Gt(l) ? l.__isVue ? ["div", e, "VueInstance"] : Ht(l) ? [
        "div",
        {},
        ["span", e, f(l)],
        "<",
        // avoid debugger accessing value affecting behavior
        s("_value" in l ? l._value : l),
        ">"
      ] : sa(l) ? [
        "div",
        {},
        ["span", e, Kt(l) ? "ShallowReactive" : "Reactive"],
        "<",
        s(l),
        `>${hr(l) ? " (readonly)" : ""}`
      ] : hr(l) ? [
        "div",
        {},
        ["span", e, Kt(l) ? "ShallowReadonly" : "Readonly"],
        "<",
        s(l),
        ">"
      ] : null : null;
    },
    hasBody(l) {
      return l && l.__isVue;
    },
    body(l) {
      if (l && l.__isVue)
        return [
          "div",
          {},
          ...o(l.$)
        ];
    }
  };
  function o(l) {
    const v = [];
    l.type.props && l.props && v.push(a("props", Ie(l.props))), l.setupState !== fn && v.push(a("setup", l.setupState)), l.data !== fn && v.push(a("data", Ie(l.data)));
    const d = c(l, "computed");
    d && v.push(a("computed", d));
    const h = c(l, "inject");
    return h && v.push(a("injected", h)), v.push([
      "div",
      {},
      [
        "span",
        {
          style: r.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: l }]
    ]), v;
  }
  function a(l, v) {
    return v = rn({}, v), Object.keys(v).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        l
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(v).map((d) => [
          "div",
          {},
          ["span", r, d + ": "],
          s(v[d], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function s(l, v = !0) {
    return typeof l == "number" ? ["span", t, l] : typeof l == "string" ? ["span", n, JSON.stringify(l)] : typeof l == "boolean" ? ["span", r, l] : Gt(l) ? ["object", { object: v ? Ie(l) : l }] : ["span", n, String(l)];
  }
  function c(l, v) {
    const d = l.type;
    if (Et(d))
      return;
    const h = {};
    for (const _ in l.ctx)
      u(d, _, v) && (h[_] = l.ctx[_]);
    return h;
  }
  function u(l, v, d) {
    const h = l[d];
    if (qe(h) && h.includes(v) || Gt(h) && v in h || l.extends && u(l.extends, v, d) || l.mixins && l.mixins.some((_) => u(_, v, d)))
      return !0;
  }
  function f(l) {
    return Kt(l) ? "ShallowRef" : l.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* vue v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function sT() {
  aT();
}
process.env.NODE_ENV !== "production" && sT();
const tt = Symbol.for("AppSettingsData"), Rs = Symbol.for("AppSettingsVersion"), Ps = Symbol.for("AppSettingsLaunchMode");
function cT() {
  window[tt] ?? (window[tt] = cl(null)), window[Rs] ?? (window[Rs] = cl("")), window[Ps] ?? (window[Ps] = cl("DevelopSession"));
}
async function uT(e) {
  cT(), window[tt].value = await e.settingsResolver(), window[Rs].value = await e.versionResolver(), window[Ps].value = await e.launchModeResolver();
}
function cP() {
  return {
    setupAppSettings: uT
  };
}
function fT() {
  return {
    channel: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.channel) ?? null;
    }),
    environment: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.environment) ?? null;
    }),
    cloudBackendUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.cloudBackendUrl) ?? null;
    }),
    localBackendUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.localBackendUrl) ?? null;
    }),
    localCA: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.localCA) ?? null;
    }),
    appInsightsConnString: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.appInsightsConnString) ?? null;
    }),
    accountPageUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.accountPageUrl) ?? null;
    }),
    helpSiteUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.helpSiteUrl) ?? null;
    }),
    bowlerUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.bowlerUrl) ?? null;
    }),
    bowlerUrlBeta: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.bowlerUrlBeta) ?? null;
    }),
    bowlerBlobFontUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.bowlerBlobFontUrl) ?? null;
    }),
    qportalUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.qportalUrl) ?? null;
    }),
    qportalUrlBeta: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.qportalUrlBeta) ?? null;
    }),
    qdeskUrl: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.qdeskUrl) ?? null;
    }),
    qdeskUrlBeta: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.qdeskUrlBeta) ?? null;
    }),
    adb2cAuth: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.adb2cAuth) ?? null;
    }),
    oidcAuth: Ke(() => {
      var e;
      return ((e = window[tt].value) == null ? void 0 : e.oidcAuth) ?? null;
    })
  };
}
function lT() {
  return {
    version: Ke(() => window[Rs].value),
    launchMode: Ke(() => window[Ps].value),
    ...fT()
  };
}
function uP() {
  const e = "en-US", t = {
    is24h: !1,
    timeSep: ":",
    textDirection: "ltr"
  };
  let n = {}, r = "", i = { ...t }, o = (f) => Promise.resolve({}), a = (f, l) => "", s = null;
  const c = /* @__PURE__ */ new Map();
  async function u(f) {
    const l = c.get(f);
    if (l) return Promise.resolve(l);
    let v = await o(f);
    "default" in v && (v = v.default), c.set(f, v);
  }
  return function() {
    return {
      setup(l) {
        n = l.languages, o = l.languageFetcher, a = l.translateKeyResolver, s = l.rootElement ?? null;
      },
      async setLanguage(l) {
        const v = n ? Object.keys(n) : [], _ = v.includes(l) ? l : (() => {
          const E = l.split("-");
          return v.find((O) => O.split("-")[0] === E[0]);
        })() ?? e, m = n[_] ?? t;
        await u(_), s == null || s.setAttribute("lang", _), s == null || s.setAttribute("dir", m.textDirection), r = _, i = m;
      },
      getIsoCode() {
        return r ?? e;
      },
      getLanguage() {
        return i ?? t;
      },
      translateKey(l, v) {
        if (!l) return "";
        const d = a(c.get(r), l);
        if (!d) return "";
        if (!v) return d;
        const h = /{{[a-zA-Z0-9]+}}/gm, _ = d.matchAll(h);
        let m = String(d);
        for (const E of _) {
          const y = E[0];
          m = m.replace(y, y.toLowerCase());
        }
        for (const E in v)
          m = m.replace(`{{${E.toLowerCase()}}}`, v[E]);
        return m;
      }
    };
  };
}
const dT = Symbol.for("module-definitions"), Fo = Symbol.for("registered-modules");
async function fP(e, t) {
  window[Fo] ?? (window[Fo] = /* @__PURE__ */ new Map());
  const n = "default" in t ? t.default : t;
  if (window[Fo].has(t.id)) return;
  let r = n.setup(e);
  r instanceof Promise && (r = await r), typeof r.component == "function" && r.component.prototype instanceof HTMLElement && customElements.define(`qamf-${n.id}`, r.component), window[Fo].set(n.id, r);
}
function lP(e) {
  return window[Fo].get(e);
}
async function dP(e, t) {
  return await new Promise((n, r) => {
    const i = document.createElement("script");
    i.src = t, i.type = "module", i.addEventListener("load", n), i.addEventListener("error", r), document.head.append(i);
  }).catch(() => {
    throw new Error(`Failed to load module "${e}" from "${t}"`);
  }), window[dT].get(e);
}
var vT = void 0, mh = null, hT = "", _T = "function", pT = "number", gT = "object", fE = "prototype", Rc = "undefined", lE = "call", wh = Object, dE = wh[fE];
function ET(e, t) {
  var n = t;
  try {
    n = e();
  } catch {
  }
  return n;
}
// @__NO_SIDE_EFFECTS__
function ST(e) {
  return function(t) {
    return typeof t === e;
  };
}
// @__NO_SIDE_EFFECTS__
function mT(e) {
  var t = "[object " + e + "]";
  return function(n) {
    return !!(n && /* @__PURE__ */ vE(n) === t);
  };
}
// @__NO_SIDE_EFFECTS__
function vE(e) {
  return dE.toString[lE](e);
}
var wT = /* @__PURE__ */ ST(pT), yT = /* @__PURE__ */ mT("Error");
// @__NO_SIDE_EFFECTS__
function _r(e, t) {
  return e && dE.hasOwnProperty[lE](e, t);
}
function TT(e) {
  throw new TypeError(e);
}
var k_ = "__tsUtils$gblCfg", vl;
// @__NO_SIDE_EFFECTS__
function hE() {
  var e;
  return typeof globalThis !== Rc && (e = globalThis), !e && typeof self !== Rc && (e = self), !e && typeof window !== Rc && (e = window), !e && typeof global !== Rc && (e = global), e;
}
// @__NO_SIDE_EFFECTS__
function bT() {
  if (!vl) {
    var e = /* @__PURE__ */ hE() || {};
    vl = e[k_] = e[k_] || {};
  }
  return vl;
}
// @__NO_SIDE_EFFECTS__
function _E(e, t) {
  var n = hT;
  if (yT(e))
    n = "{ stack: '" + e.stack + "', message: '" + e.message + "', name: '" + e.name + "'";
  else
    try {
      n = JSON.stringify(e, mh, t ? wT(t) ? t : 4 : vT);
    } catch (r) {
      n = " - " + /* @__PURE__ */ _E(r, t);
    }
  return /* @__PURE__ */ vE(e) + ": " + n;
}
var x_ = wh.defineProperty, $r, ev = function() {
  $r = /* @__PURE__ */ bT(), ev = mh;
};
function CT(e) {
  var t = {};
  return ev && ev(), t.b = $r.lzy, x_(t, "v", {
    configurable: !0,
    get: function() {
      var n = e();
      return $r.lzy || (x_(t, "v", {
        value: n
      }), t.b && delete t.b), $r.lzy && t.b !== $r.lzy && (t.b = $r.lzy), n;
    }
  }), t;
}
function NT(e, t) {
  return CT(function() {
    return ET(e, t);
  });
}
var Pc;
// @__NO_SIDE_EFFECTS__
function IT(e) {
  return (!Pc || e === !1 || $r && $r.lzy && !Pc.b) && (Pc = NT(hE, mh)), Pc.v;
}
var ba = wh.create || DT;
// @__NO_SIDE_EFFECTS__
function DT(e) {
  if (!e)
    return {};
  var t = typeof e;
  if (t !== gT && t !== _T)
    throw new TypeError("Prototype must be an Object or function: " + /* @__PURE__ */ _E(e));
  function n() {
  }
  return n[fE] = e, new n();
}
var Ac, xu = "constructor", pr = "prototype", Lu = "function", Mu = "_dynInstFuncs", tv = "_isDynProxy", ua = "_dynClass", RT = "_dynCls$", nv = "_dynInstChk", Gs = nv, pE = "_dfOpts", L_ = "_unknown_", yh = "__proto__", Oc = "_dyn" + yh, M_ = "__dynProto$Gbl", hl = "_dynInstProto", uu = "useBaseInst", rv = "setInstFuncs", Th = Object, Ks = Th.getPrototypeOf, U_ = Th.getOwnPropertyNames, $_ = /* @__PURE__ */ IT(), iv = $_[M_] || ($_[M_] = {
  o: (Ac = {}, Ac[rv] = !0, Ac[uu] = !0, Ac),
  n: 1e3
  // Start new global index @ 1000 so we "fix" some cases when mixed with 1.1.6 or earlier
});
function fu(e) {
  return e && (e === Th[pr] || e === Array[pr]);
}
function bh(e) {
  return fu(e) || e === Function[pr];
}
function to(e) {
  var t;
  if (e) {
    if (Ks)
      return Ks(e);
    var n = e[yh] || e[pr] || (e[xu] ? e[xu][pr] : null);
    t = e[Oc] || n, /* @__PURE__ */ _r(e, Oc) || (delete e[hl], t = e[Oc] = e[hl] || e[Oc], e[hl] = n);
  }
  return t;
}
function Uu(e, t) {
  var n = [];
  if (U_)
    n = U_(e);
  else
    for (var r in e)
      typeof r == "string" && /* @__PURE__ */ _r(e, r) && n.push(r);
  if (n && n.length > 0)
    for (var i = 0; i < n.length; i++)
      t(n[i]);
}
function Ch(e, t, n) {
  return t !== xu && typeof e[t] === Lu && (n || /* @__PURE__ */ _r(e, t)) && t !== yh && t !== pr;
}
function $u(e) {
  TT("DynamicProto: " + e);
}
function PT(e) {
  var t = ba(null);
  return Uu(e, function(n) {
    !t[n] && Ch(e, n, !1) && (t[n] = e[n]);
  }), t;
}
function Nh(e, t) {
  for (var n = e.length - 1; n >= 0; n--)
    if (e[n] === t)
      return !0;
  return !1;
}
function AT(e, t, n, r) {
  function i(c, u, f) {
    var l = u[f];
    if (l[tv] && r) {
      var v = c[Mu] || {};
      v[Gs] !== !1 && (l = (v[u[ua]] || {})[f] || l);
    }
    return function() {
      return l.apply(c, arguments);
    };
  }
  var o = ba(null);
  Uu(n, function(c) {
    o[c] = i(t, n, c);
  });
  for (var a = to(e), s = []; a && !bh(a) && !Nh(s, a); )
    Uu(a, function(c) {
      !o[c] && Ch(a, c, !Ks) && (o[c] = i(t, a, c));
    }), s.push(a), a = to(a);
  return o;
}
function OT(e, t, n, r) {
  var i = null;
  if (e && /* @__PURE__ */ _r(n, ua)) {
    var o = e[Mu] || ba(null);
    if (i = (o[n[ua]] || ba(null))[t], i || $u("Missing [" + t + "] " + Lu), !i[nv] && o[Gs] !== !1) {
      for (var a = !/* @__PURE__ */ _r(e, t), s = to(e), c = []; a && s && !bh(s) && !Nh(c, s); ) {
        var u = s[t];
        if (u) {
          a = u === r;
          break;
        }
        c.push(s), s = to(s);
      }
      try {
        a && (e[t] = i), i[nv] = 1;
      } catch {
        o[Gs] = !1;
      }
    }
  }
  return i;
}
function kT(e, t, n) {
  var r = t[e];
  return r === n && (r = to(t)[e]), typeof r !== Lu && $u("[" + e + "] is not a " + Lu), r;
}
function xT(e, t, n, r, i) {
  function o(c, u) {
    var f = function() {
      var l = OT(this, u, c, f) || kT(u, c, f);
      return l.apply(this, arguments);
    };
    return f[tv] = 1, f;
  }
  if (!fu(e)) {
    var a = n[Mu] = n[Mu] || ba(null);
    if (!fu(a)) {
      var s = a[t] = a[t] || ba(null);
      a[Gs] !== !1 && (a[Gs] = !!i), fu(s) || Uu(n, function(c) {
        Ch(n, c, !1) && n[c] !== r[c] && (s[c] = n[c], delete n[c], (!/* @__PURE__ */ _r(e, c) || e[c] && !e[c][tv]) && (e[c] = o(e, c)));
      });
    }
  }
}
function LT(e, t) {
  if (Ks) {
    for (var n = [], r = to(t); r && !bh(r) && !Nh(n, r); ) {
      if (r === e)
        return !0;
      n.push(r), r = to(r);
    }
    return !1;
  }
  return !0;
}
function _l(e, t) {
  return /* @__PURE__ */ _r(e, pr) ? e.name || t || L_ : ((e || {})[xu] || {}).name || t || L_;
}
function Be(e, t, n, r) {
  /* @__PURE__ */ _r(e, pr) || $u("theClass is an invalid class definition.");
  var i = e[pr];
  LT(i, t) || $u("[" + _l(e) + "] not in hierarchy of [" + _l(t) + "]");
  var o = null;
  /* @__PURE__ */ _r(i, ua) ? o = i[ua] : (o = RT + _l(e, "_") + "$" + iv.n, iv.n++, i[ua] = o);
  var a = Be[pE], s = !!a[uu];
  s && r && r[uu] !== void 0 && (s = !!r[uu]);
  var c = PT(t), u = AT(i, t, c, s);
  n(t, u);
  var f = !!Ks && !!a[rv];
  f && r && (f = !!r[rv]), xT(i, o, t, c, f !== !1);
}
Be[pE] = iv.o;
var gE = "function", EE = "object", Ih = "undefined", Vn = "prototype", Dh = Object, MT = Dh[Vn], UT = void 0, Rh = null, $T = "", FT = "function", HT = "number", YT = "object", SE = "prototype", kc = "undefined", VT = "call", Lf = Object, BT = Lf[SE];
function zT(e, t) {
  var n = t;
  try {
    n = e();
  } catch {
  }
  return n;
}
// @__NO_SIDE_EFFECTS__
function GT(e) {
  return function(t) {
    return typeof t === e;
  };
}
// @__NO_SIDE_EFFECTS__
function KT(e) {
  var t = "[object " + e + "]";
  return function(n) {
    return !!(n && /* @__PURE__ */ mE(n) === t);
  };
}
// @__NO_SIDE_EFFECTS__
function mE(e) {
  return BT.toString[VT](e);
}
var WT = /* @__PURE__ */ GT(HT), qT = /* @__PURE__ */ KT("Error");
function jT(e) {
  throw new TypeError(e);
}
var ov = Lf.assign, F_ = "__tsUtils$gblCfg", pl;
// @__NO_SIDE_EFFECTS__
function wE() {
  var e;
  return typeof globalThis !== kc && (e = globalThis), !e && typeof self !== kc && (e = self), !e && typeof window !== kc && (e = window), !e && typeof global !== kc && (e = global), e;
}
// @__NO_SIDE_EFFECTS__
function XT() {
  if (!pl) {
    var e = /* @__PURE__ */ wE() || {};
    pl = e[F_] = e[F_] || {};
  }
  return pl;
}
// @__NO_SIDE_EFFECTS__
function yE(e, t) {
  var n = $T;
  if (qT(e))
    n = "{ stack: '" + e.stack + "', message: '" + e.message + "', name: '" + e.name + "'";
  else
    try {
      n = JSON.stringify(e, Rh, t ? WT(t) ? t : 4 : UT);
    } catch (r) {
      n = " - " + /* @__PURE__ */ yE(r, t);
    }
  return /* @__PURE__ */ mE(e) + ": " + n;
}
var H_ = Lf.defineProperty, Fr, av = function() {
  Fr = /* @__PURE__ */ XT(), av = Rh;
};
function JT(e) {
  var t = {};
  return av && av(), t.b = Fr.lzy, H_(t, "v", {
    configurable: !0,
    get: function() {
      var n = e();
      return Fr.lzy || (H_(t, "v", {
        value: n
      }), t.b && delete t.b), Fr.lzy && t.b !== Fr.lzy && (t.b = Fr.lzy), n;
    }
  }), t;
}
function QT(e, t) {
  return JT(function() {
    return zT(e, t);
  });
}
var xc;
// @__NO_SIDE_EFFECTS__
function or(e) {
  return (!xc || e === !1 || Fr && Fr.lzy && !xc.b) && (xc = QT(wE, Rh)), xc.v;
}
var ZT = Lf.create || e0;
// @__NO_SIDE_EFFECTS__
function e0(e) {
  if (!e)
    return {};
  var t = typeof e;
  if (t !== YT && t !== FT)
    throw new TypeError("Prototype must be an Object or function: " + /* @__PURE__ */ yE(e));
  function n() {
  }
  return n[SE] = e, new n();
}
(/* @__PURE__ */ or() || {}).Symbol;
(/* @__PURE__ */ or() || {}).Reflect;
var TE = "hasOwnProperty", t0 = function(e) {
  for (var t, n = 1, r = arguments.length; n < r; n++) {
    t = arguments[n];
    for (var i in t)
      MT[TE].call(t, i) && (e[i] = t[i]);
  }
  return e;
}, Mt = ov || t0, sv = function(e, t) {
  return sv = Dh.setPrototypeOf || // tslint:disable-next-line: only-arrow-functions
  { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || // tslint:disable-next-line: only-arrow-functions
  function(n, r) {
    for (var i in r)
      r[TE](i) && (n[i] = r[i]);
  }, sv(e, t);
};
function yr(e, t) {
  typeof t !== gE && t !== null && jT("Class extends value " + String(t) + " is not a constructor or null"), sv(e, t);
  function n() {
    this.constructor = e;
  }
  e[Vn] = t === null ? ZT(t) : (n[Vn] = t[Vn], new n());
}
function Y_(e, t) {
  for (var n = 0, r = t.length, i = e.length; n < r; n++, i++)
    e[i] = t[n];
  return e;
}
/*! https://github.com/nevware21/ts-utils v0.11.8 */
// @__NO_SIDE_EFFECTS__
function Tr(e, t) {
  return e || t;
}
// @__NO_SIDE_EFFECTS__
function Pt(e, t) {
  return e[t];
}
var zt = void 0, vt = null, Ph = "", Mf = "function", vc = "object", ar = "prototype", cv = "__proto__", ki = "undefined", Fu = "constructor", Ah = "Symbol", n0 = "_polyfill", fa = "length", Hu = "name", bt = "call", Uf = "toString", Jn = /* @__PURE__ */ Tr(Object), Oh = /* @__PURE__ */ Pt(Jn, ar), bE = /* @__PURE__ */ Tr(String), uo = /* @__PURE__ */ Pt(bE, ar), $f = /* @__PURE__ */ Tr(Math), CE = /* @__PURE__ */ Tr(Array), Ff = /* @__PURE__ */ Pt(CE, ar), gr = /* @__PURE__ */ Pt(Ff, "slice");
function Wt(e, t) {
  try {
    return {
      v: e.apply(this, t)
    };
  } catch (n) {
    return { e: n };
  }
}
// @__NO_SIDE_EFFECTS__
function r0(e, t) {
  var n = Wt(e);
  return n.e ? t : n.v;
}
var gl;
// @__NO_SIDE_EFFECTS__
function Hf(e) {
  return function(t) {
    return typeof t === e;
  };
}
// @__NO_SIDE_EFFECTS__
function NE(e) {
  var t = "[object " + e + "]";
  return function(n) {
    return !!(n && /* @__PURE__ */ i0(n) === t);
  };
}
// @__NO_SIDE_EFFECTS__
function i0(e) {
  return Oh[Uf].call(e);
}
// @__NO_SIDE_EFFECTS__
function Je(e) {
  return typeof e === ki || e === ki;
}
// @__NO_SIDE_EFFECTS__
function o0(e) {
  return !/* @__PURE__ */ kh(e);
}
// @__NO_SIDE_EFFECTS__
function Y(e) {
  return e === vt || /* @__PURE__ */ Je(e);
}
// @__NO_SIDE_EFFECTS__
function a0(e) {
  return e === vt || !/* @__PURE__ */ kh(e);
}
// @__NO_SIDE_EFFECTS__
function kh(e) {
  return !!e || e !== zt;
}
// @__NO_SIDE_EFFECTS__
function s0(e) {
  return !gl && (gl = ["string", "number", "boolean", ki, "symbol", "bigint"]), e !== vc && gl.indexOf(e) !== -1;
}
var ce = /* @__PURE__ */ Hf("string"), ye = /* @__PURE__ */ Hf(Mf);
// @__NO_SIDE_EFFECTS__
function qt(e) {
  return !e && /* @__PURE__ */ Y(e) ? !1 : !!e && typeof e === vc;
}
var Te = /* @__PURE__ */ Pt(CE, "isArray"), c0 = /* @__PURE__ */ NE("Date"), Yf = /* @__PURE__ */ Hf("number"), IE = /* @__PURE__ */ Hf("boolean"), xh = /* @__PURE__ */ NE("Error");
// @__NO_SIDE_EFFECTS__
function Ws(e) {
  return !!(e && e.then && ye(e.then));
}
// @__NO_SIDE_EFFECTS__
function Yu(e) {
  return !(!e || /* @__PURE__ */ r0(function() {
    return !(e && 0 + e);
  }, !e));
}
var Lh = /* @__PURE__ */ Pt(Jn, "getOwnPropertyDescriptor");
// @__NO_SIDE_EFFECTS__
function Mh(e, t) {
  return !!e && Oh.hasOwnProperty[bt](e, t);
}
var Xr = /* @__PURE__ */ Tr(/* @__PURE__ */ Pt(Jn, "hasOwn"), u0);
// @__NO_SIDE_EFFECTS__
function u0(e, t) {
  return /* @__PURE__ */ Mh(e, t) || !!Lh(e, t);
}
function Ne(e, t, n) {
  if (e && /* @__PURE__ */ qt(e)) {
    for (var r in e)
      if (Xr(e, r) && t[bt](e, r, e[r]) === -1)
        break;
  }
}
var Lc = {
  e: "enumerable",
  c: "configurable",
  v: "value",
  w: "writable",
  g: "get",
  s: "set"
};
// @__NO_SIDE_EFFECTS__
function f0(e) {
  var t = {};
  if (t[Lc.c] = !0, t[Lc.e] = !0, e.l) {
    t.get = function() {
      return e.l.v;
    };
    var n = Lh(e.l, "v");
    n && n.set && (t.set = function(r) {
      e.l.v = r;
    });
  }
  return Ne(e, function(r, i) {
    t[Lc[r]] = /* @__PURE__ */ o0(i) ? t[Lc[r]] : i;
  }), t;
}
var no = /* @__PURE__ */ Pt(Jn, "defineProperty");
function Le(e, t, n) {
  return no(e, t, /* @__PURE__ */ f0(n));
}
// @__NO_SIDE_EFFECTS__
function DE(e, t, n, r, i) {
  var o = {};
  return Ne(e, function(a, s) {
    Vu(o, a, t ? s : a), Vu(o, s, a);
  }), r ? r(o) : o;
}
function Vu(e, t, n, r) {
  no(e, t, {
    value: n,
    enumerable: !0,
    writable: !1
  });
}
var Ut = /* @__PURE__ */ Tr(bE), l0 = "[object Error]";
// @__NO_SIDE_EFFECTS__
function Q(e, t) {
  var n = Ph, r = Oh[Uf][bt](e);
  r === l0 && (e = { stack: Ut(e.stack), message: Ut(e.message), name: Ut(e.name) });
  try {
    n = JSON.stringify(e, vt, t ? typeof t == "number" ? t : 4 : zt), n = (n ? n.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : vt) || Ut(e);
  } catch (i) {
    n = " - " + /* @__PURE__ */ Q(i, t);
  }
  return r + ": " + n;
}
function Qt(e) {
  throw new Error(e);
}
function ka(e) {
  throw new TypeError(e);
}
var RE = /* @__PURE__ */ Pt(Jn, "freeze");
function d0(e) {
  return e;
}
// @__NO_SIDE_EFFECTS__
function v0(e) {
  return e[cv] || vt;
}
var sr = /* @__PURE__ */ Pt(Jn, "keys");
function xa(e) {
  return RE && Ne(e, function(t, n) {
    (Te(n) || /* @__PURE__ */ qt(n)) && xa(n);
  }), In(e);
}
var In = /* @__PURE__ */ Tr(RE, d0), uv = /* @__PURE__ */ Tr(/* @__PURE__ */ Pt(Jn, "getPrototypeOf"), v0);
// @__NO_SIDE_EFFECTS__
function h0(e) {
  return /* @__PURE__ */ DE(e, 1, 0, In);
}
// @__NO_SIDE_EFFECTS__
function _0(e) {
  return /* @__PURE__ */ DE(e, 0, 0, In);
}
// @__NO_SIDE_EFFECTS__
function p0(e) {
  var t = {};
  return Ne(e, function(n, r) {
    Vu(t, n, r[1]), Vu(t, r[0], r[1]);
  }), In(t);
}
// @__NO_SIDE_EFFECTS__
function g0(e) {
  return /* @__PURE__ */ p0(e);
}
var PE = /* @__PURE__ */ _0({
  asyncIterator: 0,
  hasInstance: 1,
  isConcatSpreadable: 2,
  iterator: 3,
  match: 4,
  matchAll: 5,
  replace: 6,
  search: 7,
  species: 8,
  split: 9,
  toPrimitive: 10,
  toStringTag: 11,
  unscopables: 12
}), V_ = "__tsUtils$gblCfg", El;
// @__NO_SIDE_EFFECTS__
function AE() {
  var e;
  return typeof globalThis !== ki && (e = globalThis), !e && typeof self !== ki && (e = self), !e && typeof window !== ki && (e = window), !e && typeof global !== ki && (e = global), e;
}
// @__NO_SIDE_EFFECTS__
function OE() {
  if (!El) {
    var e = Wt(AE).v || {};
    El = e[V_] = e[V_] || {};
  }
  return El;
}
var fo = Vf;
// @__NO_SIDE_EFFECTS__
function Vf(e, t, n) {
  var r = t ? t[e] : vt;
  return function(i) {
    var o = (i ? i[e] : vt) || r;
    if (o || n) {
      var a = arguments;
      return (o || n).apply(i, o ? gr[bt](a, 1) : a);
    }
    ka('"' + Ut(e) + '" not defined for ' + /* @__PURE__ */ Q(i));
  };
}
// @__NO_SIDE_EFFECTS__
function E0(e) {
  return function(t) {
    return t[e];
  };
}
var kE = /* @__PURE__ */ Pt($f, "min"), As = /* @__PURE__ */ Pt($f, "max"), B_ = /* @__PURE__ */ fo("slice", uo), Qn = /* @__PURE__ */ fo("substring", uo), Hr = /* @__PURE__ */ Vf("substr", uo, S0);
// @__NO_SIDE_EFFECTS__
function S0(e, t, n) {
  return /* @__PURE__ */ Y(e) && ka("Invalid " + /* @__PURE__ */ Q(e)), n < 0 ? Ph : (t = t || 0, t < 0 && (t = As(t + e[fa], 0)), /* @__PURE__ */ Je(n) ? B_(e, t) : B_(e, t, t + n));
}
// @__NO_SIDE_EFFECTS__
function Uh(e, t) {
  return Qn(e, 0, t);
}
var z_ = "_urid", Sl;
// @__NO_SIDE_EFFECTS__
function m0() {
  if (!Sl) {
    var e = /* @__PURE__ */ OE();
    Sl = e.gblSym = e.gblSym || { k: {}, s: {} };
  }
  return Sl;
}
var Mc;
// @__NO_SIDE_EFFECTS__
function $h(e) {
  var t = {
    description: Ut(e),
    toString: function() {
      return Ah + "(" + e + ")";
    }
  };
  return t[n0] = !0, t;
}
// @__NO_SIDE_EFFECTS__
function w0(e) {
  var t = /* @__PURE__ */ m0();
  if (!Xr(t.k, e)) {
    var n = /* @__PURE__ */ $h(e), r = sr(t.s).length;
    n[z_] = function() {
      return r + "_" + n[Uf]();
    }, t.k[e] = n, t.s[n[z_]()] = Ut(e);
  }
  return t.k[e];
}
// @__NO_SIDE_EFFECTS__
function y0(e) {
  !Mc && (Mc = {});
  var t, n = PE[e];
  return n && (t = Mc[n] = Mc[n] || /* @__PURE__ */ $h(Ah + "." + n)), t;
}
var gt;
function lo() {
  gt = /* @__PURE__ */ OE();
}
// @__NO_SIDE_EFFECTS__
function T0(e) {
  var t = {};
  return !gt && lo(), t.b = gt.lzy, no(t, "v", {
    configurable: !0,
    get: function() {
      var n = e();
      return gt.lzy || no(t, "v", {
        value: n
      }), t.b = gt.lzy, n;
    }
  }), t;
}
// @__NO_SIDE_EFFECTS__
function vo(e) {
  return no({
    toJSON: function() {
      return e;
    }
  }, "v", { value: e });
}
var xE = "window", Os;
function hc(e, t) {
  var n;
  return function() {
    return !gt && lo(), (!n || gt.lzy) && (n = /* @__PURE__ */ vo(Wt(e, t).v)), n.v;
  };
}
function b0(e) {
  return !gt && lo(), (!Os || e === !1 || gt.lzy) && (Os = /* @__PURE__ */ vo(Wt(AE).v || vt)), Os.v;
}
// @__NO_SIDE_EFFECTS__
function ut(e, t) {
  var n;
  if (!Os || t === !1 ? n = b0(t) : n = Os.v, n && n[e])
    return n[e];
  if (e === xE)
    try {
      return window;
    } catch {
    }
  return vt;
}
// @__NO_SIDE_EFFECTS__
function LE() {
  return !!/* @__PURE__ */ Dt();
}
var Dt = /* @__PURE__ */ hc(ut, ["document"]);
// @__NO_SIDE_EFFECTS__
function Bf() {
  return !!/* @__PURE__ */ vn();
}
var vn = /* @__PURE__ */ hc(ut, [xE]);
// @__NO_SIDE_EFFECTS__
function C0() {
  return !!/* @__PURE__ */ Zn();
}
var Zn = /* @__PURE__ */ hc(ut, ["navigator"]);
// @__NO_SIDE_EFFECTS__
function N0() {
  return !!/* @__PURE__ */ ME();
}
var ME = /* @__PURE__ */ hc(ut, ["history"]), UE = /* @__PURE__ */ hc(function() {
  return !!Wt(function() {
    return self && self instanceof WorkerGlobalScope;
  }).v;
}), qs, ml;
// @__NO_SIDE_EFFECTS__
function Fh() {
  return qs = /* @__PURE__ */ vo(Wt(ut, [Ah]).v), qs;
}
function I0(e) {
  var t = (gt.lzy ? 0 : qs) || /* @__PURE__ */ Fh();
  return t.v ? t.v[e] : zt;
}
// @__NO_SIDE_EFFECTS__
function $E(e, t) {
  var n = PE[e];
  !gt && lo();
  var r = (gt.lzy ? 0 : qs) || /* @__PURE__ */ Fh();
  return r.v ? r.v[n || e] : t ? zt : /* @__PURE__ */ y0(e);
}
// @__NO_SIDE_EFFECTS__
function Ba(e, t) {
  !gt && lo();
  var n = (gt.lzy ? 0 : qs) || /* @__PURE__ */ Fh();
  return n.v ? n.v(e) : /* @__PURE__ */ $h(e);
}
// @__NO_SIDE_EFFECTS__
function Hh(e) {
  return !gt && lo(), ml = (gt.lzy ? 0 : ml) || /* @__PURE__ */ vo(Wt(I0, ["for"]).v), (ml.v || w0)(e);
}
// @__NO_SIDE_EFFECTS__
function fv(e) {
  return !!e && ye(e.next);
}
// @__NO_SIDE_EFFECTS__
function D0(e) {
  return !/* @__PURE__ */ a0(e) && ye(e[/* @__PURE__ */ $E(3)]);
}
var Uc;
function R0(e, t, n) {
  if (e && (/* @__PURE__ */ fv(e) || (!Uc && (Uc = /* @__PURE__ */ vo(/* @__PURE__ */ $E(3))), e = e[Uc.v] ? e[Uc.v]() : vt), /* @__PURE__ */ fv(e))) {
    var r = zt, i = zt;
    try {
      for (var o = 0; !(i = e.next()).done && t[bt](n || e, i.value, o, e) !== -1; )
        o++;
    } catch (a) {
      r = { e: a }, e.throw && (i = vt, e.throw(r));
    } finally {
      try {
        i && !i.done && e.return && e.return(i);
      } finally {
        if (r)
          throw r.e;
      }
    }
  }
}
function Qo(e, t, n) {
  return e.apply(t, n);
}
function Zo(e, t) {
  return !/* @__PURE__ */ Je(t) && e && (Te(t) ? Qo(e.push, e, t) : /* @__PURE__ */ fv(t) || /* @__PURE__ */ D0(t) ? R0(t, function(n) {
    e.push(n);
  }) : e.push(t)), e;
}
function J(e, t, n) {
  if (e)
    for (var r = e[fa] >>> 0, i = 0; i < r && !(i in e && t[bt](e, e[i], i, e) === -1); i++)
      ;
}
var Rt = /* @__PURE__ */ fo("indexOf", Ff), js = /* @__PURE__ */ fo("map", Ff);
function P0(e, t, n) {
  return ((e ? e.slice : vt) || gr).apply(e, gr[bt](arguments, 1));
}
var A0 = /* @__PURE__ */ fo("reduce", Ff), O0 = /* @__PURE__ */ Tr(/* @__PURE__ */ Pt(Jn, "create"), k0);
// @__NO_SIDE_EFFECTS__
function k0(e) {
  if (!e)
    return {};
  var t = typeof e;
  t !== vc && t !== Mf && ka("Prototype must be an Object or function: " + /* @__PURE__ */ Q(e));
  function n() {
  }
  return n[ar] = e, new n();
}
var wl;
function FE(e, t) {
  var n = Jn.setPrototypeOf || function(r, i) {
    var o;
    !wl && (wl = /* @__PURE__ */ vo((o = {}, o[cv] = [], o instanceof Array))), wl.v ? r[cv] = i : Ne(i, function(a, s) {
      return r[a] = s;
    });
  };
  return n(e, t);
}
// @__NO_SIDE_EFFECTS__
function x0(e, t, n) {
  Wt(Le, [t, Hu, { v: e, c: !0, e: !1 }]), t = FE(t, n);
  function r() {
    this[Fu] = t, Wt(Le, [this, Hu, { v: e, c: !0, e: !1 }]);
  }
  return t[ar] = n === vt ? O0(n) : (r[ar] = n[ar], new r()), t;
}
function G_(e, t) {
  t && (e[Hu] = t);
}
// @__NO_SIDE_EFFECTS__
function HE(e, t, n) {
  var r = Error, i = r[ar][Hu], o = Error.captureStackTrace;
  return /* @__PURE__ */ x0(e, function() {
    var a = this, s = arguments;
    try {
      Wt(G_, [r, e]);
      var c = Qo(r, a, gr[bt](s)) || a;
      if (c !== a) {
        var u = uv(a);
        u !== uv(c) && FE(c, u);
      }
      return o && o(c, a[Fu]), t && t(c, s), c;
    } finally {
      Wt(G_, [r, i]);
    }
  }, r);
}
var yl;
function L0(e) {
  throw yl || (yl = /* @__PURE__ */ HE("UnsupportedError")), new yl(e);
}
// @__NO_SIDE_EFFECTS__
function Kn() {
  return (Date.now || M0)();
}
// @__NO_SIDE_EFFECTS__
function M0() {
  return (/* @__PURE__ */ new Date()).getTime();
}
// @__NO_SIDE_EFFECTS__
function U0(e) {
  return function(n) {
    return /* @__PURE__ */ Y(n) && ka("strTrim called [" + /* @__PURE__ */ Q(n) + "]"), n && n.replace && (n = n.replace(e, Ph)), n;
  };
}
var $0 = /* @__PURE__ */ U0(/^\s+|(?=\s)\s+$/g), Ve = /* @__PURE__ */ Vf("trim", uo, $0), tn = /* @__PURE__ */ Pt($f, "floor"), Tl, bl, Cl;
// @__NO_SIDE_EFFECTS__
function $t(e) {
  if (!e || typeof e !== vc)
    return !1;
  Cl || (Cl = /* @__PURE__ */ Bf() ? vn() : !0);
  var t = !1;
  if (e !== Cl) {
    bl || (Tl = Function[ar][Uf], bl = Tl[bt](Jn));
    try {
      var n = uv(e);
      t = !n, t || (/* @__PURE__ */ Mh(n, Fu) && (n = n[Fu]), t = !!(n && typeof n === Mf && Tl[bt](n) === bl));
    } catch {
    }
  }
  return t;
}
// @__NO_SIDE_EFFECTS__
function F0(e) {
  return e.value && VE(e), !0;
}
var K_ = [
  B0,
  VE,
  G0,
  z0
];
// @__NO_SIDE_EFFECTS__
function H0(e, t, n, r) {
  var i;
  return J(e, function(o) {
    if (o.k === t)
      return i = o, -1;
  }), i || (i = { k: t, v: t }, e.push(i), r(i)), i.v;
}
function Yh(e, t, n, r) {
  var i = n.handler, o = n.path ? r ? n.path.concat(r) : n.path : [], a = {
    handler: n.handler,
    src: n.src,
    path: o
  }, s = typeof t, c = !1, u = t === vt;
  u || (t && s === vc ? c = /* @__PURE__ */ $t(t) : u = /* @__PURE__ */ s0(s));
  var f = {
    type: s,
    isPrim: u,
    isPlain: c,
    value: t,
    result: t,
    path: o,
    origin: n.src,
    copy: function(l, v) {
      return Yh(e, l, v ? a : n, v);
    },
    copyTo: function(l, v) {
      return YE(e, l, v, a);
    }
  };
  return f.isPrim ? i && i[bt](n, f) ? f.result : t : /* @__PURE__ */ H0(e, t, o, function(l) {
    Le(f, "result", {
      g: function() {
        return l.v;
      },
      s: function(h) {
        l.v = h;
      }
    });
    for (var v = 0, d = i; !(d || (v < K_.length ? K_[v++] : F0))[bt](n, f); )
      d = vt;
  });
}
function YE(e, t, n, r) {
  if (!/* @__PURE__ */ Y(n))
    for (var i in n)
      t[i] = Yh(e, n[i], r, i);
  return t;
}
function Y0(e, t, n) {
  var r = {
    handler: n,
    src: t,
    path: []
  };
  return YE([], e, t, r);
}
// @__NO_SIDE_EFFECTS__
function V0(e, t) {
  var n = {
    handler: t,
    src: e
  };
  return Yh([], e, n);
}
function B0(e) {
  var t = e.value;
  if (Te(t)) {
    var n = e.result = [];
    return n.length = t.length, e.copyTo(n, t), !0;
  }
  return !1;
}
function z0(e) {
  var t = e.value;
  return c0(t) ? (e.result = new Date(t.getTime()), !0) : !1;
}
function G0(e) {
  return e.type === Mf;
}
function VE(e) {
  var t = e.value;
  if (t && e.isPlain) {
    var n = e.result = {};
    return e.copyTo(n, t), !0;
  }
  return !1;
}
function BE(e, t) {
  return J(t, function(n) {
    Y0(e, n);
  }), e;
}
function W_(e, t, n, r, i, o, a) {
  return BE(/* @__PURE__ */ V0(e) || {}, gr[bt](arguments));
}
function K0(e, t, n, r, i, o, a) {
  return BE(e || {}, gr[bt](arguments));
}
var W0 = /* @__PURE__ */ E0(fa), Nl;
// @__NO_SIDE_EFFECTS__
function Er() {
  return !gt && lo(), (!Nl || gt.lzy) && (Nl = /* @__PURE__ */ vo(Wt(ut, ["performance"]).v)), Nl.v;
}
var zE = /* @__PURE__ */ Pt($f, "round"), GE = /* @__PURE__ */ fo("split", uo);
function KE(e, t, n) {
  if (e && t) {
    var r = GE(t, "."), i = r.pop();
    J(r, function(o) {
      /* @__PURE__ */ Y(e[o]) && (e[o] = {}), e = e[o];
    }), e[i] = n;
  }
}
var WE = /* @__PURE__ */ Vf("endsWith", uo, q0);
// @__NO_SIDE_EFFECTS__
function q0(e, t, n) {
  ce(e) || ka("'" + /* @__PURE__ */ Q(e) + "' is not a string");
  var r = ce(t) ? t : Ut(t), i = !/* @__PURE__ */ Je(n) && n < e[fa] ? n : e[fa];
  return Qn(e, i - r[fa], i) === r;
}
var Ft = /* @__PURE__ */ fo("indexOf", uo), Il = "ref", Dl = "unref", Rl = "hasRef", j0 = "enabled";
// @__NO_SIDE_EFFECTS__
function X0(e, t, n) {
  var r = !0, i = e ? t(vt) : vt, o;
  function a() {
    return r = !1, i && i[Dl] && i[Dl](), o;
  }
  function s() {
    i && n(i), i = vt;
  }
  function c() {
    return i = t(i), r || a(), o;
  }
  function u(f) {
    !f && i && s(), f && !i && c();
  }
  return o = {
    cancel: s,
    refresh: c
  }, o[Rl] = function() {
    return i && i[Rl] ? i[Rl]() : r;
  }, o[Il] = function() {
    return r = !0, i && i[Il] && i[Il](), o;
  }, o[Dl] = a, o = no(o, j0, {
    get: function() {
      return !!i;
    },
    set: u
  }), {
    h: o,
    dn: function() {
      i = vt;
    }
  };
}
function qE(e, t, n) {
  var r = Te(t), i = r ? t.length : 0, o = (i > 0 ? t[0] : r ? zt : t) || setTimeout, a = (i > 1 ? t[1] : zt) || clearTimeout, s = n[0];
  n[0] = function() {
    c.dn(), Qo(s, zt, gr[bt](arguments));
  };
  var c = /* @__PURE__ */ X0(e, function(u) {
    if (u) {
      if (u.refresh)
        return u.refresh(), u;
      Qo(a, zt, [u]);
    }
    return Qo(o, zt, n);
  }, function(u) {
    Qo(a, zt, [u]);
  });
  return c.h;
}
function Wn(e, t) {
  return qE(!0, zt, gr[bt](arguments));
}
function J0(e, t) {
  return qE(!1, zt, gr[bt](arguments));
}
var jE = h0, Q0 = g0, Lr = jE({
  NONE: 0,
  PENDING: 3,
  INACTIVE: 1,
  ACTIVE: 2
  /* eActiveStatus.ACTIVE */
}), Ca = "toLowerCase", pe = "length", Bu = "warnToConsole", _c = "throwInternal", Vi = "watch", ro = "apply", Pe = "push", La = "splice", ot = "logger", ea = "cancel", pc = "initialize", Yr = "identifier", zu = "removeNotificationListener", Gu = "addNotificationListener", Fn = "isInitialized", ks = "value", $c = "getNotifyMgr", Xs = "getPlugin", io = "name", Lt = "processNext", XE = "getProcessTelContext", ta = "enabled", q_ = "stopPollingInternalLogs", oo = "unload", Fc = "onComplete", lv = "version", JE = "loggingLevelConsole", ao = "createNew", ir = "teardown", Ku = "messageId", Bi = "message", cr = "diagLog", Wu = "_doTeardown", Js = "update", Bn = "getNext", Qs = "setNextPlugin", dv = "userAgent", Na = "split", zi = "replace", Jr = "type", j_ = "evtName", hs = "status", X_ = "getAllResponseHeaders", vv = "isChildEvt", Ho = "data", la = "getCtx", xn = "setCtx", J_ = "itemsReceived", za = "urlString", Pl = "headers", Co = "timeout", hv = "traceFlags", Al = "getAttribute", Ol;
function Z0(e, t) {
  Ol || (Ol = /* @__PURE__ */ HE("AggregationError", function(r, i) {
    i[
      pe
      /* @min:%2elength */
    ] > 1 && (r.errors = i[1]);
  }));
  var n = e;
  throw J(t, function(r, i) {
    n += `
`.concat(i, " > ").concat(/* @__PURE__ */ Q(r));
  }), new Ol(n, t || []);
}
/*! https://github.com/nevware21/ts-utils v0.11.6 */
// @__NO_SIDE_EFFECTS__
function Ma(e, t) {
  return e || t;
}
// @__NO_SIDE_EFFECTS__
function si(e, t) {
  return e[t];
}
var mn = void 0, hn = null, eb = "", tb = "function", nb = "object", QE = "prototype", na = "undefined", Vh = "Symbol", rb = "_polyfill", ib = "length", ci = "call", ob = "toString", gc = /* @__PURE__ */ Ma(Object), ZE = /* @__PURE__ */ si(gc, QE), ab = /* @__PURE__ */ Ma(String), eS = /* @__PURE__ */ Ma(Array), sb = /* @__PURE__ */ si(eS, QE), qu = /* @__PURE__ */ si(sb, "slice");
function ui(e, t) {
  try {
    return {
      v: e.apply(this, t)
    };
  } catch (n) {
    return { e: n };
  }
}
// @__NO_SIDE_EFFECTS__
function tS(e) {
  return function(t) {
    return typeof t === e;
  };
}
// @__NO_SIDE_EFFECTS__
function nS(e) {
  return typeof e === na || e === na;
}
// @__NO_SIDE_EFFECTS__
function cb(e) {
  return !/* @__PURE__ */ rS(e);
}
// @__NO_SIDE_EFFECTS__
function ub(e) {
  return e === hn || /* @__PURE__ */ nS(e);
}
// @__NO_SIDE_EFFECTS__
function fb(e) {
  return e === hn || !/* @__PURE__ */ rS(e);
}
// @__NO_SIDE_EFFECTS__
function rS(e) {
  return !!e || e !== mn;
}
var Qr = /* @__PURE__ */ tS(tb);
// @__NO_SIDE_EFFECTS__
function lb(e) {
  return !e && /* @__PURE__ */ ub(e) ? !1 : !!e && typeof e === nb;
}
var iS = /* @__PURE__ */ si(eS, "isArray"), db = /* @__PURE__ */ tS("number");
// @__NO_SIDE_EFFECTS__
function _v(e) {
  return !!(e && e.then && Qr(e.then));
}
var oS = /* @__PURE__ */ si(gc, "getOwnPropertyDescriptor");
// @__NO_SIDE_EFFECTS__
function vb(e, t) {
  return !!e && ZE.hasOwnProperty[ci](e, t);
}
var hb = /* @__PURE__ */ Ma(/* @__PURE__ */ si(gc, "hasOwn"), _b);
// @__NO_SIDE_EFFECTS__
function _b(e, t) {
  return /* @__PURE__ */ vb(e, t) || !!oS(e, t);
}
function aS(e, t, n) {
  if (e && /* @__PURE__ */ lb(e)) {
    for (var r in e)
      if (hb(e, r) && t[ci](e, r, e[r]) === -1)
        break;
  }
}
var Hc = {
  e: "enumerable",
  c: "configurable",
  v: "value",
  w: "writable",
  g: "get",
  s: "set"
};
// @__NO_SIDE_EFFECTS__
function pb(e) {
  var t = {};
  if (t[Hc.c] = !0, t[Hc.e] = !0, e.l) {
    t.get = function() {
      return e.l.v;
    };
    var n = oS(e.l, "v");
    n && n.set && (t.set = function(r) {
      e.l.v = r;
    });
  }
  return aS(e, function(r, i) {
    t[Hc[r]] = /* @__PURE__ */ cb(i) ? t[Hc[r]] : i;
  }), t;
}
var Ua = /* @__PURE__ */ si(gc, "defineProperty");
function gb(e, t, n) {
  return Ua(e, t, /* @__PURE__ */ pb(n));
}
// @__NO_SIDE_EFFECTS__
function Eb(e, t, n, r, i) {
  var o = {};
  return aS(e, function(a, s) {
    Q_(o, a, a, i), Q_(o, s, a, i);
  }), r ? r(o) : o;
}
function Q_(e, t, n, r) {
  Ua(e, t, {
    value: n,
    enumerable: !0,
    writable: !!r
  });
}
var _s = /* @__PURE__ */ Ma(ab), Sb = "[object Error]";
// @__NO_SIDE_EFFECTS__
function zf(e, t) {
  var n = eb, r = ZE[ob][ci](e);
  r === Sb && (e = { stack: _s(e.stack), message: _s(e.message), name: _s(e.name) });
  try {
    n = JSON.stringify(e, hn, t ? typeof t == "number" ? t : 4 : mn), n = (n ? n.replace(/"(\w+)"\s*:\s{0,1}/g, "$1: ") : hn) || _s(e);
  } catch (i) {
    n = " - " + /* @__PURE__ */ zf(i, t);
  }
  return r + ": " + n;
}
function Bh(e) {
  throw new TypeError(e);
}
var mb = /* @__PURE__ */ si(gc, "freeze");
function wb(e) {
  return e;
}
var yb = /* @__PURE__ */ Ma(mb, wb);
// @__NO_SIDE_EFFECTS__
function Tb(e) {
  return /* @__PURE__ */ Eb(e, 0, 0, yb);
}
var sS = /* @__PURE__ */ Tb({
  asyncIterator: 0,
  hasInstance: 1,
  isConcatSpreadable: 2,
  iterator: 3,
  match: 4,
  matchAll: 5,
  replace: 6,
  search: 7,
  species: 8,
  split: 9,
  toPrimitive: 10,
  toStringTag: 11,
  unscopables: 12
}), Z_ = "__tsUtils$gblCfg", kl;
// @__NO_SIDE_EFFECTS__
function cS() {
  var e;
  return typeof globalThis !== na && (e = globalThis), !e && typeof self !== na && (e = self), !e && typeof window !== na && (e = window), !e && typeof global !== na && (e = global), e;
}
// @__NO_SIDE_EFFECTS__
function bb() {
  if (!kl) {
    var e = ui(cS).v || {};
    kl = e[Z_] = e[Z_] || {};
  }
  return kl;
}
var Yc;
// @__NO_SIDE_EFFECTS__
function Cb(e) {
  var t = {
    description: _s(e),
    toString: function() {
      return Vh + "(" + e + ")";
    }
  };
  return t[rb] = !0, t;
}
// @__NO_SIDE_EFFECTS__
function Nb(e) {
  !Yc && (Yc = {});
  var t, n = sS[e];
  return n && (t = Yc[n] = Yc[n] || /* @__PURE__ */ Cb(Vh + "." + n)), t;
}
var Sr;
function Gf() {
  Sr = /* @__PURE__ */ bb();
}
// @__NO_SIDE_EFFECTS__
function br(e) {
  return Ua({
    toJSON: function() {
      return e;
    }
  }, "v", { value: e });
}
var uS = "window", xs;
function zh(e, t) {
  var n;
  return function() {
    return !Sr && Gf(), (!n || Sr.lzy) && (n = /* @__PURE__ */ br(ui(e, t).v)), n.v;
  };
}
function fS(e) {
  return !Sr && Gf(), (!xs || e === !1 || Sr.lzy) && (xs = /* @__PURE__ */ br(ui(cS).v || hn)), xs.v;
}
// @__NO_SIDE_EFFECTS__
function $a(e, t) {
  var n;
  if (!xs || t === !1 ? n = fS(t) : n = xs.v, n && n[e])
    return n[e];
  if (e === uS)
    try {
      return window;
    } catch {
    }
  return hn;
}
var Ib = /* @__PURE__ */ zh($a, ["document"]), Db = /* @__PURE__ */ zh($a, [uS]), Rb = /* @__PURE__ */ zh(function() {
  return !!ui(function() {
    return process && (process.versions || {}).node;
  }).v;
}), ju;
// @__NO_SIDE_EFFECTS__
function lS() {
  return ju = /* @__PURE__ */ br(ui($a, [Vh]).v), ju;
}
// @__NO_SIDE_EFFECTS__
function Pb() {
  return !!/* @__PURE__ */ Ab();
}
// @__NO_SIDE_EFFECTS__
function Ab() {
  return !Sr && Gf(), ((Sr.lzy ? 0 : ju) || /* @__PURE__ */ lS()).v;
}
// @__NO_SIDE_EFFECTS__
function Gh(e, t) {
  var n = sS[e];
  !Sr && Gf();
  var r = (Sr.lzy ? 0 : ju) || /* @__PURE__ */ lS();
  return r.v ? r.v[n || e] : /* @__PURE__ */ Nb(e);
}
// @__NO_SIDE_EFFECTS__
function ep(e) {
  return !!e && Qr(e.next);
}
// @__NO_SIDE_EFFECTS__
function Ob(e) {
  return !/* @__PURE__ */ fb(e) && Qr(e[/* @__PURE__ */ Gh(3)]);
}
var Vc;
function dS(e, t, n) {
  if (e && (/* @__PURE__ */ ep(e) || (!Vc && (Vc = /* @__PURE__ */ br(/* @__PURE__ */ Gh(3))), e = e[Vc.v] ? e[Vc.v]() : hn), /* @__PURE__ */ ep(e))) {
    var r = mn, i = mn;
    try {
      for (var o = 0; !(i = e.next()).done && t[ci](n || e, i.value, o, e) !== -1; )
        o++;
    } catch (a) {
      r = { e: a }, e.throw && (i = hn, e.throw(r));
    } finally {
      try {
        i && !i.done && e.return && e.return(i);
      } finally {
        if (r)
          throw r.e;
      }
    }
  }
}
function Bc(e, t, n) {
  return e.apply(t, n);
}
function vS(e, t, n) {
  if (e)
    for (var r = e[ib] >>> 0, i = 0; i < r && !(i in e && t[ci](e, e[i], i, e) === -1); i++)
      ;
}
function Kh(e, t, n) {
  return ((e ? e.slice : hn) || qu).apply(e, qu[ci](arguments, 1));
}
var xl = "ref", Ll = "unref", Ml = "hasRef", kb = "enabled";
// @__NO_SIDE_EFFECTS__
function xb(e, t, n) {
  var r = !0, i = t(hn), o;
  function a() {
    return r = !1, i && i[Ll] && i[Ll](), o;
  }
  function s() {
    i && n(i), i = hn;
  }
  function c() {
    return i = t(i), r || a(), o;
  }
  function u(f) {
    !f && i && s(), f && !i && c();
  }
  return o = {
    cancel: s,
    refresh: c
  }, o[Ml] = function() {
    return i && i[Ml] ? i[Ml]() : r;
  }, o[xl] = function() {
    return r = !0, i && i[xl] && i[xl](), o;
  }, o[Ll] = a, o = Ua(o, kb, {
    get: function() {
      return !!i;
    },
    set: u
  }), {
    h: o,
    dn: function() {
      i = hn;
    }
  };
}
function Lb(e, t, n) {
  var r = iS(t), i = r ? t.length : 0, o = (i > 0 ? t[0] : r ? mn : t) || setTimeout, a = (i > 1 ? t[1] : mn) || clearTimeout, s = n[0];
  n[0] = function() {
    c.dn(), Bc(s, mn, qu[ci](arguments));
  };
  var c = /* @__PURE__ */ xb(e, function(u) {
    if (u) {
      if (u.refresh)
        return u.refresh(), u;
      Bc(a, mn, [u]);
    }
    return Bc(o, mn, n);
  }, function(u) {
    Bc(a, mn, [u]);
  });
  return c.h;
}
function hS(e, t) {
  return Lb(!0, mn, qu[ci](arguments));
}
/*!
 * NevWare21 Solutions LLC - ts-async, 0.5.4
 * https://github.com/nevware21/ts-async
 * Copyright (c) NevWare21 Solutions LLC and contributors. All rights reserved.
 * Licensed under the MIT license.
 */
var Xu = "Promise", Wh = "rejected";
function mr(e, t) {
  return _S(e, function(n) {
    return t ? t({
      status: "fulfilled",
      rejected: !1,
      value: n
    }) : n;
  }, function(n) {
    return t ? t({
      status: Wh,
      rejected: !0,
      reason: n
    }) : n;
  });
}
function _S(e, t, n, r) {
  var i = e;
  try {
    if (/* @__PURE__ */ _v(e))
      (t || n) && (i = e.then(t, n));
    else
      try {
        t && (i = t(e));
      } catch (o) {
        if (n)
          i = n(o);
        else
          throw o;
      }
  } finally {
  }
  return i;
}
var pS = [
  "pending",
  "resolving",
  "resolved",
  Wh
], tp = "dispatchEvent", zc;
function Mb(e) {
  var t;
  return e && e.createEvent && (t = e.createEvent("Event")), !!t && t.initEvent;
}
function Ub(e, t, n, r) {
  var i = Ib();
  !zc && (zc = /* @__PURE__ */ br(!!ui(Mb, [i]).v));
  var o = zc.v ? i.createEvent("Event") : r ? new Event(t) : {};
  if (n && n(o), zc.v && o.initEvent(t, !1, !0), o && e[tp])
    e[tp](o);
  else {
    var a = e["on" + t];
    if (a)
      a(o);
    else {
      var s = /* @__PURE__ */ $a("console");
      s && (s.error || s.log)(t, /* @__PURE__ */ zf(o));
    }
  }
}
var gS = "unhandledRejection", $b = gS.toLowerCase(), np = [], Fb = 0, Hb = 10, Ul;
function rp(e) {
  return Qr(e) ? e.toString() : /* @__PURE__ */ zf(e);
}
function ES(e, t, n) {
  var r = Kh(arguments, 3), i = 0, o = !1, a, s = [], c = Fb++, u = !1, f = null, l;
  function v(I, P) {
    try {
      np.push(c), u = !0, f && f.cancel(), f = null;
      var B = e(function(D, b) {
        s.push(function() {
          try {
            var F = i === 2 ? I : P, U = /* @__PURE__ */ nS(F) ? a : Qr(F) ? F(a) : F;
            /* @__PURE__ */ _v(U) ? U.then(D, b) : F ? D(U) : i === 3 ? b(U) : D(U);
          } catch (z) {
            b(z);
          }
        }), o && m();
      }, r);
      return B;
    } finally {
      np.pop();
    }
  }
  function d(I) {
    return v(void 0, I);
  }
  function h(I) {
    var P = I, B = I;
    return Qr(I) && (P = function(D) {
      return I && I(), D;
    }, B = function(D) {
      throw I && I(), D;
    }), v(P, B);
  }
  function _() {
    return pS[i];
  }
  function m() {
    if (s.length > 0) {
      var I = s.slice();
      s = [], u = !0, f && f.cancel(), f = null, t(I);
    }
  }
  function E(I, P) {
    return function(B) {
      if (i === P) {
        if (I === 2 && /* @__PURE__ */ _v(B)) {
          i = 1, B.then(E(2, 1), E(3, 1));
          return;
        }
        i = I, o = !0, a = B, m(), !u && I === 3 && !f && (f = hS(y, Hb));
      }
    };
  }
  function y() {
    if (!u)
      if (u = !0, Rb())
        process.emit(gS, a, l);
      else {
        var I = Db() || fS();
        !Ul && (Ul = /* @__PURE__ */ br(ui($a, [Xu + "RejectionEvent"]).v)), Ub(I, $b, function(P) {
          return gb(P, "promise", { g: function() {
            return l;
          } }), P.reason = a, P;
        }, !!Ul.v);
      }
  }
  l = {
    then: v,
    catch: d,
    finally: h
  }, Ua(l, "state", {
    get: _
  }), /* @__PURE__ */ Pb() && (l[/* @__PURE__ */ Gh(11)] = "IPromise");
  function O() {
    return "IPromise " + _() + (o ? " - " + rp(a) : "");
  }
  return l.toString = O, function() {
    Qr(n) || Bh(Xu + ": executor is not a function - " + rp(n));
    var P = E(3, 0);
    try {
      n.call(l, E(2, 0), P);
    } catch (B) {
      P(B);
    }
  }(), l;
}
// @__NO_SIDE_EFFECTS__
function Yb(e) {
  return function(t) {
    var n = Kh(arguments, 1);
    return e(function(r, i) {
      try {
        var o = [], a = 1;
        dS(t, function(s, c) {
          s && (a++, _S(s, function(u) {
            o[c] = u, --a === 0 && r(o);
          }, i));
        }), a--, a === 0 && r(o);
      } catch (s) {
        i(s);
      }
    }, n);
  };
}
// @__NO_SIDE_EFFECTS__
function Vb(e) {
  return /* @__PURE__ */ br(function(t) {
    var n = Kh(arguments, 1);
    return e(function(r, i) {
      var o = [], a = 1;
      function s(c, u) {
        a++, mr(c, function(f) {
          f.rejected ? o[u] = {
            status: Wh,
            reason: f.reason
          } : o[u] = {
            status: "fulfilled",
            value: f.value
          }, --a === 0 && r(o);
        });
      }
      try {
        iS(t) ? vS(t, s) : /* @__PURE__ */ Ob(t) ? dS(t, s) : Bh("Input is not an iterable"), a--, a === 0 && r(o);
      } catch (c) {
        i(c);
      }
    }, n);
  });
}
function SS(e) {
  vS(e, function(t) {
    try {
      t();
    } catch {
    }
  });
}
function Bb(e) {
  var t = db(e) ? e : 0;
  return function(n) {
    hS(function() {
      SS(n);
    }, t);
  };
}
function mS(e, t) {
  return ES(mS, Bb(t), e, t);
}
var $l;
function zb(e, t) {
  !$l && ($l = /* @__PURE__ */ br(ui($a, [Xu]).v || null));
  var n = $l.v;
  if (!n)
    return mS(e);
  Qr(e) || Bh(Xu + ": executor is not a function - " + /* @__PURE__ */ zf(e));
  var r = 0;
  function i() {
    return pS[r];
  }
  var o = new n(function(a, s) {
    function c(f) {
      r = 2, a(f);
    }
    function u(f) {
      r = 3, s(f);
    }
    e(c, u);
  });
  return Ua(o, "state", {
    get: i
  }), o;
}
var Fl;
function Ls(e) {
  return ES(Ls, SS, e);
}
function Gb(e, t) {
  return !Fl && (Fl = /* @__PURE__ */ Vb(Ls)), Fl.v(e, t);
}
var Hl;
function ii(e, t) {
  return !Hl && (Hl = /* @__PURE__ */ br(zb)), Hl.v.call(this, e, t);
}
var Kb = /* @__PURE__ */ Yb(ii), Un = void 0, De = "", Yo = "channels", ht = "core", pv = "createPerfMgr", gv = "disabled", da = "extensionConfig", Vo = "extensions", qn = "processTelemetry", Ju = "priority", lu = "eventsSent", Ms = "eventsDiscarded", du = "eventsSendRequest", xi = "perfEvent", Yl = "offlineEventsStored", Vl = "offlineBatchSent", Bl = "offlineBatchDrop", Qu = "getPerfMgr", Ev = "domain", zl = "path", Wb = "Not dynamic - ", qb = "getPrototypeOf", jb = /-([a-z])/g, Xb = /([^\w\d_$])/g, Jb = /^(\d+[\w\d_$])/, Qb = Object[qb];
function Gi(e) {
  return !/* @__PURE__ */ Y(e);
}
function Zu(e) {
  var t = e;
  return t && ce(t) && (t = t[
    zi
    /* @min:%2ereplace */
  ](jb, function(n, r) {
    return r.toUpperCase();
  }), t = t[
    zi
    /* @min:%2ereplace */
  ](Xb, "_"), t = t[
    zi
    /* @min:%2ereplace */
  ](Jb, function(n, r) {
    return "_" + r;
  })), t;
}
function Nt(e, t) {
  return e && t ? Ft(e, t) !== -1 : !1;
}
function Ia(e) {
  return e && e.toISOString() || "";
}
function xe(e) {
  return xh(e) ? e[
    io
    /* @min:%2ename */
  ] : De;
}
function Fe(e, t, n, r, i) {
  var o = n;
  return e && (o = e[t], o !== n && (!i || i(o)) && (!r || r(n)) && (o = n, e[t] = o)), o;
}
function kt(e, t, n) {
  var r;
  return e ? (r = e[t], !r && /* @__PURE__ */ Y(r) && (r = /* @__PURE__ */ Je(n) ? {} : n, e[t] = r)) : r = /* @__PURE__ */ Je(n) ? {} : n, r;
}
function wS(e, t) {
  var n = null, r = null;
  return ye(e) ? n = e : r = e, function() {
    var i = arguments;
    if (n && (r = n()), r)
      return r[t][
        ro
        /* @min:%2eapply */
      ](r, i);
  };
}
function Zb(e, t, n) {
  if (e && t && /* @__PURE__ */ qt(e) && /* @__PURE__ */ qt(t)) {
    var r = function(o) {
      if (ce(o)) {
        var a = t[o];
        ye(a) ? (!n || n(o, !0, t, e)) && (e[o] = wS(t, o)) : (!n || n(o, !1, t, e)) && (Xr(e, o) && delete e[o], Le(e, o, {
          g: function() {
            return t[o];
          },
          s: function(s) {
            t[o] = s;
          }
        }));
      }
    };
    for (var i in t)
      r(i);
  }
  return e;
}
function ef(e, t, n, r, i) {
  e && t && n && (e[t] = wS(n, r));
}
function ps(e, t, n, r) {
  return e && t && /* @__PURE__ */ qt(e) && Te(n) && J(n, function(i) {
    ce(i) && ef(e, i, t, i);
  }), e;
}
function eC(e) {
  return (
    /** @class */
    /* @__PURE__ */ function() {
      function t() {
        var n = this;
        e && Ne(e, function(r, i) {
          n[r] = i;
        });
      }
      return t;
    }()
  );
}
function yS(e) {
  return e && ov && (e = Dh(ov({}, e))), e;
}
function TS(e, t, n, r, i, o) {
  var a = arguments, s = a[0] || {}, c = a[
    pe
    /* @min:%2elength */
  ], u = !1, f = 1;
  for (c > 0 && IE(s) && (u = s, s = a[f] || {}, f++), /* @__PURE__ */ qt(s) || (s = {}); f < c; f++) {
    var l = a[f], v = Te(l), d = /* @__PURE__ */ qt(l);
    for (var h in l) {
      var _ = v && h in l || d && Xr(l, h);
      if (_) {
        var m = l[h], E = void 0;
        if (u && m && ((E = Te(m)) || /* @__PURE__ */ $t(m))) {
          var y = s[h];
          E ? Te(y) || (y = []) : /* @__PURE__ */ $t(y) || (y = {}), m = TS(u, y, m);
        }
        m !== void 0 && (s[h] = m);
      }
    }
  }
  return s;
}
function Gl(e, t) {
  var n = !1, r = t && t.featureOptIn && t.featureOptIn[e];
  if (e && r) {
    var i = r.mode;
    n = i == 3 || i == 1;
  }
  return n;
}
function tf(e) {
  try {
    return e.responseText;
  } catch {
  }
  return null;
}
function bS(e, t) {
  return e ? "XDomainRequest,Response:" + tf(e) || "" : t;
}
function nf(e, t) {
  return e ? "XMLHttpRequest,Status:" + e[
    hs
    /* @min:%2estatus */
  ] + ",Response:" + tf(e) || e.response || "" : t;
}
function ip(e, t) {
  return t && (Yf(t) ? e = [t].concat(e) : Te(t) && (e = t.concat(e))), e;
}
var tC = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation", op = "withCredentials", nC = "timeout";
function rC(e, t, n, r, i, o) {
  i === void 0 && (i = !1);
  function a(c, u, f) {
    try {
      c[u] = f;
    } catch {
    }
  }
  var s = new XMLHttpRequest();
  return a(s, tC, r), n && a(s, op, n), s.open(e, t, !i), n && a(s, op, n), !i && o && a(s, nC, o), s;
}
function iC(e) {
  var t = {};
  if (ce(e)) {
    var n = Ve(e)[
      Na
      /* @min:%2esplit */
    ](/[\r\n]+/);
    J(n, function(r) {
      if (r) {
        var i = r.indexOf(": ");
        if (i !== -1) {
          var o = Ve(r.substring(0, i))[
            Ca
            /* @min:%2etoLowerCase */
          ](), a = Ve(r.substring(i + 1));
          t[o] = a;
        } else
          t[Ve(r)] = 1;
      }
    });
  }
  return t;
}
function Kl(e, t, n) {
  if (!e[n] && t && t.getResponseHeader) {
    var r = t.getResponseHeader(n);
    r && (e[n] = Ve(r));
  }
  return e;
}
var oC = "kill-duration", aC = "kill-duration-seconds", sC = "time-delta-millis";
function Wl(e, t) {
  var n = {};
  return e[
    X_
    /* @min:%2egetAllResponseHeaders */
  ] ? n = iC(e[
    X_
    /* @min:%2egetAllResponseHeaders */
  ]()) : t && (n = Kl(n, e, sC), n = Kl(n, e, oC), n = Kl(n, e, aC)), n;
}
var cC = "documentMode", uC = "location", fC = "console", CS = "JSON", lC = "crypto", dC = "msCrypto", vC = "ReactNative", Sv = "msie", mv = "trident/", NS = "XMLHttpRequest", ql = null, jl = null, hC = !1, No = null, Xl = null;
function IS(e, t) {
  var n = !1;
  if (e) {
    try {
      if (n = t in e, !n) {
        var r = e[Vn];
        r && (n = t in r);
      }
    } catch {
    }
    if (!n)
      try {
        var i = new e();
        n = !/* @__PURE__ */ Je(i[t]);
      } catch {
      }
  }
  return n;
}
function Hn(e) {
  if (e && hC) {
    var t = /* @__PURE__ */ ut("__mockLocation");
    if (t)
      return t;
  }
  return typeof location === EE && location ? location : /* @__PURE__ */ ut(uC);
}
function _C() {
  return typeof console !== Ih ? console : /* @__PURE__ */ ut(fC);
}
function Ec() {
  return !!(typeof JSON === EE && JSON || /* @__PURE__ */ ut(CS) !== null);
}
function Dn() {
  return Ec() ? JSON || /* @__PURE__ */ ut(CS) : null;
}
function pC() {
  return /* @__PURE__ */ ut(lC);
}
function gC() {
  return /* @__PURE__ */ ut(dC);
}
function EC() {
  var e = Zn();
  return e && e.product ? e.product === vC : !1;
}
function wv() {
  var e = Zn();
  if (e && (e[
    dv
    /* @min:%2euserAgent */
  ] !== jl || ql === null)) {
    jl = e[
      dv
      /* @min:%2euserAgent */
    ];
    var t = (jl || De)[
      Ca
      /* @min:%2etoLowerCase */
    ]();
    ql = Nt(t, Sv) || Nt(t, mv);
  }
  return ql;
}
function DS(e) {
  if (e === void 0 && (e = null), !e) {
    var t = Zn() || {};
    e = t ? (t.userAgent || De)[
      Ca
      /* @min:%2etoLowerCase */
    ]() : De;
  }
  var n = (e || De)[
    Ca
    /* @min:%2etoLowerCase */
  ]();
  if (Nt(n, Sv)) {
    var r = Dt() || {};
    return As(parseInt(n[
      Na
      /* @min:%2esplit */
    ](Sv)[1]), r[cC] || 0);
  } else if (Nt(n, mv)) {
    var i = parseInt(n[
      Na
      /* @min:%2esplit */
    ](mv)[1]);
    if (i)
      return i + 4;
  }
  return null;
}
function gs(e) {
  return (Xl === null || e === !1) && (Xl = /* @__PURE__ */ C0() && !!Zn().sendBeacon), Xl;
}
function qh(e) {
  var t = !1;
  try {
    t = !!/* @__PURE__ */ ut("fetch");
    var n = /* @__PURE__ */ ut("Request");
    t && e && n && (t = IS(n, "keepalive"));
  } catch {
  }
  return t;
}
function SC() {
  return No === null && (No = typeof XDomainRequest !== Ih, No && Kf() && (No = No && !IS(/* @__PURE__ */ ut(NS), "withCredentials"))), No;
}
function Kf() {
  var e = !1;
  try {
    var t = /* @__PURE__ */ ut(NS);
    e = !!t;
  } catch {
  }
  return e;
}
function mC(e, t) {
  return e && e.dispatchEvent && t ? (e.dispatchEvent(t), !0) : !1;
}
function wC(e, t) {
  var n = null, r = { detail: t || null };
  if (ye(CustomEvent))
    n = new CustomEvent(e, r);
  else {
    var i = Dt();
    i && i.createEvent && (n = i.createEvent("CustomEvent"), n.initCustomEvent(e, !0, !0, r));
  }
  return n;
}
function yC(e, t, n) {
  var r = /* @__PURE__ */ or();
  if (r && r.CustomEvent)
    try {
      var i = { cfg: t || null, customDetails: n || null };
      return mC(r, wC(e, i));
    } catch {
    }
  return !1;
}
var RS = 4294967296, Zr = 4294967295, PS = 123456789, AS = 987654321, OS = !1, Es = PS, Ss = AS;
function TC(e) {
  e < 0 && (e >>>= 0), Es = PS + e & Zr, Ss = AS - e & Zr, OS = !0;
}
function bC() {
  try {
    var e = /* @__PURE__ */ Kn() & 2147483647;
    TC((Math.random() * RS ^ e) + e);
  } catch {
  }
}
function CC(e) {
  return tn(Zs() / Zr * (e + 1)) >>> 0;
}
function Zs(e) {
  var t = 0, n = pC() || gC();
  return n && n.getRandomValues && (t = n.getRandomValues(new Uint32Array(1))[0] & Zr), t === 0 && wv() && (OS || bC(), t = NC() & Zr), t === 0 && (t = tn(RS * Math.random() | 0)), t >>>= 0, t;
}
function NC(e) {
  Ss = 36969 * (Ss & 65535) + (Ss >> 16) & Zr, Es = 18e3 * (Es & 65535) + (Es >> 16) & Zr;
  var t = (Ss << 16) + (Es & 65535) >>> 0 & Zr | 0;
  return t >>>= 0, t;
}
function jh(e) {
  e === void 0 && (e = 22);
  for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = Zs() >>> 0, r = 0, i = De; i[
    pe
    /* @min:%2elength */
  ] < e; )
    r++, i += t.charAt(n & 63), n >>>= 6, r === 5 && (n = (Zs() << 2 & 4294967295 | n & 3) >>> 0, r = 0);
  return i;
}
var kS = "3.3.6", IC = "." + jh(6), DC = 0;
function xS(e) {
  return e.nodeType === 1 || e.nodeType === 9 || !+e.nodeType;
}
function RC(e, t) {
  var n = t[e.id];
  if (!n) {
    n = {};
    try {
      xS(t) && Le(t, e.id, {
        e: !1,
        v: n
      });
    } catch {
    }
  }
  return n;
}
function _n(e, t) {
  return t === void 0 && (t = !1), Zu(e + DC++ + (t ? "." + kS : De) + IC);
}
function LS(e) {
  var t = {
    id: _n("_aiData-" + (e || De) + "." + kS),
    accept: function(n) {
      return xS(n);
    },
    get: function(n, r, i, o) {
      var a = n[t.id];
      return a ? a[Zu(r)] : (o && (a = RC(t, n), a[Zu(r)] = i), i);
    },
    kill: function(n, r) {
      if (n && n[r])
        try {
          delete n[r];
        } catch {
        }
    }
  };
  return t;
}
function vu(e) {
  return e && /* @__PURE__ */ qt(e) && (e.isVal || e.fb || Xr(e, "v") || Xr(e, "mrg") || Xr(e, "ref") || e.set);
}
function MS(e, t, n) {
  var r, i = n.dfVal || kh;
  if (t && n.fb) {
    var o = n.fb;
    Te(o) || (o = [o]);
    for (var a = 0; a < o[
      pe
      /* @min:%2elength */
    ]; a++) {
      var s = o[a], c = t[s];
      if (i(c) ? r = c : e && (c = e.cfg[s], i(c) && (r = c), e.set(e.cfg, Ut(s), c)), i(r))
        break;
    }
  }
  return !i(r) && i(n.v) && (r = n.v), r;
}
function yv(e, t, n) {
  var r = n;
  if (n && vu(n) && (r = MS(e, t, n)), r) {
    vu(r) && (r = yv(e, t, r));
    var i;
    Te(r) ? (i = [], i[
      pe
      /* @min:%2elength */
    ] = r[
      pe
      /* @min:%2elength */
    ]) : /* @__PURE__ */ $t(r) && (i = {}), i && (Ne(r, function(o, a) {
      a && vu(a) && (a = yv(e, t, a)), i[o] = a;
    }), r = i);
  }
  return r;
}
function Xh(e, t, n, r) {
  var i, o, a, s = r, c, u, f, l;
  vu(s) ? (i = s.isVal, o = s.set, f = s.rdOnly, l = s.blkVal, c = s.mrg, u = s.ref, !u && /* @__PURE__ */ Je(u) && (u = !!c), a = MS(e, t, s)) : a = r, l && e.blkVal(t, n);
  var v, d = !0, h = t[n];
  (h || !/* @__PURE__ */ Y(h)) && (v = h, d = !1, i && v !== a && !i(v) && (v = a, d = !0), o && (v = o(v, a, t), d = v === a)), d ? a ? v = yv(e, t, a) : v = a : (/* @__PURE__ */ $t(v) || Te(a)) && c && a && (/* @__PURE__ */ $t(a) || Te(a)) && Ne(a, function(_, m) {
    Xh(e, v, _, m);
  }), e.set(t, n, v), u && e.ref(t, n), f && e.rdOnly(t, n);
}
var oi = /* @__PURE__ */ Hh("[[ai_dynCfg_1]]"), US = /* @__PURE__ */ Hh("[[ai_blkDynCfg_1]]"), PC = /* @__PURE__ */ Hh("[[ai_frcDynCfg_1]]");
function $S(e) {
  if (e) {
    var t;
    if (Te(e) ? (t = [], t[
      pe
      /* @min:%2elength */
    ] = e[
      pe
      /* @min:%2elength */
    ]) : /* @__PURE__ */ $t(e) && (t = {}), t)
      return Ne(e, function(n, r) {
        t[n] = $S(r);
      }), t;
  }
  return e;
}
function AC(e) {
  if (e) {
    var t = e[oi] || e;
    if (t.cfg && (t.cfg === e || t.cfg[oi] === t))
      return t;
  }
  return null;
}
function OC(e) {
  if (e && (/* @__PURE__ */ $t(e) || Te(e)))
    try {
      e[US] = !0;
    } catch {
    }
  return e;
}
function Jl(e, t, n) {
  var r = !1;
  return n && !e[t.blkVal] && (r = n[PC], !r && !n[US] && (r = /* @__PURE__ */ $t(n) || Te(n))), r;
}
function FS(e) {
  ka("InvalidAccess:" + e);
}
var kC = [
  "push",
  "pop",
  "shift",
  "unshift",
  "splice"
], ec = function(e, t, n, r) {
  e && e[
    _c
    /* @min:%2ethrowInternal */
  ](3, 108, "".concat(n, " [").concat(t, "] failed - ") + /* @__PURE__ */ Q(r));
};
function xC(e, t, n) {
  Te(t) && J(kC, function(r) {
    var i = t[r];
    t[r] = function() {
      for (var o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      var s = i[
        ro
        /* @min:%2eapply */
      ](this, o);
      return of(e, t, n, "Patching"), s;
    };
  });
}
function rf(e, t) {
  var n = Lh(e, t);
  return n && n.get;
}
function LC(e, t, n, r) {
  var i = {
    n,
    h: [],
    trk: function(u) {
      u && u.fn && (Rt(i.h, u) === -1 && i.h[
        Pe
        /* @min:%2epush */
      ](u), e.trk(u, i));
    },
    clr: function(u) {
      var f = Rt(i.h, u);
      f !== -1 && i.h[
        La
        /* @min:%2esplice */
      ](f, 1);
    }
  }, o = !0, a = !1;
  function s() {
    o && (a = a || Jl(s, e, r), r && !r[oi] && a && (r = of(e, r, n, "Converting")), o = !1);
    var u = e.act;
    return u && i.trk(u), r;
  }
  s[e.prop] = {
    chng: function() {
      e.add(i);
    }
  };
  function c(u) {
    if (r !== u) {
      s[e.ro] && !e.upd && FS("[" + n + "] is read-only:" + /* @__PURE__ */ Q(t)), o && (a = a || Jl(s, e, r), o = !1);
      var f = a && s[e.rf];
      if (a)
        if (f) {
          Ne(r, function(v) {
            r[v] = u ? u[v] : Un;
          });
          try {
            Ne(u, function(v, d) {
              Wf(e, r, v, d);
            }), u = r;
          } catch (v) {
            ec((e.hdlr || {})[
              ot
              /* @min:%2elogger */
            ], n, "Assigning", v), a = !1;
          }
        } else r && r[oi] && Ne(r, function(v) {
          var d = rf(r, v);
          if (d) {
            var h = d[e.prop];
            h && h.chng();
          }
        });
      if (u !== r) {
        var l = u && Jl(s, e, u);
        !f && l && (u = of(e, u, n, "Converting")), r = u, a = l;
      }
      e.add(i);
    }
  }
  Le(t, i.n, { g: s, s: c });
}
function Wf(e, t, n, r) {
  if (t) {
    var i = rf(t, n), o = i && !!i[e.prop];
    o ? t[n] = r : LC(e, t, n, r);
  }
  return t;
}
function Ql(e, t, n, r) {
  if (t) {
    var i = rf(t, n), o = i && !!i[e.prop], a = r && r[
      0
      /* _eSetDynamicPropertyFlags.inPlace */
    ], s = r && r[
      1
      /* _eSetDynamicPropertyFlags.readOnly */
    ], c = r && r[
      2
      /* _eSetDynamicPropertyFlags.blockDynamicProperty */
    ];
    if (!o) {
      if (c)
        try {
          OC(t);
        } catch (u) {
          ec((e.hdlr || {})[
            ot
            /* @min:%2elogger */
          ], n, "Blocking", u);
        }
      try {
        Wf(e, t, n, t[n]), i = rf(t, n);
      } catch (u) {
        ec((e.hdlr || {})[
          ot
          /* @min:%2elogger */
        ], n, "State", u);
      }
    }
    a && (i[e.rf] = a), s && (i[e.ro] = s), c && (i[e.blkVal] = !0);
  }
  return t;
}
function of(e, t, n, r) {
  try {
    Ne(t, function(i, o) {
      Wf(e, t, i, o);
    }), t[oi] || (no(t, oi, {
      get: function() {
        return e.hdlr;
      }
    }), xC(e, t, n));
  } catch (i) {
    ec((e.hdlr || {})[
      ot
      /* @min:%2elogger */
    ], n, r, i);
  }
  return t;
}
var Ga = "[[ai_", Ka = "]]";
function MC(e) {
  var t = /* @__PURE__ */ Ba(Ga + "get" + e.uid + Ka), n = /* @__PURE__ */ Ba(Ga + "ro" + e.uid + Ka), r = /* @__PURE__ */ Ba(Ga + "rf" + e.uid + Ka), i = /* @__PURE__ */ Ba(Ga + "blkVal" + e.uid + Ka), o = /* @__PURE__ */ Ba(Ga + "dtl" + e.uid + Ka), a = null, s = null, c;
  function u(d, h) {
    var _ = c.act;
    try {
      c.act = d, d && d[o] && (J(d[o], function(E) {
        E.clr(d);
      }), d[o] = []), h({
        cfg: e.cfg,
        set: e.set.bind(e),
        setDf: e.setDf.bind(e),
        ref: e.ref.bind(e),
        rdOnly: e.rdOnly.bind(e)
      });
    } catch (E) {
      var m = e[
        ot
        /* @min:%2elogger */
      ];
      throw m && m[
        _c
        /* @min:%2ethrowInternal */
      ](1, 107, /* @__PURE__ */ Q(E)), E;
    } finally {
      c.act = _ || null;
    }
  }
  function f() {
    if (a) {
      var d = a;
      a = null, s && s[
        ea
        /* @min:%2ecancel */
      ](), s = null;
      var h = [];
      if (J(d, function(_) {
        if (_ && (_[o] && (J(_[o], function(m) {
          m.clr(_);
        }), _[o] = null), _.fn))
          try {
            u(_, _.fn);
          } catch (m) {
            h[
              Pe
              /* @min:%2epush */
            ](m);
          }
      }), a)
        try {
          f();
        } catch (_) {
          h[
            Pe
            /* @min:%2epush */
          ](_);
        }
      h[
        pe
        /* @min:%2elength */
      ] > 0 && Z0("Watcher error(s): ", h);
    }
  }
  function l(d) {
    if (d && d.h[
      pe
      /* @min:%2elength */
    ] > 0) {
      a || (a = []), s || (s = Wn(function() {
        s = null, f();
      }, 0));
      for (var h = 0; h < d.h[
        pe
        /* @min:%2elength */
      ]; h++) {
        var _ = d.h[h];
        _ && Rt(a, _) === -1 && a[
          Pe
          /* @min:%2epush */
        ](_);
      }
    }
  }
  function v(d, h) {
    if (d) {
      var _ = d[o] = d[o] || [];
      Rt(_, h) === -1 && _[
        Pe
        /* @min:%2epush */
      ](h);
    }
  }
  return c = {
    prop: t,
    ro: n,
    rf: r,
    blkVal: i,
    hdlr: e,
    add: l,
    notify: f,
    use: u,
    trk: v
  }, c;
}
function UC(e, t) {
  var n = {
    fn: t,
    rm: function() {
      n.fn = null, e = null, t = null;
    }
  };
  return Le(n, "toJSON", { v: function() {
    return "WatcherHandler" + (n.fn ? "" : "[X]");
  } }), e.use(n, t), n;
}
function $C(e, t, n) {
  var r = AC(t);
  if (r)
    return r;
  var i = _n("dyncfg", !0), o = t && n !== !1 ? t : $S(t), a;
  function s() {
    a.notify();
  }
  function c(m, E, y) {
    try {
      m = Wf(a, m, E, y);
    } catch (O) {
      ec(e, E, "Setting value", O);
    }
    return m[E];
  }
  function u(m) {
    return UC(a, m);
  }
  function f(m, E) {
    a.use(null, function(y) {
      var O = a.upd;
      try {
        /* @__PURE__ */ Je(E) || (a.upd = E), m(y);
      } finally {
        a.upd = O;
      }
    });
  }
  function l(m, E) {
    var y;
    return Ql(a, m, E, (y = {}, y[
      0
      /* _eSetDynamicPropertyFlags.inPlace */
    ] = !0, y))[E];
  }
  function v(m, E) {
    var y;
    return Ql(a, m, E, (y = {}, y[
      1
      /* _eSetDynamicPropertyFlags.readOnly */
    ] = !0, y))[E];
  }
  function d(m, E) {
    var y;
    return Ql(a, m, E, (y = {}, y[
      2
      /* _eSetDynamicPropertyFlags.blockDynamicProperty */
    ] = !0, y))[E];
  }
  function h(m, E) {
    return E && Ne(E, function(y, O) {
      Xh(_, m, y, O);
    }), m;
  }
  var _ = {
    uid: null,
    cfg: o,
    logger: e,
    notify: s,
    set: c,
    setDf: h,
    watch: u,
    ref: l,
    rdOnly: v,
    blkVal: d,
    _block: f
  };
  return Le(_, "uid", {
    c: !1,
    e: !1,
    w: !1,
    v: i
  }), a = MC(_), of(a, o, "config", "Creating"), _;
}
function FC(e, t) {
  e ? (e[
    Bu
    /* @min:%2ewarnToConsole */
  ](t), e[
    _c
    /* @min:%2ethrowInternal */
  ](2, 108, t)) : FS(t);
}
function pn(e, t, n, r) {
  var i = $C(n, e || {}, r);
  return t && i.setDf(i.cfg, t), i;
}
function nt(e, t, n) {
  var r = e[oi] || e;
  return r.cfg && (r.cfg === e || r.cfg[oi] === r) ? r[
    Vi
    /* @min:%2ewatch */
  ](t) : (FC(n, Wb + /* @__PURE__ */ Q(e)), pn(e, null, n)[
    Vi
    /* @min:%2ewatch */
  ](t));
}
function ra(e, t) {
  if (e && e[
    oo
    /* @min:%2eunload */
  ])
    return e[
      oo
      /* @min:%2eunload */
    ](t);
}
function HS(e, t, n) {
  var r;
  return n || (r = ii(function(i) {
    n = i;
  })), e && W0(e) > 0 ? mr(ra(e[0], t), function() {
    HS(P0(e, 1), t, n);
  }) : n(), r;
}
var HC = 500, ap = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
function YC(e, t, n) {
  return !e && /* @__PURE__ */ Y(e) ? t : IE(e) ? e : Ut(e)[
    Ca
    /* @min:%2etoLowerCase */
  ]() === "true";
}
function Sn(e) {
  return {
    mrg: !0,
    v: e
  };
}
function sp(e, t) {
  return {
    set: e,
    v: t
  };
}
function af(e, t, n) {
  return {
    fb: n,
    isVal: e,
    v: t
  };
}
function at(e, t) {
  return {
    fb: t,
    set: YC,
    v: !!e
  };
}
function VC(e) {
  return {
    isVal: ce,
    v: Ut(De)
  };
}
var Zl = [lu, Ms, du, xi], sf = null, Gc;
function BC(e, t) {
  return function() {
    var n = arguments, r = YS(t);
    if (r) {
      var i = r.listener;
      i && i[e] && i[e][
        ro
        /* @min:%2eapply */
      ](i, n);
    }
  };
}
function zC() {
  var e = /* @__PURE__ */ ut("Microsoft");
  return e && (sf = e.ApplicationInsights), sf;
}
function YS(e) {
  var t = sf;
  return !t && e.disableDbgExt !== !0 && (t = sf || zC()), t ? t.ChromeDbgExt : null;
}
function GC(e) {
  if (!Gc) {
    Gc = {};
    for (var t = 0; t < Zl[
      pe
      /* @min:%2elength */
    ]; t++)
      Gc[Zl[t]] = BC(Zl[t], e);
  }
  return Gc;
}
var Io, VS = "warnToConsole", KC = "AI (Internal): ", WC = "AI: ", qC = "AITR_", jC = {
  loggingLevelConsole: 0,
  loggingLevelTelemetry: 1,
  maxMessageLimit: 25,
  enableDebug: !1
}, XC = (Io = {}, Io[
  0
  /* eLoggingSeverity.DISABLED */
] = null, Io[
  1
  /* eLoggingSeverity.CRITICAL */
] = "errorToConsole", Io[
  2
  /* eLoggingSeverity.WARNING */
] = VS, Io[
  3
  /* eLoggingSeverity.DEBUG */
] = "debugToConsole", Io);
function cp(e) {
  return e ? '"' + e[
    zi
    /* @min:%2ereplace */
  ](/\"/g, De) + '"' : De;
}
function ed(e, t) {
  var n = _C();
  if (n) {
    var r = "log";
    n[e] && (r = e), ye(n[r]) && n[r](t);
  }
}
var tc = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      r === void 0 && (r = !1);
      var o = this;
      o[
        Ku
        /* @min:%2emessageId */
      ] = t, o[
        Bi
        /* @min:%2emessage */
      ] = (r ? WC : KC) + t;
      var a = De;
      Ec() && (a = Dn().stringify(i));
      var s = (n ? " message:" + cp(n) : De) + (i ? " props:" + cp(a) : De);
      o[
        Bi
        /* @min:%2emessage */
      ] += s;
    }
    return e.dataType = "MessageData", e;
  }()
);
function ho(e, t) {
  return (e || {})[
    ot
    /* @min:%2elogger */
  ] || new cf(t);
}
var cf = (
  /** @class */
  function() {
    function e(t) {
      this.identifier = "DiagnosticLogger", this.queue = [];
      var n = 0, r = {}, i, o, a, s, c;
      Be(e, this, function(u) {
        c = l(t || {}), u.consoleLoggingLevel = function() {
          return i;
        }, u[
          _c
          /* @min:%2ethrowInternal */
        ] = function(h, _, m, E, y) {
          y === void 0 && (y = !1);
          var O = new tc(_, m, y, E);
          if (s)
            throw /* @__PURE__ */ Q(O);
          var I = XC[h] || VS;
          if (/* @__PURE__ */ Je(O[
            Bi
            /* @min:%2emessage */
          ]))
            d("throw" + (h === 1 ? "Critical" : "Warning"), O);
          else {
            if (y) {
              var P = +O[
                Ku
                /* @min:%2emessageId */
              ];
              !r[P] && i >= h && (u[I](O[
                Bi
                /* @min:%2emessage */
              ]), r[P] = !0);
            } else
              i >= h && u[I](O[
                Bi
                /* @min:%2emessage */
              ]);
            f(h, O);
          }
        }, u.debugToConsole = function(h) {
          ed("debug", h), d("warning", h);
        }, u[
          Bu
          /* @min:%2ewarnToConsole */
        ] = function(h) {
          ed("warn", h), d("warning", h);
        }, u.errorToConsole = function(h) {
          ed("error", h), d("error", h);
        }, u.resetInternalMessageCount = function() {
          n = 0, r = {};
        }, u.logInternalMessage = f, u[
          oo
          /* @min:%2eunload */
        ] = function(h) {
          c && c.rm(), c = null;
        };
        function f(h, _) {
          if (!v()) {
            var m = !0, E = qC + _[
              Ku
              /* @min:%2emessageId */
            ];
            if (r[E] ? m = !1 : r[E] = !0, m && (h <= o && (u.queue[
              Pe
              /* @min:%2epush */
            ](_), n++, d(h === 1 ? "error" : "warn", _)), n === a)) {
              var y = "Internal events throttle limit per PageView reached for this app.", O = new tc(23, y, !1);
              u.queue[
                Pe
                /* @min:%2epush */
              ](O), h === 1 ? u.errorToConsole(y) : u[
                Bu
                /* @min:%2ewarnToConsole */
              ](y);
            }
          }
        }
        function l(h) {
          return nt(pn(h, jC, u).cfg, function(_) {
            var m = _.cfg;
            i = m[
              JE
              /* @min:%2eloggingLevelConsole */
            ], o = m.loggingLevelTelemetry, a = m.maxMessageLimit, s = m.enableDebug;
          });
        }
        function v() {
          return n >= a;
        }
        function d(h, _) {
          var m = YS(t || {});
          m && m[
            cr
            /* @min:%2ediagLog */
          ] && m[
            cr
            /* @min:%2ediagLog */
          ](h, _);
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
);
function Jh(e) {
  return e || new cf();
}
function K(e, t, n, r, i, o) {
  o === void 0 && (o = !1), Jh(e)[
    _c
    /* @min:%2ethrowInternal */
  ](t, n, r, i, o);
}
function Ki(e, t) {
  Jh(e)[
    Bu
    /* @min:%2ewarnToConsole */
  ](t);
}
function JC(e, t, n) {
  Jh(e).logInternalMessage(t, n);
}
var td, _i, up = "toGMTString", fp = "toUTCString", Qh = "cookie", nd = "expires", lp = "isCookieUseDisabled", Tv = "disableCookiesUsage", ia = "_ckMgr", Kc = null, rd = null, dp = null, zn, vp = {}, uf = {}, QC = (td = {
  cookieCfg: Sn((_i = {}, _i[Ev] = { fb: "cookieDomain", dfVal: Gi }, _i.path = { fb: "cookiePath", dfVal: Gi }, _i.enabled = Un, _i.ignoreCookies = Un, _i.blockedCookies = Un, _i)),
  cookieDomain: Un,
  cookiePath: Un
}, td[Tv] = Un, td);
function Zh() {
  !zn && (zn = /* @__PURE__ */ T0(function() {
    return Dt();
  }));
}
function ZC(e, t) {
  var n = hu[ia] || uf[ia];
  return n || (n = hu[ia] = hu(e, t), uf[ia] = n), n;
}
function Wc(e) {
  return e ? e.isEnabled() : !0;
}
function BS(e, t) {
  return t && e && Te(e.ignoreCookies) ? Rt(e.ignoreCookies, t) !== -1 : !1;
}
function eN(e, t) {
  return t && e && Te(e.blockedCookies) && Rt(e.blockedCookies, t) !== -1 ? !0 : BS(e, t);
}
function hp(e, t) {
  var n = t[
    ta
    /* @min:%2eenabled */
  ];
  if (/* @__PURE__ */ Y(n)) {
    var r = void 0;
    /* @__PURE__ */ Je(e[lp]) || (r = !e[lp]), /* @__PURE__ */ Je(e[Tv]) || (r = !e[Tv]), n = r;
  }
  return n;
}
function e_(e, t) {
  var n;
  return e && (n = e.getCookieMgr()), n || (n = ZC(t, (e || {})[
    ot
    /* @min:%2elogger */
  ])), n;
}
function hu(e, t) {
  var n, r, i, o, a, s, c, u;
  e = pn(e || uf, null, t).cfg, o = nt(e, function(l) {
    l.setDf(l.cfg, QC), n = l.ref(l.cfg, "cookieCfg"), r = n[
      zl
      /* @min:%2epath */
    ] || "/", i = n[
      Ev
      /* @min:%2edomain */
    ], a = hp(e, n) !== !1, s = n.getCookie || tN, c = n.setCookie || Ep, u = n.delCookie || Ep;
  }, t);
  var f = {
    isEnabled: function() {
      var l = hp(e, n) !== !1 && a && _p(t), v = uf[ia];
      return l && v && f !== v && (l = Wc(v)), l;
    },
    setEnabled: function(l) {
      a = l !== !1, n[
        ta
        /* @min:%2eenabled */
      ] = l;
    },
    set: function(l, v, d, h, _) {
      var m = !1;
      if (Wc(f) && !eN(n, l)) {
        var E = {}, y = Ve(v || De), O = Ft(y, ";");
        if (O !== -1 && (y = Ve(/* @__PURE__ */ Uh(v, O)), E = zS(Qn(v, O + 1))), Fe(E, Ev, h || i, Yu, Je), !/* @__PURE__ */ Y(d)) {
          var I = wv();
          if (/* @__PURE__ */ Je(E[nd])) {
            var P = /* @__PURE__ */ Kn(), B = P + d * 1e3;
            if (B > 0) {
              var D = /* @__PURE__ */ new Date();
              D.setTime(B), Fe(E, nd, pp(D, I ? up : fp) || pp(D, I ? up : fp) || De, Yu);
            }
          }
          I || Fe(E, "max-age", De + d, null, Je);
        }
        var b = Hn();
        b && b.protocol === "https:" && (Fe(E, "secure", null, null, Je), rd === null && (rd = !nN((Zn() || {})[
          dv
          /* @min:%2euserAgent */
        ])), rd && Fe(E, "SameSite", "None", null, Je)), Fe(E, zl, _ || r, null, Je), c(l, gp(y, E)), m = !0;
      }
      return m;
    },
    get: function(l) {
      var v = De;
      return Wc(f) && !BS(n, l) && (v = s(l)), v;
    },
    del: function(l, v) {
      var d = !1;
      return Wc(f) && (d = f.purge(l, v)), d;
    },
    purge: function(l, v) {
      var d, h = !1;
      if (_p(t)) {
        var _ = (d = {}, d[zl] = v || "/", d[nd] = "Thu, 01 Jan 1970 00:00:01 GMT", d);
        wv() || (_["max-age"] = "0"), u(l, gp(De, _)), h = !0;
      }
      return h;
    },
    unload: function(l) {
      o && o.rm(), o = null;
    }
  };
  return f[ia] = f, f;
}
function _p(e) {
  if (Kc === null) {
    Kc = !1, !zn && Zh();
    try {
      var t = zn.v || {};
      Kc = t[Qh] !== void 0;
    } catch (n) {
      K(e, 2, 68, "Cannot access document.cookie - " + xe(n), { exception: /* @__PURE__ */ Q(n) });
    }
  }
  return Kc;
}
function zS(e) {
  var t = {};
  if (e && e[
    pe
    /* @min:%2elength */
  ]) {
    var n = Ve(e)[
      Na
      /* @min:%2esplit */
    ](";");
    J(n, function(r) {
      if (r = Ve(r || De), r) {
        var i = Ft(r, "=");
        i === -1 ? t[r] = null : t[Ve(/* @__PURE__ */ Uh(r, i))] = Ve(Qn(r, i + 1));
      }
    });
  }
  return t;
}
function pp(e, t) {
  return ye(e[t]) ? e[t]() : null;
}
function gp(e, t) {
  var n = e || De;
  return Ne(t, function(r, i) {
    n += "; " + r + (/* @__PURE__ */ Y(i) ? De : "=" + i);
  }), n;
}
function tN(e) {
  var t = De;
  if (!zn && Zh(), zn.v) {
    var n = zn.v[Qh] || De;
    dp !== n && (vp = zS(n), dp = n), t = Ve(vp[e] || De);
  }
  return t;
}
function Ep(e, t) {
  !zn && Zh(), zn.v && (zn.v[Qh] = e + "=" + t);
}
function nN(e) {
  return ce(e) ? !!(Nt(e, "CPU iPhone OS 12") || Nt(e, "iPad; CPU OS 12") || Nt(e, "Macintosh; Intel Mac OS X 10_14") && Nt(e, "Version/") && Nt(e, "Safari") || Nt(e, "Macintosh; Intel Mac OS X 10_14") && WE(e, "AppleWebKit/605.1.15 (KHTML, like Gecko)") || Nt(e, "Chrome/5") || Nt(e, "Chrome/6") || Nt(e, "UnrealEngine") && !Nt(e, "Chrome") || Nt(e, "UCBrowser/12") || Nt(e, "UCBrowser/11")) : !1;
}
var rN = {
  perfEvtsSendAll: !1
};
function iN(e) {
  e.h = null;
  var t = e.cb;
  e.cb = [], J(t, function(n) {
    Wt(n.fn, [n.arg]);
  });
}
function Cr(e, t, n, r) {
  J(e, function(i) {
    i && i[t] && (n ? (n.cb[
      Pe
      /* @min:%2epush */
    ]({
      fn: r,
      arg: i
    }), n.h = n.h || Wn(iN, 0, n)) : Wt(r, [i]));
  });
}
var oN = (
  /** @class */
  function() {
    function e(t) {
      this.listeners = [];
      var n, r, i = [], o = {
        h: null,
        cb: []
      }, a = pn(t, rN);
      r = a[
        Vi
        /* @min:%2ewatch */
      ](function(s) {
        n = !!s.cfg.perfEvtsSendAll;
      }), Be(e, this, function(s) {
        Le(s, "listeners", {
          g: function() {
            return i;
          }
        }), s[
          Gu
          /* @min:%2eaddNotificationListener */
        ] = function(c) {
          i[
            Pe
            /* @min:%2epush */
          ](c);
        }, s[
          zu
          /* @min:%2eremoveNotificationListener */
        ] = function(c) {
          for (var u = Rt(i, c); u > -1; )
            i[
              La
              /* @min:%2esplice */
            ](u, 1), u = Rt(i, c);
        }, s[
          lu
          /* @min:%2eeventsSent */
        ] = function(c) {
          Cr(i, lu, o, function(u) {
            u[
              lu
              /* @min:%2eeventsSent */
            ](c);
          });
        }, s[
          Ms
          /* @min:%2eeventsDiscarded */
        ] = function(c, u) {
          Cr(i, Ms, o, function(f) {
            f[
              Ms
              /* @min:%2eeventsDiscarded */
            ](c, u);
          });
        }, s[
          du
          /* @min:%2eeventsSendRequest */
        ] = function(c, u) {
          Cr(i, du, u ? o : null, function(f) {
            f[
              du
              /* @min:%2eeventsSendRequest */
            ](c, u);
          });
        }, s[
          xi
          /* @min:%2eperfEvent */
        ] = function(c) {
          c && (n || !c[
            vv
            /* @min:%2eisChildEvt */
          ]()) && Cr(i, xi, null, function(u) {
            c.isAsync ? Wn(function() {
              return u[
                xi
                /* @min:%2eperfEvent */
              ](c);
            }, 0) : u[
              xi
              /* @min:%2eperfEvent */
            ](c);
          });
        }, s[
          Yl
          /* @min:%2eofflineEventsStored */
        ] = function(c) {
          c && c[
            pe
            /* @min:%2elength */
          ] && Cr(i, Yl, o, function(u) {
            u[
              Yl
              /* @min:%2eofflineEventsStored */
            ](c);
          });
        }, s[
          Vl
          /* @min:%2eofflineBatchSent */
        ] = function(c) {
          c && c[
            Ho
            /* @min:%2edata */
          ] && Cr(i, Vl, o, function(u) {
            u[
              Vl
              /* @min:%2eofflineBatchSent */
            ](c);
          });
        }, s[
          Bl
          /* @min:%2eofflineBatchDrop */
        ] = function(c, u) {
          if (c > 0) {
            var f = u || 0;
            Cr(i, Bl, o, function(l) {
              l[
                Bl
                /* @min:%2eofflineBatchDrop */
              ](c, f);
            });
          }
        }, s[
          oo
          /* @min:%2eunload */
        ] = function(c) {
          var u = function() {
            r && r.rm(), r = null, i = [], o.h && o.h[
              ea
              /* @min:%2ecancel */
            ](), o.h = null, o.cb = [];
          }, f;
          if (Cr(i, "unload", null, function(l) {
            var v = l[
              oo
              /* @min:%2eunload */
            ](c);
            v && (f || (f = []), f[
              Pe
              /* @min:%2epush */
            ](v));
          }), f)
            return ii(function(l) {
              return mr(Kb(f), function() {
                u(), l();
              });
            });
          u();
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), va = "ctx", bv = "ParentContextKey", Us = "ChildrenContextKey", aN = null, _u = (
  /** @class */
  function() {
    function e(t, n, r) {
      var i = this;
      if (i.start = /* @__PURE__ */ Kn(), i[
        io
        /* @min:%2ename */
      ] = t, i.isAsync = r, i[
        vv
        /* @min:%2eisChildEvt */
      ] = function() {
        return !1;
      }, ye(n)) {
        var o;
        Le(i, "payload", {
          g: function() {
            return !o && ye(n) && (o = n(), n = null), o;
          }
        });
      }
      i[
        la
        /* @min:%2egetCtx */
      ] = function(a) {
        return a ? a === e[bv] || a === e[Us] ? i[a] : (i[va] || {})[a] : null;
      }, i[
        xn
        /* @min:%2esetCtx */
      ] = function(a, s) {
        if (a)
          if (a === e[bv])
            i[a] || (i[
              vv
              /* @min:%2eisChildEvt */
            ] = function() {
              return !0;
            }), i[a] = s;
          else if (a === e[Us])
            i[a] = s;
          else {
            var c = i[va] = i[va] || {};
            c[a] = s;
          }
      }, i.complete = function() {
        var a = 0, s = i[
          la
          /* @min:%2egetCtx */
        ](e[Us]);
        if (Te(s))
          for (var c = 0; c < s[
            pe
            /* @min:%2elength */
          ]; c++) {
            var u = s[c];
            u && (a += u.time);
          }
        i.time = /* @__PURE__ */ Kn() - i.start, i.exTime = i.time - a, i.complete = function() {
        };
      };
    }
    return e.ParentContextKey = "parent", e.ChildrenContextKey = "childEvts", e;
  }()
), sN = (
  /** @class */
  function() {
    function e(t) {
      this.ctx = {}, Be(e, this, function(n) {
        n.create = function(r, i, o) {
          return new _u(r, i, o);
        }, n.fire = function(r) {
          r && (r.complete(), t && ye(t[
            xi
            /* @min:%2eperfEvent */
          ]) && t[
            xi
            /* @min:%2eperfEvent */
          ](r));
        }, n[
          xn
          /* @min:%2esetCtx */
        ] = function(r, i) {
          if (r) {
            var o = n[va] = n[va] || {};
            o[r] = i;
          }
        }, n[
          la
          /* @min:%2egetCtx */
        ] = function(r) {
          return (n[va] || {})[r];
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), id = "CoreUtils.doPerf";
function ff(e, t, n, r, i) {
  if (e) {
    var o = e;
    if (o[Qu] && (o = o[Qu]()), o) {
      var a = void 0, s = o[
        la
        /* @min:%2egetCtx */
      ](id);
      try {
        if (a = o.create(t(), r, i), a) {
          if (s && a[
            xn
            /* @min:%2esetCtx */
          ] && (a[
            xn
            /* @min:%2esetCtx */
          ](_u[bv], s), s[
            la
            /* @min:%2egetCtx */
          ] && s[
            xn
            /* @min:%2esetCtx */
          ])) {
            var c = s[
              la
              /* @min:%2egetCtx */
            ](_u[Us]);
            c || (c = [], s[
              xn
              /* @min:%2esetCtx */
            ](_u[Us], c)), c[
              Pe
              /* @min:%2epush */
            ](a);
          }
          return o[
            xn
            /* @min:%2esetCtx */
          ](id, a), n(a);
        }
      } catch (u) {
        a && a[
          xn
          /* @min:%2esetCtx */
        ] && a[
          xn
          /* @min:%2esetCtx */
        ]("exception", u);
      } finally {
        a && o.fire(a), o[
          xn
          /* @min:%2esetCtx */
        ](id, s);
      }
    }
  }
  return n();
}
function cN() {
  return aN;
}
function Kr() {
  for (var e = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"], t = De, n, r = 0; r < 4; r++)
    n = Zs(), t += e[n & 15] + e[n >> 4 & 15] + e[n >> 8 & 15] + e[n >> 12 & 15] + e[n >> 16 & 15] + e[n >> 20 & 15] + e[n >> 24 & 15] + e[n >> 28 & 15];
  var i = e[8 + (Zs() & 3) | 0];
  return Hr(t, 0, 8) + Hr(t, 9, 4) + "4" + Hr(t, 13, 3) + i + Hr(t, 16, 3) + Hr(t, 19, 12);
}
var Cv = "00", uN = "ff", GS = "00000000000000000000000000000000", KS = "0000000000000000";
function Sc(e, t, n) {
  return e && e[
    pe
    /* @min:%2elength */
  ] === t && e !== n ? !!e.match(/^[\da-f]*$/i) : !1;
}
function Sp(e, t, n) {
  return Sc(e, t) ? e : n;
}
function fN(e) {
  (isNaN(e) || e < 0 || e > 255) && (e = 1);
  for (var t = e.toString(16); t[
    pe
    /* @min:%2elength */
  ] < 2; )
    t = "0" + t;
  return t;
}
function mp(e, t, n, r) {
  return {
    version: Sc(r, 2, uN) ? r : Cv,
    traceId: t_(e) ? e : Kr(),
    spanId: n_(t) ? t : /* @__PURE__ */ Uh(Kr(), 16),
    traceFlags: n >= 0 && n <= 255 ? n : 1
  };
}
function t_(e) {
  return Sc(e, 32, GS);
}
function n_(e) {
  return Sc(e, 16, KS);
}
function wp(e) {
  if (e) {
    var t = fN(e[
      hv
      /* @min:%2etraceFlags */
    ]);
    Sc(t, 2) || (t = "01");
    var n = e[
      lv
      /* @min:%2eversion */
    ] || Cv;
    return n !== "00" && n !== "ff" && (n = Cv), "".concat(n.toLowerCase(), "-").concat(Sp(e.traceId, 32, GS).toLowerCase(), "-").concat(Sp(e.spanId, 16, KS).toLowerCase(), "-").concat(t.toLowerCase());
  }
  return "";
}
function lN(e) {
  var t = e.getElementsByTagName("script"), n = [];
  return J(t, function(r) {
    var i = r[
      Al
      /* @min:%2egetAttribute */
    ]("src");
    if (i) {
      var o = r[
        Al
        /* @min:%2egetAttribute */
      ]("crossorigin"), a = r.hasAttribute("async") === !0, s = r.hasAttribute("defer") === !0, c = r[
        Al
        /* @min:%2egetAttribute */
      ]("referrerpolicy"), u = { url: i };
      o && (u.crossOrigin = o), a && (u.async = a), s && (u.defer = s), c && (u.referrerPolicy = c), n[
        Pe
        /* @min:%2epush */
      ](u);
    }
  }), n;
}
var dN = LS("plugin");
function Wi(e) {
  return dN.get(e, "state", {}, !0);
}
function yp(e, t) {
  for (var n = [], r = null, i = e[
    Bn
    /* @min:%2egetNext */
  ](), o; i; ) {
    var a = i[
      Xs
      /* @min:%2egetPlugin */
    ]();
    if (a) {
      r && r[
        Qs
        /* @min:%2esetNextPlugin */
      ] && a[
        qn
        /* @min:%2eprocessTelemetry */
      ] && r[
        Qs
        /* @min:%2esetNextPlugin */
      ](a), o = Wi(a);
      var s = !!o[
        Fn
        /* @min:%2eisInitialized */
      ];
      a[
        Fn
        /* @min:%2eisInitialized */
      ] && (s = a[
        Fn
        /* @min:%2eisInitialized */
      ]()), s || n[
        Pe
        /* @min:%2epush */
      ](a), r = a, i = i[
        Bn
        /* @min:%2egetNext */
      ]();
    }
  }
  J(n, function(c) {
    var u = e[
      ht
      /* @min:%2ecore */
    ]();
    c[
      pc
      /* @min:%2einitialize */
    ](e.getCfg(), u, t, e[
      Bn
      /* @min:%2egetNext */
    ]()), o = Wi(c), !c[ht] && !o[ht] && (o[ht] = u), o[
      Fn
      /* @min:%2eisInitialized */
    ] = !0, delete o[
      ir
      /* @min:%2eteardown */
    ];
  });
}
function od(e) {
  return e.sort(function(t, n) {
    var r = 0;
    if (n) {
      var i = n[qn];
      t[qn] ? r = i ? t[Ju] - n[Ju] : 1 : i && (r = -1);
    } else
      r = t ? 1 : -1;
    return r;
  });
}
function vN(e) {
  var t = {};
  return {
    getName: function() {
      return t[
        io
        /* @min:%2ename */
      ];
    },
    setName: function(n) {
      t[
        io
        /* @min:%2ename */
      ] = n;
    },
    getTraceId: function() {
      return t.traceId;
    },
    setTraceId: function(n) {
      t_(n) && (t.traceId = n);
    },
    getSpanId: function() {
      return t.spanId;
    },
    setSpanId: function(n) {
      n_(n) && (t.spanId = n);
    },
    getTraceFlags: function() {
      return t[
        hv
        /* @min:%2etraceFlags */
      ];
    },
    setTraceFlags: function(n) {
      t[
        hv
        /* @min:%2etraceFlags */
      ] = n;
    }
  };
}
var hN = "TelemetryPluginChain", Tp = "_hasRun", bp = "_getTelCtx", Cp = 0;
function _N(e, t, n) {
  for (; e; ) {
    if (e[
      Xs
      /* @min:%2egetPlugin */
    ]() === n)
      return e;
    e = e[
      Bn
      /* @min:%2egetNext */
    ]();
  }
  return so([n], t.config || {}, t);
}
function r_(e, t, n, r) {
  var i = null, o = [];
  t || (t = pn({}, null, n[
    ot
    /* @min:%2elogger */
  ])), r !== null && (i = r ? _N(e, n, r) : e);
  var a = {
    _next: c,
    ctx: {
      core: function() {
        return n;
      },
      diagLog: function() {
        return ho(n, t.cfg);
      },
      getCfg: function() {
        return t.cfg;
      },
      getExtCfg: f,
      getConfig: l,
      hasNext: function() {
        return !!i;
      },
      getNext: function() {
        return i;
      },
      setNext: function(d) {
        i = d;
      },
      iterate: v,
      onComplete: s
    }
  };
  function s(d, h) {
    for (var _ = [], m = 2; m < arguments.length; m++)
      _[m - 2] = arguments[m];
    d && o[
      Pe
      /* @min:%2epush */
    ]({
      func: d,
      self: /* @__PURE__ */ Je(h) ? a.ctx : h,
      args: _
    });
  }
  function c() {
    var d = i;
    if (i = d ? d[
      Bn
      /* @min:%2egetNext */
    ]() : null, !d) {
      var h = o;
      h && h[
        pe
        /* @min:%2elength */
      ] > 0 && (J(h, function(_) {
        try {
          _.func.call(_.self, _.args);
        } catch (m) {
          K(n[
            ot
            /* @min:%2elogger */
          ], 2, 73, "Unexpected Exception during onComplete - " + /* @__PURE__ */ Q(m));
        }
      }), o = []);
    }
    return d;
  }
  function u(d, h) {
    var _ = null, m = t.cfg;
    if (m && d) {
      var E = m[
        da
        /* @min:%2eextensionConfig */
      ];
      !E && h && (E = {}), m[da] = E, E = t.ref(m, da), E && (_ = E[d], !_ && h && (_ = {}), E[d] = _, _ = t.ref(E, d));
    }
    return _;
  }
  function f(d, h) {
    var _ = u(d, !0);
    return h && Ne(h, function(m, E) {
      if (/* @__PURE__ */ Y(_[m])) {
        var y = t.cfg[m];
        (y || !/* @__PURE__ */ Y(y)) && (_[m] = y);
      }
      Xh(t, _, m, E);
    }), t.setDf(_, h);
  }
  function l(d, h, _) {
    _ === void 0 && (_ = !1);
    var m, E = u(d, !1), y = t.cfg;
    return E && (E[h] || !/* @__PURE__ */ Y(E[h])) ? m = E[h] : (y[h] || !/* @__PURE__ */ Y(y[h])) && (m = y[h]), m || !/* @__PURE__ */ Y(m) ? m : _;
  }
  function v(d) {
    for (var h; h = a._next(); ) {
      var _ = h[
        Xs
        /* @min:%2egetPlugin */
      ]();
      _ && d(_);
    }
  }
  return a;
}
function Rn(e, t, n, r) {
  var i = pn(t), o = r_(e, i, n, r), a = o.ctx;
  function s(u) {
    var f = o._next();
    return f && f[
      qn
      /* @min:%2eprocessTelemetry */
    ](u, a), !f;
  }
  function c(u, f) {
    return u === void 0 && (u = null), Te(u) && (u = so(u, i.cfg, n, f)), Rn(u || a[
      Bn
      /* @min:%2egetNext */
    ](), i.cfg, n, f);
  }
  return a[
    Lt
    /* @min:%2eprocessNext */
  ] = s, a[
    ao
    /* @min:%2ecreateNew */
  ] = c, a;
}
function lf(e, t, n) {
  var r = pn(t.config), i = r_(e, r, t, n), o = i.ctx;
  function a(c) {
    var u = i._next();
    return u && u[
      oo
      /* @min:%2eunload */
    ](o, c), !u;
  }
  function s(c, u) {
    return c === void 0 && (c = null), Te(c) && (c = so(c, r.cfg, t, u)), lf(c || o[
      Bn
      /* @min:%2egetNext */
    ](), t, u);
  }
  return o[
    Lt
    /* @min:%2eprocessNext */
  ] = a, o[
    ao
    /* @min:%2ecreateNew */
  ] = s, o;
}
function i_(e, t, n) {
  var r = pn(t.config), i = r_(e, r, t, n), o = i.ctx;
  function a(c) {
    return o.iterate(function(u) {
      ye(u[
        Js
        /* @min:%2eupdate */
      ]) && u[
        Js
        /* @min:%2eupdate */
      ](o, c);
    });
  }
  function s(c, u) {
    return c === void 0 && (c = null), Te(c) && (c = so(c, r.cfg, t, u)), i_(c || o[
      Bn
      /* @min:%2egetNext */
    ](), t, u);
  }
  return o[
    Lt
    /* @min:%2eprocessNext */
  ] = a, o[
    ao
    /* @min:%2ecreateNew */
  ] = s, o;
}
function so(e, t, n, r) {
  var i = null, o = !r;
  if (Te(e) && e[
    pe
    /* @min:%2elength */
  ] > 0) {
    var a = null;
    J(e, function(s) {
      if (!o && r === s && (o = !0), o && s && ye(s[
        qn
        /* @min:%2eprocessTelemetry */
      ])) {
        var c = pN(s, t, n);
        i || (i = c), a && a._setNext(c), a = c;
      }
    });
  }
  return r && !i ? so([r], t, n) : i;
}
function pN(e, t, n) {
  var r = null, i = ye(e[
    qn
    /* @min:%2eprocessTelemetry */
  ]), o = ye(e[
    Qs
    /* @min:%2esetNextPlugin */
  ]), a;
  e ? a = e[
    Yr
    /* @min:%2eidentifier */
  ] + "-" + e[
    Ju
    /* @min:%2epriority */
  ] + "-" + Cp++ : a = "Unknown-0-" + Cp++;
  var s = {
    getPlugin: function() {
      return e;
    },
    getNext: function() {
      return r;
    },
    processTelemetry: f,
    unload: l,
    update: v,
    _id: a,
    _setNext: function(d) {
      r = d;
    }
  };
  function c() {
    var d;
    return e && ye(e[bp]) && (d = e[bp]()), d || (d = Rn(s, t, n)), d;
  }
  function u(d, h, _, m, E) {
    var y = !1, O = e ? e[
      Yr
      /* @min:%2eidentifier */
    ] : hN, I = d[Tp];
    return I || (I = d[Tp] = {}), d.setNext(r), e && ff(d[
      ht
      /* @min:%2ecore */
    ](), function() {
      return O + ":" + _;
    }, function() {
      I[a] = !0;
      try {
        var P = r ? r._id : De;
        P && (I[P] = !1), y = h(d);
      } catch (D) {
        var B = r ? I[r._id] : !0;
        B && (y = !0), (!r || !B) && K(d[
          cr
          /* @min:%2ediagLog */
        ](), 1, 73, "Plugin [" + O + "] failed during " + _ + " - " + /* @__PURE__ */ Q(D) + ", run flags: " + /* @__PURE__ */ Q(I));
      }
    }, m, E), y;
  }
  function f(d, h) {
    h = h || c();
    function _(m) {
      if (!e || !i)
        return !1;
      var E = Wi(e);
      return E[
        ir
        /* @min:%2eteardown */
      ] || E[gv] ? !1 : (o && e[
        Qs
        /* @min:%2esetNextPlugin */
      ](r), e[
        qn
        /* @min:%2eprocessTelemetry */
      ](d, m), !0);
    }
    u(h, _, "processTelemetry", function() {
      return { item: d };
    }, !d.sync) || h[
      Lt
      /* @min:%2eprocessNext */
    ](d);
  }
  function l(d, h) {
    function _() {
      var m = !1;
      if (e) {
        var E = Wi(e), y = e[ht] || E[
          ht
          /* @min:%2ecore */
        ];
        e && (!y || y === d.core()) && !E[
          ir
          /* @min:%2eteardown */
        ] && (E[
          ht
          /* @min:%2ecore */
        ] = null, E[
          ir
          /* @min:%2eteardown */
        ] = !0, E[
          Fn
          /* @min:%2eisInitialized */
        ] = !1, e[
          ir
          /* @min:%2eteardown */
        ] && e[
          ir
          /* @min:%2eteardown */
        ](d, h) === !0 && (m = !0));
      }
      return m;
    }
    u(d, _, "unload", function() {
    }, h.isAsync) || d[
      Lt
      /* @min:%2eprocessNext */
    ](h);
  }
  function v(d, h) {
    function _() {
      var m = !1;
      if (e) {
        var E = Wi(e), y = e[ht] || E[
          ht
          /* @min:%2ecore */
        ];
        e && (!y || y === d.core()) && !E[
          ir
          /* @min:%2eteardown */
        ] && e[
          Js
          /* @min:%2eupdate */
        ] && e[
          Js
          /* @min:%2eupdate */
        ](d, h) === !0 && (m = !0);
      }
      return m;
    }
    u(d, _, "update", function() {
    }, !1) || d[
      Lt
      /* @min:%2eprocessNext */
    ](h);
  }
  return In(s);
}
function WS() {
  var e = [];
  function t(r) {
    r && e[
      Pe
      /* @min:%2epush */
    ](r);
  }
  function n(r, i) {
    J(e, function(o) {
      try {
        o(r, i);
      } catch (a) {
        K(r[
          cr
          /* @min:%2ediagLog */
        ](), 2, 73, "Unexpected error calling unload handler - " + /* @__PURE__ */ Q(a));
      }
    }), e = [];
  }
  return {
    add: t,
    run: n
  };
}
function qS() {
  var e = [];
  function t(r) {
    var i = e;
    e = [], J(i, function(o) {
      try {
        (o.rm || o.remove).call(o);
      } catch (a) {
        K(r, 2, 73, "Unloading:" + /* @__PURE__ */ Q(a));
      }
    });
  }
  function n(r) {
    r && Zo(e, r);
  }
  return {
    run: t,
    add: n
  };
}
var ad, Nr = "getPlugin", gN = (ad = {}, ad[da] = { isVal: Gi, v: {} }, ad), Fa = (
  /** @class */
  function() {
    function e() {
      var t = this, n, r, i, o, a;
      u(), Be(e, t, function(f) {
        f[
          pc
          /* @min:%2einitialize */
        ] = function(l, v, d, h) {
          c(l, v, h), n = !0;
        }, f[
          ir
          /* @min:%2eteardown */
        ] = function(l, v) {
          var d = f[
            ht
            /* @min:%2ecore */
          ];
          if (!d || l && d !== l[
            ht
            /* @min:%2ecore */
          ]())
            return;
          var h, _ = !1, m = l || lf(null, d, i && i[Nr] ? i[Nr]() : i), E = v || {
            reason: 0,
            isAsync: !1
          };
          function y() {
            _ || (_ = !0, o.run(m, v), a.run(m[
              cr
              /* @min:%2ediagLog */
            ]()), h === !0 && m[
              Lt
              /* @min:%2eprocessNext */
            ](E), u());
          }
          return !f[
            Wu
            /* @min:%2e_doTeardown */
          ] || f[
            Wu
            /* @min:%2e_doTeardown */
          ](m, E, y) !== !0 ? y() : h = !0, h;
        }, f[
          Js
          /* @min:%2eupdate */
        ] = function(l, v) {
          var d = f[
            ht
            /* @min:%2ecore */
          ];
          if (!d || l && d !== l[
            ht
            /* @min:%2ecore */
          ]())
            return;
          var h, _ = !1, m = l || i_(null, d, i && i[Nr] ? i[Nr]() : i), E = v || {
            reason: 0
            /* TelemetryUpdateReason.Unknown */
          };
          function y() {
            _ || (_ = !0, c(m.getCfg(), m.core(), m[
              Bn
              /* @min:%2egetNext */
            ]()));
          }
          return !f._doUpdate || f._doUpdate(m, E, y) !== !0 ? y() : h = !0, h;
        }, ef(f, "_addUnloadCb", function() {
          return o;
        }, "add"), ef(f, "_addHook", function() {
          return a;
        }, "add"), Le(f, "_unloadHooks", { g: function() {
          return a;
        } });
      }), t[
        cr
        /* @min:%2ediagLog */
      ] = function(f) {
        return s(f)[
          cr
          /* @min:%2ediagLog */
        ]();
      }, t[
        Fn
        /* @min:%2eisInitialized */
      ] = function() {
        return n;
      }, t.setInitialized = function(f) {
        n = f;
      }, t[
        Qs
        /* @min:%2esetNextPlugin */
      ] = function(f) {
        i = f;
      }, t[
        Lt
        /* @min:%2eprocessNext */
      ] = function(f, l) {
        l ? l[
          Lt
          /* @min:%2eprocessNext */
        ](f) : i && ye(i[
          qn
          /* @min:%2eprocessTelemetry */
        ]) && i[
          qn
          /* @min:%2eprocessTelemetry */
        ](f, null);
      }, t._getTelCtx = s;
      function s(f) {
        f === void 0 && (f = null);
        var l = f;
        if (!l) {
          var v = r || Rn(null, {}, t[
            ht
            /* @min:%2ecore */
          ]);
          i && i[Nr] ? l = v[
            ao
            /* @min:%2ecreateNew */
          ](null, i[Nr]) : l = v[
            ao
            /* @min:%2ecreateNew */
          ](null, i);
        }
        return l;
      }
      function c(f, l, v) {
        pn(f, gN, ho(l)), !v && l && (v = l[
          XE
          /* @min:%2egetProcessTelContext */
        ]()[
          Bn
          /* @min:%2egetNext */
        ]());
        var d = i;
        i && i[Nr] && (d = i[Nr]()), t[
          ht
          /* @min:%2ecore */
        ] = l, r = Rn(v, f, l, d);
      }
      function u() {
        n = !1, t[
          ht
          /* @min:%2ecore */
        ] = null, r = null, i = null, a = qS(), o = WS();
      }
    }
    return e.__ieDyn = 1, e;
  }()
);
function EN(e, t, n) {
  var r = {
    id: t,
    fn: n
  };
  Zo(e, r);
  var i = {
    remove: function() {
      J(e, function(o, a) {
        if (o.id === r.id)
          return e[
            La
            /* @min:%2esplice */
          ](a, 1), -1;
      });
    }
  };
  return i;
}
function SN(e, t, n) {
  for (var r = !1, i = e[
    pe
    /* @min:%2elength */
  ], o = 0; o < i; ++o) {
    var a = e[o];
    if (a)
      try {
        if (a.fn[
          ro
          /* @min:%2eapply */
        ](null, [t]) === !1) {
          r = !0;
          break;
        }
      } catch (s) {
        K(n, 2, 64, "Telemetry initializer failed: " + xe(s), { exception: /* @__PURE__ */ Q(s) }, !0);
      }
  }
  return !r;
}
var mN = (
  /** @class */
  function(e) {
    yr(t, e);
    function t() {
      var n = e.call(this) || this;
      n.identifier = "TelemetryInitializerPlugin", n.priority = 199;
      var r, i;
      o(), Be(t, n, function(a, s) {
        a.addTelemetryInitializer = function(c) {
          return EN(i, r++, c);
        }, a[
          qn
          /* @min:%2eprocessTelemetry */
        ] = function(c, u) {
          SN(i, c, u ? u[
            cr
            /* @min:%2ediagLog */
          ]() : a[
            cr
            /* @min:%2ediagLog */
          ]()) && a[
            Lt
            /* @min:%2eprocessNext */
          ](c, u);
        }, a[
          Wu
          /* @min:%2e_doTeardown */
        ] = function() {
          o();
        };
      });
      function o() {
        r = 0, i = [];
      }
      return n;
    }
    return t.__ieDyn = 1, t;
  }(Fa)
), Ir, jS = "Plugins must provide initialize method", wN = "_notificationManager", Np = "SDK is still unloading...", yN = "SDK is not initialized", TN = 100, bN = 5e4, sd = xa((Ir = {
  cookieCfg: {}
}, Ir[Vo] = { rdOnly: !0, ref: !0, v: [] }, Ir[Yo] = { rdOnly: !0, ref: !0, v: [] }, Ir[da] = { ref: !0, v: {} }, Ir[pv] = Un, Ir.loggingLevelConsole = 0, Ir.diagnosticLogInterval = Un, Ir));
function CN(e, t) {
  return new sN(t);
}
function NN(e, t, n) {
  var r = [], i = [], o = {};
  return J(n, function(a) {
    (/* @__PURE__ */ Y(a) || /* @__PURE__ */ Y(a[
      pc
      /* @min:%2einitialize */
    ])) && Qt(jS);
    var s = a[
      Ju
      /* @min:%2epriority */
    ], c = a[
      Yr
      /* @min:%2eidentifier */
    ];
    a && s && (/* @__PURE__ */ Y(o[s]) ? o[s] = c : Ki(e, "Two extensions have same priority #" + s + " - " + o[s] + ", " + c)), !s || s < t ? r[
      Pe
      /* @min:%2epush */
    ](a) : i[
      Pe
      /* @min:%2epush */
    ](a);
  }), {
    core: r,
    channels: i
  };
}
function Ip(e, t) {
  var n = !1;
  return J(t, function(r) {
    if (r === e)
      return n = !0, -1;
  }), n;
}
function Nv(e, t, n, r) {
  n && Ne(n, function(i, o) {
    r && /* @__PURE__ */ $t(o) && /* @__PURE__ */ $t(t[i]) && Nv(e, t[i], o, r), r && /* @__PURE__ */ $t(o) && /* @__PURE__ */ $t(t[i]) ? Nv(e, t[i], o, r) : e.set(t, i, o);
  });
}
function Dp(e, t) {
  var n = null, r = -1;
  return J(e, function(i, o) {
    if (i.w === t)
      return n = i, r = o, -1;
  }), { i: r, l: n };
}
function IN(e, t) {
  var n = Dp(e, t).l;
  return n || (n = {
    w: t,
    rm: function() {
      var r = Dp(e, t);
      r.i !== -1 && e[
        La
        /* @min:%2esplice */
      ](r.i, 1);
    }
  }, e[
    Pe
    /* @min:%2epush */
  ](n)), n;
}
function DN(e, t, n) {
  J(t, function(r) {
    var i = nt(e, r.w, n);
    delete r.w, r.rm = function() {
      i.rm();
    };
  });
}
function RN(e, t, n, r) {
  return t.add(e[
    Vi
    /* @min:%2ewatch */
  ](function(i) {
    var o = i.cfg.disableDbgExt;
    o === !0 && r && (n[
      zu
      /* @min:%2eremoveNotificationListener */
    ](r), r = null), n && !r && o !== !0 && (r = GC(i.cfg), n[
      Gu
      /* @min:%2eaddNotificationListener */
    ](r));
  })), r;
}
function PN(e) {
  return Le({
    rm: function() {
      e.rm();
    }
  }, "toJSON", { v: function() {
    return "aicore::onCfgChange<" + JSON.stringify(e) + ">";
  } });
}
var AN = (
  /** @class */
  function() {
    function e() {
      var t, n, r, i, o, a, s, c, u, f, l, v, d, h, _, m, E, y, O, I, P, B, D, b, F, U, z, ne, X, S, N, $;
      Be(e, this, function(w) {
        p(), w._getDbgPlgTargets = function() {
          return [D, i];
        }, w[
          Fn
          /* @min:%2eisInitialized */
        ] = function() {
          return n;
        }, w.activeStatus = function() {
          return U;
        }, w._setPendingStatus = function() {
          U = 3;
        }, w[
          pc
          /* @min:%2einitialize */
        ] = function(R, j, fe, oe) {
          d && Qt(Np), w[
            Fn
            /* @min:%2eisInitialized */
          ]() && Qt("Core cannot be initialized more than once"), t = pn(R, sd, fe || w[
            ot
            /* @min:%2elogger */
          ], !1), R = t.cfg, ft(t[
            Vi
            /* @min:%2ewatch */
          ](function(Oe) {
            var C = Oe.cfg, L = U === 3;
            if (!L) {
              ne = C.initInMemoMaxSize || TN;
              var V = C.instrumentationKey, H = C.endpointUrl;
              if (/* @__PURE__ */ Y(V)) {
                P = null, U = Lr.INACTIVE;
                var G = "Please provide instrumentation key";
                n ? (K(r, 1, 100, G), ie()) : Qt(G);
                return;
              }
              var ee = [];
              if (/* @__PURE__ */ Ws(V) ? (ee[
                Pe
                /* @min:%2epush */
              ](V), P = null) : P = V, /* @__PURE__ */ Ws(H) ? (ee[
                Pe
                /* @min:%2epush */
              ](H), z = null) : z = H, ee[
                pe
                /* @min:%2elength */
              ]) {
                X = !1, U = 3;
                var de = Gi(C.initTimeOut) ? C.initTimeOut : bN, me = Gb(ee);
                Wn(function() {
                  X || W();
                }, de), mr(me, function(be) {
                  try {
                    if (X)
                      return;
                    if (!be.rejected) {
                      var ke = be[
                        ks
                        /* @min:%2evalue */
                      ];
                      if (ke && ke[
                        pe
                        /* @min:%2elength */
                      ]) {
                        var rt = ke[0];
                        if (P = rt && rt[
                          ks
                          /* @min:%2evalue */
                        ], ke[
                          pe
                          /* @min:%2elength */
                        ] > 1) {
                          var on = ke[1];
                          z = on && on[
                            ks
                            /* @min:%2evalue */
                          ];
                        }
                      }
                      P && (R.instrumentationKey = P, R.endpointUrl = z);
                    }
                    W();
                  } catch {
                    X || W();
                  }
                });
              } else
                W();
              var ue = Oe.ref(Oe.cfg, da);
              Ne(ue, function(be) {
                Oe.ref(ue, be);
              });
            }
          })), o = oe, O = RN(t, y, o && w[
            $c
            /* @min:%2egetNotifyMgr */
          ](), O), He(), w[
            ot
            /* @min:%2elogger */
          ] = fe;
          var ae = R[
            Vo
            /* @min:%2eextensions */
          ];
          if (f = [], f[
            Pe
            /* @min:%2epush */
          ].apply(f, Y_(Y_([], j, !1), ae)), l = R[
            Yo
            /* @min:%2echannels */
          ], A(null), (!v || v[
            pe
            /* @min:%2elength */
          ] === 0) && Qt("No " + Yo + " available"), l && l[
            pe
            /* @min:%2elength */
          ] > 1) {
            var Ae = w[
              Xs
              /* @min:%2egetPlugin */
            ]("TeeChannelController");
            (!Ae || !Ae.plugin) && K(r, 1, 28, "TeeChannel required");
          }
          DN(R, B, r), B = null, n = !0, U === Lr.ACTIVE && ie();
        }, w.getChannels = function() {
          var R = [];
          return v && J(v, function(j) {
            R[
              Pe
              /* @min:%2epush */
            ](j);
          }), In(R);
        }, w.track = function(R) {
          ff(w[
            Qu
            /* @min:%2egetPerfMgr */
          ](), function() {
            return "AppInsightsCore:track";
          }, function() {
            R === null && ($e(R), Qt("Invalid telemetry item")), !R[
              io
              /* @min:%2ename */
            ] && /* @__PURE__ */ Y(R[
              io
              /* @min:%2ename */
            ]) && ($e(R), Qt("telemetry name required")), R.iKey = R.iKey || P, R.time = R.time || Ia(/* @__PURE__ */ new Date()), R.ver = R.ver || "4.0", !d && w[
              Fn
              /* @min:%2eisInitialized */
            ]() && U === Lr.ACTIVE ? g()[
              Lt
              /* @min:%2eprocessNext */
            ](R) : U !== Lr.INACTIVE && i[
              pe
              /* @min:%2elength */
            ] <= ne && i[
              Pe
              /* @min:%2epush */
            ](R);
          }, function() {
            return { item: R };
          }, !R.sync);
        }, w[
          XE
          /* @min:%2egetProcessTelContext */
        ] = g, w[
          $c
          /* @min:%2egetNotifyMgr */
        ] = function() {
          return o || (o = new oN(t.cfg), w[wN] = o), o;
        }, w[
          Gu
          /* @min:%2eaddNotificationListener */
        ] = function(R) {
          w.getNotifyMgr()[
            Gu
            /* @min:%2eaddNotificationListener */
          ](R);
        }, w[
          zu
          /* @min:%2eremoveNotificationListener */
        ] = function(R) {
          o && o[
            zu
            /* @min:%2eremoveNotificationListener */
          ](R);
        }, w.getCookieMgr = function() {
          return c || (c = hu(t.cfg, w[
            ot
            /* @min:%2elogger */
          ])), c;
        }, w.setCookieMgr = function(R) {
          c !== R && (ra(c, !1), c = R);
        }, w[
          Qu
          /* @min:%2egetPerfMgr */
        ] = function() {
          return a || s || cN();
        }, w.setPerfMgr = function(R) {
          a = R;
        }, w.eventCnt = function() {
          return i[
            pe
            /* @min:%2elength */
          ];
        }, w.releaseQueue = function() {
          if (n && i[
            pe
            /* @min:%2elength */
          ] > 0) {
            var R = i;
            i = [], U === 2 ? J(R, function(j) {
              j.iKey = j.iKey || P, g()[
                Lt
                /* @min:%2eprocessNext */
              ](j);
            }) : K(r, 2, 20, "core init status is not active");
          }
        }, w.pollInternalLogs = function(R) {
          return _ = R || null, $ = !1, S && S[
            ea
            /* @min:%2ecancel */
          ](), Z(!0);
        };
        function W() {
          X = !0, /* @__PURE__ */ Y(P) ? (U = Lr.INACTIVE, K(r, 1, 112, "ikey can't be resolved from promises")) : U = Lr.ACTIVE, ie();
        }
        function ie() {
          n && (w.releaseQueue(), w.pollInternalLogs());
        }
        function Z(R) {
          if ((!S || !S[
            ta
            /* @min:%2eenabled */
          ]) && !$) {
            var j = R || r && r.queue[
              pe
              /* @min:%2elength */
            ] > 0;
            j && (N || (N = !0, ft(t[
              Vi
              /* @min:%2ewatch */
            ](function(fe) {
              var oe = fe.cfg.diagnosticLogInterval;
              (!oe || !(oe > 0)) && (oe = 1e4);
              var ae = !1;
              S && (ae = S[
                ta
                /* @min:%2eenabled */
              ], S[
                ea
                /* @min:%2ecancel */
              ]()), S = J0(Se, oe), S.unref(), S[
                ta
                /* @min:%2eenabled */
              ] = ae;
            }))), S[
              ta
              /* @min:%2eenabled */
            ] = !0);
          }
          return S;
        }
        w[
          q_
          /* @min:%2estopPollingInternalLogs */
        ] = function() {
          $ = !0, S && S[
            ea
            /* @min:%2ecancel */
          ](), Se();
        }, ps(w, function() {
          return h;
        }, ["addTelemetryInitializer"]), w[
          oo
          /* @min:%2eunload */
        ] = function(R, j, fe) {
          R === void 0 && (R = !0), n || Qt(yN), d && Qt(Np);
          var oe = {
            reason: 50,
            isAsync: R,
            flushComplete: !1
          }, ae;
          R && !j && (ae = ii(function(C) {
            j = C;
          }));
          var Ae = lf(te(), w);
          Ae[
            Fc
            /* @min:%2eonComplete */
          ](function() {
            y.run(w[
              ot
              /* @min:%2elogger */
            ]), HS([c, o, r], R, function() {
              p(), j && j(oe);
            });
          }, w);
          function Oe(C) {
            oe.flushComplete = C, d = !0, E.run(Ae, oe), w[
              q_
              /* @min:%2estopPollingInternalLogs */
            ](), Ae[
              Lt
              /* @min:%2eprocessNext */
            ](oe);
          }
          return Se(), ge(R, Oe, 6, fe), ae;
        }, w[
          Xs
          /* @min:%2egetPlugin */
        ] = M, w.addPlugin = function(R, j, fe, oe) {
          if (!R) {
            oe && oe(!1), gn(jS);
            return;
          }
          var ae = M(R[
            Yr
            /* @min:%2eidentifier */
          ]);
          if (ae && !j) {
            oe && oe(!1), gn("Plugin [" + R[
              Yr
              /* @min:%2eidentifier */
            ] + "] is already loaded!");
            return;
          }
          var Ae = {
            reason: 16
            /* TelemetryUpdateReason.PluginAdded */
          };
          function Oe(V) {
            f[
              Pe
              /* @min:%2epush */
            ](R), Ae.added = [R], A(Ae), oe && oe(!0);
          }
          if (ae) {
            var C = [ae.plugin], L = {
              reason: 2,
              isAsync: !!fe
            };
            se(C, L, function(V) {
              V ? (Ae.removed = C, Ae.reason |= 32, Oe()) : oe && oe(!1);
            });
          } else
            Oe();
        }, w.updateCfg = function(R, j) {
          j === void 0 && (j = !0);
          var fe;
          if (w[
            Fn
            /* @min:%2eisInitialized */
          ]()) {
            fe = {
              reason: 1,
              cfg: t.cfg,
              oldCfg: W_({}, t.cfg),
              newConfig: W_({}, R),
              merge: j
            }, R = fe.newConfig;
            var oe = t.cfg;
            R[
              Vo
              /* @min:%2eextensions */
            ] = oe[
              Vo
              /* @min:%2eextensions */
            ], R[
              Yo
              /* @min:%2echannels */
            ] = oe[
              Yo
              /* @min:%2echannels */
            ];
          }
          t._block(function(ae) {
            var Ae = ae.cfg;
            Nv(ae, Ae, R, j), j || Ne(Ae, function(Oe) {
              Xr(R, Oe) || ae.set(Ae, Oe, Un);
            }), ae.setDf(Ae, sd);
          }, !0), t.notify(), fe && St(fe);
        }, w.evtNamespace = function() {
          return m;
        }, w.flush = ge, w.getTraceCtx = function(R) {
          return I || (I = vN()), I;
        }, w.setTraceCtx = function(R) {
          I = R || null;
        }, w.addUnloadHook = ft, ef(w, "addUnloadCb", function() {
          return E;
        }, "add"), w.onCfgChange = function(R) {
          var j;
          return n ? j = nt(t.cfg, R, w[
            ot
            /* @min:%2elogger */
          ]) : j = IN(B, R), PN(j);
        }, w.getWParam = function() {
          return /* @__PURE__ */ LE() || t.cfg.enableWParam ? 0 : -1;
        };
        function _e() {
          var R = {};
          b = [];
          var j = function(fe) {
            fe && J(fe, function(oe) {
              if (oe[
                Yr
                /* @min:%2eidentifier */
              ] && oe[
                lv
                /* @min:%2eversion */
              ] && !R[oe.identifier]) {
                var ae = oe[
                  Yr
                  /* @min:%2eidentifier */
                ] + "=" + oe[
                  lv
                  /* @min:%2eversion */
                ];
                b[
                  Pe
                  /* @min:%2epush */
                ](ae), R[oe.identifier] = oe;
              }
            });
          };
          j(v), l && J(l, function(fe) {
            j(fe);
          }), j(f);
        }
        function p() {
          n = !1, t = pn({}, sd, w[
            ot
            /* @min:%2elogger */
          ]), t.cfg[
            JE
            /* @min:%2eloggingLevelConsole */
          ] = 1, Le(w, "config", {
            g: function() {
              return t.cfg;
            },
            s: function(j) {
              w.updateCfg(j, !1);
            }
          }), Le(w, "pluginVersionStringArr", {
            g: function() {
              return b || _e(), b;
            }
          }), Le(w, "pluginVersionString", {
            g: function() {
              return F || (b || _e(), F = b.join(";")), F || De;
            }
          }), Le(w, "logger", {
            g: function() {
              return r || (r = new cf(t.cfg), t[
                ot
                /* @min:%2elogger */
              ] = r), r;
            },
            s: function(j) {
              t[
                ot
                /* @min:%2elogger */
              ] = j, r !== j && (ra(r, !1), r = j);
            }
          }), w[
            ot
            /* @min:%2elogger */
          ] = new cf(t.cfg), D = [];
          var R = w.config[
            Vo
            /* @min:%2eextensions */
          ] || [];
          R.splice(0, R[
            pe
            /* @min:%2elength */
          ]), Zo(R, D), h = new mN(), i = [], ra(o, !1), o = null, a = null, s = null, ra(c, !1), c = null, u = null, f = [], l = null, v = null, d = !1, _ = null, m = _n("AIBaseCore", !0), E = WS(), I = null, P = null, y = qS(), B = [], F = null, b = null, $ = !1, S = null, N = !1, U = 0, z = null, ne = null, X = !1;
        }
        function g() {
          var R = Rn(te(), t.cfg, w);
          return R[
            Fc
            /* @min:%2eonComplete */
          ](Z), R;
        }
        function A(R) {
          var j = NN(w[
            ot
            /* @min:%2elogger */
          ], HC, f);
          u = null, F = null, b = null, v = (l || [])[0] || [], v = od(Zo(v, j[
            Yo
            /* @min:%2echannels */
          ]));
          var fe = Zo(od(j[
            ht
            /* @min:%2ecore */
          ]), v);
          D = In(fe);
          var oe = w.config[
            Vo
            /* @min:%2eextensions */
          ] || [];
          oe.splice(0, oe[
            pe
            /* @min:%2elength */
          ]), Zo(oe, D);
          var ae = g();
          v && v[
            pe
            /* @min:%2elength */
          ] > 0 && yp(ae[
            ao
            /* @min:%2ecreateNew */
          ](v), fe), yp(ae, fe), R && St(R);
        }
        function M(R) {
          var j = null, fe = null, oe = [];
          return J(D, function(ae) {
            if (ae[
              Yr
              /* @min:%2eidentifier */
            ] === R && ae !== h)
              return fe = ae, -1;
            ae.getChannel && oe[
              Pe
              /* @min:%2epush */
            ](ae);
          }), !fe && oe[
            pe
            /* @min:%2elength */
          ] > 0 && J(oe, function(ae) {
            if (fe = ae.getChannel(R), !fe)
              return -1;
          }), fe && (j = {
            plugin: fe,
            setEnabled: function(ae) {
              Wi(fe)[gv] = !ae;
            },
            isEnabled: function() {
              var ae = Wi(fe);
              return !ae[
                ir
                /* @min:%2eteardown */
              ] && !ae[gv];
            },
            remove: function(ae, Ae) {
              ae === void 0 && (ae = !0);
              var Oe = [fe], C = {
                reason: 1,
                isAsync: ae
              };
              se(Oe, C, function(L) {
                L && A({
                  reason: 32,
                  removed: Oe
                }), Ae && Ae(L);
              });
            }
          }), j;
        }
        function te() {
          if (!u) {
            var R = (D || []).slice();
            Rt(R, h) === -1 && R[
              Pe
              /* @min:%2epush */
            ](h), u = so(od(R), t.cfg, w);
          }
          return u;
        }
        function se(R, j, fe) {
          if (R && R[
            pe
            /* @min:%2elength */
          ] > 0) {
            var oe = so(R, t.cfg, w), ae = lf(oe, w);
            ae[
              Fc
              /* @min:%2eonComplete */
            ](function() {
              var Ae = !1, Oe = [];
              J(f, function(L, V) {
                Ip(L, R) ? Ae = !0 : Oe[
                  Pe
                  /* @min:%2epush */
                ](L);
              }), f = Oe, F = null, b = null;
              var C = [];
              l && (J(l, function(L, V) {
                var H = [];
                J(L, function(G) {
                  Ip(G, R) ? Ae = !0 : H[
                    Pe
                    /* @min:%2epush */
                  ](G);
                }), C[
                  Pe
                  /* @min:%2epush */
                ](H);
              }), l = C), fe && fe(Ae), Z();
            }), ae[
              Lt
              /* @min:%2eprocessNext */
            ](j);
          } else
            fe(!1);
        }
        function Se() {
          if (r && r.queue) {
            var R = r.queue.slice(0);
            r.queue[
              pe
              /* @min:%2elength */
            ] = 0, J(R, function(j) {
              var fe = {
                name: _ || "InternalMessageId: " + j[
                  Ku
                  /* @min:%2emessageId */
                ],
                iKey: P,
                time: Ia(/* @__PURE__ */ new Date()),
                baseType: tc.dataType,
                baseData: { message: j[
                  Bi
                  /* @min:%2emessage */
                ] }
              };
              w.track(fe);
            });
          }
        }
        function ge(R, j, fe, oe) {
          var ae = 1, Ae = !1, Oe = null;
          oe = oe || 5e3;
          function C() {
            ae--, Ae && ae === 0 && (Oe && Oe[
              ea
              /* @min:%2ecancel */
            ](), Oe = null, j && j(Ae), j = null);
          }
          if (v && v[
            pe
            /* @min:%2elength */
          ] > 0) {
            var L = g()[
              ao
              /* @min:%2ecreateNew */
            ](v);
            L.iterate(function(V) {
              if (V.flush) {
                ae++;
                var H = !1;
                V.flush(R, function() {
                  H = !0, C();
                }, fe) || H || (R && Oe == null ? Oe = Wn(function() {
                  Oe = null, C();
                }, oe) : C());
              }
            });
          }
          return Ae = !0, C(), !0;
        }
        function He() {
          var R;
          ft(t[
            Vi
            /* @min:%2ewatch */
          ](function(j) {
            var fe = j.cfg.enablePerfMgr;
            if (fe) {
              var oe = j.cfg[
                pv
                /* @min:%2ecreatePerfMgr */
              ];
              (R !== oe || !R) && (oe || (oe = CN), kt(j.cfg, pv, oe), R = oe, s = null), !a && !s && ye(oe) && (s = oe(w, w[
                $c
                /* @min:%2egetNotifyMgr */
              ]()));
            } else
              s = null, R = null;
          }));
        }
        function St(R) {
          var j = i_(te(), w);
          j[
            Fc
            /* @min:%2eonComplete */
          ](Z), (!w._updateHook || w._updateHook(j, R) !== !0) && j[
            Lt
            /* @min:%2eprocessNext */
          ](R);
        }
        function gn(R) {
          var j = w[
            ot
            /* @min:%2elogger */
          ];
          j ? (K(j, 2, 73, R), Z()) : Qt(R);
        }
        function $e(R) {
          var j = w[
            $c
            /* @min:%2egetNotifyMgr */
          ]();
          j && j[
            Ms
            /* @min:%2eeventsDiscarded */
          ](
            [R],
            2
            /* eEventsDiscardedReason.InvalidEvent */
          );
        }
        function ft(R) {
          y.add(R);
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
);
function cd(e, t) {
  try {
    if (e && e !== "") {
      var n = Dn().parse(e);
      if (n && n[
        J_
        /* @min:%2eitemsReceived */
      ] && n[
        J_
        /* @min:%2eitemsReceived */
      ] >= n.itemsAccepted && n.itemsReceived - n.itemsAccepted === n.errors[
        pe
        /* @min:%2elength */
      ])
        return n;
    }
  } catch (r) {
    K(t, 1, 43, "Cannot parse the response. " + (r[
      io
      /* @min:%2ename */
    ] || /* @__PURE__ */ Q(r)), {
      response: e
    });
  }
  return null;
}
var Pn = "", ON = "NoResponseBody", Rp = "&" + ON + "=true", ud = "POST", kN = (
  /** @class */
  function() {
    function e() {
      var t = 0, n, r, i, o, a, s, c, u, f, l, v, d, h, _;
      Be(e, this, function(m, E) {
        var y = !0;
        X(), m[
          pc
          /* @min:%2einitialize */
        ] = function(S, N) {
          i = N, r && K(i, 1, 28, "Sender is already initialized"), m.SetConfig(S), r = !0;
        }, m._getDbgPlgTargets = function() {
          return [r, o, s, n];
        }, m.SetConfig = function(S) {
          try {
            if (a = S.senderOnCompleteCallBack || {}, s = !!S.disableCredentials, c = S.fetchCredentials, o = !!S.isOneDs, n = !!S.enableSendPromise, f = !!S.disableXhr, l = !!S.disableBeacon, v = !!S.disableBeaconSync, _ = S.timeWrapper, h = !!S.addNoResponse, d = !!S.disableFetchKeepAlive, u = { sendPOST: U }, o || (y = !1), s) {
              var N = Hn();
              N && N.protocol && N.protocol[
                Ca
                /* @min:%2etoLowerCase */
              ]() === "file:" && (y = !1);
            }
            return !0;
          } catch {
          }
          return !1;
        }, m.getSyncFetchPayload = function() {
          return t;
        }, m.getSenderInst = function(S, N) {
          return S && S[
            pe
            /* @min:%2elength */
          ] ? B(S, N) : null;
        }, m.getFallbackInst = function() {
          return u;
        }, m[
          Wu
          /* @min:%2e_doTeardown */
        ] = function(S, N) {
          X();
        };
        function O(S, N) {
          D(N, 200, {}, S);
        }
        function I(S, N) {
          K(i, 2, 26, "Failed to send telemetry.", { message: S }), D(N, 400, {});
        }
        function P(S) {
          I("No endpoint url is provided for the batch", S);
        }
        function B(S, N) {
          for (var $ = 0, w = null, W = 0; w == null && W < S[
            pe
            /* @min:%2elength */
          ]; )
            $ = S[W], !f && $ === 1 ? SC() ? w = ne : Kf() && (w = U) : $ === 2 && qh(N) && (!N || !d) ? w = z : $ === 3 && gs() && (N ? !v : !l) && (w = F), W++;
          return w ? {
            _transport: $,
            _isSync: N,
            sendPOST: w
          } : null;
        }
        function D(S, N, $, w) {
          try {
            S && S(N, $, w);
          } catch {
          }
        }
        function b(S, N) {
          var $ = Zn(), w = S[
            za
            /* @min:%2eurlString */
          ];
          if (!w)
            return P(N), !0;
          w = S[
            za
            /* @min:%2eurlString */
          ] + (h ? Rp : Pn);
          var W = S[
            Ho
            /* @min:%2edata */
          ], ie = o ? W : new Blob([W], { type: "text/plain;charset=UTF-8" }), Z = $.sendBeacon(w, ie);
          return Z;
        }
        function F(S, N, $) {
          var w = S[
            Ho
            /* @min:%2edata */
          ];
          try {
            if (w)
              if (b(S, N))
                O(Pn, N);
              else {
                var W = a && a.beaconOnRetry;
                W && ye(W) ? W(S, N, b) : (u && u.sendPOST(S, N, !0), K(i, 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender."));
              }
          } catch (ie) {
            o && Ki(i, "Failed to send telemetry using sendBeacon API. Ex:" + /* @__PURE__ */ Q(ie)), D(N, o ? 0 : 400, {}, Pn);
          }
        }
        function U(S, N, $) {
          var w, W, ie, Z = S[
            Pl
            /* @min:%2eheaders */
          ] || {};
          !$ && n && (w = ii(function(A, M) {
            W = A, ie = M;
          })), o && $ && S.disableXhrSync && ($ = !1);
          var _e = S[
            za
            /* @min:%2eurlString */
          ];
          if (!_e) {
            P(N), W && W(!1);
            return;
          }
          var p = rC(ud, _e, y, !0, $, S[
            Co
            /* @min:%2etimeout */
          ]);
          o || p.setRequestHeader("Content-type", "application/json"), J(sr(Z), function(A) {
            p.setRequestHeader(A, Z[A]);
          }), p.onreadystatechange = function() {
            o || (g(p), p.readyState === 4 && W && W(!0));
          }, p.onload = function() {
            o && g(p);
          };
          function g(A) {
            var M = a && a.xhrOnComplete, te = M && ye(M);
            if (te)
              M(A, N, S);
            else {
              var se = tf(A);
              D(N, A[
                hs
                /* @min:%2estatus */
              ], Wl(A, o), se);
            }
          }
          return p.onerror = function(A) {
            D(N, o ? p[
              hs
              /* @min:%2estatus */
            ] : 400, Wl(p, o), o ? Pn : nf(p)), ie && ie(A);
          }, p.ontimeout = function() {
            D(N, o ? p[
              hs
              /* @min:%2estatus */
            ] : 500, Wl(p, o), o ? Pn : nf(p)), W && W(!1);
          }, p.send(S[
            Ho
            /* @min:%2edata */
          ]), w;
        }
        function z(S, N, $) {
          var w, W = S[
            za
            /* @min:%2eurlString */
          ], ie = S[
            Ho
            /* @min:%2edata */
          ], Z = o ? ie : new Blob([ie], { type: "application/json" }), _e, p, g, A = new Headers(), M = ie[
            pe
            /* @min:%2elength */
          ], te = !1, se = !1, Se = S[
            Pl
            /* @min:%2eheaders */
          ] || {}, ge = (w = {
            method: ud,
            body: Z
          }, w[ap] = !0, w);
          S.headers && sr(S.headers)[
            pe
            /* @min:%2elength */
          ] > 0 && (J(sr(Se), function($e) {
            A.append($e, Se[$e]);
          }), ge[
            Pl
            /* @min:%2eheaders */
          ] = A), c ? ge.credentials = c : y && o && (ge.credentials = "include"), $ && (ge.keepalive = !0, t += M, o ? S._sendReason === 2 && (te = !0, h && (W += Rp)) : te = !0);
          var He = new Request(W, ge);
          try {
            He[ap] = !0;
          } catch {
          }
          if (!$ && n && (_e = ii(function($e, ft) {
            p = $e, g = ft;
          })), !W) {
            P(N), p && p(!1);
            return;
          }
          function St($e) {
            D(N, o ? 0 : 400, {}, o ? Pn : $e);
          }
          function gn($e, ft, R) {
            var j = $e[
              hs
              /* @min:%2estatus */
            ], fe = a.fetchOnComplete;
            fe && ye(fe) ? fe($e, N, R || Pn, ft) : D(N, j, {}, R || Pn);
          }
          try {
            mr(fetch(o ? W : He, o ? ge : null), function($e) {
              if ($ && (t -= M, M = 0), !se)
                if (se = !0, $e.rejected)
                  St($e.reason && $e.reason[
                    Bi
                    /* @min:%2emessage */
                  ]), g && g($e.reason);
                else {
                  var ft = $e[
                    ks
                    /* @min:%2evalue */
                  ];
                  try {
                    !o && !ft.ok ? (St(ft.statusText), p && p(!1)) : o && !ft.body ? (gn(ft, null, Pn), p && p(!0)) : mr(ft.text(), function(R) {
                      gn(ft, S, R[
                        ks
                        /* @min:%2evalue */
                      ]), p && p(!0);
                    });
                  } catch (R) {
                    St(/* @__PURE__ */ Q(R)), g && g(R);
                  }
                }
            });
          } catch ($e) {
            se || (St(/* @__PURE__ */ Q($e)), g && g($e));
          }
          return te && !se && (se = !0, D(N, 200, {}), p && p(!0)), o && !se && S[
            Co
            /* @min:%2etimeout */
          ] > 0 && _ && _.set(function() {
            se || (se = !0, D(N, 500, {}), p && p(!0));
          }, S[
            Co
            /* @min:%2etimeout */
          ]), _e;
        }
        function ne(S, N, $) {
          var w = vn(), W = new XDomainRequest(), ie = S[
            Ho
            /* @min:%2edata */
          ];
          W.onload = function() {
            var A = tf(W), M = a && a.xdrOnComplete;
            M && ye(M) ? M(W, N, S) : D(N, 200, {}, A);
          }, W.onerror = function() {
            D(N, 400, {}, o ? Pn : bS(W));
          }, W.ontimeout = function() {
            D(N, 500, {});
          }, W.onprogress = function() {
          };
          var Z = w && w.location && w.location.protocol || "", _e = S[
            za
            /* @min:%2eurlString */
          ];
          if (!_e) {
            P(N);
            return;
          }
          if (!o && _e.lastIndexOf(Z, 0) !== 0) {
            var p = "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.";
            K(i, 2, 40, ". " + p), I(p, N);
            return;
          }
          var g = o ? _e : _e[
            zi
            /* @min:%2ereplace */
          ](/^(https?:)/, "");
          W.open(ud, g), S[
            Co
            /* @min:%2etimeout */
          ] && (W[
            Co
            /* @min:%2etimeout */
          ] = S[
            Co
            /* @min:%2etimeout */
          ]), W.send(ie), o && $ ? _ && _.set(function() {
            W.send(ie);
          }, 0) : W.send(ie);
        }
        function X() {
          t = 0, r = !1, n = !1, i = null, o = null, a = null, s = null, c = null, u = null, f = !1, l = !1, v = !1, d = !1, h = !1, _ = null;
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
), XS = "on", Pp = "attachEvent", Ap = "addEventListener", Op = "detachEvent", kp = "removeEventListener", Iv = "events", Dv = "visibilitychange", qf = "pagehide", JS = "unload", QS = "beforeunload", ZS = _n("aiEvtPageHide");
_n("aiEvtPageShow");
var xN = /\.[\.]+/g, LN = /[\.]+$/, MN = 1, df = LS("events"), UN = /^([^.]*)(?:\.(.+)|)/;
function xp(e) {
  return e && e[
    zi
    /* @min:%2ereplace */
  ] ? e[
    zi
    /* @min:%2ereplace */
  ](/^[\s\.]+|(?=[\s\.])[\.\s]+$/g, De) : e;
}
function o_(e, t) {
  if (t) {
    var n = De;
    Te(t) ? (n = De, J(t, function(i) {
      i = xp(i), i && (i[0] !== "." && (i = "." + i), n += i);
    })) : n = xp(t), n && (n[0] !== "." && (n = "." + n), e = (e || De) + n);
  }
  var r = UN.exec(e || De) || [];
  return {
    type: r[1],
    ns: (r[2] || De).replace(xN, ".").replace(LN, De)[
      Na
      /* @min:%2esplit */
    ](".").sort().join(".")
  };
}
function em(e, t, n) {
  n === void 0 && (n = !0);
  var r = df.get(e, Iv, {}, n), i = r[t];
  return i || (i = r[t] = []), i;
}
function tm(e, t, n, r) {
  e && t && t[
    Jr
    /* @min:%2etype */
  ] && (e[kp] ? e[kp](t[
    Jr
    /* @min:%2etype */
  ], n, r) : e[Op] && e[Op](XS + t[
    Jr
    /* @min:%2etype */
  ], n));
}
function $N(e, t, n, r) {
  var i = !1;
  return e && t && t[
    Jr
    /* @min:%2etype */
  ] && n && (e[Ap] ? (e[Ap](t[
    Jr
    /* @min:%2etype */
  ], n, r), i = !0) : e[Pp] && (e[Pp](XS + t[
    Jr
    /* @min:%2etype */
  ], n), i = !0)), i;
}
function Lp(e, t, n, r) {
  for (var i = t[
    pe
    /* @min:%2elength */
  ]; i--; ) {
    var o = t[i];
    o && (!n.ns || n.ns === o[
      j_
      /* @min:%2eevtName */
    ].ns) && (!r || r(o)) && (tm(e, o[
      j_
      /* @min:%2eevtName */
    ], o.handler, o.capture), t[
      La
      /* @min:%2esplice */
    ](i, 1));
  }
}
function FN(e, t, n) {
  if (t[
    Jr
    /* @min:%2etype */
  ])
    Lp(e, em(e, t[
      Jr
      /* @min:%2etype */
    ]), t, n);
  else {
    var r = df.get(e, Iv, {});
    Ne(r, function(i, o) {
      Lp(e, o, t, n);
    }), sr(r)[
      pe
      /* @min:%2elength */
    ] === 0 && df.kill(e, Iv);
  }
}
function fi(e, t) {
  var n;
  return t ? (Te(t) ? n = [e].concat(t) : n = [e, t], n = o_("xx", n).ns[
    Na
    /* @min:%2esplit */
  ](".")) : n = e, n;
}
function ur(e, t, n, r, i) {
  i === void 0 && (i = !1);
  var o = !1;
  if (e)
    try {
      var a = o_(t, r);
      if (o = $N(e, a, n, i), o && df.accept(e)) {
        var s = {
          guid: MN++,
          evtName: a,
          handler: n,
          capture: i
        };
        em(e, a.type)[
          Pe
          /* @min:%2epush */
        ](s);
      }
    } catch {
    }
  return o;
}
function ha(e, t, n, r, i) {
  if (i === void 0 && (i = !1), e)
    try {
      var o = o_(t, r), a = !1;
      FN(e, o, function(s) {
        return o.ns && !n || s.handler === n ? (a = !0, !0) : !1;
      }), a || tm(e, o, n, i);
    } catch {
    }
}
function HN(e, t, n) {
  var r = !1, i = vn();
  i && (r = ur(i, e, t, n), r = ur(i.body, e, t, n) || r);
  var o = Dt();
  return o && (r = ur(o, e, t, n) || r), r;
}
function YN(e, t, n) {
  var r = vn();
  r && (ha(r, e, t, n), ha(r.body, e, t, n));
  var i = Dt();
  i && ha(i, e, t, n);
}
function vf(e, t, n, r) {
  var i = !1;
  return t && e && e[
    pe
    /* @min:%2elength */
  ] > 0 && J(e, function(o) {
    o && (!n || Rt(n, o) === -1) && (i = HN(o, t, r) || i);
  }), i;
}
function VN(e, t, n, r) {
  var i = !1;
  return t && e && Te(e) && (i = vf(e, t, n, r), !i && n && n[
    pe
    /* @min:%2elength */
  ] > 0 && (i = vf(e, t, null, r))), i;
}
function Rv(e, t, n) {
  e && Te(e) && J(e, function(r) {
    r && YN(r, t, n);
  });
}
function BN(e, t, n) {
  return VN([QS, JS, qf], e, t, n);
}
function zN(e, t) {
  Rv([QS, JS, qf], e, t);
}
function Pv(e, t, n) {
  function r(a) {
    var s = Dt();
    e && s && s.visibilityState === "hidden" && e(a);
  }
  var i = fi(ZS, n), o = vf([qf], e, t, i);
  return (!t || Rt(t, Dv) === -1) && (o = vf([Dv], r, t, i) || o), !o && t && (o = Pv(e, null, n)), o;
}
function GN(e, t) {
  var n = fi(ZS, t);
  Rv([qf], e, n), Rv([Dv], null, n);
}
var Mp = "_aiHooks", Up = [
  "req",
  "rsp",
  "hkErr",
  "fnErr"
];
function a_(e, t) {
  if (e)
    for (var n = 0; n < e[
      pe
      /* @min:%2elength */
    ] && !t(e[n], n); n++)
      ;
}
function fd(e, t, n, r, i) {
  i >= 0 && i <= 2 && a_(e, function(o, a) {
    var s = o.cbks, c = s[Up[i]];
    if (c) {
      t.ctx = function() {
        var l = r[a] = r[a] || {};
        return l;
      };
      try {
        c[
          ro
          /* @min:%2eapply */
        ](t.inst, n);
      } catch (l) {
        var u = t.err;
        try {
          var f = s[Up[
            2
            /* CallbackType.HookError */
          ]];
          f && (t.err = l, f[
            ro
            /* @min:%2eapply */
          ](t.inst, n));
        } catch {
        } finally {
          t.err = u;
        }
      }
    }
  });
}
function KN(e) {
  return function() {
    var t = this, n = arguments, r = e.h, i = {
      name: e.n,
      inst: t,
      ctx: null,
      set: c
    }, o = [], a = s([i], n);
    i.evt = /* @__PURE__ */ ut("event");
    function s(f, l) {
      return a_(l, function(v) {
        f[
          Pe
          /* @min:%2epush */
        ](v);
      }), f;
    }
    function c(f, l) {
      n = s([], n), n[f] = l, a = s([i], n);
    }
    fd(
      r,
      i,
      a,
      o,
      0
      /* CallbackType.Request */
    );
    var u = e.f;
    if (u)
      try {
        i.rslt = u[
          ro
          /* @min:%2eapply */
        ](t, n);
      } catch (f) {
        throw i.err = f, fd(
          r,
          i,
          a,
          o,
          3
          /* CallbackType.FunctionError */
        ), f;
      }
    return fd(
      r,
      i,
      a,
      o,
      1
      /* CallbackType.Response */
    ), i.rslt;
  };
}
function s_(e, t, n, r) {
  var i = null;
  return e && (/* @__PURE__ */ Mh(e, t) ? i = e : n && (i = s_(Qb(e), t, r, !1))), i;
}
function WN(e, t, n) {
  return e ? Av(e[Vn], t, n, !1) : null;
}
function nm(e, t, n, r) {
  var i = n && n[Mp];
  if (!i) {
    i = {
      i: 0,
      n: t,
      f: n,
      h: []
    };
    var o = KN(i);
    o[Mp] = i, e[t] = o;
  }
  var a = {
    // tslint:disable:object-literal-shorthand
    id: i.i,
    cbks: r,
    rm: function() {
      var s = this.id;
      a_(i.h, function(c, u) {
        if (c.id === s)
          return i.h[
            La
            /* @min:%2esplice */
          ](u, 1), 1;
      });
    }
    // tslint:enable:object-literal-shorthand
  };
  return i.i++, i.h[
    Pe
    /* @min:%2epush */
  ](a), a;
}
function Av(e, t, n, r, i) {
  if (r === void 0 && (r = !0), e && t && n) {
    var o = s_(e, t, r, i);
    if (o) {
      var a = o[t];
      if (typeof a === gE)
        return nm(o, t, a, n);
    }
  }
  return null;
}
function qc(e, t, n, r, i) {
  if (e && t && n) {
    var o = s_(e, t, r, i) || e;
    if (o)
      return nm(o, t, o[t], n);
  }
  return null;
}
var Li = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation", rm = "sampleRate", ld = "ProcessLegacy", $p = "http.method", c_ = "https://dc.services.visualstudio.com", _a = "/v2/track", jn = "not_specified", dd = "iKey", Ue = Q0({
  requestContextHeader: [0, "Request-Context"],
  requestContextTargetKey: [1, "appId"],
  requestContextAppIdFormat: [2, "appId=cid-v1:"],
  requestIdHeader: [3, "Request-Id"],
  traceParentHeader: [4, "traceparent"],
  traceStateHeader: [5, "tracestate"],
  sdkContextHeader: [6, "Sdk-Context"],
  sdkContextHeaderAppIdRequest: [7, "appId"],
  requestContextHeaderLowerCase: [8, "request-context"]
}), Da = "split", he = "length", nc = "toLowerCase", pi = "ingestionendpoint", rc = "toString", u_ = "removeItem", mc = "message", Bo = "count", vd = "preTriggerDate", hd = "getUTCDate", hf = "stringify", _d = "pathname", ic = "match", Fp = "correlationHeaderExcludePatterns", Xn = "name", Yn = "properties", fr = "measurements", pu = "sizeInBytes", gu = "typeName", Wa = "exceptions", ms = "severityLevel", pd = "problemGroup", pa = "parsedStack", _f = "hasFullStack", pf = "assembly", lr = "fileName", Ra = "line", jf = "aiDataContract", gf = "duration";
function im(e, t, n) {
  var r = t[
    he
    /* @min:%2elength */
  ], i = qN(e, t);
  if (i[
    he
    /* @min:%2elength */
  ] !== r) {
    for (var o = 0, a = i; n[a] !== void 0; )
      o++, a = Qn(i, 0, 147) + JN(o);
    i = a;
  }
  return i;
}
function qN(e, t) {
  var n;
  return t && (t = Ve(Ut(t)), t[
    he
    /* @min:%2elength */
  ] > 150 && (n = Qn(
    t,
    0,
    150
    /* DataSanitizerValues.MAX_NAME_LENGTH */
  ), K(e, 2, 57, "name is too long.  It has been truncated to 150 characters.", { name: t }, !0))), n || t;
}
function ct(e, t, n) {
  n === void 0 && (n = 1024);
  var r;
  return t && (n = n || 1024, t = Ve(Ut(t)), t[
    he
    /* @min:%2elength */
  ] > n && (r = Qn(t, 0, n), K(e, 2, 61, "string value is too long. It has been truncated to " + n + " characters.", { value: t }, !0))), r || t;
}
function Xf(e, t) {
  return am(
    e,
    t,
    2048,
    66
    /* _eInternalMessageId.UrlTooLong */
  );
}
function om(e, t) {
  var n;
  return t && t[
    he
    /* @min:%2elength */
  ] > 32768 && (n = Qn(
    t,
    0,
    32768
    /* DataSanitizerValues.MAX_MESSAGE_LENGTH */
  ), K(e, 2, 56, "message is too long, it has been truncated to 32768 characters.", { message: t }, !0)), n || t;
}
function jN(e, t) {
  var n;
  if (t) {
    var r = "" + t;
    r[
      he
      /* @min:%2elength */
    ] > 32768 && (n = Qn(
      r,
      0,
      32768
      /* DataSanitizerValues.MAX_EXCEPTION_LENGTH */
    ), K(e, 2, 52, "exception is too long, it has been truncated to 32768 characters.", { exception: t }, !0));
  }
  return n || t;
}
function _o(e, t) {
  if (t) {
    var n = {};
    Ne(t, function(r, i) {
      if (/* @__PURE__ */ qt(i) && Ec())
        try {
          i = Dn()[
            hf
            /* @min:%2estringify */
          ](i);
        } catch (o) {
          K(e, 2, 49, "custom property is not valid", { exception: o }, !0);
        }
      i = ct(
        e,
        i,
        8192
        /* DataSanitizerValues.MAX_PROPERTY_LENGTH */
      ), r = im(e, r, n), n[r] = i;
    }), t = n;
  }
  return t;
}
function po(e, t) {
  if (t) {
    var n = {};
    Ne(t, function(r, i) {
      r = im(e, r, n), n[r] = i;
    }), t = n;
  }
  return t;
}
function XN(e, t) {
  return t && am(
    e,
    t,
    128,
    69
    /* _eInternalMessageId.IdTooLong */
  )[
    rc
    /* @min:%2etoString */
  ]();
}
function am(e, t, n, r) {
  var i;
  return t && (t = Ve(Ut(t)), t[
    he
    /* @min:%2elength */
  ] > n && (i = Qn(t, 0, n), K(e, 2, r, "input is too long, it has been truncated to " + n + " characters.", { data: t }, !0))), i || t;
}
function JN(e) {
  var t = "00" + e;
  return Hr(t, t[
    he
    /* @min:%2elength */
  ] - 3);
}
var Hp = Dt() || {}, Yp = 0, QN = [null, null, null, null, null];
function f_(e) {
  var t = Yp, n = QN, r = n[t];
  return Hp.createElement ? n[t] || (r = n[t] = Hp.createElement("a")) : r = { host: tI(e) }, r.href = e, t++, t >= n[
    he
    /* @min:%2elength */
  ] && (t = 0), Yp = t, r;
}
function ZN(e) {
  var t, n = f_(e);
  return n && (t = n.href), t;
}
function eI(e, t) {
  return e ? e.toUpperCase() + " " + t : t;
}
function tI(e, t) {
  var n = sm(e) || "";
  if (n) {
    var r = n[
      ic
      /* @min:%2ematch */
    ](/(www\d{0,5}\.)?([^\/:]{1,256})(:\d{1,20})?/i);
    if (r != null && r[
      he
      /* @min:%2elength */
    ] > 3 && ce(r[2]) && r[2][
      he
      /* @min:%2elength */
    ] > 0)
      return r[2] + (r[3] || "");
  }
  return n;
}
function sm(e, t) {
  var n = null;
  if (e) {
    var r = e[
      ic
      /* @min:%2ematch */
    ](/(\w{1,150}):\/\/([^\/:]{1,256})(:\d{1,20})?/i);
    if (r != null && r[
      he
      /* @min:%2elength */
    ] > 2 && ce(r[2]) && r[2][
      he
      /* @min:%2elength */
    ] > 0 && (n = r[2] || "", r[
      he
      /* @min:%2elength */
    ] > 2)) {
      var i = (r[1] || "")[
        nc
        /* @min:%2etoLowerCase */
      ](), o = r[3] || "";
      (i === "http" && o === ":80" || i === "https" && o === ":443") && (o = ""), n += o;
    }
  }
  return n;
}
var nI = [
  c_ + _a,
  "https://breeze.aimon.applicationinsights.io" + _a,
  "https://dc-int.services.visualstudio.com" + _a
], rI = "cid-v1:";
function Ov(e) {
  return Rt(nI, e[
    nc
    /* @min:%2etoLowerCase */
  ]()) !== -1;
}
function Vp(e, t, n) {
  if (!t || e && e.disableCorrelationHeaders)
    return !1;
  if (e && e[
    Fp
    /* @min:%2ecorrelationHeaderExcludePatterns */
  ]) {
    for (var r = 0; r < e.correlationHeaderExcludePatterns[
      he
      /* @min:%2elength */
    ]; r++)
      if (e[
        Fp
        /* @min:%2ecorrelationHeaderExcludePatterns */
      ][r].test(t))
        return !1;
  }
  var i = f_(t).host[
    nc
    /* @min:%2etoLowerCase */
  ]();
  if (i && (Ft(i, ":443") !== -1 || Ft(i, ":80") !== -1) && (i = (sm(t) || "")[
    nc
    /* @min:%2etoLowerCase */
  ]()), (!e || !e.enableCorsCorrelation) && i && i !== n)
    return !1;
  var o = e && e.correlationHeaderDomains;
  if (o) {
    var a;
    if (J(o, function(u) {
      var f = new RegExp(u.toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
      a = a || f.test(i);
    }), !a)
      return !1;
  }
  var s = e && e.correlationHeaderExcludedDomains;
  if (!s || s[
    he
    /* @min:%2elength */
  ] === 0)
    return !0;
  for (var r = 0; r < s[
    he
    /* @min:%2elength */
  ]; r++) {
    var c = new RegExp(s[r].toLowerCase().replace(/\\/g, "\\\\").replace(/\./g, "\\.").replace(/\*/g, ".*"));
    if (c.test(i))
      return !1;
  }
  return i && i[
    he
    /* @min:%2elength */
  ] > 0;
}
function Bp(e) {
  if (e) {
    var t = iI(e, Ue[
      1
      /* eRequestHeaders.requestContextTargetKey */
    ]);
    if (t && t !== rI)
      return t;
  }
}
function iI(e, t) {
  if (e)
    for (var n = e[
      Da
      /* @min:%2esplit */
    ](","), r = 0; r < n[
      he
      /* @min:%2elength */
    ]; ++r) {
      var i = n[r][
        Da
        /* @min:%2esplit */
      ]("=");
      if (i[
        he
        /* @min:%2elength */
      ] === 2 && i[0] === t)
        return i[1];
    }
}
function oI(e, t, n, r) {
  var i, o = r, a = r;
  if (t && t[
    he
    /* @min:%2elength */
  ] > 0) {
    var s = f_(t);
    if (i = s.host, !o)
      if (s[
        _d
        /* @min:%2epathname */
      ] != null) {
        var c = s.pathname[
          he
          /* @min:%2elength */
        ] === 0 ? "/" : s[
          _d
          /* @min:%2epathname */
        ];
        c.charAt(0) !== "/" && (c = "/" + c), a = s[
          _d
          /* @min:%2epathname */
        ], o = ct(e, n ? n + " " + c : c);
      } else
        o = ct(e, t);
  } else
    i = r, o = r;
  return {
    target: i,
    name: o,
    data: a
  };
}
function jc() {
  var e = /* @__PURE__ */ Er();
  if (e && e.now && e.timing) {
    var t = e.now() + e.timing.navigationStart;
    if (t > 0)
      return t;
  }
  return /* @__PURE__ */ Kn();
}
function Bt(e, t) {
  var n = null;
  return e !== 0 && t !== 0 && !/* @__PURE__ */ Y(e) && !/* @__PURE__ */ Y(t) && (n = t - e), n;
}
function l_(e, t) {
  var n = e || {};
  return {
    getName: function() {
      return n[
        Xn
        /* @min:%2ename */
      ];
    },
    setName: function(r) {
      t && t.setName(r), n[
        Xn
        /* @min:%2ename */
      ] = r;
    },
    getTraceId: function() {
      return n.traceID;
    },
    setTraceId: function(r) {
      t && t.setTraceId(r), t_(r) && (n.traceID = r);
    },
    getSpanId: function() {
      return n.parentID;
    },
    setSpanId: function(r) {
      t && t.setSpanId(r), n_(r) && (n.parentID = r);
    },
    getTraceFlags: function() {
      return n.traceFlags;
    },
    setTraceFlags: function(r) {
      t && t.setTraceFlags(r), n.traceFlags = r;
    }
  };
}
var wc = jE({
  LocalStorage: 0,
  SessionStorage: 1
  /* eStorageType.SessionStorage */
}), ei = void 0, ti = void 0, cm = "";
function d_() {
  return Qf() ? Jf(wc.LocalStorage) : null;
}
function Jf(e) {
  try {
    if (/* @__PURE__ */ Y(/* @__PURE__ */ or()))
      return null;
    var t = (/* @__PURE__ */ new Date())[
      rc
      /* @min:%2etoString */
    ](), n = /* @__PURE__ */ ut(e === wc.LocalStorage ? "localStorage" : "sessionStorage"), r = cm + t;
    n.setItem(r, t);
    var i = n.getItem(r) !== t;
    if (n[
      u_
      /* @min:%2eremoveItem */
    ](r), !i)
      return n;
  } catch {
  }
  return null;
}
function v_() {
  return oc() ? Jf(wc.SessionStorage) : null;
}
function aI() {
  ei = !1, ti = !1;
}
function h_(e) {
  cm = e || "";
}
function sI() {
  ei = Qf(!0), ti = oc(!0);
}
function Qf(e) {
  return (e || ei === void 0) && (ei = !!Jf(wc.LocalStorage)), ei;
}
function um(e, t) {
  var n = d_();
  if (n !== null)
    try {
      return n.getItem(t);
    } catch (r) {
      ei = !1, K(e, 2, 1, "Browser failed read of local storage. " + xe(r), { exception: /* @__PURE__ */ Q(r) });
    }
  return null;
}
function fm(e, t, n) {
  var r = d_();
  if (r !== null)
    try {
      return r.setItem(t, n), !0;
    } catch (i) {
      ei = !1, K(e, 2, 3, "Browser failed write to local storage. " + xe(i), { exception: /* @__PURE__ */ Q(i) });
    }
  return !1;
}
function cI(e, t) {
  var n = d_();
  if (n !== null)
    try {
      return n[
        u_
        /* @min:%2eremoveItem */
      ](t), !0;
    } catch (r) {
      ei = !1, K(e, 2, 5, "Browser failed removal of local storage item. " + xe(r), { exception: /* @__PURE__ */ Q(r) });
    }
  return !1;
}
function oc(e) {
  return (e || ti === void 0) && (ti = !!Jf(wc.SessionStorage)), ti;
}
function kv(e, t) {
  var n = v_();
  if (n !== null)
    try {
      return n.getItem(t);
    } catch (r) {
      ti = !1, K(e, 2, 2, "Browser failed read of session storage. " + xe(r), { exception: /* @__PURE__ */ Q(r) });
    }
  return null;
}
function lm(e, t, n) {
  var r = v_();
  if (r !== null)
    try {
      return r.setItem(t, n), !0;
    } catch (i) {
      ti = !1, K(e, 2, 4, "Browser failed write to session storage. " + xe(i), { exception: /* @__PURE__ */ Q(i) });
    }
  return !1;
}
function dm(e, t) {
  var n = v_();
  if (n !== null)
    try {
      return n[
        u_
        /* @min:%2eremoveItem */
      ](t), !0;
    } catch (r) {
      ti = !1, K(e, 2, 6, "Browser failed removal of session storage item. " + xe(r), { exception: /* @__PURE__ */ Q(r) });
    }
  return !1;
}
var uI = "appInsightsThrottle", fI = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = this, i, o, a, s, c, u, f, l = !1, v = !1;
      h(), r._getDbgPlgTargets = function() {
        return [f];
      }, r.getConfig = function() {
        return a;
      }, r.canThrottle = function(S) {
        var N = z(S), $ = _(S);
        return y($, i, N);
      }, r.isTriggered = function(S) {
        return ne(S);
      }, r.isReady = function() {
        return l;
      }, r.flush = function(S) {
        try {
          var N = X(S);
          if (N && N[
            he
            /* @min:%2elength */
          ] > 0) {
            var $ = N.slice(0);
            return f[S] = [], J($, function(w) {
              d(w.msgID, w[
                mc
                /* @min:%2emessage */
              ], w.severity, !1);
            }), !0;
          }
        } catch {
        }
        return !1;
      }, r.flushAll = function() {
        try {
          if (f) {
            var S = !0;
            return Ne(f, function(N) {
              var $ = r.flush(parseInt(N));
              S = S && $;
            }), S;
          }
        } catch {
        }
        return !1;
      }, r.onReadyState = function(S, N) {
        return N === void 0 && (N = !0), l = /* @__PURE__ */ Y(S) ? !0 : S, l && N ? r.flushAll() : null;
      }, r.sendMessage = function(S, N, $) {
        return d(S, N, $, !0);
      };
      function d(S, N, $, w) {
        if (l) {
          var W = U(S);
          if (!W)
            return;
          var ie = _(S), Z = z(S), _e = y(ie, i, Z), p = !1, g = 0, A = ne(S);
          try {
            _e && !A ? (g = kE(ie.limit.maxSendNumber, Z[
              Bo
              /* @min:%2ecount */
            ] + 1), Z[
              Bo
              /* @min:%2ecount */
            ] = 0, p = !0, c[S] = !0, Z[
              vd
              /* @min:%2epreTriggerDate */
            ] = /* @__PURE__ */ new Date()) : (c[S] = _e, Z[
              Bo
              /* @min:%2ecount */
            ] += 1);
            var M = O(S);
            D(o, M, Z);
            for (var te = 0; te < g; te++)
              F(S, o, N, $);
          } catch {
          }
          return {
            isThrottled: p,
            throttleNum: g
          };
        } else if (w) {
          var se = X(S);
          se.push({
            msgID: S,
            message: N,
            severity: $
          });
        }
        return null;
      }
      function h() {
        o = ho(t), c = {}, s = {}, f = {}, a = {}, m(
          109
          /* _eInternalMessageId.DefaultThrottleMsgKey */
        ), u = Gi(n) ? n : "", t.addUnloadHook(nt(t.config, function(S) {
          var N = S.cfg;
          i = Qf();
          var $ = N.throttleMgrCfg || {};
          Ne($, function(w, W) {
            m(parseInt(w), W);
          });
        }));
      }
      function _(S) {
        return a[S] || a[
          109
          /* _eInternalMessageId.DefaultThrottleMsgKey */
        ];
      }
      function m(S, N) {
        var $, w;
        try {
          var W = N || {}, ie = {};
          ie.disabled = !!W.disabled;
          var Z = W.interval || {};
          v = (Z == null ? void 0 : Z.daysOfMonth) && (Z == null ? void 0 : Z.daysOfMonth[
            he
            /* @min:%2elength */
          ]) > 0, ie.interval = E(Z);
          var _e = {
            samplingRate: (($ = W.limit) === null || $ === void 0 ? void 0 : $.samplingRate) || 100,
            // dafault: every time sent only 1 event
            maxSendNumber: ((w = W.limit) === null || w === void 0 ? void 0 : w.maxSendNumber) || 1
          };
          ie.limit = _e, a[S] = ie;
        } catch {
        }
      }
      function E(S) {
        S = S || {};
        var N = S == null ? void 0 : S.monthInterval, $ = S == null ? void 0 : S.dayInterval;
        return /* @__PURE__ */ Y(N) && /* @__PURE__ */ Y($) && (S.monthInterval = 3, v || (S.daysOfMonth = [28], v = !0)), S = {
          // dafault: sent every three months
          monthInterval: S == null ? void 0 : S.monthInterval,
          dayInterval: S == null ? void 0 : S.dayInterval,
          daysOfMonth: S == null ? void 0 : S.daysOfMonth
        }, S;
      }
      function y(S, N, $) {
        if (S && !S.disabled && N && Gi($)) {
          var w = B(), W = $.date, ie = S.interval, Z = 1;
          if (ie != null && ie.monthInterval) {
            var _e = (w.getUTCFullYear() - W.getUTCFullYear()) * 12 + w.getUTCMonth() - W.getUTCMonth();
            Z = b(ie.monthInterval, 0, _e);
          }
          var p = 1;
          if (v)
            p = Rt(ie.daysOfMonth, w[
              hd
              /* @min:%2egetUTCDate */
            ]());
          else if (ie != null && ie.dayInterval) {
            var g = tn((w.getTime() - W.getTime()) / 864e5);
            p = b(ie.dayInterval, 0, g);
          }
          return Z >= 0 && p >= 0;
        }
        return !1;
      }
      function O(S, N) {
        var $ = Gi(N) ? N : "";
        return S ? uI + $ + "-" + S : null;
      }
      function I(S) {
        try {
          if (S) {
            var N = /* @__PURE__ */ new Date();
            return S.getUTCFullYear() === N.getUTCFullYear() && S.getUTCMonth() === N.getUTCMonth() && S[
              hd
              /* @min:%2egetUTCDate */
            ]() === N[
              hd
              /* @min:%2egetUTCDate */
            ]();
          }
        } catch {
        }
        return !1;
      }
      function P(S, N, $) {
        try {
          var w = {
            date: B(),
            count: 0
          };
          if (S) {
            var W = JSON.parse(S), ie = {
              date: B(W.date) || w.date,
              count: W[
                Bo
                /* @min:%2ecount */
              ] || w[
                Bo
                /* @min:%2ecount */
              ],
              preTriggerDate: W.preTriggerDate ? B(W[
                vd
                /* @min:%2epreTriggerDate */
              ]) : void 0
            };
            return ie;
          } else
            return D(N, $, w), w;
        } catch {
        }
        return null;
      }
      function B(S) {
        try {
          if (S) {
            var N = new Date(S);
            if (!isNaN(N.getDate()))
              return N;
          } else
            return /* @__PURE__ */ new Date();
        } catch {
        }
        return null;
      }
      function D(S, N, $) {
        try {
          return fm(S, N, Ve(JSON[
            hf
            /* @min:%2estringify */
          ]($)));
        } catch {
        }
        return !1;
      }
      function b(S, N, $) {
        return S <= 0 ? 1 : $ >= N && ($ - N) % S == 0 ? tn(($ - N) / S) + 1 : -1;
      }
      function F(S, N, $, w) {
        K(N, w || 1, S, $);
      }
      function U(S) {
        try {
          var N = _(S);
          return CC(1e6) <= N.limit.samplingRate;
        } catch {
        }
        return !1;
      }
      function z(S) {
        try {
          var N = s[S];
          if (!N) {
            var $ = O(S, u);
            N = P(um(o, $), o, $), s[S] = N;
          }
          return s[S];
        } catch {
        }
        return null;
      }
      function ne(S) {
        var N = c[S];
        if (/* @__PURE__ */ Y(N)) {
          N = !1;
          var $ = z(S);
          $ && (N = I($[
            vd
            /* @min:%2epreTriggerDate */
          ])), c[S] = N;
        }
        return c[S];
      }
      function X(S) {
        return f = f || {}, /* @__PURE__ */ Y(f[S]) && (f[S] = []), f[S];
      }
    }
    return e;
  }()
), lI = ";", dI = "=";
function zp(e) {
  if (!e)
    return {};
  var t = e[
    Da
    /* @min:%2esplit */
  ](lI), n = A0(t, function(i, o) {
    var a = o[
      Da
      /* @min:%2esplit */
    ](dI);
    if (a[
      he
      /* @min:%2elength */
    ] === 2) {
      var s = a[0][
        nc
        /* @min:%2etoLowerCase */
      ](), c = a[1];
      i[s] = c;
    }
    return i;
  }, {});
  if (sr(n)[
    he
    /* @min:%2elength */
  ] > 0) {
    if (n.endpointsuffix) {
      var r = n.location ? n.location + "." : "";
      n[
        pi
        /* @min:%2eingestionendpoint */
      ] = n[
        pi
        /* @min:%2eingestionendpoint */
      ] || "https://" + r + "dc." + n.endpointsuffix;
    }
    n[
      pi
      /* @min:%2eingestionendpoint */
    ] = n[
      pi
      /* @min:%2eingestionendpoint */
    ] || c_, WE(n[
      pi
      /* @min:%2eingestionendpoint */
    ], "/") && (n[
      pi
      /* @min:%2eingestionendpoint */
    ] = n[
      pi
      /* @min:%2eingestionendpoint */
    ].slice(0, -1));
  }
  return n;
}
var vI = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n, r) {
      var i = this, o = this;
      o.ver = 1, o.sampleRate = 100, o.tags = {}, o[
        Xn
        /* @min:%2ename */
      ] = ct(t, r) || jn, o.data = n, o.time = Ia(/* @__PURE__ */ new Date()), o[
        jf
        /* @min:%2eaiDataContract */
      ] = {
        time: 1,
        iKey: 1,
        name: 1,
        sampleRate: function() {
          return i.sampleRate === 100 ? 4 : 1;
        },
        tags: 1,
        data: 1
        /* FieldType.Required */
      };
    }
    return e;
  }()
), Vr = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      this.aiDataContract = {
        ver: 1,
        name: 1,
        properties: 0,
        measurements: 0
        /* FieldType.Default */
      };
      var o = this;
      o.ver = 2, o[
        Xn
        /* @min:%2ename */
      ] = ct(t, n) || jn, o[
        Yn
        /* @min:%2eproperties */
      ] = _o(t, r), o[
        fr
        /* @min:%2emeasurements */
      ] = po(t, i);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Event", e.dataType = "EventData", e;
  }()
), hI = 58, _I = /^\s{0,50}(from\s|at\s|Line\s{1,5}\d{1,10}\s{1,5}of|\w{1,50}@\w{1,80}|[^\(\s\n]+:[0-9\?]+(?::[0-9\?]+)?)/, pI = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+):([0-9\?]+)\)?$/, gI = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\]]+):([0-9\?]+)\)?$/, EI = /^(?:\s{0,50}at)?\s{0,50}([^\@\()\s]+)?\s{0,50}(?:\s|\@|\()\s{0,5}([^\(\s\n\)\]]+)\)?$/, SI = /(?:^|\(|\s{0,10}[\w\)]+\@)?([^\(\n\s\]\)]+)(?:\:([0-9]+)(?:\:([0-9]+))?)?\)?(?:,|$)/, mI = /([^\(\s\n]+):([0-9]+):([0-9]+)$/, wI = /([^\(\s\n]+):([0-9]+)$/, Gp = "<no_method>", ga = "error", cn = "stack", xv = "stackDetails", Kp = "errorSrc", Lv = "message", vm = "description", Wp = [
  { re: pI, len: 5, m: 1, fn: 2, ln: 3, col: 4 },
  { chk: TI, pre: yI, re: gI, len: 4, m: 1, fn: 2, ln: 3 },
  { re: EI, len: 3, m: 1, fn: 2, hdl: jp },
  { re: SI, len: 2, fn: 1, hdl: jp }
];
function yI(e) {
  return e.replace(/(\(anonymous\))/, "<anonymous>");
}
function TI(e) {
  return Ft(e, "[native") < 0;
}
function Mv(e, t) {
  var n = e;
  return n && !ce(n) && (JSON && JSON[
    hf
    /* @min:%2estringify */
  ] ? (n = JSON[
    hf
    /* @min:%2estringify */
  ](e), t && (!n || n === "{}") && (ye(e[
    rc
    /* @min:%2etoString */
  ]) ? n = e[
    rc
    /* @min:%2etoString */
  ]() : n = "" + e)) : n = "" + e + " - (Missing JSON.stringify)"), n || "";
}
function hm(e, t) {
  var n = e;
  return e && (n && !ce(n) && (n = e[Lv] || e[vm] || n), n && !ce(n) && (n = Mv(n, !0)), e.filename && (n = n + " @" + (e.filename || "") + ":" + (e.lineno || "?") + ":" + (e.colno || "?"))), t && t !== "String" && t !== "Object" && t !== "Error" && Ft(n || "", t) === -1 && (n = t + ": " + n), n || "";
}
function bI(e) {
  try {
    if (/* @__PURE__ */ qt(e))
      return "hasFullStack" in e && "typeName" in e;
  } catch {
  }
  return !1;
}
function CI(e) {
  try {
    if (/* @__PURE__ */ qt(e))
      return "ver" in e && "exceptions" in e && "properties" in e;
  } catch {
  }
  return !1;
}
function qp(e) {
  return e && e.src && ce(e.src) && e.obj && Te(e.obj);
}
function gi(e) {
  var t = e || "";
  ce(t) || (ce(t[cn]) ? t = t[cn] : t = "" + t);
  var n = t[
    Da
    /* @min:%2esplit */
  ](`
`);
  return {
    src: t,
    obj: n
  };
}
function NI(e) {
  for (var t = [], n = e[
    Da
    /* @min:%2esplit */
  ](`
`), r = 0; r < n[
    he
    /* @min:%2elength */
  ]; r++) {
    var i = n[r];
    n[r + 1] && (i += "@" + n[r + 1], r++), t.push(i);
  }
  return {
    src: e,
    obj: t
  };
}
function _m(e) {
  var t = null;
  if (e)
    try {
      if (e[cn])
        t = gi(e[cn]);
      else if (e[ga] && e[ga][cn])
        t = gi(e[ga][cn]);
      else if (e.exception && e.exception[cn])
        t = gi(e.exception[cn]);
      else if (qp(e))
        t = e;
      else if (qp(e[xv]))
        t = e[xv];
      else if (vn() && vn().opera && e[Lv])
        t = NI(e[
          mc
          /* @min:%2emessage */
        ]);
      else if (e.reason && e.reason[cn])
        t = gi(e.reason[cn]);
      else if (ce(e))
        t = gi(e);
      else {
        var n = e[Lv] || e[vm] || "";
        ce(e[Kp]) && (n && (n += `
`), n += " from " + e[Kp]), n && (t = gi(n));
      }
    } catch (r) {
      t = gi(r);
    }
  return t || {
    src: "",
    obj: null
  };
}
function II(e) {
  var t = "";
  return e && (e.obj ? t = e.obj.join(`
`) : t = e.src || ""), t;
}
function DI(e) {
  var t, n = e.obj;
  if (n && n[
    he
    /* @min:%2elength */
  ] > 0) {
    t = [];
    var r = 0, i = !1, o = 0;
    J(n, function(_) {
      if (i || OI(_)) {
        var m = Ut(_);
        i = !0;
        var E = kI(m, r);
        E && (o += E[
          pu
          /* @min:%2esizeInBytes */
        ], t.push(E), r++);
      }
    });
    var a = 32 * 1024;
    if (o > a)
      for (var s = 0, c = t[
        he
        /* @min:%2elength */
      ] - 1, u = 0, f = s, l = c; s < c; ) {
        var v = t[s][
          pu
          /* @min:%2esizeInBytes */
        ], d = t[c][
          pu
          /* @min:%2esizeInBytes */
        ];
        if (u += v + d, u > a) {
          var h = l - f + 1;
          t.splice(f, h);
          break;
        }
        f = s, l = c, s++, c--;
      }
  }
  return t;
}
function Ef(e) {
  var t = "";
  if (e && (t = e.typeName || e[
    Xn
    /* @min:%2ename */
  ] || "", !t))
    try {
      var n = /function (.{1,200})\(/, r = n.exec(e.constructor[
        rc
        /* @min:%2etoString */
      ]());
      t = r && r[
        he
        /* @min:%2elength */
      ] > 1 ? r[1] : "";
    } catch {
    }
  return t;
}
function gd(e) {
  if (e)
    try {
      if (!ce(e)) {
        var t = Ef(e), n = Mv(e, !1);
        return (!n || n === "{}") && (e[ga] && (e = e[ga], t = Ef(e)), n = Mv(e, !0)), Ft(n, t) !== 0 && t !== "String" ? t + ":" + n : n;
      }
    } catch {
    }
  return "" + (e || "");
}
var un = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a) {
      this.aiDataContract = {
        ver: 1,
        exceptions: 1,
        severityLevel: 0,
        properties: 0,
        measurements: 0
        /* FieldType.Default */
      };
      var s = this;
      s.ver = 2, CI(n) ? (s[
        Wa
        /* @min:%2eexceptions */
      ] = n[
        Wa
        /* @min:%2eexceptions */
      ] || [], s[
        Yn
        /* @min:%2eproperties */
      ] = n[
        Yn
        /* @min:%2eproperties */
      ], s[
        fr
        /* @min:%2emeasurements */
      ] = n[
        fr
        /* @min:%2emeasurements */
      ], n[
        ms
        /* @min:%2eseverityLevel */
      ] && (s[
        ms
        /* @min:%2eseverityLevel */
      ] = n[
        ms
        /* @min:%2eseverityLevel */
      ]), n.id && (s.id = n.id, n[
        Yn
        /* @min:%2eproperties */
      ].id = n.id), n[
        pd
        /* @min:%2eproblemGroup */
      ] && (s[
        pd
        /* @min:%2eproblemGroup */
      ] = n[
        pd
        /* @min:%2eproblemGroup */
      ]), /* @__PURE__ */ Y(n.isManual) || (s.isManual = n.isManual)) : (r || (r = {}), a && (r.id = a), s[
        Wa
        /* @min:%2eexceptions */
      ] = [pm(t, n, r)], s[
        Yn
        /* @min:%2eproperties */
      ] = _o(t, r), s[
        fr
        /* @min:%2emeasurements */
      ] = po(t, i), o && (s[
        ms
        /* @min:%2eseverityLevel */
      ] = o), a && (s.id = a));
    }
    return e.CreateAutoException = function(t, n, r, i, o, a, s, c) {
      var u = Ef(o || a || t);
      return {
        message: hm(t, u),
        url: n,
        lineNumber: r,
        columnNumber: i,
        error: gd(o || a || t),
        evt: gd(a || t),
        typeName: u,
        stackDetails: _m(s || o || a),
        errorSrc: c
      };
    }, e.CreateFromInterface = function(t, n, r, i) {
      var o = n[
        Wa
        /* @min:%2eexceptions */
      ] && js(n[
        Wa
        /* @min:%2eexceptions */
      ], function(s) {
        return AI(t, s);
      }), a = new e(t, Mt(Mt({}, n), { exceptions: o }), r, i);
      return a;
    }, e.prototype.toInterface = function() {
      var t = this, n = t.exceptions, r = t.properties, i = t.measurements, o = t.severityLevel, a = t.problemGroup, s = t.id, c = t.isManual, u = n instanceof Array && js(n, function(f) {
        return f.toInterface();
      }) || void 0;
      return {
        ver: "4.0",
        exceptions: u,
        severityLevel: o,
        properties: r,
        measurements: i,
        problemGroup: a,
        id: s,
        isManual: c
      };
    }, e.CreateSimpleException = function(t, n, r, i, o, a) {
      var s;
      return {
        exceptions: [
          (s = {}, s[
            _f
            /* @min:hasFullStack */
          ] = !0, s.message = t, s.stack = o, s.typeName = n, s)
        ]
      };
    }, e.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception", e.dataType = "ExceptionData", e.formatError = gd, e;
  }()
), RI = In({
  id: 0,
  outerId: 0,
  typeName: 1,
  message: 1,
  hasFullStack: 0,
  stack: 0,
  parsedStack: 2
  /* FieldType.Array */
});
function PI() {
  var e = this, t = Te(e[
    pa
    /* @min:%2eparsedStack */
  ]) && js(e[
    pa
    /* @min:%2eparsedStack */
  ], function(r) {
    return LI(r);
  }), n = {
    id: e.id,
    outerId: e.outerId,
    typeName: e[
      gu
      /* @min:%2etypeName */
    ],
    message: e[
      mc
      /* @min:%2emessage */
    ],
    hasFullStack: e[
      _f
      /* @min:%2ehasFullStack */
    ],
    stack: e[cn],
    parsedStack: t || void 0
  };
  return n;
}
function pm(e, t, n) {
  var r, i, o, a, s, c, u, f;
  if (bI(t))
    a = t[
      gu
      /* @min:%2etypeName */
    ], s = t[
      mc
      /* @min:%2emessage */
    ], u = t[cn], f = t[
      pa
      /* @min:%2eparsedStack */
    ] || [], c = t[
      _f
      /* @min:%2ehasFullStack */
    ];
  else {
    var l = t, v = l && l.evt;
    xh(l) || (l = l[ga] || v || l), a = ct(e, Ef(l)) || jn, s = om(e, hm(t || l, a)) || jn;
    var d = t[xv] || _m(t);
    f = DI(d), Te(f) && js(f, function(h) {
      h[
        pf
        /* @min:%2eassembly */
      ] = ct(e, h[
        pf
        /* @min:%2eassembly */
      ]), h[
        lr
        /* @min:%2efileName */
      ] = ct(e, h[
        lr
        /* @min:%2efileName */
      ]);
    }), u = jN(e, II(d)), c = Te(f) && f[
      he
      /* @min:%2elength */
    ] > 0, n && (n[
      gu
      /* @min:%2etypeName */
    ] = n[
      gu
      /* @min:%2etypeName */
    ] || a);
  }
  return r = {}, r[
    jf
    /* @min:aiDataContract */
  ] = RI, r.id = i, r.outerId = o, r.typeName = a, r.message = s, r[
    _f
    /* @min:hasFullStack */
  ] = c, r.stack = u, r.parsedStack = f, r.toInterface = PI, r;
}
function AI(e, t) {
  var n = Te(t[
    pa
    /* @min:%2eparsedStack */
  ]) && js(t[
    pa
    /* @min:%2eparsedStack */
  ], function(i) {
    return xI(i);
  }) || t[
    pa
    /* @min:%2eparsedStack */
  ], r = pm(e, Mt(Mt({}, t), { parsedStack: n }));
  return r;
}
function gm(e, t) {
  var n = t[
    ic
    /* @min:%2ematch */
  ](mI);
  if (n && n[
    he
    /* @min:%2elength */
  ] >= 4)
    e[
      lr
      /* @min:%2efileName */
    ] = n[1], e[
      Ra
      /* @min:%2eline */
    ] = parseInt(n[2]);
  else {
    var r = t[
      ic
      /* @min:%2ematch */
    ](wI);
    r && r[
      he
      /* @min:%2elength */
    ] >= 3 ? (e[
      lr
      /* @min:%2efileName */
    ] = r[1], e[
      Ra
      /* @min:%2eline */
    ] = parseInt(r[2])) : e[
      lr
      /* @min:%2efileName */
    ] = t;
  }
}
function jp(e, t, n) {
  var r = e[
    lr
    /* @min:%2efileName */
  ];
  t.fn && n && n[
    he
    /* @min:%2elength */
  ] > t.fn && (t.ln && n[
    he
    /* @min:%2elength */
  ] > t.ln ? (r = Ve(n[t.fn] || ""), e[
    Ra
    /* @min:%2eline */
  ] = parseInt(Ve(n[t.ln] || "")) || 0) : r = Ve(n[t.fn] || "")), r && gm(e, r);
}
function OI(e) {
  var t = !1;
  if (e && ce(e)) {
    var n = Ve(e);
    n && (t = _I.test(n));
  }
  return t;
}
var Em = In({
  level: 1,
  method: 1,
  assembly: 0,
  fileName: 0,
  line: 0
  /* FieldType.Default */
});
function kI(e, t) {
  var n, r;
  if (e && ce(e) && Ve(e)) {
    r = (n = {}, n[
      jf
      /* @min:aiDataContract */
    ] = Em, n.level = t, n.assembly = Ve(e), n.method = Gp, n.fileName = "", n.line = 0, n.sizeInBytes = 0, n);
    for (var i = 0; i < Wp[
      he
      /* @min:%2elength */
    ]; ) {
      var o = Wp[i];
      if (o.chk && !o.chk(e))
        break;
      o.pre && (e = o.pre(e));
      var a = e[
        ic
        /* @min:%2ematch */
      ](o.re);
      if (a && a[
        he
        /* @min:%2elength */
      ] >= o.len) {
        o.m && (r.method = Ve(a[o.m] || Gp)), o.hdl ? o.hdl(r, o, a) : o.fn && (o.ln ? (r[
          lr
          /* @min:%2efileName */
        ] = Ve(a[o.fn] || ""), r[
          Ra
          /* @min:%2eline */
        ] = parseInt(Ve(a[o.ln] || "")) || 0) : gm(r, a[o.fn] || ""));
        break;
      }
      i++;
    }
  }
  return Sm(r);
}
function xI(e) {
  var t, n = (t = {}, t[
    jf
    /* @min:aiDataContract */
  ] = Em, t.level = e.level, t.method = e.method, t.assembly = e[
    pf
    /* @min:%2eassembly */
  ], t.fileName = e[
    lr
    /* @min:%2efileName */
  ], t.line = e[
    Ra
    /* @min:%2eline */
  ], t.sizeInBytes = 0, t);
  return Sm(n);
}
function Sm(e) {
  var t = hI;
  return e && (t += e.method[
    he
    /* @min:%2elength */
  ], t += e.assembly[
    he
    /* @min:%2elength */
  ], t += e.fileName[
    he
    /* @min:%2elength */
  ], t += e.level.toString()[
    he
    /* @min:%2elength */
  ], t += e.line.toString()[
    he
    /* @min:%2elength */
  ], e[
    pu
    /* @min:%2esizeInBytes */
  ] = t), e;
}
function LI(e) {
  return {
    level: e.level,
    method: e.method,
    assembly: e[
      pf
      /* @min:%2eassembly */
    ],
    fileName: e[
      lr
      /* @min:%2efileName */
    ],
    line: e[
      Ra
      /* @min:%2eline */
    ]
  };
}
var MI = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.aiDataContract = {
        name: 1,
        kind: 0,
        value: 1,
        count: 0,
        min: 0,
        max: 0,
        stdDev: 0
        /* FieldType.Default */
      }, this.kind = 0;
    }
    return e;
  }()
), qi = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a, s, c, u) {
      this.aiDataContract = {
        ver: 1,
        metrics: 1,
        properties: 0
        /* FieldType.Default */
      };
      var f = this;
      f.ver = 2;
      var l = new MI();
      l[
        Bo
        /* @min:%2ecount */
      ] = i > 0 ? i : void 0, l.max = isNaN(a) || a === null ? void 0 : a, l.min = isNaN(o) || o === null ? void 0 : o, l[
        Xn
        /* @min:%2ename */
      ] = ct(t, n) || jn, l.value = r, l.stdDev = isNaN(s) || s === null ? void 0 : s, f.metrics = [l], f[
        Yn
        /* @min:%2eproperties */
      ] = _o(t, c), f[
        fr
        /* @min:%2emeasurements */
      ] = po(t, u);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric", e.dataType = "MetricData", e;
  }()
), qa = "";
function Br(e) {
  (isNaN(e) || e < 0) && (e = 0), e = zE(e);
  var t = qa + e % 1e3, n = qa + tn(e / 1e3) % 60, r = qa + tn(e / (1e3 * 60)) % 60, i = qa + tn(e / (1e3 * 60 * 60)) % 24, o = tn(e / (1e3 * 60 * 60 * 24));
  return t = t[
    he
    /* @min:%2elength */
  ] === 1 ? "00" + t : t[
    he
    /* @min:%2elength */
  ] === 2 ? "0" + t : t, n = n[
    he
    /* @min:%2elength */
  ] < 2 ? "0" + n : n, r = r[
    he
    /* @min:%2elength */
  ] < 2 ? "0" + r : r, i = i[
    he
    /* @min:%2elength */
  ] < 2 ? "0" + i : i, (o > 0 ? o + "." : qa) + i + ":" + r + ":" + n + "." + t;
}
function UI(e, t, n, r, i) {
  return !i && ce(e) && (e === "Script error." || e === "Script error");
}
var ni = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a, s) {
      this.aiDataContract = {
        ver: 1,
        name: 0,
        url: 0,
        duration: 0,
        properties: 0,
        measurements: 0,
        id: 0
        /* FieldType.Default */
      };
      var c = this;
      c.ver = 2, c.id = XN(t, s), c.url = Xf(t, r), c[
        Xn
        /* @min:%2ename */
      ] = ct(t, n) || jn, isNaN(i) || (c[
        gf
        /* @min:%2eduration */
      ] = Br(i)), c[
        Yn
        /* @min:%2eproperties */
      ] = _o(t, o), c[
        fr
        /* @min:%2emeasurements */
      ] = po(t, a);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview", e.dataType = "PageviewData", e;
  }()
), ji = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a, s, c, u, f, l, v) {
      u === void 0 && (u = "Ajax"), this.aiDataContract = {
        id: 1,
        ver: 1,
        name: 0,
        resultCode: 0,
        duration: 0,
        success: 0,
        data: 0,
        target: 0,
        type: 0,
        properties: 0,
        measurements: 0,
        kind: 0,
        value: 0,
        count: 0,
        min: 0,
        max: 0,
        stdDev: 0,
        dependencyKind: 0,
        dependencySource: 0,
        commandName: 0,
        dependencyTypeName: 0
        /* FieldType.Default */
      };
      var d = this;
      d.ver = 2, d.id = n, d[
        gf
        /* @min:%2eduration */
      ] = Br(o), d.success = a, d.resultCode = s + "", d.type = ct(t, u);
      var h = oI(t, r, c, i);
      d.data = Xf(t, i) || h.data, d.target = ct(t, h.target), f && (d.target = "".concat(d.target, " | ").concat(f)), d[
        Xn
        /* @min:%2ename */
      ] = ct(t, h[
        Xn
        /* @min:%2ename */
      ]), d[
        Yn
        /* @min:%2eproperties */
      ] = _o(t, l), d[
        fr
        /* @min:%2emeasurements */
      ] = po(t, v);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency", e.dataType = "RemoteDependencyData", e;
  }()
), Ea = (
  /** @class */
  function() {
    function e(t, n, r, i, o) {
      this.aiDataContract = {
        ver: 1,
        message: 1,
        severityLevel: 0,
        properties: 0
        /* FieldType.Default */
      };
      var a = this;
      a.ver = 2, n = n || jn, a[
        mc
        /* @min:%2emessage */
      ] = om(t, n), a[
        Yn
        /* @min:%2eproperties */
      ] = _o(t, i), a[
        fr
        /* @min:%2emeasurements */
      ] = po(t, o), r && (a[
        ms
        /* @min:%2eseverityLevel */
      ] = r);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.Message", e.dataType = "MessageData", e;
  }()
), Sa = (
  /** @class */
  function() {
    function e(t, n, r, i, o, a, s) {
      this.aiDataContract = {
        ver: 1,
        name: 0,
        url: 0,
        duration: 0,
        perfTotal: 0,
        networkConnect: 0,
        sentRequest: 0,
        receivedResponse: 0,
        domProcessing: 0,
        properties: 0,
        measurements: 0
        /* FieldType.Default */
      };
      var c = this;
      c.ver = 2, c.url = Xf(t, r), c[
        Xn
        /* @min:%2ename */
      ] = ct(t, n) || jn, c[
        Yn
        /* @min:%2eproperties */
      ] = _o(t, o), c[
        fr
        /* @min:%2emeasurements */
      ] = po(t, a), s && (c.domProcessing = s.domProcessing, c[
        gf
        /* @min:%2eduration */
      ] = s[
        gf
        /* @min:%2eduration */
      ], c.networkConnect = s.networkConnect, c.perfTotal = s.perfTotal, c.receivedResponse = s.receivedResponse, c.sentRequest = s.sentRequest);
    }
    return e.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance", e.dataType = "PageviewPerformanceData", e;
  }()
), go = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      this.aiDataContract = {
        baseType: 1,
        baseData: 1
        /* FieldType.Required */
      }, this.baseType = t, this.baseData = n;
    }
    return e;
  }()
);
function li(e) {
  var t = "ai." + e + ".";
  return function(n) {
    return t + n;
  };
}
var ja = li("application"), lt = li("device"), Xc = li("location"), Do = li("operation"), Ed = li("session"), Dr = li("user"), Ei = li("cloud"), Xa = li("internal"), mm = (
  /** @class */
  function(e) {
    yr(t, e);
    function t() {
      return e.call(this) || this;
    }
    return t;
  }(eC({
    applicationVersion: ja("ver"),
    applicationBuild: ja("build"),
    applicationTypeId: ja("typeId"),
    applicationId: ja("applicationId"),
    applicationLayer: ja("layer"),
    deviceId: lt("id"),
    deviceIp: lt("ip"),
    deviceLanguage: lt("language"),
    deviceLocale: lt("locale"),
    deviceModel: lt("model"),
    deviceFriendlyName: lt("friendlyName"),
    deviceNetwork: lt("network"),
    deviceNetworkName: lt("networkName"),
    deviceOEMName: lt("oemName"),
    deviceOS: lt("os"),
    deviceOSVersion: lt("osVersion"),
    deviceRoleInstance: lt("roleInstance"),
    deviceRoleName: lt("roleName"),
    deviceScreenResolution: lt("screenResolution"),
    deviceType: lt("type"),
    deviceMachineName: lt("machineName"),
    deviceVMName: lt("vmName"),
    deviceBrowser: lt("browser"),
    deviceBrowserVersion: lt("browserVersion"),
    locationIp: Xc("ip"),
    locationCountry: Xc("country"),
    locationProvince: Xc("province"),
    locationCity: Xc("city"),
    operationId: Do("id"),
    operationName: Do("name"),
    operationParentId: Do("parentId"),
    operationRootId: Do("rootId"),
    operationSyntheticSource: Do("syntheticSource"),
    operationCorrelationVector: Do("correlationVector"),
    sessionId: Ed("id"),
    sessionIsFirst: Ed("isFirst"),
    sessionIsNew: Ed("isNew"),
    userAccountAcquisitionDate: Dr("accountAcquisitionDate"),
    userAccountId: Dr("accountId"),
    userAgent: Dr("userAgent"),
    userId: Dr("id"),
    userStoreRegion: Dr("storeRegion"),
    userAuthUserId: Dr("authUserId"),
    userAnonymousUserAcquisitionDate: Dr("anonUserAcquisitionDate"),
    userAuthenticatedUserAcquisitionDate: Dr("authUserAcquisitionDate"),
    cloudName: Ei("name"),
    cloudRole: Ei("role"),
    cloudRoleVer: Ei("roleVer"),
    cloudRoleInstance: Ei("roleInstance"),
    cloudEnvironment: Ei("environment"),
    cloudLocation: Ei("location"),
    cloudDeploymentUnit: Ei("deploymentUnit"),
    internalNodeName: Xa("nodeName"),
    internalSdkVersion: Xa("sdkVersion"),
    internalAgentVersion: Xa("agentVersion"),
    internalSnippet: Xa("snippet"),
    internalSdkSrc: Xa("sdkSrc")
  }))
);
function Or(e, t, n, r, i, o) {
  n = ct(r, n) || jn, (/* @__PURE__ */ Y(e) || /* @__PURE__ */ Y(t) || /* @__PURE__ */ Y(n)) && Qt("Input doesn't contain all required fields");
  var a = "";
  e[dd] && (a = e[dd], delete e[dd]);
  var s = {
    name: n,
    time: Ia(/* @__PURE__ */ new Date()),
    iKey: a,
    ext: o || {},
    tags: [],
    data: {},
    baseType: t,
    baseData: e
    // Part B
  };
  return /* @__PURE__ */ Y(i) || Ne(i, function(c, u) {
    s.data[c] = u;
  }), s;
}
var Jt = {
  UserExt: "user",
  DeviceExt: "device",
  TraceExt: "trace",
  WebExt: "web",
  AppExt: "app",
  OSExt: "os",
  SessionExt: "ses",
  SDKExt: "sdk"
}, Ye = new mm();
function Ja(e) {
  var t = null;
  if (ye(Event))
    t = new Event(e);
  else {
    var n = Dt();
    n && n.createEvent && (t = n.createEvent("Event"), t.initEvent(e, !0, !0));
  }
  return t;
}
function Xp(e, t) {
  ha(e, null, null, t);
}
function $I(e) {
  var t = Dt(), n = Zn(), r = !1, i = [], o = 1;
  n && !/* @__PURE__ */ Y(n.onLine) && !n.onLine && (o = 2);
  var a = 0, s = v(), c = fi(_n("OfflineListener"), e);
  try {
    if (f(vn()) && (r = !0), t) {
      var u = t.body || t;
      u.ononline && f(u) && (r = !0);
    }
  } catch {
    r = !1;
  }
  function f(O) {
    var I = !1;
    return O && (I = ur(O, "online", _, c), I && ur(O, "offline", m, c)), I;
  }
  function l() {
    return s;
  }
  function v() {
    return !(a === 2 || o === 2);
  }
  function d() {
    var O = v();
    s !== O && (s = O, J(i, function(I) {
      var P = {
        isOnline: s,
        rState: o,
        uState: a
      };
      try {
        I(P);
      } catch {
      }
    }));
  }
  function h(O) {
    a = O, d();
  }
  function _() {
    o = 1, d();
  }
  function m() {
    o = 2, d();
  }
  function E() {
    var O = vn();
    if (O && r) {
      if (Xp(O, c), t) {
        var I = t.body || t;
        /* @__PURE__ */ Je(I.ononline) || Xp(I, c);
      }
      r = !1;
    }
  }
  function y(O) {
    return i.push(O), {
      rm: function() {
        var I = i.indexOf(O);
        if (I > -1)
          return i.splice(I, 1);
      }
    };
  }
  return {
    isOnline: l,
    isListening: function() {
      return r;
    },
    unload: E,
    addListener: y,
    setOnlineState: h
  };
}
var Zf = "AppInsightsPropertiesPlugin", wm = "AppInsightsChannelPlugin", ym = "ApplicationInsightsAnalytics", Sf = "toString", Uv = "isStorageUseDisabled", Ro = "_addHook", wt = "core", Rr = "dataType", Si = "envelopeType", Xt = "diagLog", mi = "track", Eu = "trackPageView", $v = "trackPreviousPageVisit", Ri = "sendPageViewInternal", Pa = "startTime", ws = "properties", Ln = "duration", Fv = "sendPageViewPerformanceInternal", __ = "populatePageViewPerformanceEvent", zo = "href", Jp = "sendExceptionInternal", Qa = "error", Sd = "lineNumber", md = "columnNumber", wd = "CreateAutoException", Jc = "addTelemetryInitializer", FI = "overridePageViewDuration", yd = "autoExceptionInstrumented", Tm = "autoTrackPageVisitTime", bm = "isBrowserLinkTrackingEnabled", ac = "length", Cm = "enableAutoRouteTracking", Nm = "enableUnhandledPromiseRejectionTracking", Hv = "autoUnhandledPromiseInstrumented", Yv = "getEntriesByType", Im = "isPerformanceTimingSupported", Dm = "getPerformanceTiming", mf = "navigationStart", Vv = "shouldCollectDuration", Rm = "isPerformanceTimingDataReady", ys = "responseStart", HI = "requestStart", Su = "loadEventEnd", Bv = "responseEnd", mu = "connectEnd", YI = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      Be(e, this, function(o) {
        var a = null, s = [], c = !1, u = !1, f;
        r && (f = r.logger);
        function l(h) {
          r && r.flush(h, function() {
          });
        }
        function v() {
          a || (a = Wn(function() {
            a = null;
            var h = s.slice(0), _ = !1;
            s = [], J(h, function(m) {
              m() ? _ = !0 : s.push(m);
            }), s[
              ac
              /* @min:%2elength */
            ] > 0 && v(), _ && l(!0);
          }, 100));
        }
        function d(h) {
          s.push(h), v();
        }
        o[
          Eu
          /* @min:%2etrackPageView */
        ] = function(h, _) {
          var m = h.name;
          if (/* @__PURE__ */ Y(m) || typeof m != "string") {
            var E = Dt();
            m = h.name = E && E.title || "";
          }
          var y = h.uri;
          if (/* @__PURE__ */ Y(y) || typeof y != "string") {
            var O = Hn();
            y = h.uri = O && O[
              zo
              /* @min:%2ehref */
            ] || "";
          }
          if (!u) {
            var I = /* @__PURE__ */ Er(), P = I && I[
              Yv
              /* @min:%2egetEntriesByType */
            ] && I[
              Yv
              /* @min:%2egetEntriesByType */
            ]("navigation");
            if (P && P[0] && !/* @__PURE__ */ Je(I.timeOrigin)) {
              var B = P[0].loadEventStart;
              h[
                Pa
                /* @min:%2estartTime */
              ] = new Date(I.timeOrigin + B);
            } else {
              var D = (_ || h[
                ws
                /* @min:%2eproperties */
              ] || {})[
                Ln
                /* @min:%2eduration */
              ] || 0;
              h[
                Pa
                /* @min:%2estartTime */
              ] = new Date((/* @__PURE__ */ new Date()).getTime() - D);
            }
            u = !0;
          }
          if (!i[
            Im
            /* @min:%2eisPerformanceTimingSupported */
          ]()) {
            t[
              Ri
              /* @min:%2esendPageViewInternal */
            ](h, _), l(!0), UE() || K(f, 2, 25, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
            return;
          }
          var b = !1, F, U = i[
            Dm
            /* @min:%2egetPerformanceTiming */
          ]()[
            mf
            /* @min:%2enavigationStart */
          ];
          U > 0 && (F = Bt(U, +/* @__PURE__ */ new Date()), i[
            Vv
            /* @min:%2eshouldCollectDuration */
          ](F) || (F = void 0));
          var z;
          !/* @__PURE__ */ Y(_) && !/* @__PURE__ */ Y(_[
            Ln
            /* @min:%2eduration */
          ]) && (z = _[
            Ln
            /* @min:%2eduration */
          ]), (n || !isNaN(z)) && (isNaN(z) && (_ || (_ = {}), _[
            Ln
            /* @min:%2eduration */
          ] = F), t[
            Ri
            /* @min:%2esendPageViewInternal */
          ](h, _), l(!0), b = !0);
          var ne = 6e4;
          _ || (_ = {}), d(function() {
            var X = !1;
            try {
              if (i[
                Rm
                /* @min:%2eisPerformanceTimingDataReady */
              ]()) {
                X = !0;
                var S = {
                  name: m,
                  uri: y
                };
                i[
                  __
                  /* @min:%2epopulatePageViewPerformanceEvent */
                ](S), !S.isValid && !b ? (_[
                  Ln
                  /* @min:%2eduration */
                ] = F, t[
                  Ri
                  /* @min:%2esendPageViewInternal */
                ](h, _)) : (b || (_[
                  Ln
                  /* @min:%2eduration */
                ] = S.durationMs, t[
                  Ri
                  /* @min:%2esendPageViewInternal */
                ](h, _)), c || (t[
                  Fv
                  /* @min:%2esendPageViewPerformanceInternal */
                ](S, _), c = !0));
              } else U > 0 && Bt(U, +/* @__PURE__ */ new Date()) > ne && (X = !0, b || (_[
                Ln
                /* @min:%2eduration */
              ] = ne, t[
                Ri
                /* @min:%2esendPageViewInternal */
              ](h, _)));
            } catch (N) {
              K(f, 1, 38, "trackPageView failed on page load calculation: " + xe(N), { exception: /* @__PURE__ */ Q(N) });
            }
            return X;
          });
        }, o.teardown = function(h, _) {
          if (a) {
            a.cancel(), a = null;
            var m = s.slice(0);
            s = [], J(m, function(E) {
              E();
            });
          }
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), VI = 36e5, Qp = ["googlebot", "adsbot-google", "apis-google", "mediapartners-google"];
function Pm() {
  var e = /* @__PURE__ */ Er();
  return e && !!e.timing;
}
function BI() {
  var e = /* @__PURE__ */ Er();
  return e && e.getEntriesByType && e.getEntriesByType("navigation")[
    ac
    /* @min:%2elength */
  ] > 0;
}
function zI() {
  var e = /* @__PURE__ */ Er(), t = e ? e.timing : 0;
  return t && t.domainLookupStart > 0 && t[
    mf
    /* @min:%2enavigationStart */
  ] > 0 && t[
    ys
    /* @min:%2eresponseStart */
  ] > 0 && t[
    HI
    /* @min:%2erequestStart */
  ] > 0 && t[
    Su
    /* @min:%2eloadEventEnd */
  ] > 0 && t[
    Bv
    /* @min:%2eresponseEnd */
  ] > 0 && t[
    mu
    /* @min:%2econnectEnd */
  ] > 0 && t.domLoading > 0;
}
function Zp() {
  return Pm() ? (/* @__PURE__ */ Er()).timing : null;
}
function GI() {
  return BI() ? (/* @__PURE__ */ Er())[
    Yv
    /* @min:%2egetEntriesByType */
  ]("navigation")[0] : null;
}
function KI() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = Zn() || {}, r = n.userAgent, i = !1;
  if (r)
    for (var o = 0; o < Qp[
      ac
      /* @min:%2elength */
    ]; o++)
      i = i || Ft(r.toLowerCase(), Qp[o]) !== -1;
  if (i)
    return !1;
  for (var o = 0; o < e[
    ac
    /* @min:%2elength */
  ]; o++)
    if (e[o] < 0 || e[o] >= VI)
      return !1;
  return !0;
}
var WI = (
  /** @class */
  function() {
    function e(t) {
      var n = ho(t);
      Be(e, this, function(r) {
        r[
          __
          /* @min:%2epopulatePageViewPerformanceEvent */
        ] = function(i) {
          i.isValid = !1;
          var o = GI(), a = Zp(), s = 0, c = 0, u = 0, f = 0, l = 0;
          (o || a) && (o ? (s = o[
            Ln
            /* @min:%2eduration */
          ], c = o[
            Pa
            /* @min:%2estartTime */
          ] === 0 ? o[
            mu
            /* @min:%2econnectEnd */
          ] : Bt(o[
            Pa
            /* @min:%2estartTime */
          ], o[
            mu
            /* @min:%2econnectEnd */
          ]), u = Bt(o.requestStart, o[
            ys
            /* @min:%2eresponseStart */
          ]), f = Bt(o[
            ys
            /* @min:%2eresponseStart */
          ], o[
            Bv
            /* @min:%2eresponseEnd */
          ]), l = Bt(o.responseEnd, o[
            Su
            /* @min:%2eloadEventEnd */
          ])) : (s = Bt(a[
            mf
            /* @min:%2enavigationStart */
          ], a[
            Su
            /* @min:%2eloadEventEnd */
          ]), c = Bt(a[
            mf
            /* @min:%2enavigationStart */
          ], a[
            mu
            /* @min:%2econnectEnd */
          ]), u = Bt(a.requestStart, a[
            ys
            /* @min:%2eresponseStart */
          ]), f = Bt(a[
            ys
            /* @min:%2eresponseStart */
          ], a[
            Bv
            /* @min:%2eresponseEnd */
          ]), l = Bt(a.responseEnd, a[
            Su
            /* @min:%2eloadEventEnd */
          ])), s === 0 ? K(n, 2, 10, "error calculating page view performance.", { total: s, network: c, request: u, response: f, dom: l }) : r[
            Vv
            /* @min:%2eshouldCollectDuration */
          ](s, c, u, f, l) ? s < tn(c) + tn(u) + tn(f) + tn(l) ? K(n, 2, 8, "client performance math error.", { total: s, network: c, request: u, response: f, dom: l }) : (i.durationMs = s, i.perfTotal = i[
            Ln
            /* @min:%2eduration */
          ] = Br(s), i.networkConnect = Br(c), i.sentRequest = Br(u), i.receivedResponse = Br(f), i.domProcessing = Br(l), i.isValid = !0) : K(n, 2, 45, "Invalid page load duration value. Browser perf data won't be sent.", { total: s, network: c, request: u, response: f, dom: l }));
        }, r[
          Dm
          /* @min:%2egetPerformanceTiming */
        ] = Zp, r[
          Im
          /* @min:%2eisPerformanceTimingSupported */
        ] = Pm, r[
          Rm
          /* @min:%2eisPerformanceTimingDataReady */
        ] = zI, r[
          Vv
          /* @min:%2eshouldCollectDuration */
        ] = KI;
      });
    }
    return e.__ieDyn = 1, e;
  }()
), qI = (
  /** @class */
  function() {
    function e(t, n) {
      var r = "prevPageVisitData";
      Be(e, this, function(i) {
        i[
          $v
          /* @min:%2etrackPreviousPageVisit */
        ] = function(s, c) {
          try {
            var u = o(s, c);
            u && n(u.pageName, u.pageUrl, u.pageVisitTime);
          } catch (f) {
            Ki(t, "Auto track page visit time failed, metric will not be collected: " + /* @__PURE__ */ Q(f));
          }
        };
        function o(s, c) {
          var u = null;
          try {
            if (u = a(), oc()) {
              kv(t, r) != null && Qt("Cannot call startPageVisit consecutively without first calling stopPageVisit");
              var f = Dn().stringify(new jI(s, c));
              lm(t, r, f);
            }
          } catch (l) {
            Ki(t, "Call to restart failed: " + /* @__PURE__ */ Q(l)), u = null;
          }
          return u;
        }
        function a() {
          var s = null;
          try {
            if (oc()) {
              var c = /* @__PURE__ */ Kn(), u = kv(t, r);
              u && Ec() && (s = Dn().parse(u), s.pageVisitTime = c - s.pageVisitStartTime, dm(t, r));
            }
          } catch (f) {
            Ki(t, "Stop page visit timer failed: " + /* @__PURE__ */ Q(f)), s = null;
          }
          return s;
        }
        Le(i, "_logger", { g: function() {
          return t;
        } }), Le(i, "pageVisitTimeTrackingHandler", { g: function() {
          return n;
        } });
      });
    }
    return e.__ieDyn = 1, e;
  }()
), jI = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      this.pageVisitStartTime = /* @__PURE__ */ Kn(), this.pageName = t, this.pageUrl = n;
    }
    return e;
  }()
), eg = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = this, i = {};
      r.start = function(o) {
        typeof i[o] < "u" && K(t, 2, 62, "start was called more than once for this event without calling stop.", { name: o, key: o }, !0), i[o] = +/* @__PURE__ */ new Date();
      }, r.stop = function(o, a, s, c) {
        var u = i[o];
        if (isNaN(u))
          K(t, 2, 63, "stop was called without a corresponding start.", { name: o, key: o }, !0);
        else {
          var f = +/* @__PURE__ */ new Date(), l = Bt(u, f);
          r.action(o, a, l, s, c);
        }
        delete i[o], i[o] = void 0;
      };
    }
    return e;
  }()
), At, XI = "event";
function Za(e, t) {
  e && e.dispatchEvent && t && e.dispatchEvent(t);
}
function JI(e) {
  if (e && e.reason) {
    var t = e.reason;
    return !ce(t) && ye(t[
      Sf
      /* @min:%2etoString */
    ]) ? t[
      Sf
      /* @min:%2etoString */
    ]() : /* @__PURE__ */ Q(t);
  }
  return e || "";
}
var tg = 6e4, QI = xa((At = {
  sessionRenewalMs: sp(ng, 30 * 60 * 1e3),
  sessionExpirationMs: sp(ng, 24 * 60 * 60 * 1e3),
  disableExceptionTracking: at()
}, At[
  Tm
  /* @min:autoTrackPageVisitTime */
] = at(), At[
  FI
  /* @min:overridePageViewDuration */
] = at(), At[
  Nm
  /* @min:enableUnhandledPromiseRejectionTracking */
] = at(), At[
  Hv
  /* @min:autoUnhandledPromiseInstrumented */
] = !1, At.samplingPercentage = af(ZI, 100), At[
  Uv
  /* @min:isStorageUseDisabled */
] = at(), At[
  bm
  /* @min:isBrowserLinkTrackingEnabled */
] = at(), At[
  Cm
  /* @min:enableAutoRouteTracking */
] = at(), At.namePrefix = VC(), At.enableDebug = at(), At.disableFlushOnBeforeUnload = at(), At.disableFlushOnUnload = at(!1, "disableFlushOnBeforeUnload"), At.expCfg = Sn({ inclScripts: !1, expLog: void 0, maxLogs: 50 }), At));
function ng(e, t) {
  return e = e || t, e < tg && (e = tg), +e;
}
function ZI(e) {
  return !isNaN(e) && e > 0 && e <= 100;
}
function eD(e) {
  /* @__PURE__ */ Je(e[
    Uv
    /* @min:%2eisStorageUseDisabled */
  ]) || (e[
    Uv
    /* @min:%2eisStorageUseDisabled */
  ] ? aI() : sI());
}
var tD = (
  /** @class */
  function(e) {
    yr(t, e);
    function t() {
      var n = e.call(this) || this;
      n.identifier = ym, n.priority = 180, n.autoRoutePVDelay = 500;
      var r, i, o, a, s, c, u, f, l, v, d, h, _, m, E, y, O, I, P, B, D;
      return Be(t, n, function(b, F) {
        var U = F[
          Ro
          /* @min:%2e_addHook */
        ];
        _e(), b.getCookieMgr = function() {
          return e_(b[
            wt
            /* @min:%2ecore */
          ]);
        }, b.processTelemetry = function(p, g) {
          b.processNext(p, g);
        }, b.trackEvent = function(p, g) {
          try {
            var A = Or(p, Vr[
              Rr
              /* @min:%2edataType */
            ], Vr[
              Si
              /* @min:%2eenvelopeType */
            ], b[
              Xt
              /* @min:%2ediagLog */
            ](), g);
            b[
              wt
              /* @min:%2ecore */
            ][
              mi
              /* @min:%2etrack */
            ](A);
          } catch (M) {
            Z(2, 39, "trackTrace failed, trace will not be collected: " + xe(M), { exception: /* @__PURE__ */ Q(M) });
          }
        }, b.startTrackEvent = function(p) {
          try {
            r.start(p);
          } catch (g) {
            Z(1, 29, "startTrackEvent failed, event will not be collected: " + xe(g), { exception: /* @__PURE__ */ Q(g) });
          }
        }, b.stopTrackEvent = function(p, g, A) {
          try {
            r.stop(p, void 0, g, A);
          } catch (M) {
            Z(1, 30, "stopTrackEvent failed, event will not be collected: " + xe(M), { exception: /* @__PURE__ */ Q(M) });
          }
        }, b.trackTrace = function(p, g) {
          try {
            var A = Or(p, Ea[
              Rr
              /* @min:%2edataType */
            ], Ea[
              Si
              /* @min:%2eenvelopeType */
            ], b[
              Xt
              /* @min:%2ediagLog */
            ](), g);
            b[
              wt
              /* @min:%2ecore */
            ][
              mi
              /* @min:%2etrack */
            ](A);
          } catch (M) {
            Z(2, 39, "trackTrace failed, trace will not be collected: " + xe(M), { exception: /* @__PURE__ */ Q(M) });
          }
        }, b.trackMetric = function(p, g) {
          try {
            var A = Or(p, qi[
              Rr
              /* @min:%2edataType */
            ], qi[
              Si
              /* @min:%2eenvelopeType */
            ], b[
              Xt
              /* @min:%2ediagLog */
            ](), g);
            b[
              wt
              /* @min:%2ecore */
            ][
              mi
              /* @min:%2etrack */
            ](A);
          } catch (M) {
            Z(1, 36, "trackMetric failed, metric will not be collected: " + xe(M), { exception: /* @__PURE__ */ Q(M) });
          }
        }, b[
          Eu
          /* @min:%2etrackPageView */
        ] = function(p, g) {
          try {
            var A = p || {};
            o[
              Eu
              /* @min:%2etrackPageView */
            ](A, Mt(Mt(Mt({}, A.properties), A.measurements), g)), y && s[
              $v
              /* @min:%2etrackPreviousPageVisit */
            ](A.name, A.uri);
          } catch (M) {
            Z(1, 37, "trackPageView failed, page view will not be collected: " + xe(M), { exception: /* @__PURE__ */ Q(M) });
          }
        }, b[
          Ri
          /* @min:%2esendPageViewInternal */
        ] = function(p, g, A) {
          var M = Dt();
          if (M && (p.refUri = p.refUri === void 0 ? M.referrer : p.refUri), /* @__PURE__ */ Y(p[
            Pa
            /* @min:%2estartTime */
          ])) {
            var te = (g || p[
              ws
              /* @min:%2eproperties */
            ] || {})[
              Ln
              /* @min:%2eduration */
            ] || 0;
            p[
              Pa
              /* @min:%2estartTime */
            ] = new Date((/* @__PURE__ */ new Date()).getTime() - te);
          }
          var se = Or(p, ni[
            Rr
            /* @min:%2edataType */
          ], ni[
            Si
            /* @min:%2eenvelopeType */
          ], b[
            Xt
            /* @min:%2ediagLog */
          ](), g, A);
          b[
            wt
            /* @min:%2ecore */
          ][
            mi
            /* @min:%2etrack */
          ](se);
        }, b[
          Fv
          /* @min:%2esendPageViewPerformanceInternal */
        ] = function(p, g, A) {
          var M = Or(p, Sa[
            Rr
            /* @min:%2edataType */
          ], Sa[
            Si
            /* @min:%2eenvelopeType */
          ], b[
            Xt
            /* @min:%2ediagLog */
          ](), g, A);
          b[
            wt
            /* @min:%2ecore */
          ][
            mi
            /* @min:%2etrack */
          ](M);
        }, b.trackPageViewPerformance = function(p, g) {
          var A = p || {};
          try {
            a[
              __
              /* @min:%2epopulatePageViewPerformanceEvent */
            ](A), b[
              Fv
              /* @min:%2esendPageViewPerformanceInternal */
            ](A, g);
          } catch (M) {
            Z(1, 37, "trackPageViewPerformance failed, page view will not be collected: " + xe(M), { exception: /* @__PURE__ */ Q(M) });
          }
        }, b.startTrackPage = function(p) {
          try {
            if (typeof p != "string") {
              var g = Dt();
              p = g && g.title || "";
            }
            i.start(p);
          } catch (A) {
            Z(1, 31, "startTrackPage failed, page view may not be collected: " + xe(A), { exception: /* @__PURE__ */ Q(A) });
          }
        }, b.stopTrackPage = function(p, g, A, M) {
          try {
            if (typeof p != "string") {
              var te = Dt();
              p = te && te.title || "";
            }
            if (typeof g != "string") {
              var se = Hn();
              g = se && se[
                zo
                /* @min:%2ehref */
              ] || "";
            }
            i.stop(p, g, A, M), y && s[
              $v
              /* @min:%2etrackPreviousPageVisit */
            ](p, g);
          } catch (Se) {
            Z(1, 32, "stopTrackPage failed, page view will not be collected: " + xe(Se), { exception: /* @__PURE__ */ Q(Se) });
          }
        }, b[
          Jp
          /* @min:%2esendExceptionInternal */
        ] = function(p, g, A) {
          var M = p && (p.exception || p[
            Qa
            /* @min:%2eerror */
          ]) || // - Handle someone calling trackException based of v1 API where the exception was the Error
          xh(p) && p || // - Handles no error being defined and instead of creating a new Error() instance attempt to map so any stacktrace
          //   is preserved and does not list ApplicationInsights code as the source
          { name: p && typeof p, message: p || jn };
          p = p || {};
          var te = new un(b[
            Xt
            /* @min:%2ediagLog */
          ](), M, p[
            ws
            /* @min:%2eproperties */
          ] || g, p.measurements, p.severityLevel, p.id).toInterface(), se = Dt();
          if (se && (O != null && O.inclScripts)) {
            var Se = lN(se);
            te[
              ws
              /* @min:%2eproperties */
            ].exceptionScripts = JSON.stringify(Se);
          }
          if (O != null && O.expLog) {
            var ge = O.expLog();
            ge && ge.logs && Te(ge.logs) && (te[
              ws
              /* @min:%2eproperties */
            ].exceptionLog = ge.logs.slice(0, O.maxLogs).join(`
`));
          }
          var He = Or(te, un[
            Rr
            /* @min:%2edataType */
          ], un[
            Si
            /* @min:%2eenvelopeType */
          ], b[
            Xt
            /* @min:%2ediagLog */
          ](), g, A);
          b[
            wt
            /* @min:%2ecore */
          ][
            mi
            /* @min:%2etrack */
          ](He);
        }, b.trackException = function(p, g) {
          p && !p.exception && p[
            Qa
            /* @min:%2eerror */
          ] && (p.exception = p[
            Qa
            /* @min:%2eerror */
          ]);
          try {
            b[
              Jp
              /* @min:%2esendExceptionInternal */
            ](p, g);
          } catch (A) {
            Z(1, 35, "trackException failed, exception will not be collected: " + xe(A), { exception: /* @__PURE__ */ Q(A) });
          }
        }, b._onerror = function(p) {
          var g = p && p[
            Qa
            /* @min:%2eerror */
          ], A = p && p.evt;
          try {
            if (!A) {
              var M = vn();
              M && (A = M[XI]);
            }
            var te = p && p.url || (Dt() || {}).URL, se = p.errorSrc || "window.onerror@" + te + ":" + (p[
              Sd
              /* @min:%2elineNumber */
            ] || 0) + ":" + (p[
              md
              /* @min:%2ecolumnNumber */
            ] || 0), Se = {
              errorSrc: se,
              url: te,
              lineNumber: p[
                Sd
                /* @min:%2elineNumber */
              ] || 0,
              columnNumber: p[
                md
                /* @min:%2ecolumnNumber */
              ] || 0,
              message: p.message
            };
            UI(p.message, p.url, p.lineNumber, p.columnNumber, p[
              Qa
              /* @min:%2eerror */
            ]) ? S(un[
              wd
              /* @min:%2eCreateAutoException */
            ]("Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.", te, p[
              Sd
              /* @min:%2elineNumber */
            ] || 0, p[
              md
              /* @min:%2ecolumnNumber */
            ] || 0, g, A, null, se), Se) : (p.errorSrc || (p.errorSrc = se), b.trackException({
              exception: p,
              severityLevel: 3
              /* eSeverityLevel.Error */
            }, Se));
          } catch (He) {
            var ge = g ? g.name + ", " + g.message : "null";
            Z(1, 11, "_onError threw exception while logging error, error will not be collected: " + xe(He), { exception: /* @__PURE__ */ Q(He), errorString: ge });
          }
        }, b[
          Jc
          /* @min:%2eaddTelemetryInitializer */
        ] = function(p) {
          if (b[
            wt
            /* @min:%2ecore */
          ])
            return b[
              wt
              /* @min:%2ecore */
            ][
              Jc
              /* @min:%2eaddTelemetryInitializer */
            ](p);
          c || (c = []), c.push(p);
        }, b.initialize = function(p, g, A, M) {
          if (!b.isInitialized()) {
            /* @__PURE__ */ Y(g) && Qt("Error initializing"), F.initialize(p, g, A, M);
            try {
              B = fi(_n(b.identifier), g.evtNamespace && g.evtNamespace()), c && (J(c, function(te) {
                g[
                  Jc
                  /* @min:%2eaddTelemetryInitializer */
                ](te);
              }), c = null), z(p), a = new WI(b[
                wt
                /* @min:%2ecore */
              ]), o = new YI(b, E.overridePageViewDuration, b[
                wt
                /* @min:%2ecore */
              ], a), s = new qI(b[
                Xt
                /* @min:%2ediagLog */
              ](), function(te, se, Se) {
                return ne(te, se, Se);
              }), r = new eg(b[
                Xt
                /* @min:%2ediagLog */
              ](), "trackEvent"), r.action = function(te, se, Se, ge, He) {
                ge || (ge = {}), He || (He = {}), ge.duration = Se[
                  Sf
                  /* @min:%2etoString */
                ](), b.trackEvent({ name: te, properties: ge, measurements: He });
              }, i = new eg(b[
                Xt
                /* @min:%2ediagLog */
              ](), "trackPageView"), i.action = function(te, se, Se, ge, He) {
                /* @__PURE__ */ Y(ge) && (ge = {}), ge.duration = Se[
                  Sf
                  /* @min:%2etoString */
                ]();
                var St = {
                  name: te,
                  uri: se,
                  properties: ge,
                  measurements: He
                };
                b[
                  Ri
                  /* @min:%2esendPageViewInternal */
                ](St, ge);
              }, /* @__PURE__ */ Bf() && (N(), $());
            } catch (te) {
              throw b.setInitialized(!1), te;
            }
          }
        }, b._doTeardown = function(p, g) {
          o && o.teardown(p, g), ha(window, null, null, B), _e();
        }, b._getDbgPlgTargets = function() {
          return [D, h];
        };
        function z(p) {
          var g = b.identifier, A = b[
            wt
            /* @min:%2ecore */
          ];
          b[
            Ro
            /* @min:%2e_addHook */
          ](nt(p, function() {
            var M = Rn(null, p, A);
            E = M.getExtCfg(g, QI), h = h || p[
              yd
              /* @min:%2eautoExceptionInstrumented */
            ] || E[
              yd
              /* @min:%2eautoExceptionInstrumented */
            ], O = E.expCfg, y = E[
              Tm
              /* @min:%2eautoTrackPageVisitTime */
            ], p.storagePrefix && h_(p.storagePrefix), eD(E), u = E[
              bm
              /* @min:%2eisBrowserLinkTrackingEnabled */
            ], X();
          }));
        }
        function ne(p, g, A) {
          var M = { PageName: p, PageUrl: g };
          b.trackMetric({
            name: "PageVisitTime",
            average: A,
            max: A,
            min: A,
            sampleCount: 1
          }, M);
        }
        function X() {
          if (!f && u) {
            var p = ["/browserLinkSignalR/", "/__browserLink/"], g = function(A) {
              if (u && A.baseType === ji[
                Rr
                /* @min:%2edataType */
              ]) {
                var M = A.baseData;
                if (M) {
                  for (var te = 0; te < p[
                    ac
                    /* @min:%2elength */
                  ]; te++)
                    if (M.target && Ft(M.target, p[te]) >= 0)
                      return !1;
                }
              }
              return !0;
            };
            b[
              Ro
              /* @min:%2e_addHook */
            ](b[
              Jc
              /* @min:%2eaddTelemetryInitializer */
            ](g)), f = !0;
          }
        }
        function S(p, g) {
          var A = Or(p, un[
            Rr
            /* @min:%2edataType */
          ], un[
            Si
            /* @min:%2eenvelopeType */
          ], b[
            Xt
            /* @min:%2ediagLog */
          ](), g);
          b[
            wt
            /* @min:%2ecore */
          ][
            mi
            /* @min:%2etrack */
          ](A);
        }
        function N() {
          var p = vn(), g = Hn(!0);
          b[
            Ro
            /* @min:%2e_addHook */
          ](nt(E, function() {
            d = E.disableExceptionTracking, !d && !h && !E[
              yd
              /* @min:%2eautoExceptionInstrumented */
            ] && (U(qc(p, "onerror", {
              ns: B,
              rsp: function(A, M, te, se, Se, ge) {
                !d && A.rslt !== !0 && b._onerror(un[
                  wd
                  /* @min:%2eCreateAutoException */
                ](M, te, se, Se, ge, A.evt));
              }
            }, !1)), D++, h = !0);
          })), ie(p, g);
        }
        function $() {
          var p = vn(), g = Hn(!0);
          b[
            Ro
            /* @min:%2e_addHook */
          ](nt(E, function() {
            if (l = E[
              Cm
              /* @min:%2eenableAutoRouteTracking */
            ] === !0, p && l && !v && /* @__PURE__ */ N0()) {
              var A = ME();
              ye(A.pushState) && ye(A.replaceState) && typeof Event !== Ih && W(p, A, g);
            }
          }));
        }
        function w() {
          var p = null;
          if (b[
            wt
            /* @min:%2ecore */
          ] && b[
            wt
            /* @min:%2ecore */
          ].getTraceCtx && (p = b[
            wt
            /* @min:%2ecore */
          ].getTraceCtx(!1)), !p) {
            var g = b[
              wt
              /* @min:%2ecore */
            ].getPlugin(Zf);
            if (g) {
              var A = g.plugin.context;
              A && (p = l_(A.telemetryTrace));
            }
          }
          return p;
        }
        function W(p, g, A) {
          if (v)
            return;
          var M = E.namePrefix || "";
          function te() {
            l && Za(p, Ja(M + "locationchange"));
          }
          function se() {
            if (P && (I = P), P = A && A[
              zo
              /* @min:%2ehref */
            ] || "", l) {
              var Se = w();
              if (Se) {
                Se.setTraceId(Kr());
                var ge = "_unknown_";
                A && A.pathname && (ge = A.pathname + (A.hash || "")), Se.setName(ct(b[
                  Xt
                  /* @min:%2ediagLog */
                ](), ge));
              }
              Wn((function(He) {
                b[
                  Eu
                  /* @min:%2etrackPageView */
                ]({ refUri: He, properties: { duration: 0 } });
              }).bind(b, I), b.autoRoutePVDelay);
            }
          }
          U(qc(g, "pushState", {
            ns: B,
            rsp: function() {
              l && (Za(p, Ja(M + "pushState")), Za(p, Ja(M + "locationchange")));
            }
          }, !0)), U(qc(g, "replaceState", {
            ns: B,
            rsp: function() {
              l && (Za(p, Ja(M + "replaceState")), Za(p, Ja(M + "locationchange")));
            }
          }, !0)), ur(p, M + "popstate", te, B), ur(p, M + "locationchange", se, B), v = !0;
        }
        function ie(p, g) {
          b[
            Ro
            /* @min:%2e_addHook */
          ](nt(E, function() {
            _ = E[
              Nm
              /* @min:%2eenableUnhandledPromiseRejectionTracking */
            ] === !0, h = h || E[
              Hv
              /* @min:%2eautoUnhandledPromiseInstrumented */
            ], _ && !m && (U(qc(p, "onunhandledrejection", {
              ns: B,
              rsp: function(A, M) {
                _ && A.rslt !== !0 && b._onerror(un[
                  wd
                  /* @min:%2eCreateAutoException */
                ](JI(M), g ? g[
                  zo
                  /* @min:%2ehref */
                ] : "", 0, 0, M, A.evt));
              }
            }, !1)), D++, E[
              Hv
              /* @min:%2eautoUnhandledPromiseInstrumented */
            ] = m = !0);
          }));
        }
        function Z(p, g, A, M, te) {
          b[
            Xt
            /* @min:%2ediagLog */
          ]().throwInternal(p, g, A, M, te);
        }
        function _e() {
          r = null, i = null, o = null, a = null, s = null, c = null, u = !1, f = !1, l = !1, v = !1, d = !1, h = !1, _ = !1, m = !1, y = !1;
          var p = Hn(!0);
          I = p && p[
            zo
            /* @min:%2ehref */
          ] || "", P = null, B = null, E = null, D = 0, Le(b, "config", {
            g: function() {
              return E;
            }
          });
        }
        Le(b, "_pageViewManager", { g: function() {
          return o;
        } }), Le(b, "_pageViewPerformanceManager", { g: function() {
          return a;
        } }), Le(b, "_pageVisitTimeManager", { g: function() {
          return s;
        } }), Le(b, "_evtNamespace", { g: function() {
          return "." + B;
        } });
      }), n;
    }
    return t.Version = "3.3.6", t;
  }(Fa)
), wu = "featureOptIn", Am = "scheduleFetchTimeout";
function Om(e, t, n, r) {
  try {
    var i = n > r;
    i && (e = null);
    var o = n == 0 ? K0({}, e) : e;
    return o && t && !i && Ne(o, function(a) {
      var s = t[a];
      s && (/* @__PURE__ */ qt(o[a]) && /* @__PURE__ */ qt(s) ? o[a] = Om(o[a], s, ++n, r) : delete o[a]);
    }), o;
  } catch {
  }
  return e;
}
var ma = "featureOptIn.", km = ".mode", xm = ".onCfg", Lm = ".offCfg";
function nD(e, t, n) {
  var r;
  if (!t || !t.enabled)
    return null;
  var i = (t[
    wu
    /* @min:%2efeatureOptIn */
  ] || {})[e] || {
    mode: 1
    /* CdnFeatureMode.none */
  }, o = i.mode, a = i.onCfg, s = i.offCfg, c = (n || {})[e] || {
    mode: 2
    /* FeatureOptInMode.disable */
  }, u = c.mode, f = c.onCfg, l = c.offCfg, v = !!c.blockCdnCfg, d = ma + e + km, h = ma + e + xm, _ = ma + e + Lm, m = u, E = f, y = l;
  return v || (o === 4 || o === 5 ? (m = o == 4 ? 3 : 2, E = a || f, y = s || l) : o === 2 || u === 2 ? (m = 2, E = f || a, y = l || s) : o === 3 ? (m = 3, E = f || a, y = l || s) : o === 1 && u === 1 && (m = 1)), r = {}, r[d] = m, r[h] = E, r[_] = y, r;
}
function rD(e, t) {
  try {
    if (!e || !e.enabled)
      return null;
    if (!e[
      wu
      /* @min:%2efeatureOptIn */
    ])
      return e.config;
    var n = e[
      wu
      /* @min:%2efeatureOptIn */
    ], r = e.config || {};
    return Ne(n, function(i) {
      var o = nD(i, e, t.config[
        wu
        /* @min:%2efeatureOptIn */
      ]);
      /* @__PURE__ */ Y(o) || (Ne(o, function(a, s) {
        KE(r, a, s);
      }), iD(i, o, r));
    }), r;
  } catch {
  }
  return null;
}
function iD(e, t, n) {
  var r = t[ma + e + km], i = t[ma + e + xm], o = t[ma + e + Lm], a = null;
  r === 3 && (a = i), r === 2 && (a = o), a && Ne(a, function(s, c) {
    KE(n, s, c);
  });
}
var es, oD = "ai_cfgsync", rg = "GET", aD = 18e5, Po = void 0, sD = { instrumentationKey: !0, connectionString: !0, endpointUrl: !0 }, cD = xa((es = {
  syncMode: 1,
  blkCdnCfg: Po,
  customEvtName: Po,
  cfgUrl: Po,
  overrideSyncFn: Po,
  overrideFetchFn: Po,
  onCfgChangeReceive: Po
}, es[
  Am
  /* @min:scheduleFetchTimeout */
] = aD, es.nonOverrideConfigs = sD, es.enableAjax = !1, es)), uD = (
  /** @class */
  function(e) {
    yr(t, e);
    function t() {
      var n = e.call(this) || this;
      n.priority = 198, n.identifier = "AppInsightsCfgSyncPlugin";
      var r, i, o, a, s, c, u, f, l, v, d, h, _, m, E, y, O = !1, I;
      return Be(t, n, function(P, B) {
        D(), P.initialize = function(p, g, A, M) {
          B.initialize(p, g, A, M), a = fi(_n(P.identifier), g.evtNamespace && g.evtNamespace()), b(p);
        }, P.getCfg = function() {
          return i;
        }, P.pause = function() {
          O = !0, _e();
        }, P.resume = function() {
          O = !1, Z();
        }, P.setCfg = function(p) {
          return F(p);
        }, P.sync = function(p) {
          return z(p);
        }, P.updateEventListenerName = function(p) {
          return ne(p);
        }, P._doTeardown = function(p, g) {
          U(), _e(), D();
        }, P._getDbgPlgTargets = function() {
          return [f, u, o, l, _];
        };
        function D() {
          i = null, o = null, a = null, s = null, u = null, f = null, _ = null, c = null, v = null, d = null, l = null, I = !1, E = null, y = null, h = null;
        }
        function b(p) {
          var g = P.identifier, A = P.core;
          P._addHook(nt(p, function() {
            var M = Rn(null, p, A);
            r = M.getExtCfg(g, cD);
            var te = l;
            l = !!r.blkCdnCfg, I = !!r.enableAjax, !/* @__PURE__ */ Y(te) && te !== l && (!l && s ? m && m(s, $, f) : _e()), /* @__PURE__ */ Y(u) && (u = r.syncMode === 2), /* @__PURE__ */ Y(f) && (f = r.syncMode === 1);
            var se = r.customEvtName || oD;
            o !== se && (u ? ne(se) : (U(), o = se)), /* @__PURE__ */ Y(s) && (s = r.cfgUrl), s || (i = p, f && z());
          })), y = r.overrideSyncFn, E = r.overrideFetchFn, h = r.onCfgChangeReceive, _ = r.nonOverrideConfigs, v = r[
            Am
            /* @min:%2escheduleFetchTimeout */
          ], m = X(), d = 0, s && !l && m && m(s, $, f);
        }
        function F(p, g) {
          if (p) {
            if (i = p, g && !O)
              return z();
            if (u && !O)
              return P.core.updateCfg(p), !0;
          }
          return !1;
        }
        function U() {
          try {
            var p = /* @__PURE__ */ or();
            p && ha(p, null, null, a);
          } catch {
          }
        }
        function z(p) {
          try {
            return y && ye(y) ? y(i, p) : yC(o, i, p);
          } catch {
          }
          return !1;
        }
        function ne(p) {
          try {
            return U(), p && (o = p, W()), !0;
          } catch {
          }
          return !1;
        }
        function X() {
          var p = E;
          return /* @__PURE__ */ Y(p) && (qh() ? p = S : Kf() && (p = N)), p;
        }
        function S(p, g, A) {
          var M = /* @__PURE__ */ or(), te = M && M.fetch || null;
          if (p && te && ye(te))
            try {
              var se = {
                method: rg
              };
              I || (se[Li] = !0);
              var Se = new Request(p, se);
              if (!I)
                try {
                  Se[Li] = !0;
                } catch {
                }
              mr(fetch(Se), function(ge) {
                var He = ge.value;
                ge.rejected ? w(g, 400) : He.ok ? mr(He.text(), function(St) {
                  w(g, He.status, St.value, A);
                }) : w(g, He.status, null, A);
              });
            } catch {
            }
        }
        function N(p, g, A) {
          try {
            var M = new XMLHttpRequest();
            I || (M[Li] = !0), M.open(rg, p), M.onreadystatechange = function() {
              M.readyState === XMLHttpRequest.DONE && w(g, M.status, M.responseText, A);
            }, M.onerror = function() {
              w(g, 400);
            }, M.ontimeout = function() {
              w(g, 400);
            }, M.send();
          } catch {
          }
        }
        function $(p, g, A) {
          try {
            if (p >= 200 && p < 400 && g) {
              d = 0;
              var M = Dn();
              if (M) {
                var te = M.parse(g), se = rD(te, P.core), Se = se && /* @__PURE__ */ $t(se) && ie(se);
                Se && F(Se, A);
              }
            } else
              d++;
            d < 3 && Z();
          } catch {
          }
        }
        function w(p, g, A, M) {
          try {
            p(g, A, M);
          } catch {
          }
        }
        function W() {
          if (u) {
            var p = /* @__PURE__ */ or();
            if (p)
              try {
                ur(p, o, function(g) {
                  var A = g && g.detail;
                  if (h && A)
                    h(A);
                  else {
                    var M = A && A.cfg, te = M && /* @__PURE__ */ $t(M) && ie(M);
                    te && F(te);
                  }
                }, a, !0);
              } catch {
              }
          }
        }
        function ie(p, g) {
          var A = null;
          try {
            p && (A = Om(p, _, 0, 5));
          } catch {
          }
          return A;
        }
        function Z() {
          !c && v && (c = Wn(function() {
            c = null, m(s, $, f);
          }, v), c.unref());
        }
        function _e() {
          c && c.cancel(), c = null, d = 0;
        }
        P.processTelemetry = function(p, g) {
          P.processNext(p, g);
        };
      }), n;
    }
    return t.__ieDyn = 1, t;
  }(Fa)
), Ni = "duration", Tt = "tags", Td = "deviceType", en = "data", wr = "name", sc = "traceID", Ce = "length", cc = "stringify", Eo = "measurements", Gn = "dataType", So = "envelopeType", Ii = "toString", Xi = "enqueue", Ji = "count", dr = "push", zv = "emitLineDelimitedJson", wa = "clear", wf = "markAsSent", $s = "clearSent", p_ = "bufferOverride", ts = "BUFFER_KEY", Pr = "SENT_BUFFER_KEY", Go = "concat", ns = "MAX_BUFFER_SIZE", rs = "triggerSend", Ct = "diagLog", bd = "initialize", is = "_sender", os = "endpointUrl", Ts = "instrumentationKey", Gv = "customHeaders", Mm = "maxBatchSizeInBytes", Kv = "onunloadDisableBeacon", Wv = "isBeaconApiDisabled", Um = "alwaysUseXhrOverride", $m = "enableSessionStorageBuffer", An = "_buffer", Fm = "onunloadDisableFetch", Hm = "disableSendBeaconSplit", Qc = "getSenderInst", wi = "_onError", Cd = "_onPartialSuccess", Zc = "_onSuccess", Nd = "itemsReceived", Id = "itemsAccepted", Dd = "baseType", yf = "sampleRate", fD = "getHashCodeScore", Rd = "baseType", We = "baseData", _t = "properties", ig = "true";
function et(e, t, n) {
  return Fe(e, t, n, Yu);
}
function lD(e, t, n) {
  var r = n[
    Tt
    /* @min:%2etags */
  ] = n[
    Tt
    /* @min:%2etags */
  ] || {}, i = t.ext = t.ext || {}, o = t[
    Tt
    /* @min:%2etags */
  ] = t[
    Tt
    /* @min:%2etags */
  ] || [], a = i.user;
  a && (et(r, Ye.userAuthUserId, a.authId), et(r, Ye.userId, a.id || a.localId));
  var s = i.app;
  s && et(r, Ye.sessionId, s.sesId);
  var c = i.device;
  c && (et(r, Ye.deviceId, c.id || c.localId), et(r, Ye[
    Td
    /* @min:%2edeviceType */
  ], c.deviceClass), et(r, Ye.deviceIp, c.ip), et(r, Ye.deviceModel, c.model), et(r, Ye[
    Td
    /* @min:%2edeviceType */
  ], c[
    Td
    /* @min:%2edeviceType */
  ]));
  var u = t.ext.web;
  if (u) {
    et(r, Ye.deviceLanguage, u.browserLang), et(r, Ye.deviceBrowserVersion, u.browserVer), et(r, Ye.deviceBrowser, u.browser);
    var f = n[
      en
      /* @min:%2edata */
    ] = n[
      en
      /* @min:%2edata */
    ] || {}, l = f[We] = f[We] || {}, v = l[_t] = l[_t] || {};
    et(v, "domain", u.domain), et(v, "isManual", u.isManual ? ig : null), et(v, "screenRes", u.screenRes), et(v, "userConsent", u.userConsent ? ig : null);
  }
  var d = i.os;
  d && (et(r, Ye.deviceOS, d[
    wr
    /* @min:%2ename */
  ]), et(r, Ye.deviceOSVersion, d.osVer));
  var h = i.trace;
  h && (et(r, Ye.operationParentId, h.parentID), et(r, Ye.operationName, ct(e, h[
    wr
    /* @min:%2ename */
  ])), et(r, Ye.operationId, h[
    sc
    /* @min:%2etraceID */
  ]));
  for (var _ = {}, m = o[
    Ce
    /* @min:%2elength */
  ] - 1; m >= 0; m--) {
    var E = o[m];
    Ne(E, function(O, I) {
      _[O] = I;
    }), o.splice(m, 1);
  }
  Ne(o, function(O, I) {
    _[O] = I;
  });
  var y = Mt(Mt({}, r), _);
  y[Ye.internalSdkVersion] || (y[Ye.internalSdkVersion] = ct(e, "javascript:".concat(dD.Version), 64)), n[
    Tt
    /* @min:%2etags */
  ] = yS(y);
}
function ai(e, t, n) {
  /* @__PURE__ */ Y(e) || Ne(e, function(r, i) {
    Yf(i) ? n[r] = i : ce(i) ? t[r] = i : Ec() && (t[r] = Dn()[
      cc
      /* @min:%2estringify */
    ](i));
  });
}
function mo(e, t) {
  /* @__PURE__ */ Y(e) || Ne(e, function(n, r) {
    e[n] = r || t;
  });
}
function wo(e, t, n, r) {
  var i = new vI(e, r, t);
  et(i, "sampleRate", n[rm]), (n[We] || {}).startTime && (i.time = Ia(n[We].startTime)), i.iKey = n.iKey;
  var o = n.iKey.replace(/-/g, "");
  return i[
    wr
    /* @min:%2ename */
  ] = i[
    wr
    /* @min:%2ename */
  ].replace("{0}", o), lD(e, n, i), n[
    Tt
    /* @min:%2etags */
  ] = n[
    Tt
    /* @min:%2etags */
  ] || [], yS(i);
}
function yo(e, t) {
  /* @__PURE__ */ Y(t[We]) && K(e, 1, 46, "telemetryItem.baseData cannot be null.");
}
var dD = {
  Version: "3.3.6"
};
function vD(e, t, n) {
  yo(e, t);
  var r = t[We][
    Eo
    /* @min:%2emeasurements */
  ] || {}, i = t[We][_t] || {};
  ai(t[
    en
    /* @min:%2edata */
  ], i, r), /* @__PURE__ */ Y(n) || mo(i, n);
  var o = t[We];
  if (/* @__PURE__ */ Y(o))
    return Ki(e, "Invalid input for dependency data"), null;
  var a = o[_t] && o[_t][$p] ? o[_t][$p] : "GET", s = new ji(e, o.id, o.target, o[
    wr
    /* @min:%2ename */
  ], o[
    Ni
    /* @min:%2eduration */
  ], o.success, o.responseCode, a, o.type, o.correlationContext, i, r), c = new go(ji[
    Gn
    /* @min:%2edataType */
  ], s);
  return wo(e, ji[
    So
    /* @min:%2eenvelopeType */
  ], t, c);
}
function Ym(e, t, n) {
  yo(e, t);
  var r = {}, i = {};
  t[Rd] !== Vr[
    Gn
    /* @min:%2edataType */
  ] && (r.baseTypeSource = t[Rd]), t[Rd] === Vr[
    Gn
    /* @min:%2edataType */
  ] ? (r = t[We][_t] || {}, i = t[We][
    Eo
    /* @min:%2emeasurements */
  ] || {}) : t[We] && ai(t[We], r, i), ai(t[
    en
    /* @min:%2edata */
  ], r, i), /* @__PURE__ */ Y(n) || mo(r, n);
  var o = t[We][
    wr
    /* @min:%2ename */
  ], a = new Vr(e, o, r, i), s = new go(Vr[
    Gn
    /* @min:%2edataType */
  ], a);
  return wo(e, Vr[
    So
    /* @min:%2eenvelopeType */
  ], t, s);
}
function hD(e, t, n) {
  yo(e, t);
  var r = t[We][
    Eo
    /* @min:%2emeasurements */
  ] || {}, i = t[We][_t] || {};
  ai(t[
    en
    /* @min:%2edata */
  ], i, r), /* @__PURE__ */ Y(n) || mo(i, n);
  var o = t[We], a = un.CreateFromInterface(e, o, i, r), s = new go(un[
    Gn
    /* @min:%2edataType */
  ], a);
  return wo(e, un[
    So
    /* @min:%2eenvelopeType */
  ], t, s);
}
function _D(e, t, n) {
  yo(e, t);
  var r = t[We], i = r[_t] || {}, o = r[
    Eo
    /* @min:%2emeasurements */
  ] || {};
  ai(t[
    en
    /* @min:%2edata */
  ], i, o), /* @__PURE__ */ Y(n) || mo(i, n);
  var a = new qi(e, r[
    wr
    /* @min:%2ename */
  ], r.average, r.sampleCount, r.min, r.max, r.stdDev, i, o), s = new go(qi[
    Gn
    /* @min:%2edataType */
  ], a);
  return wo(e, qi[
    So
    /* @min:%2eenvelopeType */
  ], t, s);
}
function pD(e, t, n) {
  yo(e, t);
  var r, i = t[We];
  !/* @__PURE__ */ Y(i) && !/* @__PURE__ */ Y(i[_t]) && !/* @__PURE__ */ Y(i[_t][Ni]) ? (r = i[_t][Ni], delete i[_t][Ni]) : !/* @__PURE__ */ Y(t[
    en
    /* @min:%2edata */
  ]) && !/* @__PURE__ */ Y(t[
    en
    /* @min:%2edata */
  ][Ni]) && (r = t[
    en
    /* @min:%2edata */
  ][Ni], delete t[
    en
    /* @min:%2edata */
  ][Ni]);
  var o = t[We], a;
  ((t.ext || {}).trace || {})[
    sc
    /* @min:%2etraceID */
  ] && (a = t.ext.trace[
    sc
    /* @min:%2etraceID */
  ]);
  var s = o.id || a, c = o[
    wr
    /* @min:%2ename */
  ], u = o.uri, f = o[_t] || {}, l = o[
    Eo
    /* @min:%2emeasurements */
  ] || {};
  if (/* @__PURE__ */ Y(o.refUri) || (f.refUri = o.refUri), /* @__PURE__ */ Y(o.pageType) || (f.pageType = o.pageType), /* @__PURE__ */ Y(o.isLoggedIn) || (f.isLoggedIn = o.isLoggedIn[
    Ii
    /* @min:%2etoString */
  ]()), !/* @__PURE__ */ Y(o[_t])) {
    var v = o[_t];
    Ne(v, function(_, m) {
      f[_] = m;
    });
  }
  ai(t[
    en
    /* @min:%2edata */
  ], f, l), /* @__PURE__ */ Y(n) || mo(f, n);
  var d = new ni(e, c, u, r, f, l, s), h = new go(ni[
    Gn
    /* @min:%2edataType */
  ], d);
  return wo(e, ni[
    So
    /* @min:%2eenvelopeType */
  ], t, h);
}
function gD(e, t, n) {
  yo(e, t);
  var r = t[We], i = r[
    wr
    /* @min:%2ename */
  ], o = r.uri || r.url, a = r[_t] || {}, s = r[
    Eo
    /* @min:%2emeasurements */
  ] || {};
  ai(t[
    en
    /* @min:%2edata */
  ], a, s), /* @__PURE__ */ Y(n) || mo(a, n);
  var c = new Sa(e, i, o, void 0, a, s, r), u = new go(Sa[
    Gn
    /* @min:%2edataType */
  ], c);
  return wo(e, Sa[
    So
    /* @min:%2eenvelopeType */
  ], t, u);
}
function ED(e, t, n) {
  yo(e, t);
  var r = t[We].message, i = t[We].severityLevel, o = t[We][_t] || {}, a = t[We][
    Eo
    /* @min:%2emeasurements */
  ] || {};
  ai(t[
    en
    /* @min:%2edata */
  ], o, a), /* @__PURE__ */ Y(n) || mo(o, n);
  var s = new Ea(e, r, i, o, a), c = new go(Ea[
    Gn
    /* @min:%2edataType */
  ], s);
  return wo(e, Ea[
    So
    /* @min:%2eenvelopeType */
  ], t, c);
}
var Vm = (
  /** @class */
  function() {
    function e(t, n) {
      var r = [], i = !1, o = n.maxRetryCnt;
      this._get = function() {
        return r;
      }, this._set = function(a) {
        return r = a, r;
      }, Be(e, this, function(a) {
        a[
          Xi
          /* @min:%2eenqueue */
        ] = function(s) {
          if (a[
            Ji
            /* @min:%2ecount */
          ]() >= n.eventsLimitInMem) {
            i || (K(t, 2, 105, "Maximum in-memory buffer size reached: " + a[
              Ji
              /* @min:%2ecount */
            ](), !0), i = !0);
            return;
          }
          s.cnt = s.cnt || 0, !(!/* @__PURE__ */ Y(o) && s.cnt > o) && r[
            dr
            /* @min:%2epush */
          ](s);
        }, a[
          Ji
          /* @min:%2ecount */
        ] = function() {
          return r[
            Ce
            /* @min:%2elength */
          ];
        }, a.size = function() {
          for (var s = r[
            Ce
            /* @min:%2elength */
          ], c = 0; c < r[
            Ce
            /* @min:%2elength */
          ]; c++)
            s += r[c].item[
              Ce
              /* @min:%2elength */
            ];
          return n[
            zv
            /* @min:%2eemitLineDelimitedJson */
          ] || (s += 2), s;
        }, a[
          wa
          /* @min:%2eclear */
        ] = function() {
          r = [], i = !1;
        }, a.getItems = function() {
          return r.slice(0);
        }, a.batchPayloads = function(s) {
          if (s && s[
            Ce
            /* @min:%2elength */
          ] > 0) {
            var c = [];
            J(s, function(f) {
              c[
                dr
                /* @min:%2epush */
              ](f.item);
            });
            var u = n[
              zv
              /* @min:%2eemitLineDelimitedJson */
            ] ? c.join(`
`) : "[" + c.join(",") + "]";
            return u;
          }
          return null;
        }, a.createNew = function(s, c, u) {
          var f = r.slice(0);
          s = s || t, c = c || {};
          var l = u ? new Bm(s, c) : new g_(s, c);
          return J(f, function(v) {
            l[
              Xi
              /* @min:%2eenqueue */
            ](v);
          }), l;
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), g_ = (
  /** @class */
  function(e) {
    yr(t, e);
    function t(n, r) {
      var i = e.call(this, n, r) || this;
      return Be(t, i, function(o, a) {
        o[
          wf
          /* @min:%2emarkAsSent */
        ] = function(s) {
          a[
            wa
            /* @min:%2eclear */
          ]();
        }, o[
          $s
          /* @min:%2eclearSent */
        ] = function(s) {
        };
      }), i;
    }
    return t.__ieDyn = 1, t;
  }(Vm)
), SD = ["AI_buffer", "AI_sentBuffer"], Bm = (
  /** @class */
  function(e) {
    yr(t, e);
    function t(r, i) {
      var o = e.call(this, r, i) || this, a = !1, s = i == null ? void 0 : i.namePrefix, c = i[
        p_
        /* @min:%2ebufferOverride */
      ] || { getItem: kv, setItem: lm }, u = c.getItem, f = c.setItem, l = i.maxRetryCnt;
      return Be(t, o, function(v, d) {
        var h = I(t[
          ts
          /* @min:%2eBUFFER_KEY */
        ]), _ = I(t[
          Pr
          /* @min:%2eSENT_BUFFER_KEY */
        ]), m = D(), E = _[
          Go
          /* @min:%2econcat */
        ](m), y = v._set(h[
          Go
          /* @min:%2econcat */
        ](E));
        y[
          Ce
          /* @min:%2elength */
        ] > t[
          ns
          /* @min:%2eMAX_BUFFER_SIZE */
        ] && (y[
          Ce
          /* @min:%2elength */
        ] = t[
          ns
          /* @min:%2eMAX_BUFFER_SIZE */
        ]), B(t[
          Pr
          /* @min:%2eSENT_BUFFER_KEY */
        ], []), B(t[
          ts
          /* @min:%2eBUFFER_KEY */
        ], y), v[
          Xi
          /* @min:%2eenqueue */
        ] = function(F) {
          if (v[
            Ji
            /* @min:%2ecount */
          ]() >= t[
            ns
            /* @min:%2eMAX_BUFFER_SIZE */
          ]) {
            a || (K(r, 2, 67, "Maximum buffer size reached: " + v[
              Ji
              /* @min:%2ecount */
            ](), !0), a = !0);
            return;
          }
          F.cnt = F.cnt || 0, !(!/* @__PURE__ */ Y(l) && F.cnt > l) && (d[
            Xi
            /* @min:%2eenqueue */
          ](F), B(t[
            ts
            /* @min:%2eBUFFER_KEY */
          ], v._get()));
        }, v[
          wa
          /* @min:%2eclear */
        ] = function() {
          d[
            wa
            /* @min:%2eclear */
          ](), B(t[
            ts
            /* @min:%2eBUFFER_KEY */
          ], v._get()), B(t[
            Pr
            /* @min:%2eSENT_BUFFER_KEY */
          ], []), a = !1;
        }, v[
          wf
          /* @min:%2emarkAsSent */
        ] = function(F) {
          B(t[
            ts
            /* @min:%2eBUFFER_KEY */
          ], v._set(O(F, v._get())));
          var U = I(t[
            Pr
            /* @min:%2eSENT_BUFFER_KEY */
          ]);
          U instanceof Array && F instanceof Array && (U = U[
            Go
            /* @min:%2econcat */
          ](F), U[
            Ce
            /* @min:%2elength */
          ] > t[
            ns
            /* @min:%2eMAX_BUFFER_SIZE */
          ] && (K(r, 1, 67, "Sent buffer reached its maximum size: " + U[
            Ce
            /* @min:%2elength */
          ], !0), U[
            Ce
            /* @min:%2elength */
          ] = t[
            ns
            /* @min:%2eMAX_BUFFER_SIZE */
          ]), B(t[
            Pr
            /* @min:%2eSENT_BUFFER_KEY */
          ], U));
        }, v[
          $s
          /* @min:%2eclearSent */
        ] = function(F) {
          var U = I(t[
            Pr
            /* @min:%2eSENT_BUFFER_KEY */
          ]);
          U = O(F, U), B(t[
            Pr
            /* @min:%2eSENT_BUFFER_KEY */
          ], U);
        }, v.createNew = function(F, U, z) {
          z = !!z;
          var ne = v._get().slice(0), X = I(t[
            Pr
            /* @min:%2eSENT_BUFFER_KEY */
          ]).slice(0);
          F = F || r, U = U || {}, v[
            wa
            /* @min:%2eclear */
          ]();
          var S = z ? new t(F, U) : new g_(F, U);
          return J(ne, function(N) {
            S[
              Xi
              /* @min:%2eenqueue */
            ](N);
          }), z && S[
            wf
            /* @min:%2emarkAsSent */
          ](X), S;
        };
        function O(F, U) {
          var z = [], ne = [];
          return J(F, function(X) {
            ne[
              dr
              /* @min:%2epush */
            ](X.item);
          }), J(U, function(X) {
            !ye(X) && Rt(ne, X.item) === -1 && z[
              dr
              /* @min:%2epush */
            ](X);
          }), z;
        }
        function I(F) {
          var U = F;
          return U = s ? s + "_" + U : U, P(U);
        }
        function P(F) {
          try {
            var U = u(r, F);
            if (U) {
              var z = Dn().parse(U);
              if (ce(z) && (z = Dn().parse(z)), z && Te(z))
                return z;
            }
          } catch (ne) {
            K(r, 1, 42, " storage key: " + F + ", " + xe(ne), { exception: /* @__PURE__ */ Q(ne) });
          }
          return [];
        }
        function B(F, U) {
          var z = F;
          try {
            z = s ? s + "_" + z : z;
            var ne = JSON[
              cc
              /* @min:%2estringify */
            ](U);
            f(r, z, ne);
          } catch (X) {
            f(r, z, JSON[
              cc
              /* @min:%2estringify */
            ]([])), K(r, 2, 41, " storage key: " + z + ", " + xe(X) + ". Buffer cleared", { exception: /* @__PURE__ */ Q(X) });
          }
        }
        function D() {
          var F = [];
          try {
            return J(SD, function(U) {
              var z = b(U);
              if (F = F[
                Go
                /* @min:%2econcat */
              ](z), s) {
                var ne = s + "_" + U, X = b(ne);
                F = F[
                  Go
                  /* @min:%2econcat */
                ](X);
              }
            }), F;
          } catch (U) {
            K(r, 2, 41, "Transfer events from previous buffers: " + xe(U) + ". previous Buffer items can not be removed", { exception: /* @__PURE__ */ Q(U) });
          }
          return [];
        }
        function b(F) {
          try {
            var U = P(F), z = [];
            return J(U, function(ne) {
              var X = {
                item: ne,
                cnt: 0
                // previous events will be default to 0 count
              };
              z[
                dr
                /* @min:%2epush */
              ](X);
            }), dm(r, F), z;
          } catch {
          }
          return [];
        }
      }), o;
    }
    var n;
    return n = t, t.VERSION = "_1", t.BUFFER_KEY = "AI_buffer" + n.VERSION, t.SENT_BUFFER_KEY = "AI_sentBuffer" + n.VERSION, t.MAX_BUFFER_SIZE = 2e3, t;
  }(Vm)
), mD = (
  /** @class */
  function() {
    function e(t) {
      Be(e, this, function(n) {
        n.serialize = function(a) {
          var s = r(a, "root");
          try {
            return Dn()[
              cc
              /* @min:%2estringify */
            ](s);
          } catch (c) {
            K(t, 1, 48, c && ye(c[
              Ii
              /* @min:%2etoString */
            ]) ? c[
              Ii
              /* @min:%2etoString */
            ]() : "Error serializing object", null, !0);
          }
        };
        function r(a, s) {
          var c = "__aiCircularRefCheck", u = {};
          if (!a)
            return K(t, 1, 48, "cannot serialize object because it is null or undefined", { name: s }, !0), u;
          if (a[c])
            return K(t, 2, 50, "Circular reference detected while serializing object", { name: s }, !0), u;
          if (!a.aiDataContract) {
            if (s === "measurements")
              u = o(a, "number", s);
            else if (s === "properties")
              u = o(a, "string", s);
            else if (s === "tags")
              u = o(a, "string", s);
            else if (Te(a))
              u = i(a, s);
            else {
              K(t, 2, 49, "Attempting to serialize an object which does not implement ISerializable", { name: s }, !0);
              try {
                Dn()[
                  cc
                  /* @min:%2estringify */
                ](a), u = a;
              } catch (f) {
                K(t, 1, 48, f && ye(f[
                  Ii
                  /* @min:%2etoString */
                ]) ? f[
                  Ii
                  /* @min:%2etoString */
                ]() : "Error serializing object", null, !0);
              }
            }
            return u;
          }
          return a[c] = !0, Ne(a.aiDataContract, function(f, l) {
            var v = ye(l) ? l() & 1 : l & 1, d = ye(l) ? l() & 4 : l & 4, h = l & 2, _ = a[f] !== void 0, m = /* @__PURE__ */ qt(a[f]) && a[f] !== null;
            if (v && !_ && !h)
              K(t, 1, 24, "Missing required field specification. The field is required but not present on source", { field: f, name: s });
            else if (!d) {
              var E = void 0;
              m ? h ? E = i(a[f], f) : E = r(a[f], f) : E = a[f], E !== void 0 && (u[f] = E);
            }
          }), delete a[c], u;
        }
        function i(a, s) {
          var c;
          if (a)
            if (!Te(a))
              K(t, 1, 54, `This field was specified as an array in the contract but the item is not an array.\r
`, { name: s }, !0);
            else {
              c = [];
              for (var u = 0; u < a[
                Ce
                /* @min:%2elength */
              ]; u++) {
                var f = a[u], l = r(f, s + "[" + u + "]");
                c[
                  dr
                  /* @min:%2epush */
                ](l);
              }
            }
          return c;
        }
        function o(a, s, c) {
          var u;
          return a && (u = {}, Ne(a, function(f, l) {
            if (s === "string")
              l === void 0 ? u[f] = "undefined" : l === null ? u[f] = "null" : l[
                Ii
                /* @min:%2etoString */
              ] ? u[f] = l[
                Ii
                /* @min:%2etoString */
              ]() : u[f] = "invalid field: toString() is not defined.";
            else if (s === "number")
              if (l === void 0)
                u[f] = "undefined";
              else if (l === null)
                u[f] = "null";
              else {
                var v = parseFloat(l);
                u[f] = v;
              }
            else
              u[f] = "invalid field: " + c + " is of unknown type.", K(t, 1, u[f], null, !0);
          })), u;
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
), wD = 8, yD = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getHashCodeScore = function(t) {
      var n = this.getHashCode(t) / e.INT_MAX_VALUE;
      return n * 100;
    }, e.prototype.getHashCode = function(t) {
      if (t === "")
        return 0;
      for (; t[
        Ce
        /* @min:%2elength */
      ] < wD; )
        t = t[
          Go
          /* @min:%2econcat */
        ](t);
      for (var n = 5381, r = 0; r < t[
        Ce
        /* @min:%2elength */
      ]; ++r)
        n = (n << 5) + n + t.charCodeAt(r), n = n & n;
      return Math.abs(n);
    }, e.INT_MAX_VALUE = 2147483647, e;
  }()
), TD = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      var t = this, n = new yD(), r = new mm();
      t.getSamplingScore = function(i) {
        var o = 0;
        return i[
          Tt
          /* @min:%2etags */
        ] && i[
          Tt
          /* @min:%2etags */
        ][r.userId] ? o = n.getHashCodeScore(i[
          Tt
          /* @min:%2etags */
        ][r.userId]) : i.ext && i.ext.user && i.ext.user.id ? o = n[
          fD
          /* @min:%2egetHashCodeScore */
        ](i.ext.user.id) : i[
          Tt
          /* @min:%2etags */
        ] && i[
          Tt
          /* @min:%2etags */
        ][r.operationId] ? o = n.getHashCodeScore(i[
          Tt
          /* @min:%2etags */
        ][r.operationId]) : i.ext && i.ext.telemetryTrace && i.ext.telemetryTrace[
          sc
          /* @min:%2etraceID */
        ] ? o = n.getHashCodeScore(i.ext.telemetryTrace[
          sc
          /* @min:%2etraceID */
        ]) : o = Math.random() * 100, o;
      };
    }
    return e;
  }()
), bD = (
  /** @class */
  function() {
    function e(t, n) {
      this.INT_MAX_VALUE = 2147483647;
      var r = n || ho(null);
      (t > 100 || t < 0) && (r.throwInternal(2, 58, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: t }, !0), t = 100), this[
        yf
        /* @min:%2esampleRate */
      ] = t, this.samplingScoreGenerator = new TD();
    }
    return e.prototype.isSampledIn = function(t) {
      var n = this[
        yf
        /* @min:%2esampleRate */
      ], r = !1;
      return n == null || n >= 100 || t.baseType === qi[
        Gn
        /* @min:%2edataType */
      ] ? !0 : (r = this.samplingScoreGenerator.getSamplingScore(t) < n, r);
    }, e;
  }()
), ze, tr, Mn = void 0, og = "", CD = 65e3;
function ag(e) {
  try {
    return e.responseText;
  } catch {
  }
  return null;
}
function ND(e) {
  return e && e.sendPOST;
}
var sg = xa((ze = {
  // Use the default value (handles empty string in the configuration)
  endpointUrl: af(Yu, c_ + _a)
}, ze[
  zv
  /* @min:emitLineDelimitedJson */
] = at(), ze.maxBatchInterval = 15e3, ze[
  Mm
  /* @min:maxBatchSizeInBytes */
] = 102400, ze.disableTelemetry = at(), ze[
  $m
  /* @min:enableSessionStorageBuffer */
] = at(!0), ze.isRetryDisabled = at(), ze[
  Wv
  /* @min:isBeaconApiDisabled */
] = at(!0), ze[
  Hm
  /* @min:disableSendBeaconSplit */
] = at(!0), ze.disableXhr = at(), ze[
  Fm
  /* @min:onunloadDisableFetch */
] = at(), ze[
  Kv
  /* @min:onunloadDisableBeacon */
] = at(), ze[
  Ts
  /* @min:instrumentationKey */
] = Mn, ze.namePrefix = Mn, ze.samplingPercentage = af(ID, 100), ze[
  Gv
  /* @min:customHeaders */
] = Mn, ze.convertUndefined = Mn, ze.eventsLimitInMem = 1e4, ze[
  p_
  /* @min:bufferOverride */
] = !1, ze.httpXHROverride = { isVal: ND, v: Mn }, ze[
  Um
  /* @min:alwaysUseXhrOverride */
] = at(), ze.transports = Mn, ze.retryCodes = Mn, ze.maxRetryCnt = { isVal: Yf, v: 10 }, ze));
function ID(e) {
  return !isNaN(e) && e > 0 && e <= 100;
}
var DD = (tr = {}, tr[Vr.dataType] = Ym, tr[Ea.dataType] = ED, tr[ni.dataType] = pD, tr[Sa.dataType] = gD, tr[un.dataType] = hD, tr[qi.dataType] = _D, tr[ji.dataType] = vD, tr), RD = (
  /** @class */
  function(e) {
    yr(t, e);
    function t() {
      var n = e.call(this) || this;
      n.priority = 1001, n.identifier = wm;
      var r, i, o, a, s, c, u, f, l = 0, v, d, h, _, m, E, y, O, I, P, B, D, b, F, U, z, ne, X, S, N, $, w, W, ie, Z, _e, p;
      return Be(t, n, function(g, A) {
        di(), g.pause = function() {
          ke(), a = !0;
        }, g.resume = function() {
          a && (a = !1, i = null, C(), be());
        }, g.flush = function(T, x, q) {
          if (T === void 0 && (T = !0), !a) {
            ke();
            try {
              return g[
                rs
                /* @min:%2etriggerSend */
              ](
                T,
                null,
                q || 1
                /* SendRequestReason.ManualFlush */
              );
            } catch (re) {
              K(g[
                Ct
                /* @min:%2ediagLog */
              ](), 1, 22, "flush failed, telemetry will not be collected: " + xe(re), { exception: /* @__PURE__ */ Q(re) });
            }
          }
        }, g.onunloadFlush = function() {
          if (!a)
            if (y || N)
              try {
                return g[
                  rs
                  /* @min:%2etriggerSend */
                ](
                  !0,
                  H,
                  2
                  /* SendRequestReason.Unload */
                );
              } catch (T) {
                K(g[
                  Ct
                  /* @min:%2ediagLog */
                ](), 1, 20, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + xe(T), { exception: /* @__PURE__ */ Q(T) });
              }
            else
              g.flush(!1);
        }, g.addHeader = function(T, x) {
          f[T] = x;
        }, g[
          bd
          /* @min:%2einitialize */
        ] = function(T, x, q, re) {
          g.isInitialized() && K(g[
            Ct
            /* @min:%2ediagLog */
          ](), 1, 28, "Sender is already initialized"), A[
            bd
            /* @min:%2einitialize */
          ](T, x, q, re);
          var ve = g.identifier;
          c = new mD(x.logger), r = 0, i = null, o = 0, g[
            is
            /* @min:%2e_sender */
          ] = null, u = 0;
          var le = g[
            Ct
            /* @min:%2ediagLog */
          ]();
          h = fi(_n("Sender"), x.evtNamespace && x.evtNamespace()), d = $I(h), g._addHook(nt(T, function(Re) {
            var Ze = Re.cfg;
            Ze.storagePrefix && h_(Ze.storagePrefix);
            var jt = Rn(null, Ze, x), we = jt.getExtCfg(ve, sg), w_ = we[
              os
              /* @min:%2eendpointUrl */
            ];
            if (_ && w_ === _) {
              var tl = Ze[
                os
                /* @min:%2eendpointUrl */
              ];
              tl && tl !== w_ && (we[
                os
                /* @min:%2eendpointUrl */
              ] = tl);
            }
            /* @__PURE__ */ Ws(we[
              Ts
              /* @min:%2einstrumentationKey */
            ]) && (we[
              Ts
              /* @min:%2einstrumentationKey */
            ] = Ze[
              Ts
              /* @min:%2einstrumentationKey */
            ]), Le(g, "_senderConfig", {
              g: function() {
                return we;
              }
            }), m !== we[
              os
              /* @min:%2eendpointUrl */
            ] && (_ = m = we[
              os
              /* @min:%2eendpointUrl */
            ]), x.activeStatus() === Lr.PENDING ? g.pause() : x.activeStatus() === Lr.ACTIVE && g.resume(), P && P !== we[
              Gv
              /* @min:%2ecustomHeaders */
            ] && J(P, function(mt) {
              delete f[mt.header];
            }), E = we[
              Mm
              /* @min:%2emaxBatchSizeInBytes */
            ], y = (we[
              Kv
              /* @min:%2eonunloadDisableBeacon */
            ] === !1 || we[
              Wv
              /* @min:%2eisBeaconApiDisabled */
            ] === !1) && gs(), O = we[
              Kv
              /* @min:%2eonunloadDisableBeacon */
            ] === !1 && gs(), I = we[
              Wv
              /* @min:%2eisBeaconApiDisabled */
            ] === !1 && gs(), N = we[
              Um
              /* @min:%2ealwaysUseXhrOverride */
            ], $ = !!we.disableXhr, p = we.retryCodes;
            var nl = we[
              p_
              /* @min:%2ebufferOverride */
            ], To = !!we[
              $m
              /* @min:%2eenableSessionStorageBuffer */
            ] && (!!nl || oc()), y_ = we.namePrefix, gw = To !== z || To && X !== y_ || To && ne !== nl;
            if (g[
              An
              /* @min:%2e_buffer */
            ]) {
              if (gw)
                try {
                  g[
                    An
                    /* @min:%2e_buffer */
                  ] = g[
                    An
                    /* @min:%2e_buffer */
                  ].createNew(le, we, To);
                } catch (mt) {
                  K(g[
                    Ct
                    /* @min:%2ediagLog */
                  ](), 1, 12, "failed to transfer telemetry to different buffer storage, telemetry will be lost: " + xe(mt), { exception: /* @__PURE__ */ Q(mt) });
                }
              C();
            } else
              g[
                An
                /* @min:%2e_buffer */
              ] = To ? new Bm(le, we) : new g_(le, we);
            X = y_, z = To, ne = nl, w = !we[
              Fm
              /* @min:%2eonunloadDisableFetch */
            ] && qh(!0), Z = !!we[
              Hm
              /* @min:%2edisableSendBeaconSplit */
            ], g._sample = new bD(we.samplingPercentage, le), D = we[
              Ts
              /* @min:%2einstrumentationKey */
            ], !/* @__PURE__ */ Ws(D) && !Yt(D, Ze) && K(le, 1, 100, "Invalid Instrumentation key " + D), P = we[
              Gv
              /* @min:%2ecustomHeaders */
            ], ce(_) && !Ov(_) && P && P[
              Ce
              /* @min:%2elength */
            ] > 0 ? J(P, function(mt) {
              n.addHeader(mt.header, mt.value);
            }) : P = null, S = we.enableSendPromise;
            var T_ = te();
            _e ? _e.SetConfig(T_) : (_e = new kN(), _e[
              bd
              /* @min:%2einitialize */
            ](T_, le));
            var yc = we.httpXHROverride, Tc = null, Ya = null, Ew = ip([
              3,
              1,
              2
              /* TransportType.Fetch */
            ], we.transports);
            Tc = _e && _e[
              Qc
              /* @min:%2egetSenderInst */
            ](Ew, !1);
            var rl = _e && _e.getFallbackInst();
            W = function(mt, vi) {
              return ae(rl, mt, vi);
            }, ie = function(mt, vi) {
              return ae(rl, mt, vi, !1);
            }, Tc = N ? yc : Tc || yc || rl, g[
              is
              /* @min:%2e_sender */
            ] = function(mt, vi) {
              return ae(Tc, mt, vi);
            }, w && (v = de);
            var il = ip([
              3,
              1
              /* TransportType.Xhr */
            ], we.unloadTransports);
            w || (il = il.filter(function(mt) {
              return mt !== 2;
            })), Ya = _e && _e[
              Qc
              /* @min:%2egetSenderInst */
            ](il, !0), Ya = N ? yc : Ya || yc, (N || we.unloadTransports || !v) && Ya && (v = function(mt, vi) {
              return ae(Ya, mt, vi);
            }), v || (v = W), B = we.disableTelemetry, b = we.convertUndefined || Mn, F = we.isRetryDisabled, U = we.maxBatchInterval;
          }));
        }, g.processTelemetry = function(T, x) {
          x = g._getTelCtx(x);
          var q = x[
            Ct
            /* @min:%2ediagLog */
          ]();
          try {
            var re = gn(T, q);
            if (!re)
              return;
            var ve = $e(T, q);
            if (!ve)
              return;
            var le = c.serialize(ve), Re = g[
              An
              /* @min:%2e_buffer */
            ];
            C(le);
            var Ze = {
              item: le,
              cnt: 0
              // inital cnt will always be 0
            };
            Re[
              Xi
              /* @min:%2eenqueue */
            ](Ze), be();
          } catch (jt) {
            K(q, 2, 12, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + xe(jt), { exception: /* @__PURE__ */ Q(jt) });
          }
          g.processNext(T, x);
        }, g.isCompletelyIdle = function() {
          return !a && l === 0 && g._buffer[
            Ji
            /* @min:%2ecount */
          ]() === 0;
        }, g.getOfflineListener = function() {
          return d;
        }, g._xhrReadyStateChange = function(T, x, q) {
          if (!ee(x))
            return se(T, x, q);
        }, g[
          rs
          /* @min:%2etriggerSend */
        ] = function(T, x, q) {
          T === void 0 && (T = !0);
          var re;
          if (!a)
            try {
              var ve = g[
                An
                /* @min:%2e_buffer */
              ];
              if (B)
                ve[
                  wa
                  /* @min:%2eclear */
                ]();
              else {
                if (ve[
                  Ji
                  /* @min:%2ecount */
                ]() > 0) {
                  var le = ve.getItems();
                  En(q || 0, T), x ? re = x.call(g, le, T) : re = g[
                    is
                    /* @min:%2e_sender */
                  ](le, T);
                }
                o = +/* @__PURE__ */ new Date();
              }
              ke();
            } catch (Ze) {
              var Re = DS();
              (!Re || Re > 9) && K(g[
                Ct
                /* @min:%2ediagLog */
              ](), 1, 40, "Telemetry transmission failed, some telemetry will be lost: " + xe(Ze), { exception: /* @__PURE__ */ Q(Ze) });
            }
          return re;
        }, g.getOfflineSupport = function() {
          return {
            getUrl: function() {
              return _;
            },
            createPayload: j,
            serialize: ft,
            batch: R,
            shouldProcess: function(T) {
              return !!gn(T);
            }
          };
        }, g._doTeardown = function(T, x) {
          g.onunloadFlush(), ra(d, !1), di();
        }, g[
          wi
          /* @min:%2e_onError */
        ] = function(T, x, q) {
          if (!ee(T))
            return Se(T, x);
        }, g[
          Cd
          /* @min:%2e_onPartialSuccess */
        ] = function(T, x) {
          if (!ee(T))
            return ge(T, x);
        }, g[
          Zc
          /* @min:%2e_onSuccess */
        ] = function(T, x) {
          if (!ee(T))
            return He(T);
        }, g._xdrOnLoad = function(T, x) {
          if (!ee(x))
            return M(T, x);
        };
        function M(T, x) {
          var q = ag(T);
          if (T && (q + "" == "200" || q === ""))
            r = 0, g[
              Zc
              /* @min:%2e_onSuccess */
            ](x, 0);
          else {
            var re = cd(q);
            re && re[
              Nd
              /* @min:%2eitemsReceived */
            ] && re[
              Nd
              /* @min:%2eitemsReceived */
            ] > re[
              Id
              /* @min:%2eitemsAccepted */
            ] && !F ? g[
              Cd
              /* @min:%2e_onPartialSuccess */
            ](x, re) : g[
              wi
              /* @min:%2e_onError */
            ](x, bS(T));
          }
        }
        function te() {
          try {
            var T = {
              xdrOnComplete: function(q, re, ve) {
                var le = St(ve);
                if (le)
                  return M(q, le);
              },
              fetchOnComplete: function(q, re, ve, le) {
                var Re = St(le);
                if (Re)
                  return L(q.status, Re, q.url, Re[
                    Ce
                    /* @min:%2elength */
                  ], q.statusText, ve || "");
              },
              xhrOnComplete: function(q, re, ve) {
                var le = St(ve);
                if (le)
                  return se(q, le, le[
                    Ce
                    /* @min:%2elength */
                  ]);
              },
              beaconOnRetry: function(q, re, ve) {
                return G(q, re, ve);
              }
            }, x = {
              enableSendPromise: S,
              isOneDs: !1,
              disableCredentials: !1,
              disableXhr: $,
              disableBeacon: !I,
              disableBeaconSync: !O,
              senderOnCompleteCallBack: T
            };
            return x;
          } catch {
          }
          return null;
        }
        function se(T, x, q) {
          T.readyState === 4 && L(T.status, x, T.responseURL, q, nf(T), ag(T) || T.response);
        }
        function Se(T, x, q) {
          K(g[
            Ct
            /* @min:%2ediagLog */
          ](), 2, 26, "Failed to send telemetry.", { message: x }), g._buffer && g._buffer[
            $s
            /* @min:%2eclearSent */
          ](T);
        }
        function ge(T, x) {
          for (var q = [], re = [], ve = x.errors.reverse(), le = 0, Re = ve; le < Re.length; le++) {
            var Ze = Re[le], jt = T.splice(Ze.index, 1)[0];
            rt(Ze.statusCode) ? re[
              dr
              /* @min:%2epush */
            ](jt) : q[
              dr
              /* @min:%2epush */
            ](jt);
          }
          T[
            Ce
            /* @min:%2elength */
          ] > 0 && g[
            Zc
            /* @min:%2e_onSuccess */
          ](T, x[
            Id
            /* @min:%2eitemsAccepted */
          ]), q[
            Ce
            /* @min:%2elength */
          ] > 0 && g[
            wi
            /* @min:%2e_onError */
          ](q, nf(null, ["partial success", x[
            Id
            /* @min:%2eitemsAccepted */
          ], "of", x.itemsReceived].join(" "))), re[
            Ce
            /* @min:%2elength */
          ] > 0 && (me(re), K(g[
            Ct
            /* @min:%2ediagLog */
          ](), 2, 40, "Partial success. Delivered: " + T[
            Ce
            /* @min:%2elength */
          ] + ", Failed: " + q[
            Ce
            /* @min:%2elength */
          ] + ". Will retry to send " + re[
            Ce
            /* @min:%2elength */
          ] + " our of " + x[
            Nd
            /* @min:%2eitemsReceived */
          ] + " items"));
        }
        function He(T, x) {
          g._buffer && g._buffer[
            $s
            /* @min:%2eclearSent */
          ](T);
        }
        function St(T) {
          try {
            if (T) {
              var x = T, q = x.oriPayload;
              return q && q[
                Ce
                /* @min:%2elength */
              ] ? q : null;
            }
          } catch {
          }
          return null;
        }
        function gn(T, x) {
          if (B)
            return !1;
          if (!T)
            return x && K(x, 1, 7, "Cannot send empty telemetry"), !1;
          if (T.baseData && !T[
            Dd
            /* @min:%2ebaseType */
          ])
            return x && K(x, 1, 70, "Cannot send telemetry without baseData and baseType"), !1;
          if (T[
            Dd
            /* @min:%2ebaseType */
          ] || (T[
            Dd
            /* @min:%2ebaseType */
          ] = "EventData"), !g[
            is
            /* @min:%2e_sender */
          ])
            return x && K(x, 1, 28, "Sender was not initialized"), !1;
          if (fe(T))
            T[rm] = g._sample[
              yf
              /* @min:%2esampleRate */
            ];
          else
            return x && K(x, 2, 33, "Telemetry item was sampled out and not sent", { SampleRate: g._sample[
              yf
              /* @min:%2esampleRate */
            ] }), !1;
          return !0;
        }
        function $e(T, x) {
          var q = T.iKey || D, re = t.constructEnvelope(T, q, x, b);
          if (!re) {
            K(x, 1, 47, "Unable to create an AppInsights envelope");
            return;
          }
          var ve = !1;
          if (T[
            Tt
            /* @min:%2etags */
          ] && T[
            Tt
            /* @min:%2etags */
          ][ld] && (J(T[
            Tt
            /* @min:%2etags */
          ][ld], function(le) {
            try {
              le && le(re) === !1 && (ve = !0, Ki(x, "Telemetry processor check returns false"));
            } catch (Re) {
              K(x, 1, 64, "One of telemetry initializers failed, telemetry item will not be sent: " + xe(Re), { exception: /* @__PURE__ */ Q(Re) }, !0);
            }
          }), delete T[
            Tt
            /* @min:%2etags */
          ][ld]), !ve)
            return re;
        }
        function ft(T) {
          var x = og, q = g[
            Ct
            /* @min:%2ediagLog */
          ]();
          try {
            var re = gn(T, q), ve = null;
            re && (ve = $e(T, q)), ve && (x = c.serialize(ve));
          } catch {
          }
          return x;
        }
        function R(T) {
          var x = og;
          return T && T[
            Ce
            /* @min:%2elength */
          ] && (x = "[" + T.join(",") + "]"), x;
        }
        function j(T) {
          var x = Oe();
          return {
            urlString: _,
            data: T,
            headers: x
          };
        }
        function fe(T) {
          return g._sample.isSampledIn(T);
        }
        function oe(T, x, q, re) {
          x === 200 && T ? g._onSuccess(T, T[
            Ce
            /* @min:%2elength */
          ]) : re && g[
            wi
            /* @min:%2e_onError */
          ](T, re);
        }
        function ae(T, x, q, re) {
          re === void 0 && (re = !0);
          var ve = function(Ze, jt, we) {
            return oe(x, Ze, jt, we);
          }, le = Ae(x), Re = T && T.sendPOST;
          return Re && le ? (re && g._buffer[
            wf
            /* @min:%2emarkAsSent */
          ](x), Re(le, ve, !q)) : null;
        }
        function Ae(T) {
          if (Te(T) && T[
            Ce
            /* @min:%2elength */
          ] > 0) {
            var x = g[
              An
              /* @min:%2e_buffer */
            ].batchPayloads(T), q = Oe(), re = {
              data: x,
              urlString: _,
              headers: q,
              disableXhrSync: $,
              disableFetchKeepAlive: !w,
              oriPayload: T
            };
            return re;
          }
          return null;
        }
        function Oe() {
          try {
            var T = f || {};
            return Ov(_) && (T[Ue[
              6
              /* eRequestHeaders.sdkContextHeader */
            ]] = Ue[
              7
              /* eRequestHeaders.sdkContextHeaderAppIdRequest */
            ]), T;
          } catch {
          }
          return null;
        }
        function C(T) {
          var x = T ? T[
            Ce
            /* @min:%2elength */
          ] : 0;
          return g[
            An
            /* @min:%2e_buffer */
          ].size() + x > E ? ((!d || d.isOnline()) && g[
            rs
            /* @min:%2etriggerSend */
          ](
            !0,
            null,
            10
            /* SendRequestReason.MaxBatchSize */
          ), !0) : !1;
        }
        function L(T, x, q, re, ve, le) {
          var Re = null;
          if (g._appId || (Re = cd(le), Re && Re.appId && (g._appId = Re.appId)), (T < 200 || T >= 300) && T !== 0) {
            if ((T === 301 || T === 307 || T === 308) && !V(q)) {
              g[
                wi
                /* @min:%2e_onError */
              ](x, ve);
              return;
            }
            if (d && !d.isOnline()) {
              if (!F) {
                var Ze = 10;
                me(x, Ze), K(g[
                  Ct
                  /* @min:%2ediagLog */
                ](), 2, 40, ". Offline - Response Code: ".concat(T, ". Offline status: ").concat(!d.isOnline(), ". Will retry to send ").concat(x.length, " items."));
              }
              return;
            }
            !F && rt(T) ? (me(x), K(g[
              Ct
              /* @min:%2ediagLog */
            ](), 2, 40, ". Response code " + T + ". Will retry to send " + x[
              Ce
              /* @min:%2elength */
            ] + " items.")) : g[
              wi
              /* @min:%2e_onError */
            ](x, ve);
          } else
            V(q), T === 206 ? (Re || (Re = cd(le)), Re && !F ? g[
              Cd
              /* @min:%2e_onPartialSuccess */
            ](x, Re) : g[
              wi
              /* @min:%2e_onError */
            ](x, ve)) : (r = 0, g[
              Zc
              /* @min:%2e_onSuccess */
            ](x, re));
        }
        function V(T) {
          return u >= 10 ? !1 : !/* @__PURE__ */ Y(T) && T !== "" && T !== _ ? (_ = T, ++u, !0) : !1;
        }
        function H(T, x) {
          if (v)
            v(T, !1);
          else {
            var q = _e && _e[
              Qc
              /* @min:%2egetSenderInst */
            ]([
              3
              /* TransportType.Beacon */
            ], !0);
            return ae(q, T, x);
          }
        }
        function G(T, x, q) {
          var re = T, ve = re && re.oriPayload;
          if (Z)
            ie && ie(ve, !0), K(g[
              Ct
              /* @min:%2ediagLog */
            ](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender.");
          else {
            for (var le = [], Re = 0; Re < ve[
              Ce
              /* @min:%2elength */
            ]; Re++) {
              var Ze = ve[Re], jt = [Ze], we = Ae(jt);
              q(we, x) ? g._onSuccess(jt, jt[
                Ce
                /* @min:%2elength */
              ]) : le[
                dr
                /* @min:%2epush */
              ](Ze);
            }
            le[
              Ce
              /* @min:%2elength */
            ] > 0 && (ie && ie(le, !0), K(g[
              Ct
              /* @min:%2ediagLog */
            ](), 2, 40, ". Failed to send telemetry with Beacon API, retried with normal sender."));
          }
        }
        function ee(T) {
          try {
            if (T && T[
              Ce
              /* @min:%2elength */
            ])
              return ce(T[0]);
          } catch {
          }
          return null;
        }
        function de(T, x) {
          var q = null;
          if (Te(T)) {
            for (var re = T[
              Ce
              /* @min:%2elength */
            ], ve = 0; ve < T[
              Ce
              /* @min:%2elength */
            ]; ve++)
              re += T[ve].item[
                Ce
                /* @min:%2elength */
              ];
            var le = _e.getSyncFetchPayload();
            le + re <= CD ? q = 2 : gs() ? q = 3 : (q = 1, K(g[
              Ct
              /* @min:%2ediagLog */
            ](), 2, 40, ". Failed to send telemetry with Beacon API, retried with xhrSender."));
            var Re = _e && _e[
              Qc
              /* @min:%2egetSenderInst */
            ]([q], !0);
            return ae(Re, T, x);
          }
          return null;
        }
        function me(T, x) {
          if (x === void 0 && (x = 1), !(!T || T[
            Ce
            /* @min:%2elength */
          ] === 0)) {
            var q = g[
              An
              /* @min:%2e_buffer */
            ];
            q[
              $s
              /* @min:%2eclearSent */
            ](T), r++;
            for (var re = 0, ve = T; re < ve.length; re++) {
              var le = ve[re];
              le.cnt = le.cnt || 0, le.cnt++, q[
                Xi
                /* @min:%2eenqueue */
              ](le);
            }
            ue(x), be();
          }
        }
        function ue(T) {
          var x = 10, q;
          if (r <= 1)
            q = x;
          else {
            var re = (Math.pow(2, r) - 1) / 2, ve = tn(Math.random() * re * x) + 1;
            ve = T * ve, q = As(kE(ve, 3600), x);
          }
          var le = /* @__PURE__ */ Kn() + q * 1e3;
          i = le;
        }
        function be() {
          if (!s && !a) {
            var T = i ? As(0, i - /* @__PURE__ */ Kn()) : 0, x = As(U, T);
            s = Wn(function() {
              s = null, g[
                rs
                /* @min:%2etriggerSend */
              ](
                !0,
                null,
                1
                /* SendRequestReason.NormalSchedule */
              );
            }, x);
          }
        }
        function ke() {
          s && s.cancel(), s = null, i = null;
        }
        function rt(T) {
          return /* @__PURE__ */ Y(p) ? T === 401 || T === 408 || T === 429 || T === 500 || T === 502 || T === 503 || T === 504 : p[
            Ce
            /* @min:%2elength */
          ] && p.indexOf(T) > -1;
        }
        function on() {
          var T = "getNotifyMgr";
          return g.core[T] ? g.core[T]() : g.core._notificationManager;
        }
        function En(T, x) {
          var q = on();
          if (q && q.eventsSendRequest)
            try {
              q.eventsSendRequest(T, x);
            } catch (re) {
              K(g[
                Ct
                /* @min:%2ediagLog */
              ](), 1, 74, "send request notification failed: " + xe(re), { exception: /* @__PURE__ */ Q(re) });
            }
        }
        function Yt(T, x) {
          var q = x.disableInstrumentationKeyValidation, re = /* @__PURE__ */ Y(q) ? !1 : q;
          if (re)
            return !0;
          var ve = "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$", le = new RegExp(ve);
          return le.test(T);
        }
        function di() {
          g[
            is
            /* @min:%2e_sender */
          ] = null, g[
            An
            /* @min:%2e_buffer */
          ] = null, g._appId = null, g._sample = null, f = {}, d = null, r = 0, i = null, o = null, a = !1, s = null, c = null, u = 0, l = 0, v = null, h = null, _ = null, m = null, E = 0, y = !1, P = null, B = !1, D = null, b = Mn, F = !1, z = null, X = Mn, $ = !1, w = !1, Z = !1, W = null, ie = null, _e = null, Le(g, "_senderConfig", {
            g: function() {
              return TS({}, sg);
            }
          });
        }
      }), n;
    }
    return t.constructEnvelope = function(n, r, i, o) {
      var a;
      r !== n.iKey && !/* @__PURE__ */ Y(r) ? a = Mt(Mt({}, n), { iKey: r }) : a = n;
      var s = DD[a.baseType] || Ym;
      return s(i, a, o);
    }, t;
  }(Fa)
), cg = "duration", Aa = "properties", yn = "requestUrl", Mi = "length", Wr = "traceID", qr = "spanID", Tn = "traceFlags", Fs = "context", ya = "aborted", eu = "_addHook", On = "core", Pd = "includeCorrelationHeaders", qv = "getAbsoluteUrl", yi = "headers", sn = "requestHeaders", Ad = "setRequestHeader", ug = "trackDependencyDataInternal", oa = "startTime", Ao = "toLowerCase", jv = "enableRequestHeaderTracking", zm = "enableAjaxErrorStatusText", Gm = "enableAjaxPerfTracking", Km = "maxAjaxCallsPerView", Wm = "excludeRequestFromAutoTrackingPatterns", Xv = "disableAjaxTracking", qm = "ajaxPerfLookupDelay", jm = "disableFetchTracking", Xm = "enableResponseHeaderTracking", wn = "status", Pi = "statusText", Tf = "headerMap", Ui = "requestSentTime", Jv = "getTraceId", Qv = "getTraceFlags", zr = "method", Zv = "errorStatusText", Jm = "stateChangeAttached", fg = "responseText", bs = "responseFinishedTime", eh = "CreateTrackItem", lg = "getAllResponseHeaders", th = "getPartAProps", bf = "perfMark", nh = "perfTiming", rh = "ajaxDiagnosticsMessage", ih = "correlationContext", Od = "ajaxTotalDuration", kd = "eventTraceCtx";
function Qm(e, t, n) {
  var r = 0, i = e[t], o = e[n];
  return i && o && (r = Bt(i, o)), r;
}
function Ti(e, t, n, r, i) {
  var o = 0, a = Qm(n, r, i);
  return a && (o = kr(e, t, Br(a))), o;
}
function kr(e, t, n) {
  var r = "ajaxPerf", i = 0;
  if (e && t && n) {
    var o = e[r] = e[r] || {};
    o[t] = n, i = 1;
  }
  return i;
}
function PD(e, t) {
  var n = e[
    nh
    /* @min:%2eperfTiming */
  ], r = t[
    Aa
    /* @min:%2eproperties */
  ] || {}, i = 0, o = "name", a = "Start", s = "End", c = "domainLookup", u = "connect", f = "redirect", l = "request", v = "response", d = "startTime", h = c + a, _ = c + s, m = u + a, E = u + s, y = l + a, O = l + s, I = v + a, P = v + s, B = f + a, D = f = s, b = "transferSize", F = "encodedBodySize", U = "decodedBodySize", z = "serverTiming";
  if (n) {
    i |= Ti(r, f, n, B, D), i |= Ti(r, c, n, h, _), i |= Ti(r, u, n, m, E), i |= Ti(r, l, n, y, O), i |= Ti(r, v, n, I, P), i |= Ti(r, "networkConnect", n, d, E), i |= Ti(r, "sentRequest", n, y, P);
    var ne = n[
      cg
      /* @min:%2eduration */
    ];
    ne || (ne = Qm(n, d, P) || 0), i |= kr(r, cg, ne), i |= kr(r, "perfTotal", ne);
    var X = n[z];
    if (X) {
      var S = {};
      J(X, function(N, $) {
        var w = Zu(N[o] || "" + $), W = S[w] || {};
        Ne(N, function(ie, Z) {
          (ie !== o && ce(Z) || Yf(Z)) && (W[ie] && (Z = W[ie] + ";" + Z), (Z || !ce(Z)) && (W[ie] = Z));
        }), S[w] = W;
      }), i |= kr(r, z, S);
    }
    i |= kr(r, b, n[b]), i |= kr(r, F, n[F]), i |= kr(r, U, n[U]);
  } else
    e[
      bf
      /* @min:%2eperfMark */
    ] && (i |= kr(r, "missing", e.perfAttempts));
  i && (t[
    Aa
    /* @min:%2eproperties */
  ] = r);
}
var AD = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      var t = this;
      t.openDone = !1, t.setRequestHeaderDone = !1, t.sendDone = !1, t.abortDone = !1, t[
        Jm
        /* @min:%2estateChangeAttached */
      ] = !1;
    }
    return e;
  }()
), dg = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      var o = this, a = r, s = "responseText";
      o[
        bf
        /* @min:%2eperfMark */
      ] = null, o.completed = !1, o.requestHeadersSize = null, o[
        sn
        /* @min:%2erequestHeaders */
      ] = null, o.responseReceivingDuration = null, o.callbackDuration = null, o[
        Od
        /* @min:%2eajaxTotalDuration */
      ] = null, o[
        ya
        /* @min:%2eaborted */
      ] = 0, o.pageUrl = null, o[
        yn
        /* @min:%2erequestUrl */
      ] = null, o.requestSize = 0, o[
        zr
        /* @min:%2emethod */
      ] = null, o[
        wn
        /* @min:%2estatus */
      ] = null, o[
        Ui
        /* @min:%2erequestSentTime */
      ] = null, o.responseStartedTime = null, o[
        bs
        /* @min:%2eresponseFinishedTime */
      ] = null, o.callbackFinishedTime = null, o.endTime = null, o.xhrMonitoringState = new AD(), o.clientFailure = 0, o[
        Wr
        /* @min:%2etraceID */
      ] = t, o[
        qr
        /* @min:%2espanID */
      ] = n, o[
        Tn
        /* @min:%2etraceFlags */
      ] = i == null ? void 0 : i.getTraceFlags(), i ? o[
        kd
        /* @min:%2eeventTraceCtx */
      ] = {
        traceId: i[
          Jv
          /* @min:%2egetTraceId */
        ](),
        spanId: i.getSpanId(),
        traceFlags: i[
          Qv
          /* @min:%2egetTraceFlags */
        ]()
      } : o[
        kd
        /* @min:%2eeventTraceCtx */
      ] = null, Be(e, o, function(c) {
        c.getAbsoluteUrl = function() {
          return c[
            yn
            /* @min:%2erequestUrl */
          ] ? ZN(c[
            yn
            /* @min:%2erequestUrl */
          ]) : null;
        }, c.getPathName = function() {
          return c[
            yn
            /* @min:%2erequestUrl */
          ] ? Xf(a, eI(c[
            zr
            /* @min:%2emethod */
          ], c[
            yn
            /* @min:%2erequestUrl */
          ])) : null;
        }, c[
          eh
          /* @min:%2eCreateTrackItem */
        ] = function(u, f, l) {
          var v;
          if (c.ajaxTotalDuration = zE(Bt(c.requestSentTime, c.responseFinishedTime) * 1e3) / 1e3, c[
            Od
            /* @min:%2eajaxTotalDuration */
          ] < 0)
            return null;
          var d = (v = {
            id: "|" + c[
              Wr
              /* @min:%2etraceID */
            ] + "." + c[
              qr
              /* @min:%2espanID */
            ],
            target: c[
              qv
              /* @min:%2egetAbsoluteUrl */
            ](),
            name: c.getPathName(),
            type: u,
            startTime: null,
            duration: c[
              Od
              /* @min:%2eajaxTotalDuration */
            ],
            success: +c[
              wn
              /* @min:%2estatus */
            ] >= 200 && +c[
              wn
              /* @min:%2estatus */
            ] < 400,
            responseCode: +c[
              wn
              /* @min:%2estatus */
            ]
          }, v[Aa] = { HttpMethod: c[
            zr
            /* @min:%2emethod */
          ] }, v), h = d[Aa];
          if (c[
            ya
            /* @min:%2eaborted */
          ] && (h[
            ya
            /* @min:%2eaborted */
          ] = !0), c[
            Ui
            /* @min:%2erequestSentTime */
          ] && (d[
            oa
            /* @min:%2estartTime */
          ] = /* @__PURE__ */ new Date(), d[
            oa
            /* @min:%2estartTime */
          ].setTime(c[
            Ui
            /* @min:%2erequestSentTime */
          ])), PD(c, d), f && sr(c.requestHeaders)[
            Mi
            /* @min:%2elength */
          ] > 0 && (h[
            sn
            /* @min:%2erequestHeaders */
          ] = c[
            sn
            /* @min:%2erequestHeaders */
          ]), l) {
            var _ = l();
            if (_) {
              var m = _[
                ih
                /* @min:%2ecorrelationContext */
              ];
              if (m && (d.correlationContext = /* dependency.target + " | " + */
              m), _[
                Tf
                /* @min:%2eheaderMap */
              ] && sr(_.headerMap)[
                Mi
                /* @min:%2elength */
              ] > 0 && (h.responseHeaders = _[
                Tf
                /* @min:%2eheaderMap */
              ]), c[
                Zv
                /* @min:%2eerrorStatusText */
              ])
                if (c[
                  wn
                  /* @min:%2estatus */
                ] >= 400) {
                  var E = _.type;
                  (E === "" || E === "text") && (h.responseText = _.responseText ? _[
                    Pi
                    /* @min:%2estatusText */
                  ] + " - " + _[s] : _[
                    Pi
                    /* @min:%2estatusText */
                  ]), E === "json" && (h.responseText = _.response ? _[
                    Pi
                    /* @min:%2estatusText */
                  ] + " - " + JSON.stringify(_.response) : _[
                    Pi
                    /* @min:%2estatusText */
                  ]);
                } else c[
                  wn
                  /* @min:%2estatus */
                ] === 0 && (h.responseText = _[
                  Pi
                  /* @min:%2estatusText */
                ] || "");
            }
          }
          return d;
        }, c[
          th
          /* @min:%2egetPartAProps */
        ] = function() {
          var u = null, f = c[
            kd
            /* @min:%2eeventTraceCtx */
          ];
          if (f && (f.traceId || f.spanId)) {
            u = {};
            var l = u[Jt.TraceExt] = {
              traceID: f.traceId,
              parentID: f.spanId
            };
            /* @__PURE__ */ Y(f[
              Tn
              /* @min:%2etraceFlags */
            ]) || (l[
              Tn
              /* @min:%2etraceFlags */
            ] = f[
              Tn
              /* @min:%2etraceFlags */
            ]);
          }
          return u;
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), Xe, Hs = "diagLog", ri = "_ajaxData", Ai = "fetch", as = "Failed to monitor XMLHttpRequest", Zm = ", monitoring data for this ajax call ", Oo = Zm + "may be incorrect.", vg = Zm + "won't be sent.", hg = "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.", _g = "Failed to add custom defined request context as configured call back may missing a null check.", pg = "Failed to calculate the duration of the ", gg = 0;
function OD() {
  var e = /* @__PURE__ */ or();
  return !e || /* @__PURE__ */ Y(e.Request) || /* @__PURE__ */ Y(e.Request[Vn]) || /* @__PURE__ */ Y(e[Ai]) ? null : e[Ai];
}
function kD(e, t) {
  var n, r = !1;
  if (Kf()) {
    var i = XMLHttpRequest[Vn];
    r = !/* @__PURE__ */ Y(i) && !/* @__PURE__ */ Y(i.open) && // eslint-disable-line security/detect-non-literal-fs-filename -- false positive
    !/* @__PURE__ */ Y(i.send) && !/* @__PURE__ */ Y(i.abort);
  }
  var o = DS();
  if (o && o < 9 && (r = !1), r)
    try {
      var a = new XMLHttpRequest(), s = {
        xh: [],
        i: (n = {}, n[t] = {}, n)
      };
      a[ri] = s;
      var c = XMLHttpRequest[Vn].open;
      XMLHttpRequest[Vn].open = c;
    } catch (u) {
      r = !1, Ys(e, 15, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
        exception: /* @__PURE__ */ Q(u)
      });
    }
  return r;
}
var Ko = function(e, t) {
  return e && t && e[ri] ? (e[ri].i || {})[t] : null;
}, xD = function(e, t, n) {
  if (e) {
    var r = (e[ri] || {}).xh;
    r && r.push({
      n: t,
      v: n
    });
  }
}, xd = function(e, t) {
  var n = !1;
  if (e) {
    var r = (e[ri] || {}).xh;
    r && J(r, function(i) {
      if (i.n === t)
        return n = !0, -1;
    });
  }
  return n;
};
function yu(e, t) {
  var n = "";
  try {
    var r = Ko(e, t);
    r && r[
      yn
      /* @min:%2erequestUrl */
    ] && (n += "(url: '" + r[
      yn
      /* @min:%2erequestUrl */
    ] + "')");
  } catch {
  }
  return n;
}
function Ys(e, t, n, r, i) {
  K(e[Hs](), 1, t, n, r, i);
}
function nr(e, t, n, r, i) {
  K(e[Hs](), 2, t, n, r, i);
}
function ss(e, t, n) {
  return function(r) {
    var i;
    Ys(e, t, n, (i = {}, i[
      rh
      /* @min:ajaxDiagnosticsMessage */
    ] = yu(r.inst, e._ajaxDataId), i.exception = /* @__PURE__ */ Q(r.err), i));
  };
}
function ko(e, t) {
  return e && t ? Ft(e, t) : -1;
}
function Eg(e, t, n) {
  var r = {
    id: t,
    fn: n
  };
  return e.push(r), {
    remove: function() {
      J(e, function(i, o) {
        if (i.id === r.id)
          return e.splice(o, 1), -1;
      });
    }
  };
}
function ew(e, t, n, r) {
  var i = !0;
  return J(t, function(o, a) {
    try {
      o.fn.call(null, n) === !1 && (i = !1);
    } catch (s) {
      K(e && e.logger, 1, 64, "Dependency " + r + " [#" + a + "] failed: " + xe(s), { exception: /* @__PURE__ */ Q(s) }, !0);
    }
  }), i;
}
function LD(e, t, n, r, i, o) {
  var a = e[
    Mi
    /* @min:%2elength */
  ];
  if (a > 0) {
    var s = {
      core: t,
      xhr: r,
      input: i,
      init: o,
      traceId: n[
        Wr
        /* @min:%2etraceID */
      ],
      spanId: n[
        qr
        /* @min:%2espanID */
      ],
      traceFlags: n[
        Tn
        /* @min:%2etraceFlags */
      ],
      context: n[
        Fs
        /* @min:%2econtext */
      ] || {},
      aborted: !!n[
        ya
        /* @min:%2eaborted */
      ]
    };
    ew(t, e, s, "listener"), n[
      Wr
      /* @min:%2etraceID */
    ] = s.traceId, n[
      qr
      /* @min:%2espanID */
    ] = s.spanId, n[
      Tn
      /* @min:%2etraceFlags */
    ] = s[
      Tn
      /* @min:%2etraceFlags */
    ], n[
      Fs
      /* @min:%2econtext */
    ] = s[
      Fs
      /* @min:%2econtext */
    ];
  }
}
var tu = "*.blob.core.", MD = In([
  tu + "windows.net",
  tu + "chinacloudapi.cn",
  tu + "cloudapi.de",
  tu + "usgovcloudapi.net"
]), UD = [
  /https:\/\/[^\/]*(\.pipe\.aria|aria\.pipe|events\.data|collector\.azure)\.[^\/]+\/(OneCollector\/1|Collector\/3)\.0/i
], $D = In((Xe = {}, Xe[
  Km
  /* @min:maxAjaxCallsPerView */
] = 500, Xe[
  Xv
  /* @min:disableAjaxTracking */
] = !1, Xe[
  jm
  /* @min:disableFetchTracking */
] = !1, Xe[
  Wm
  /* @min:excludeRequestFromAutoTrackingPatterns */
] = void 0, Xe.disableCorrelationHeaders = !1, Xe.distributedTracingMode = 1, Xe.correlationHeaderExcludedDomains = MD, Xe.correlationHeaderDomains = void 0, Xe.correlationHeaderExcludePatterns = void 0, Xe.appId = void 0, Xe.enableCorsCorrelation = !1, Xe[
  jv
  /* @min:enableRequestHeaderTracking */
] = !1, Xe[
  Xm
  /* @min:enableResponseHeaderTracking */
] = !1, Xe[
  zm
  /* @min:enableAjaxErrorStatusText */
] = !1, Xe[
  Gm
  /* @min:enableAjaxPerfTracking */
] = !1, Xe.maxAjaxPerfLookupAttempts = 3, Xe[
  qm
  /* @min:ajaxPerfLookupDelay */
] = 25, Xe.ignoreHeaders = [
  "Authorization",
  "X-API-Key",
  "WWW-Authenticate"
], Xe.addRequestContext = void 0, Xe.addIntEndpoints = !0, Xe)), FD = (
  /** @class */
  function(e) {
    yr(t, e);
    function t() {
      var n = e.call(this) || this;
      n.identifier = t.identifier, n.priority = 120;
      var r, i, o, a, s, c, u, f, l, v, d, h, _, m, E, y, O, I, P, B, D, b, F, U, z, ne, X, S, N, $;
      return Be(t, n, function(w, W) {
        var ie = W[
          eu
          /* @min:%2e_addHook */
        ];
        Z(), w.initialize = function(C, L, V, H) {
          w.isInitialized() || (W.initialize(C, L, V, H), B = fi(_n("ajax"), L && L.evtNamespace && L.evtNamespace()), _e(C), te(), A(), p());
        }, w._doTeardown = function() {
          Z();
        }, w.trackDependencyData = function(C, L) {
          Oe(U, w[
            On
            /* @min:%2ecore */
          ], null, C, L);
        }, w[
          Pd
          /* @min:%2eincludeCorrelationHeaders */
        ] = function(C, L, V, H) {
          var G = w._currentWindowHost || o;
          if (LD(F, w[
            On
            /* @min:%2ecore */
          ], C, H, L, V), L || L === "") {
            if (Vp(a, C[
              qv
              /* @min:%2egetAbsoluteUrl */
            ](), G)) {
              V || (V = {});
              var ee = new Headers(V[
                yi
                /* @min:%2eheaders */
              ] || (L instanceof Request ? L[
                yi
                /* @min:%2eheaders */
              ] || {} : {}));
              if (v) {
                var de = "|" + C[
                  Wr
                  /* @min:%2etraceID */
                ] + "." + C[
                  qr
                  /* @min:%2espanID */
                ];
                ee.set(Ue[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ], de), s && (C[
                  sn
                  /* @min:%2erequestHeaders */
                ][Ue[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ]] = de);
              }
              var me = N || f && f.appId();
              if (me && (ee.set(Ue[
                0
                /* eRequestHeaders.requestContextHeader */
              ], Ue[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + me), s && (C[
                sn
                /* @min:%2erequestHeaders */
              ][Ue[
                0
                /* eRequestHeaders.requestContextHeader */
              ]] = Ue[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + me)), l) {
                var ue = C[
                  Tn
                  /* @min:%2etraceFlags */
                ];
                /* @__PURE__ */ Y(ue) && (ue = 1);
                var be = wp(mp(C[
                  Wr
                  /* @min:%2etraceID */
                ], C[
                  qr
                  /* @min:%2espanID */
                ], ue));
                ee.set(Ue[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ], be), s && (C[
                  sn
                  /* @min:%2erequestHeaders */
                ][Ue[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ]] = be);
              }
              V[
                yi
                /* @min:%2eheaders */
              ] = ee;
            }
            return V;
          } else if (H) {
            if (Vp(a, C[
              qv
              /* @min:%2egetAbsoluteUrl */
            ](), G)) {
              if (v)
                if (xd(H, Ue[
                  3
                  /* eRequestHeaders.requestIdHeader */
                ]))
                  nr(w, 71, "Unable to set [" + Ue[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ] + "] as it has already been set by another instance");
                else {
                  var de = "|" + C[
                    Wr
                    /* @min:%2etraceID */
                  ] + "." + C[
                    qr
                    /* @min:%2espanID */
                  ];
                  H[
                    Ad
                    /* @min:%2esetRequestHeader */
                  ](Ue[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ], de), s && (C[
                    sn
                    /* @min:%2erequestHeaders */
                  ][Ue[
                    3
                    /* eRequestHeaders.requestIdHeader */
                  ]] = de);
                }
              var me = N || f && f.appId();
              if (me && (xd(H, Ue[
                0
                /* eRequestHeaders.requestContextHeader */
              ]) ? nr(w, 71, "Unable to set [" + Ue[
                0
                /* eRequestHeaders.requestContextHeader */
              ] + "] as it has already been set by another instance") : (H[
                Ad
                /* @min:%2esetRequestHeader */
              ](Ue[
                0
                /* eRequestHeaders.requestContextHeader */
              ], Ue[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + me), s && (C[
                sn
                /* @min:%2erequestHeaders */
              ][Ue[
                0
                /* eRequestHeaders.requestContextHeader */
              ]] = Ue[
                2
                /* eRequestHeaders.requestContextAppIdFormat */
              ] + me))), l) {
                var ue = C[
                  Tn
                  /* @min:%2etraceFlags */
                ];
                if (/* @__PURE__ */ Y(ue) && (ue = 1), xd(H, Ue[
                  4
                  /* eRequestHeaders.traceParentHeader */
                ]))
                  nr(w, 71, "Unable to set [" + Ue[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ] + "] as it has already been set by another instance");
                else {
                  var be = wp(mp(C[
                    Wr
                    /* @min:%2etraceID */
                  ], C[
                    qr
                    /* @min:%2espanID */
                  ], ue));
                  H[
                    Ad
                    /* @min:%2esetRequestHeader */
                  ](Ue[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ], be), s && (C[
                    sn
                    /* @min:%2erequestHeaders */
                  ][Ue[
                    4
                    /* eRequestHeaders.traceParentHeader */
                  ]] = be);
                }
              }
            }
            return H;
          }
        }, w[
          ug
          /* @min:%2etrackDependencyDataInternal */
        ] = function(C, L, V) {
          if (_ === -1 || u < _) {
            (S === 2 || S === 1) && typeof C.id == "string" && C.id[C.id[
              Mi
              /* @min:%2elength */
            ] - 1] !== "." && (C.id += "."), /* @__PURE__ */ Y(C[
              oa
              /* @min:%2estartTime */
            ]) && (C[
              oa
              /* @min:%2estartTime */
            ] = /* @__PURE__ */ new Date());
            var H = Or(C, ji.dataType, ji.envelopeType, w[Hs](), L, V);
            w[
              On
              /* @min:%2ecore */
            ].track(H);
          } else u === _ && Ys(w, 55, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", !0);
          ++u;
        }, w.addDependencyListener = function(C) {
          return Eg(F, b++, C);
        }, w.addDependencyInitializer = function(C) {
          return Eg(U, b++, C);
        };
        function Z() {
          var C = Hn();
          r = !1, i = !1, $ = !1, o = C && C.host && C.host[
            Ao
            /* @min:%2etoLowerCase */
          ](), a = null, s = !1, c = !1, u = 0, f = null, l = !1, v = !1, d = null, h = !1, _ = 0, m = !1, E = {}, y = !1, O = !1, I = null, P = null, B = null, b = 0, F = [], U = [], D = _n("ajaxData"), w._ajaxDataId = D, z = null, ne = 1, X = 1, S = 1, N = null;
        }
        function _e(C) {
          w[
            eu
            /* @min:%2e_addHook */
          ](nt(C, function(L) {
            var V = L.cfg, H = Rn(null, V, w[
              On
              /* @min:%2ecore */
            ]);
            a = H.getExtCfg(t.identifier, $D), S = a.distributedTracingMode, s = a[
              jv
              /* @min:%2eenableRequestHeaderTracking */
            ], c = a[
              zm
              /* @min:%2eenableAjaxErrorStatusText */
            ], h = a[
              Gm
              /* @min:%2eenableAjaxPerfTracking */
            ], _ = a[
              Km
              /* @min:%2emaxAjaxCallsPerView */
            ], I = [].concat(a[
              Wm
              /* @min:%2eexcludeRequestFromAutoTrackingPatterns */
            ] || [], a.addIntEndpoints !== !1 ? UD : []), P = a.addRequestContext, v = S === 0 || S === 1, l = S === 1 || S === 2, h && (d = D), y = !!a[
              Xv
              /* @min:%2edisableAjaxTracking */
            ], ne = a.maxAjaxPerfLookupAttempts, X = a[
              qm
              /* @min:%2eajaxPerfLookupDelay */
            ], z = a.ignoreHeaders, N = a.appId;
          }));
        }
        function p() {
          var C = w[
            On
            /* @min:%2ecore */
          ].getPlugin(Zf);
          C && (f = C.plugin[
            Fs
            /* @min:%2econtext */
          ]);
        }
        function g(C) {
          var L = !0;
          return (C || z) && J(z, function(V) {
            if (V[
              Ao
              /* @min:%2etoLowerCase */
            ]() === C[
              Ao
              /* @min:%2etoLowerCase */
            ]())
              return L = !1, -1;
          }), L;
        }
        function A() {
          var C = OD();
          if (C) {
            var L = /* @__PURE__ */ or(), V = C.polyfill;
            w[
              eu
              /* @min:%2e_addHook */
            ](nt(a, function() {
              O = !!a[
                jm
                /* @min:%2edisableFetchTracking */
              ], m = a[
                Xm
                /* @min:%2eenableResponseHeaderTracking */
              ], !O && !r ? (ie(Av(L, Ai, {
                ns: B,
                // Add request hook
                req: function(H, G, ee) {
                  var de;
                  if (!O && r && !se(null, G, ee) && // If we have a polyfil and XHR instrumented then let XHR report otherwise we get duplicates
                  !(V && i)) {
                    var me = H.ctx();
                    de = fe(G, ee);
                    var ue = w[
                      Pd
                      /* @min:%2eincludeCorrelationHeaders */
                    ](de, G, ee);
                    ue !== ee && H.set(1, ue), me.data = de;
                  }
                },
                rsp: function(H, G) {
                  if (!O) {
                    var ee = H.ctx().data;
                    ee && (H.rslt = H.rslt.then(function(de) {
                      return ae(H, (de || {})[
                        wn
                        /* @min:%2estatus */
                      ], G, de, ee, function() {
                        var me, ue = (me = {
                          statusText: (de || {})[
                            Pi
                            /* @min:%2estatusText */
                          ],
                          headerMap: null
                        }, me[
                          ih
                          /* @min:correlationContext */
                        ] = Ae(de), me);
                        if (m && de) {
                          var be = {};
                          de.headers.forEach(function(ke, rt) {
                            g(rt) && (be[rt] = ke);
                          }), ue[
                            Tf
                            /* @min:%2eheaderMap */
                          ] = be;
                        }
                        return ue;
                      }), de;
                    }).catch(function(de) {
                      throw ae(H, 0, G, null, ee, null, { error: de.message || /* @__PURE__ */ Q(de) }), de;
                    }));
                  }
                },
                // Create an error callback to report any hook errors
                hkErr: ss(w, 15, "Failed to monitor Window.fetch" + Oo)
              }, !0, UE())), r = !0) : V && !$ && (ie(Av(L, Ai, {
                ns: B,
                req: function(H, G, ee) {
                  se(null, G, ee);
                }
              })), $ = !0);
            })), V && (L[Ai].polyfill = V);
          }
        }
        function M(C, L, V) {
          ie(WN(C, L, V));
        }
        function te() {
          kD(w, D) && w[
            eu
            /* @min:%2e_addHook */
          ](nt(a, function() {
            y = !!a[
              Xv
              /* @min:%2edisableAjaxTracking */
            ], s = a[
              jv
              /* @min:%2eenableRequestHeaderTracking */
            ], !y && !i && (M(XMLHttpRequest, "open", {
              ns: B,
              req: function(C, L, V, H) {
                if (!y) {
                  var G = C.inst, ee = Ko(G, D);
                  !se(G, V) && Se(G, ee, !0) && ((!ee || !ee.xhrMonitoringState.openDone) && (ee = He(G, L, V, H)), St(G, ee));
                }
              },
              hkErr: ss(w, 15, as + ".open" + Oo)
            }), M(XMLHttpRequest, "send", {
              ns: B,
              req: function(C, L) {
                if (!y) {
                  var V = C.inst, H = Ko(V, D);
                  Se(V, H) && !H.xhrMonitoringState.sendDone && (R("xhr", H), H[
                    Ui
                    /* @min:%2erequestSentTime */
                  ] = jc(), w[
                    Pd
                    /* @min:%2eincludeCorrelationHeaders */
                  ](H, void 0, void 0, V), H.xhrMonitoringState.sendDone = !0);
                }
              },
              hkErr: ss(w, 17, as + Oo)
            }), M(XMLHttpRequest, "abort", {
              ns: B,
              req: function(C) {
                if (!y) {
                  var L = C.inst, V = Ko(L, D);
                  Se(L, V) && !V.xhrMonitoringState.abortDone && (V[
                    ya
                    /* @min:%2eaborted */
                  ] = 1, V.xhrMonitoringState.abortDone = !0);
                }
              },
              hkErr: ss(w, 13, as + ".abort" + Oo)
            }), M(XMLHttpRequest, "setRequestHeader", {
              ns: B,
              req: function(C, L, V) {
                if (!y) {
                  var H = C.inst, G = Ko(H, D);
                  G && Se(H, G) && (xD(H, L, V), s && g(L) && (G[
                    sn
                    /* @min:%2erequestHeaders */
                  ][L] = V));
                }
              },
              hkErr: ss(w, 71, as + ".setRequestHeader" + Oo)
            }), i = !0);
          }));
        }
        function se(C, L, V) {
          var H = !1, G = ((ce(L) ? L : (L || {}).url || "") || "")[
            Ao
            /* @min:%2etoLowerCase */
          ]();
          if (J(I, function(me) {
            var ue = me;
            ce(me) && (ue = new RegExp(me)), H || (H = ue.test(G));
          }), H)
            return H;
          var ee = ko(G, "?"), de = ko(G, "#");
          return (ee === -1 || de !== -1 && de < ee) && (ee = de), ee !== -1 && (G = G.substring(0, ee)), /* @__PURE__ */ Y(C) ? /* @__PURE__ */ Y(L) || (H = (typeof L == "object" ? L[Li] === !0 : !1) || (V ? V[Li] === !0 : !1)) : H = C[Li] === !0 || G[Li] === !0, !H && G && Ov(G) && (H = !0), H ? E[G] || (E[G] = 1) : E[G] && (H = !0), H;
        }
        function Se(C, L, V) {
          var H = !0, G = i;
          return /* @__PURE__ */ Y(C) || (H = V === !0 || !/* @__PURE__ */ Y(L)), G && H;
        }
        function ge() {
          var C = null;
          return w[
            On
            /* @min:%2ecore */
          ] && w[
            On
            /* @min:%2ecore */
          ].getTraceCtx && (C = w[
            On
            /* @min:%2ecore */
          ].getTraceCtx(!1)), !C && f && f.telemetryTrace && (C = l_(f.telemetryTrace)), C;
        }
        function He(C, L, V, H) {
          var G, ee = ge(), de = ee && ee[
            Jv
            /* @min:%2egetTraceId */
          ]() || Kr(), me = Hr(Kr(), 0, 16), ue = C[ri] = C[ri] || { xh: [], i: {} }, be = ue.i = ue.i || {}, ke = be[D] = be[D] || new dg(de, me, w[Hs](), (G = w.core) === null || G === void 0 ? void 0 : G.getTraceCtx());
          return ke[
            Tn
            /* @min:%2etraceFlags */
          ] = ee && ee[
            Qv
            /* @min:%2egetTraceFlags */
          ](), ke[
            zr
            /* @min:%2emethod */
          ] = L, ke[
            yn
            /* @min:%2erequestUrl */
          ] = V, ke.xhrMonitoringState.openDone = !0, ke[
            sn
            /* @min:%2erequestHeaders */
          ] = {}, ke.async = H, ke[
            Zv
            /* @min:%2eerrorStatusText */
          ] = c, ke;
        }
        function St(C, L) {
          L.xhrMonitoringState[
            Jm
            /* @min:%2estateChangeAttached */
          ] = ur(C, "readystatechange", function() {
            var V;
            try {
              C && C.readyState === 4 && Se(C, L) && $e(C);
            } catch (G) {
              var H = /* @__PURE__ */ Q(G);
              (!H || ko(H[
                Ao
                /* @min:%2etoLowerCase */
              ](), "c00c023f") === -1) && Ys(w, 16, as + " 'readystatechange' event handler" + Oo, (V = {}, V[
                rh
                /* @min:ajaxDiagnosticsMessage */
              ] = yu(C, D), V.exception = H, V));
            }
          }, B);
        }
        function gn(C) {
          try {
            var L = C.responseType;
            if (L === "" || L === "text")
              return C[
                fg
                /* @min:%2eresponseText */
              ];
          } catch {
          }
          return null;
        }
        function $e(C) {
          var L = Ko(C, D);
          L[
            bs
            /* @min:%2eresponseFinishedTime */
          ] = jc(), L[
            wn
            /* @min:%2estatus */
          ] = C[
            wn
            /* @min:%2estatus */
          ];
          function V(H, G) {
            var ee = G || {};
            ee.ajaxDiagnosticsMessage = yu(C, D), H && (ee.exception = /* @__PURE__ */ Q(H)), nr(w, 14, pg + "ajax call" + vg, ee);
          }
          j("xmlhttprequest", L, function() {
            try {
              var H = L[
                eh
                /* @min:%2eCreateTrackItem */
              ]("Ajax", s, function() {
                var ue, be = (ue = {
                  statusText: C[
                    Pi
                    /* @min:%2estatusText */
                  ],
                  headerMap: null
                }, ue[
                  ih
                  /* @min:correlationContext */
                ] = ft(C), ue.type = C.responseType, ue[
                  fg
                  /* @min:responseText */
                ] = gn(C), ue.response = C.response, ue);
                if (m) {
                  var ke = C[
                    lg
                    /* @min:%2egetAllResponseHeaders */
                  ]();
                  if (ke) {
                    var rt = Ve(ke).split(/[\r\n]+/), on = {};
                    J(rt, function(En) {
                      var Yt = En.split(": "), di = Yt.shift(), T = Yt.join(": ");
                      g(di) && (on[di] = T);
                    }), be[
                      Tf
                      /* @min:%2eheaderMap */
                    ] = on;
                  }
                }
                return be;
              }), G = void 0;
              try {
                P && (G = P({ status: C[
                  wn
                  /* @min:%2estatus */
                ], xhr: C }));
              } catch {
                nr(w, 104, _g);
              }
              if (H) {
                G !== void 0 && (H[
                  Aa
                  /* @min:%2eproperties */
                ] = Mt(Mt({}, H.properties), G));
                var ee = L[
                  th
                  /* @min:%2egetPartAProps */
                ]();
                Oe(U, w[
                  On
                  /* @min:%2ecore */
                ], L, H, null, ee);
              } else
                V(null, {
                  requestSentTime: L[
                    Ui
                    /* @min:%2erequestSentTime */
                  ],
                  responseFinishedTime: L[
                    bs
                    /* @min:%2eresponseFinishedTime */
                  ]
                });
            } finally {
              try {
                var de = C[ri] || { i: {} }, me = de.i || {};
                me[D] && (me[D] = null);
              } catch {
              }
            }
          }, function(H) {
            V(H, null);
          });
        }
        function ft(C) {
          var L;
          try {
            var V = C[
              lg
              /* @min:%2egetAllResponseHeaders */
            ]();
            if (V !== null) {
              var H = ko(V[
                Ao
                /* @min:%2etoLowerCase */
              ](), Ue[
                8
                /* eRequestHeaders.requestContextHeaderLowerCase */
              ]);
              if (H !== -1) {
                var G = C.getResponseHeader(Ue[
                  0
                  /* eRequestHeaders.requestContextHeader */
                ]);
                return Bp(G);
              }
            }
          } catch (ee) {
            nr(w, 18, hg, (L = {}, L[
              rh
              /* @min:ajaxDiagnosticsMessage */
            ] = yu(C, D), L.exception = /* @__PURE__ */ Q(ee), L));
          }
        }
        function R(C, L) {
          if (L[
            yn
            /* @min:%2erequestUrl */
          ] && d && h) {
            var V = /* @__PURE__ */ Er();
            if (V && ye(V.mark)) {
              gg++;
              var H = d + C + "#" + gg;
              V.mark(H);
              var G = V.getEntriesByName(H);
              G && G[
                Mi
                /* @min:%2elength */
              ] === 1 && (L[
                bf
                /* @min:%2eperfMark */
              ] = G[0]);
            }
          }
        }
        function j(C, L, V, H) {
          var G = L[
            bf
            /* @min:%2eperfMark */
          ], ee = /* @__PURE__ */ Er(), de = ne, me = X, ue = L[
            yn
            /* @min:%2erequestUrl */
          ], be = 0;
          (function ke() {
            try {
              if (ee && G) {
                be++;
                for (var rt = null, on = ee.getEntries(), En = on[
                  Mi
                  /* @min:%2elength */
                ] - 1; En >= 0; En--) {
                  var Yt = on[En];
                  if (Yt) {
                    if (Yt.entryType === "resource")
                      Yt.initiatorType === C && (ko(Yt.name, ue) !== -1 || ko(ue, Yt.name) !== -1) && (rt = Yt);
                    else if (Yt.entryType === "mark" && Yt.name === G.name) {
                      L[
                        nh
                        /* @min:%2eperfTiming */
                      ] = rt;
                      break;
                    }
                    if (Yt[
                      oa
                      /* @min:%2estartTime */
                    ] < G[
                      oa
                      /* @min:%2estartTime */
                    ] - 1e3)
                      break;
                  }
                }
              }
              !G || // - we don't have a perfMark or
              L[
                nh
                /* @min:%2eperfTiming */
              ] || // - we have not found the perf entry or
              be >= de || // - we have tried too many attempts or
              L.async === !1 ? (G && ye(ee.clearMarks) && ee.clearMarks(G.name), L.perfAttempts = be, V()) : Wn(ke, me);
            } catch (di) {
              H(di);
            }
          })();
        }
        function fe(C, L) {
          var V, H = ge(), G = H && H[
            Jv
            /* @min:%2egetTraceId */
          ]() || Kr(), ee = Hr(Kr(), 0, 16), de = new dg(G, ee, w[Hs](), (V = w.core) === null || V === void 0 ? void 0 : V.getTraceCtx());
          de[
            Tn
            /* @min:%2etraceFlags */
          ] = H && H[
            Qv
            /* @min:%2egetTraceFlags */
          ](), de[
            Ui
            /* @min:%2erequestSentTime */
          ] = jc(), de[
            Zv
            /* @min:%2eerrorStatusText */
          ] = c;
          var me;
          if (C instanceof Request ? me = (C || {}).url || "" : me = C, me === "") {
            var ue = Hn();
            ue && ue.href && (me = GE(ue.href, "#")[0]);
          }
          de[
            yn
            /* @min:%2erequestUrl */
          ] = me;
          var be = "GET";
          L && L[
            zr
            /* @min:%2emethod */
          ] ? be = L[
            zr
            /* @min:%2emethod */
          ] : C && C instanceof Request && (be = C[
            zr
            /* @min:%2emethod */
          ]), de[
            zr
            /* @min:%2emethod */
          ] = be;
          var ke = {};
          if (s) {
            var rt = new Headers((L ? L[
              yi
              /* @min:%2eheaders */
            ] : 0) || (C instanceof Request ? C[
              yi
              /* @min:%2eheaders */
            ] || {} : {}));
            rt.forEach(function(on, En) {
              g(En) && (ke[En] = on);
            });
          }
          return de[
            sn
            /* @min:%2erequestHeaders */
          ] = ke, R(Ai, de), de;
        }
        function oe(C) {
          var L = "";
          try {
            /* @__PURE__ */ Y(C) || (typeof C == "string" ? L += "(url: '".concat(C, "')") : L += "(url: '".concat(C.url, "')"));
          } catch (V) {
            Ys(w, 15, "Failed to grab failed fetch diagnostics message", { exception: /* @__PURE__ */ Q(V) });
          }
          return L;
        }
        function ae(C, L, V, H, G, ee, de) {
          if (!G)
            return;
          function me(ue, be, ke) {
            var rt = ke || {};
            rt.fetchDiagnosticsMessage = oe(V), be && (rt.exception = /* @__PURE__ */ Q(be)), nr(w, ue, pg + "fetch call" + vg, rt);
          }
          G[
            bs
            /* @min:%2eresponseFinishedTime */
          ] = jc(), G[
            wn
            /* @min:%2estatus */
          ] = L, j(Ai, G, function() {
            var ue = G[
              eh
              /* @min:%2eCreateTrackItem */
            ]("Fetch", s, ee), be;
            try {
              P && (be = P({ status: L, request: V, response: H }));
            } catch {
              nr(w, 104, _g);
            }
            if (ue) {
              be !== void 0 && (ue[
                Aa
                /* @min:%2eproperties */
              ] = Mt(Mt({}, ue.properties), be));
              var ke = G[
                th
                /* @min:%2egetPartAProps */
              ]();
              Oe(U, w[
                On
                /* @min:%2ecore */
              ], G, ue, null, ke);
            } else
              me(14, null, {
                requestSentTime: G[
                  Ui
                  /* @min:%2erequestSentTime */
                ],
                responseFinishedTime: G[
                  bs
                  /* @min:%2eresponseFinishedTime */
                ]
              });
          }, function(ue) {
            me(18, ue, null);
          });
        }
        function Ae(C) {
          if (C && C[
            yi
            /* @min:%2eheaders */
          ])
            try {
              var L = C[
                yi
                /* @min:%2eheaders */
              ].get(Ue[
                0
                /* eRequestHeaders.requestContextHeader */
              ]);
              return Bp(L);
            } catch (V) {
              nr(w, 18, hg, {
                fetchDiagnosticsMessage: oe(C),
                exception: /* @__PURE__ */ Q(V)
              });
            }
        }
        function Oe(C, L, V, H, G, ee) {
          var de = !0, me = C[
            Mi
            /* @min:%2elength */
          ];
          if (me > 0) {
            var ue = {
              item: H,
              properties: G,
              sysProperties: ee,
              context: V ? V[
                Fs
                /* @min:%2econtext */
              ] : null,
              aborted: V ? !!V[
                ya
                /* @min:%2eaborted */
              ] : !1
            };
            de = ew(L, C, ue, "initializer");
          }
          de && w[
            ug
            /* @min:%2etrackDependencyDataInternal */
          ](H, G, ee);
        }
      }), n;
    }
    return t.prototype.processTelemetry = function(n, r) {
      this.processNext(n, r);
    }, t.prototype.addDependencyInitializer = function(n) {
      return null;
    }, t.identifier = "AjaxDependencyPlugin", t;
  }(Fa)
), HD = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), YD = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.id = "browser", this.deviceClass = "Browser";
    }
    return e;
  }()
), VD = "3.3.6", BD = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n) {
      var r = this, i = nt(t, function() {
        var o = t.sdkExtension;
        r.sdkVersion = (o ? o + "_" : "") + "javascript:" + VD;
      });
      n && n.add(i);
    }
    return e;
  }()
), zD = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Cf = "session", Nf = "sessionManager", Tu = "isUserCookieSet", If = "isNewUser", Ld = "getTraceCtx", oh = "telemetryTrace", tw = "applySessionContext", nw = "applyApplicationContext", rw = "applyOperationContext", iw = "applyOperatingSystemContxt", ow = "applyLocationContext", aw = "applyInternalContext", bu = "getSessionId", sw = "sessionCookiePostfix", Di = "automaticSession", Wo = "accountId", qo = "authenticatedId", cs = "acquisitionDate", nu = "renewalDate", us = "cookieSeparator", Md = "authUserCookieName", GD = "ai_session", KD = 864e5, WD = 18e5, qD = 6e4, cw = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), jD = (
  /** @class */
  function() {
    function e(t, n, r) {
      var i = this, o, a, s = ho(n), c = e_(n), u, f;
      Be(e, i, function(l) {
        t || (t = {});
        var v = nt(t, function(y) {
          u = t.sessionExpirationMs || KD, f = t.sessionRenewalMs || WD;
          var O = t[
            sw
            /* @min:%2esessionCookiePostfix */
          ] || t.namePrefix || "";
          o = GD + O;
        });
        r && r.add(v), l[
          Di
          /* @min:%2eautomaticSession */
        ] = new cw(), l.update = function() {
          var y = /* @__PURE__ */ Kn(), O = !1, I = l[
            Di
            /* @min:%2eautomaticSession */
          ];
          if (I.id || (O = !d(I)), !O && u > 0) {
            var P = y - I[
              cs
              /* @min:%2eacquisitionDate */
            ], B = y - I[
              nu
              /* @min:%2erenewalDate */
            ];
            O = P < 0 || B < 0, O = O || P > u, O = O || B > f;
          }
          O ? _(y) : (!a || y - a > qD) && m(I, y);
        }, l.backup = function() {
          var y = l[
            Di
            /* @min:%2eautomaticSession */
          ];
          E(y.id, y[
            cs
            /* @min:%2eacquisitionDate */
          ], y[
            nu
            /* @min:%2erenewalDate */
          ]);
        };
        function d(y, O) {
          var I = !1, P = c.get(o);
          if (P && ye(P.split))
            I = h(y, P);
          else {
            var B = um(s, o);
            B && (I = h(y, B));
          }
          return I || !!y.id;
        }
        function h(y, O) {
          var I = !1, P = ", session will be reset", B = O.split("|");
          if (B.length >= 2)
            try {
              var D = +B[1] || 0, b = +B[2] || 0;
              isNaN(D) || D <= 0 ? K(s, 2, 27, "AI session acquisition date is 0" + P) : isNaN(b) || b <= 0 ? K(s, 2, 27, "AI session renewal date is 0" + P) : B[0] && (y.id = B[0], y[
                cs
                /* @min:%2eacquisitionDate */
              ] = D, y[
                nu
                /* @min:%2erenewalDate */
              ] = b, I = !0);
            } catch (F) {
              K(s, 1, 9, "Error parsing ai_session value [" + (O || "") + "]" + P + " - " + xe(F), { exception: /* @__PURE__ */ Q(F) });
            }
          return I;
        }
        function _(y) {
          var O = t.getNewId || jh;
          l[
            Di
            /* @min:%2eautomaticSession */
          ].id = O(t.idLength || 22), l[
            Di
            /* @min:%2eautomaticSession */
          ][
            cs
            /* @min:%2eacquisitionDate */
          ] = y, m(l[
            Di
            /* @min:%2eautomaticSession */
          ], y), Qf() || K(s, 2, 0, "Browser does not support local storage. Session durations will be inaccurate.");
        }
        function m(y, O) {
          var I = y[
            cs
            /* @min:%2eacquisitionDate */
          ];
          y[
            nu
            /* @min:%2erenewalDate */
          ] = O;
          var P = f, B = I + u - O, D = [y.id, I, O], b = 0;
          B < P ? b = B / 1e3 : b = P / 1e3;
          var F = t.cookieDomain || null;
          c.set(o, D.join("|"), u > 0 ? b : null, F), a = O;
        }
        function E(y, O, I) {
          fm(s, o, [y, O, I].join("|"));
        }
      });
    }
    return e.__ieDyn = 1, e;
  }()
), XD = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n, r, i) {
      var o = this;
      o.traceID = t || Kr(), o.parentID = n;
      var a = Hn();
      !r && a && a.pathname && (r = a.pathname), o.name = ct(i, r);
    }
    return e;
  }()
);
function Sg(e) {
  return !(typeof e != "string" || !e || e.match(/,|;|=| |\|/));
}
var JD = (
  /** @class */
  function() {
    function e(t, n, r) {
      this.isNewUser = !1, this.isUserCookieSet = !1;
      var i = ho(n), o = e_(n), a;
      Be(e, this, function(s) {
        Le(s, "config", {
          g: function() {
            return t;
          }
        });
        var c = nt(t, function() {
          var v = t.userCookiePostfix || "";
          a = e.userCookieName + v;
          var d = o.get(a);
          if (d) {
            s[
              If
              /* @min:%2eisNewUser */
            ] = !1;
            var h = d.split(e[
              us
              /* @min:%2ecookieSeparator */
            ]);
            h.length > 0 && (s.id = h[0], s[
              Tu
              /* @min:%2eisUserCookieSet */
            ] = !!s.id);
          }
          if (!s.id) {
            s.id = u();
            var _ = f(s.id);
            l(_.join(e[
              us
              /* @min:%2ecookieSeparator */
            ]));
            var m = (t.namePrefix || "") + "ai_session";
            cI(i, m);
          }
          s[
            Wo
            /* @min:%2eaccountId */
          ] = t[
            Wo
            /* @min:%2eaccountId */
          ] || void 0;
          var E = o.get(e[
            Md
            /* @min:%2eauthUserCookieName */
          ]);
          if (E) {
            E = decodeURI(E);
            var y = E.split(e[
              us
              /* @min:%2ecookieSeparator */
            ]);
            y[0] && (s[
              qo
              /* @min:%2eauthenticatedId */
            ] = y[0]), y.length > 1 && y[1] && (s[
              Wo
              /* @min:%2eaccountId */
            ] = y[1]);
          }
        });
        r && r.add(c);
        function u() {
          var v = t || {}, d = v.getNewId || jh, h = d(v.idLength ? t.idLength : 22);
          return h;
        }
        function f(v) {
          var d = Ia(/* @__PURE__ */ new Date());
          s.accountAcquisitionDate = d, s[
            If
            /* @min:%2eisNewUser */
          ] = !0;
          var h = [v, d];
          return h;
        }
        function l(v) {
          var d = 31536e3;
          s[
            Tu
            /* @min:%2eisUserCookieSet */
          ] = o.set(a, v, d);
        }
        s.setAuthenticatedUserContext = function(v, d, h) {
          h === void 0 && (h = !1);
          var _ = !Sg(v) || d && !Sg(d);
          if (_) {
            K(i, 2, 60, "Setting auth user context failed. User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", !0);
            return;
          }
          s[
            qo
            /* @min:%2eauthenticatedId */
          ] = v;
          var m = s[
            qo
            /* @min:%2eauthenticatedId */
          ];
          d && (s[
            Wo
            /* @min:%2eaccountId */
          ] = d, m = [s[
            qo
            /* @min:%2eauthenticatedId */
          ], s.accountId].join(e[
            us
            /* @min:%2ecookieSeparator */
          ])), h && o.set(e[
            Md
            /* @min:%2eauthUserCookieName */
          ], encodeURI(m));
        }, s.clearAuthenticatedUserContext = function() {
          s[
            qo
            /* @min:%2eauthenticatedId */
          ] = null, s[
            Wo
            /* @min:%2eaccountId */
          ] = null, o.del(e[
            Md
            /* @min:%2eauthUserCookieName */
          ]);
        }, s.update = function(v) {
          if (s.id !== v || !s[
            Tu
            /* @min:%2eisUserCookieSet */
          ]) {
            var d = v || u(), h = f(d);
            l(h.join(e[
              us
              /* @min:%2ecookieSeparator */
            ]));
          }
        };
      });
    }
    return e.cookieSeparator = "|", e.userCookieName = "ai_user", e.authUserCookieName = "ai_authUser", e;
  }()
), ru = "ext", iu = "tags";
function xo(e, t) {
  e && e[t] && sr(e[t]).length === 0 && delete e[t];
}
function mg() {
  return null;
}
var QD = (
  /** @class */
  function() {
    function e(t, n, r, i) {
      var o = this, a = t.logger;
      Be(e, this, function(s) {
        if (s.appId = mg, s[
          bu
          /* @min:%2egetSessionId */
        ] = mg, s.application = new HD(), s.internal = new BD(n, i), /* @__PURE__ */ Bf()) {
          s[
            Nf
            /* @min:%2esessionManager */
          ] = new jD(n, t, i), s.device = new YD(), s.location = new zD(), s.user = new JD(n, t, i);
          var c = void 0, u = void 0, f;
          r && (c = r.getTraceId(), u = r.getSpanId(), f = r.getName()), s[
            oh
            /* @min:%2etelemetryTrace */
          ] = new XD(c, u, f, a), s[
            Cf
            /* @min:%2esession */
          ] = new cw();
        }
        s[
          bu
          /* @min:%2egetSessionId */
        ] = function() {
          var l = s[
            Cf
            /* @min:%2esession */
          ], v = null;
          if (l && ce(l.id))
            v = l.id;
          else {
            var d = (s[
              Nf
              /* @min:%2esessionManager */
            ] || {})[
              Di
              /* @min:%2eautomaticSession */
            ];
            v = d && ce(d.id) ? d.id : null;
          }
          return v;
        }, s[
          tw
          /* @min:%2eapplySessionContext */
        ] = function(l, v) {
          Fe(kt(l.ext, Jt.AppExt), "sesId", s[
            bu
            /* @min:%2egetSessionId */
          ](), ce);
        }, s[
          iw
          /* @min:%2eapplyOperatingSystemContxt */
        ] = function(l, v) {
          Fe(l.ext, Jt.OSExt, s.os);
        }, s[
          nw
          /* @min:%2eapplyApplicationContext */
        ] = function(l, v) {
          var d = s.application;
          if (d) {
            var h = kt(l, iu);
            Fe(h, Ye.applicationVersion, d.ver, ce), Fe(h, Ye.applicationBuild, d.build, ce);
          }
        }, s.applyDeviceContext = function(l, v) {
          var d = s.device;
          if (d) {
            var h = kt(kt(l, ru), Jt.DeviceExt);
            Fe(h, "localId", d.id, ce), Fe(h, "ip", d.ip, ce), Fe(h, "model", d.model, ce), Fe(h, "deviceClass", d.deviceClass, ce);
          }
        }, s[
          aw
          /* @min:%2eapplyInternalContext */
        ] = function(l, v) {
          var d = s.internal;
          if (d) {
            var h = kt(l, iu);
            Fe(h, Ye.internalAgentVersion, d.agentVersion, ce), Fe(h, Ye.internalSdkVersion, ct(a, d.sdkVersion, 64), ce), (l.baseType === tc.dataType || l.baseType === ni.dataType) && (Fe(h, Ye.internalSnippet, d.snippetVer, ce), Fe(h, Ye.internalSdkSrc, d.sdkSrc, ce));
          }
        }, s[
          ow
          /* @min:%2eapplyLocationContext */
        ] = function(l, v) {
          var d = o.location;
          d && Fe(kt(l, iu, []), Ye.locationIp, d.ip, ce);
        }, s[
          rw
          /* @min:%2eapplyOperationContext */
        ] = function(l, v) {
          var d = s[
            oh
            /* @min:%2etelemetryTrace */
          ];
          if (d) {
            var h = kt(kt(l, ru), Jt.TraceExt, { traceID: void 0, parentID: void 0 });
            Fe(h, "traceID", d.traceID, ce, Y), Fe(h, "name", d.name, ce, Y), Fe(h, "parentID", d.parentID, ce, Y);
          }
        }, s.applyWebContext = function(l, v) {
          var d = o.web;
          d && Fe(kt(l, ru), Jt.WebExt, d);
        }, s.applyUserContext = function(l, v) {
          var d = s.user;
          if (d) {
            var h = kt(l, iu, []);
            Fe(h, Ye.userAccountId, d[
              Wo
              /* @min:%2eaccountId */
            ], ce);
            var _ = kt(kt(l, ru), Jt.UserExt);
            Fe(_, "id", d.id, ce), Fe(_, "authId", d[
              qo
              /* @min:%2eauthenticatedId */
            ], ce);
          }
        }, s.cleanUp = function(l, v) {
          var d = l.ext;
          d && (xo(d, Jt.DeviceExt), xo(d, Jt.UserExt), xo(d, Jt.WebExt), xo(d, Jt.OSExt), xo(d, Jt.AppExt), xo(d, Jt.TraceExt));
        };
      });
    }
    return e.__ieDyn = 1, e;
  }()
), Ar, Ud, Lo = null, ZD = xa((Ar = {
  accountId: Lo,
  sessionRenewalMs: 30 * 60 * 1e3,
  samplingPercentage: 100,
  sessionExpirationMs: 24 * 60 * 60 * 1e3,
  cookieDomain: Lo,
  sdkExtension: Lo,
  isBrowserLinkTrackingEnabled: !1,
  appId: Lo
}, Ar[
  bu
  /* @min:getSessionId */
] = Lo, Ar.namePrefix = Ud, Ar[
  sw
  /* @min:sessionCookiePostfix */
] = Ud, Ar.userCookiePostfix = Ud, Ar.idLength = 22, Ar.getNewId = Lo, Ar)), eR = (
  /** @class */
  function(e) {
    yr(t, e);
    function t() {
      var n = e.call(this) || this;
      n.priority = 110, n.identifier = Zf;
      var r, i, o, a, s;
      return Be(t, n, function(c, u) {
        f(), Le(c, "context", {
          g: function() {
            return a;
          }
        }), c.initialize = function(d, h, _, m) {
          u.initialize(d, h, _, m), l(d);
        }, c.processTelemetry = function(d, h) {
          if (!/* @__PURE__ */ Y(d)) {
            h = c._getTelCtx(h), d.name === ni.envelopeType && h.diagLog().resetInternalMessageCount();
            var _ = a || {};
            _[
              Cf
              /* @min:%2esession */
            ] && typeof a[
              Cf
              /* @min:%2esession */
            ].id != "string" && _[
              Nf
              /* @min:%2esessionManager */
            ] && _[
              Nf
              /* @min:%2esessionManager */
            ].update();
            var m = _.user;
            if (m && !m[
              Tu
              /* @min:%2eisUserCookieSet */
            ] && m.update(_.user.id), v(d, h), m && m[
              If
              /* @min:%2eisNewUser */
            ] && (m[
              If
              /* @min:%2eisNewUser */
            ] = !1, !s)) {
              var E = new tc(72, (Zn() || {}).userAgent || "");
              JC(h.diagLog(), 1, E);
            }
            c.processNext(d, h);
          }
        }, c._doTeardown = function(d, h) {
          var _ = (d || {}).core();
          if (_ && _[
            Ld
            /* @min:%2egetTraceCtx */
          ]) {
            var m = _[
              Ld
              /* @min:%2egetTraceCtx */
            ](!1);
            m === i && _.setTraceCtx(o);
          }
          f();
        };
        function f() {
          r = null, i = null, o = null, a = null, s = !0;
        }
        function l(d) {
          var h = c.identifier, _ = c.core;
          c._addHook(nt(d, function() {
            var m = Rn(null, d, _);
            d.storagePrefix && h_(d.storagePrefix), s = d.disableUserInitMessage !== !1, r = m.getExtCfg(h, ZD), c._extConfig = r;
          })), o = _[
            Ld
            /* @min:%2egetTraceCtx */
          ](!1), a = new QD(_, r, o, c._unloadHooks), i = l_(c.context[
            oh
            /* @min:%2etelemetryTrace */
          ], o), _.setTraceCtx(i), c.context.appId = function() {
            var m = _.getPlugin(wm);
            return m ? m.plugin._appId : null;
          };
        }
        function v(d, h) {
          kt(d, "tags", []), kt(d, "ext", {});
          var _ = c.context;
          _[
            tw
            /* @min:%2eapplySessionContext */
          ](d, h), _[
            nw
            /* @min:%2eapplyApplicationContext */
          ](d, h), _.applyDeviceContext(d, h), _[
            rw
            /* @min:%2eapplyOperationContext */
          ](d, h), _.applyUserContext(d, h), _[
            iw
            /* @min:%2eapplyOperatingSystemContxt */
          ](d, h), _.applyWebContext(d, h), _[
            ow
            /* @min:%2eapplyLocationContext */
          ](d, h), _[
            aw
            /* @min:%2eapplyInternalContext */
          ](d, h), _.cleanUp(d, h);
        }
      }), n;
    }
    return t.__ieDyn = 1, t;
  }(Fa)
), uw = "AuthenticatedUserContext", Ha = "track", ah = "snippet", tR = "getCookieMgr", nR = "startTrackPage", rR = "stopTrackPage", $d = "flush", iR = "startTrackEvent", oR = "stopTrackEvent", aR = "addTelemetryInitializer", wg = "pollInternalLogs", Fd = "getPlugin", Hd = "evtNamespace", sR = Ha + "Event", cR = Ha + "Trace", uR = Ha + "Metric", fR = Ha + "PageView", lR = Ha + "Exception", dR = Ha + "DependencyData", vR = "set" + uw, hR = "clear" + uw, _R = "https://js.monitor.azure.com/scripts/b/ai.config.1.cfg.json", Yd = "version", bi = "queue", Cu = "connectionString", Cs = "instrumentationKey", jo = "userOverrideEndpointUrl", Vd = "endpointUrl", fs = "onunloadFlush", an = "context", yg = "addHousekeepingBeforeUnload", Bd = "sendMessage", pR = "updateSnippetDefinitions", kn, ls, Mo, zd, ds, Tg = [
  ah,
  "dependencies",
  "properties",
  "_snippetVersion",
  "appInsightsNew",
  "getSKUDefaults"
], fw = "iKeyUsage", lw = "CdnUsage", dw = "SdkLoaderVer", ou = void 0, gR = {
  samplingRate: 100,
  maxSendNumber: 1
}, ER = {
  monthInterval: 3,
  daysOfMonth: [28]
}, au = {
  disabled: !0,
  limit: Sn(gR),
  interval: Sn(ER)
}, SR = (kn = {}, kn[
  Cu
  /* @min:connectionString */
] = ou, kn.endpointUrl = ou, kn[
  Cs
  /* @min:instrumentationKey */
] = ou, kn[
  jo
  /* @min:userOverrideEndpointUrl */
] = ou, kn.diagnosticLogInterval = af(mR, 1e4), kn.featureOptIn = (ls = {}, ls[fw] = {
  mode: 3
  /* FeatureOptInMode.enable */
}, ls[lw] = {
  mode: 2
  /* FeatureOptInMode.disable */
}, ls[dw] = {
  mode: 2
  /* FeatureOptInMode.disable */
}, ls), kn.throttleMgrCfg = Sn((Mo = {}, Mo[
  109
  /* _eInternalMessageId.DefaultThrottleMsgKey */
] = Sn(au), Mo[
  106
  /* _eInternalMessageId.InstrumentationKeyDeprecation */
] = Sn(au), Mo[
  111
  /* _eInternalMessageId.SdkLdrUpdate */
] = Sn(au), Mo[
  110
  /* _eInternalMessageId.CdnDeprecation */
] = Sn(au), Mo)), kn.extensionConfig = Sn((zd = {}, zd.AppInsightsCfgSyncPlugin = Sn({
  cfgUrl: _R,
  syncMode: 2
  /* ICfgSyncMode.Receive */
}), zd)), kn);
function mR(e) {
  return e && e > 0;
}
var wR = (
  /** @class */
  function() {
    function e(t) {
      var n = this, r, i, o, a, s, c, u, f, l, v, d, h, _, m;
      Be(e, this, function(E) {
        I(), Le(E, "config", {
          g: function() {
            return f;
          }
        }), J(["pluginVersionStringArr", "pluginVersionString"], function(D) {
          Le(E, D, {
            g: function() {
              return u ? u[D] : null;
            }
          });
        }), a = "" + (t.sv || t[
          Yd
          /* @min:%2eversion */
        ] || ""), t[
          bi
          /* @min:%2equeue */
        ] = t[
          bi
          /* @min:%2equeue */
        ] || [], t[
          Yd
          /* @min:%2eversion */
        ] = t[
          Yd
          /* @min:%2eversion */
        ] || 2;
        var y = pn(t.config || {}, SR);
        f = y.cfg, l = new tD(), Le(E, "appInsights", {
          g: function() {
            return l;
          }
        }), i = new eR(), r = new FD(), o = new RD(), u = new AN(), Le(E, "core", {
          g: function() {
            return u;
          }
        }), B(nt(y, function() {
          var D = f[
            Cu
            /* @min:%2econnectionString */
          ];
          function b() {
            return Ls(function(X, S) {
              mr(D, function(N) {
                var $ = N && N.value, w = null;
                !N.rejected && $ && (f[
                  Cu
                  /* @min:%2econnectionString */
                ] = $, w = zp($)), X(w);
              });
            });
          }
          if (/* @__PURE__ */ Ws(D)) {
            var F = Ls(function(X, S) {
              b().then(function(N) {
                var $ = f[
                  Cs
                  /* @min:%2einstrumentationKey */
                ];
                $ = N && N.instrumentationkey || $, X($);
              }).catch(function(N) {
                X(null);
              });
            }), U = f[
              jo
              /* @min:%2euserOverrideEndpointUrl */
            ];
            /* @__PURE__ */ Y(U) && (U = Ls(function(X, S) {
              b().then(function(N) {
                var $ = f[
                  Vd
                  /* @min:%2eendpointUrl */
                ], w = N && N.ingestionendpoint;
                $ = w ? w + _a : $, X($);
              }).catch(function(N) {
                X(null);
              });
            })), f[
              Cs
              /* @min:%2einstrumentationKey */
            ] = F, f[
              Vd
              /* @min:%2eendpointUrl */
            ] = U;
          }
          if (ce(D) && D) {
            var z = zp(D), ne = z.ingestionendpoint;
            f.endpointUrl = f[
              jo
              /* @min:%2euserOverrideEndpointUrl */
            ] ? f[
              jo
              /* @min:%2euserOverrideEndpointUrl */
            ] : ne + _a, f[
              Cs
              /* @min:%2einstrumentationKey */
            ] = z.instrumentationkey || f[
              Cs
              /* @min:%2einstrumentationKey */
            ];
          }
          f.endpointUrl = f[
            jo
            /* @min:%2euserOverrideEndpointUrl */
          ] ? f[
            jo
            /* @min:%2euserOverrideEndpointUrl */
          ] : f[
            Vd
            /* @min:%2eendpointUrl */
          ];
        })), E[
          ah
          /* @min:%2esnippet */
        ] = t, E[
          $d
          /* @min:%2eflush */
        ] = function(D, b) {
          D === void 0 && (D = !0);
          var F;
          return ff(u, function() {
            return "AISKU.flush";
          }, function() {
            D && !b && (F = ii(function(ne) {
              b = ne;
            }));
            var U = 1, z = function() {
              U--, U === 0 && b();
            };
            J(u.getChannels(), function(ne) {
              ne && (U++, ne[
                $d
                /* @min:%2eflush */
              ](D, z));
            }), z();
          }, null, D), F;
        }, E[
          fs
          /* @min:%2eonunloadFlush */
        ] = function(D) {
          D === void 0 && (D = !0), J(u.getChannels(), function(b) {
            b[
              fs
              /* @min:%2eonunloadFlush */
            ] ? b[
              fs
              /* @min:%2eonunloadFlush */
            ]() : b[
              $d
              /* @min:%2eflush */
            ](D);
          });
        }, E.loadAppInsights = function(D, b, F) {
          D === void 0 && (D = !1), D && L0("Legacy Mode is no longer supported");
          function U(z) {
            if (z) {
              var ne = "";
              /* @__PURE__ */ Y(a) || (ne += a), E[
                an
                /* @min:%2econtext */
              ] && E[
                an
                /* @min:%2econtext */
              ].internal && (E[
                an
                /* @min:%2econtext */
              ].internal.snippetVer = ne || "-"), Ne(E, function(X, S) {
                ce(X) && !ye(S) && X && X[0] !== "_" && // Don't copy "internal" values
                Rt(Tg, X) === -1 && z[X] !== S && (z[X] = S);
              });
            }
          }
          return ff(E.core, function() {
            return "AISKU.loadAppInsights";
          }, function() {
            u.initialize(f, [o, i, r, l, v], b, F), Le(E, "context", {
              g: function() {
                return i[
                  an
                  /* @min:%2econtext */
                ];
              }
            }), d || (d = new fI(u));
            var z = yR();
            z && E[
              an
              /* @min:%2econtext */
            ] && (E[
              an
              /* @min:%2econtext */
            ].internal.sdkSrc = z), U(E[
              ah
              /* @min:%2esnippet */
            ]), E.emptyQueue(), E[
              wg
              /* @min:%2epollInternalLogs */
            ](), E[
              yg
              /* @min:%2eaddHousekeepingBeforeUnload */
            ](E), B(nt(y, function() {
              var ne = !1;
              f.throttleMgrCfg[
                109
                /* _eInternalMessageId.DefaultThrottleMsgKey */
              ] && (ne = !f.throttleMgrCfg[
                109
                /* _eInternalMessageId.DefaultThrottleMsgKey */
              ].disabled), !d.isReady() && f.extensionConfig && f.extensionConfig[v.identifier] && ne && d.onReadyState(!0), !h && !f[
                Cu
                /* @min:%2econnectionString */
              ] && Gl(fw, f) && (d[
                Bd
                /* @min:%2esendMessage */
              ](106, "See Instrumentation key support at aka.ms/IkeyMigrate"), h = !0), !_ && E[
                an
                /* @min:%2econtext */
              ].internal.sdkSrc && E[
                an
                /* @min:%2econtext */
              ].internal.sdkSrc.indexOf("az416426") != -1 && Gl(lw, f) && (d[
                Bd
                /* @min:%2esendMessage */
              ](110, "See Cdn support notice at aka.ms/JsActiveCdn"), _ = !0), !m && parseInt(a) < 6 && Gl(dw, f) && (d[
                Bd
                /* @min:%2esendMessage */
              ](111, "An updated Sdk Loader is available, see aka.ms/SnippetVer"), m = !0);
            }));
          }), E;
        }, E[
          pR
          /* @min:%2eupdateSnippetDefinitions */
        ] = function(D) {
          Zb(D, E, function(b) {
            return b && Rt(Tg, b) === -1;
          });
        }, E.emptyQueue = function() {
          try {
            if (Te(E.snippet[
              bi
              /* @min:%2equeue */
            ])) {
              for (var D = E.snippet[
                bi
                /* @min:%2equeue */
              ].length, b = 0; b < D; b++) {
                var F = E.snippet[
                  bi
                  /* @min:%2equeue */
                ][b];
                F();
              }
              E.snippet[
                bi
                /* @min:%2equeue */
              ] = void 0, delete E.snippet[
                bi
                /* @min:%2equeue */
              ];
            }
          } catch (z) {
            var U = {};
            z && ye(z.toString) && (U.exception = z.toString());
          }
        }, E[
          yg
          /* @min:%2eaddHousekeepingBeforeUnload */
        ] = function(D) {
          if (/* @__PURE__ */ Bf() || /* @__PURE__ */ LE()) {
            var b = function() {
              if (D[
                fs
                /* @min:%2eonunloadFlush */
              ](!1), ye(E.core[
                Fd
                /* @min:%2egetPlugin */
              ])) {
                var U = n.core[
                  Fd
                  /* @min:%2egetPlugin */
                ](Zf);
                if (U) {
                  var z = U.plugin;
                  z && z[
                    an
                    /* @min:%2econtext */
                  ] && z[
                    an
                    /* @min:%2econtext */
                  ]._sessionManager && z[
                    an
                    /* @min:%2econtext */
                  ]._sessionManager.backup();
                }
              }
            }, F = !1;
            c || (c = fi(s, u[
              Hd
              /* @min:%2eevtNamespace */
            ] && u[
              Hd
              /* @min:%2eevtNamespace */
            ]())), B(nt(f, function(U) {
              var z = U.cfg, ne = D.appInsights, X = Rn(null, z, ne.core), S = X.getExtCfg(ne.identifier || ym);
              P();
              var N = z.disablePageUnloadEvents;
              S.disableFlushOnBeforeUnload || (BN(b, N, c) && (F = !0), Pv(b, N, c) && (F = !0), !F && !EC() && K(u.logger, 1, 19, "Could not add handler for beforeunload and pagehide")), !F && !S.disableFlushOnUnload && Pv(b, N, c);
            }));
          }
        }, E.getSender = function() {
          return o;
        }, E.unload = function(D, b, F) {
          var U = !1, z;
          D && !b && (z = ii(function(X) {
            b = X;
          }));
          function ne(X) {
            U || (U = !0, I(), b && b(X));
          }
          return E[
            fs
            /* @min:%2eonunloadFlush */
          ](D), P(), u.unload && u.unload(D, ne, F), z;
        }, ps(E, l, [
          tR,
          sR,
          fR,
          "trackPageViewPerformance",
          lR,
          "_onerror",
          cR,
          uR,
          nR,
          rR,
          iR,
          oR
        ]), ps(E, O, [
          dR,
          "addDependencyListener",
          "addDependencyInitializer"
        ]), ps(E, u, [
          aR,
          wg,
          "stopPollingInternalLogs",
          Fd,
          "addPlugin",
          Hd,
          "addUnloadCb",
          "getTraceCtx",
          "updateCfg",
          "onCfgChange"
        ]), ps(E, function() {
          var D = i[
            an
            /* @min:%2econtext */
          ];
          return D ? D.user : null;
        }, [
          vR,
          hR
        ]);
        function O() {
          return r;
        }
        function I() {
          s = _n("AISKU"), c = null, r = null, i = null, o = null, a = null, d = null, h = !1, _ = !1, m = !1, v = new uD();
        }
        function P() {
          c && (zN(null, c), GN(null, c));
        }
        function B(D) {
          u.addUnloadHook(D);
        }
      });
    }
    return e.prototype.addDependencyInitializer = function(t) {
      return null;
    }, e;
  }()
);
function yR() {
  if (ds)
    return ds;
  var e = null, t = !1, n = [
    "://js.monitor.azure.com/",
    "://az416426.vo.msecnd.net/"
  ];
  try {
    var r = (document || {}).currentScript;
    r && (e = r.src);
  } catch {
  }
  if (e) {
    try {
      var i = e.toLowerCase();
      if (i) {
        var o = "";
        J(n, function(a, s) {
          if (Ft(i, a) !== -1)
            return o = "cdn" + (s + 1), Ft(i, "/scripts/") === -1 && (Ft(i, "/next/") !== -1 ? o += "-next" : Ft(i, "/beta/") !== -1 && (o += "-beta")), ds = o + (t ? ".mod" : ""), -1;
        });
      }
    } catch {
    }
    ds = e;
  }
  return ds;
}
class TR extends Error {
  constructor(n, r, i) {
    super(n);
    hi(this, "isRestError", !0);
    hi(this, "request");
    hi(this, "fetchResponse");
    hi(this, "code");
    hi(this, "statusCode");
    hi(this, "data");
    this.statusCode = r, this.code = i, this.message = n;
  }
  async filterIsMatching(n) {
    var r, i, o, a;
    if (typeof n == "function") {
      const s = n(this);
      return s instanceof Promise ? await s : s;
    } else
      return n.method && !((r = this.request) != null && r.method) || n.statusCode && !this.statusCode || n.errorCode && !this.code ? !1 : (!n.path || (((o = (i = this.request) == null ? void 0 : i.url) == null ? void 0 : o.href) ?? "").indexOf(n.path) > -1) && (!n.method || n.method.toLowerCase() === ((a = this.request) == null ? void 0 : a.method.toLowerCase())) && (!n.statusCode || n.statusCode === this.statusCode) && (!n.errorCode || n.errorCode === this.code);
  }
  findMatch(n) {
    return new Promise(async (r) => {
      if (!n || !n.length)
        return r(void 0);
      const i = async (a = 0) => a in n ? await this.filterIsMatching(n[a]) ? n[a] : await i(a + 1) : void 0, o = await i();
      r(o);
    });
  }
}
const Zt = Symbol.for("AppInsights"), Xo = Symbol.for("getCommonProps");
function vP() {
  return {
    setup(e) {
      window[Zt] = new wR(e), window[Zt].loadAppInsights();
    },
    setCommonPropsResolver(e) {
      window[Xo] = e;
    },
    setAuthenticatedUserContext(e, t, n) {
      var r;
      (r = window[Zt]) == null || r.setAuthenticatedUserContext(e, t, n);
    },
    clearAuthenticatedUserContext() {
      var e;
      (e = window[Zt]) == null || e.clearAuthenticatedUserContext();
    }
  };
}
function hP() {
  return {
    trackEvent(e, t, n = !1) {
      var i, o;
      const r = { ...window[Xo](), ...t ?? {} };
      (i = window[Zt]) == null || i.trackEvent({ name: e, properties: r }), n && ((o = window[Zt]) == null || o.flush());
    },
    trackTrace(e, t, n = !1) {
      var i, o;
      const r = { ...window[Xo](), ...t ?? {} };
      (i = window[Zt]) == null || i.trackTrace(e, r), n && ((o = window[Zt]) == null || o.flush());
    },
    trackMetric(e, t) {
      var r;
      const n = { ...window[Xo](), ...t ?? {} };
      (r = window[Zt]) == null || r.trackMetric(e, n);
    },
    trackView(e, t, n) {
      var r, i;
      switch (t) {
        case "start":
          (r = window[Zt]) == null || r.startTrackPage(e);
          break;
        case "end":
          (i = window[Zt]) == null || i.stopTrackPage(e, n);
          break;
      }
    },
    async trackException(e, t) {
      var r, i, o, a, s, c, u, f, l, v, d;
      const n = { exception: e, properties: t ?? {} };
      if (n.exception instanceof TR) {
        let h = "";
        try {
          h = await ((r = n.exception.fetchResponse) == null ? void 0 : r.text()) ?? "";
        } catch {
        }
        const _ = {
          url: (i = n.exception.request) == null ? void 0 : i.url.toString(),
          method: (o = n.exception.request) == null ? void 0 : o.method,
          params: (a = n.exception.request) == null ? void 0 : a.options.query,
          payload: (s = n.exception.request) == null ? void 0 : s.body,
          headers_request: (c = n.exception.request) == null ? void 0 : c.options.headers,
          headers_response: (u = n.exception.fetchResponse) == null ? void 0 : u.headers,
          status_code: n.exception.statusCode,
          error_code: n.exception.code,
          response: n.exception.data,
          rawBody: h
        };
        n.properties = {
          api: _,
          extras: t,
          common: window[Xo](),
          instanceOf: "RestError"
        };
        const m = (n.exception.statusCode + "").toLowerCase() === "timeout";
        n.exception.statusCode && ((f = n.exception.request) != null && f.method) && (m || !isNaN(+n.exception.statusCode)) && (n.exception.message = `[${n.exception.request.method.toUpperCase()}-${_.status_code}] ${(l = n.exception.request) == null ? void 0 : l.url.pathname}`);
      } else if (e) {
        n.properties.code = e.name, n.properties.common = window[Xo]();
        const h = [
          DOMException,
          EvalError,
          RangeError,
          ReferenceError,
          SyntaxError,
          TypeError,
          URIError
        ];
        for (let _ = 0; _ < h.length; _++)
          if (e instanceof h[_]) {
            n.properties.instanceOf = h[_].name;
            break;
          }
      }
      return (v = window[Zt]) == null || v.trackException(n), (d = window[Zt]) == null || d.flush(), n;
    }
  };
}
const Vt = Symbol.for("FunctionalityRepo");
function _P() {
  return {
    setupSecurity(e) {
      window[Vt] = e;
    },
    addFunctionalities(e) {
      const t = window[Vt] ?? {};
      window[Vt] = {
        ...t,
        ...e
      };
    },
    clearFunctionalities() {
      window[Vt] = null;
    }
  };
}
function pP() {
  function e(r) {
    return window[Vt] ? !!Object.keys(window[Vt]).find((i) => i === r) : !1;
  }
  function t(r) {
    return window[Vt] ? e(r) ? !!(window[Vt] && window[Vt][r] && window[Vt][r]) : (console.warn(`Key ${r} not found in functionalities repo`), !1) : !1;
  }
  function n(r) {
    return window[Vt] ? e(r) ? !!(window[Vt] && window[Vt][r] && window[Vt][r].Enabled === !0) : (console.warn(`Key ${r} not found in functionalities repo`), !1) : !1;
  }
  return {
    hasFunctionalities(r) {
      Array.isArray(r) || (r = [r]);
      const i = r.map((o) => t(o));
      return r.length === i.filter(Boolean).length;
    },
    hasFunctionalitiesEnabled(r) {
      Array.isArray(r) || (r = [r]);
      const i = r.map((o) => n(o));
      return r.length === i.filter(Boolean).length;
    },
    hasAtLeastOneFunctionality(r) {
      return r.map((o) => t(o)).filter(Boolean).length > 0;
    },
    hasAtLeastOneFunctionalityEnabled(r) {
      return r.map((o) => n(o)).filter(Boolean).length > 0;
    }
  };
}
class Qi extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
   *
   * @param {string} errorMessage A descriptive error message.
   * @param {number} statusCode The HTTP status code represented by this error.
   */
  constructor(t, n) {
    const r = new.target.prototype;
    super(`${t}: Status code '${n}'`), this.statusCode = n, this.__proto__ = r;
  }
}
class E_ extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(t = "A timeout occurred.") {
    const n = new.target.prototype;
    super(t), this.__proto__ = n;
  }
}
class bn extends Error {
  /** Constructs a new instance of {@link AbortError}.
   *
   * @param {string} errorMessage A descriptive error message.
   */
  constructor(t = "An abort occurred.") {
    const n = new.target.prototype;
    super(t), this.__proto__ = n;
  }
}
class bR extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, n) {
    const r = new.target.prototype;
    super(t), this.transport = n, this.errorType = "UnsupportedTransportError", this.__proto__ = r;
  }
}
class CR extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, n) {
    const r = new.target.prototype;
    super(t), this.transport = n, this.errorType = "DisabledTransportError", this.__proto__ = r;
  }
}
class NR extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
   *
   * @param {string} message A descriptive error message.
   * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
   */
  constructor(t, n) {
    const r = new.target.prototype;
    super(t), this.transport = n, this.errorType = "FailedToStartTransportError", this.__proto__ = r;
  }
}
class bg extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
   *
   * @param {string} message A descriptive error message.
   */
  constructor(t) {
    const n = new.target.prototype;
    super(t), this.errorType = "FailedToNegotiateWithServerError", this.__proto__ = n;
  }
}
class IR extends Error {
  /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
   *
   * @param {string} message A descriptive error message.
   * @param {Error[]} innerErrors The collection of errors this error is aggregating.
   */
  constructor(t, n) {
    const r = new.target.prototype;
    super(t), this.innerErrors = n, this.__proto__ = r;
  }
}
class vw {
  constructor(t, n, r) {
    this.statusCode = t, this.statusText = n, this.content = r;
  }
}
class el {
  get(t, n) {
    return this.send({
      ...n,
      method: "GET",
      url: t
    });
  }
  post(t, n) {
    return this.send({
      ...n,
      method: "POST",
      url: t
    });
  }
  delete(t, n) {
    return this.send({
      ...n,
      method: "DELETE",
      url: t
    });
  }
  /** Gets all cookies that apply to the specified URL.
   *
   * @param url The URL that the cookies are valid for.
   * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
   */
  // @ts-ignore
  getCookieString(t) {
    return "";
  }
}
var k;
(function(e) {
  e[e.Trace = 0] = "Trace", e[e.Debug = 1] = "Debug", e[e.Information = 2] = "Information", e[e.Warning = 3] = "Warning", e[e.Error = 4] = "Error", e[e.Critical = 5] = "Critical", e[e.None = 6] = "None";
})(k || (k = {}));
class uc {
  constructor() {
  }
  /** @inheritDoc */
  // eslint-disable-next-line
  log(t, n) {
  }
}
uc.instance = new uc();
const DR = "8.0.7";
class st {
  static isRequired(t, n) {
    if (t == null)
      throw new Error(`The '${n}' argument is required.`);
  }
  static isNotEmpty(t, n) {
    if (!t || t.match(/^\s*$/))
      throw new Error(`The '${n}' argument should not be empty.`);
  }
  static isIn(t, n, r) {
    if (!(t in n))
      throw new Error(`Unknown ${r} value: ${t}.`);
  }
}
class je {
  // react-native has a window but no document so we should check both
  static get isBrowser() {
    return !je.isNode && typeof window == "object" && typeof window.document == "object";
  }
  // WebWorkers don't have a window object so the isBrowser check would fail
  static get isWebWorker() {
    return !je.isNode && typeof self == "object" && "importScripts" in self;
  }
  // react-native has a window but no document
  static get isReactNative() {
    return !je.isNode && typeof window == "object" && typeof window.document > "u";
  }
  // Node apps shouldn't have a window object, but WebWorkers don't either
  // so we need to check for both WebWorker and window
  static get isNode() {
    return typeof process < "u" && process.release && process.release.name === "node";
  }
}
function fc(e, t) {
  let n = "";
  return co(e) ? (n = `Binary data of length ${e.byteLength}`, t && (n += `. Content: '${RR(e)}'`)) : typeof e == "string" && (n = `String data of length ${e.length}`, t && (n += `. Content: '${e}'`)), n;
}
function RR(e) {
  const t = new Uint8Array(e);
  let n = "";
  return t.forEach((r) => {
    const i = r < 16 ? "0" : "";
    n += `0x${i}${r.toString(16)} `;
  }), n.substr(0, n.length - 1);
}
function co(e) {
  return e && typeof ArrayBuffer < "u" && (e instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  e.constructor && e.constructor.name === "ArrayBuffer");
}
async function hw(e, t, n, r, i, o) {
  const a = {}, [s, c] = Oa();
  a[s] = c, e.log(k.Trace, `(${t} transport) sending data. ${fc(i, o.logMessageContent)}.`);
  const u = co(i) ? "arraybuffer" : "text", f = await n.post(r, {
    content: i,
    headers: { ...a, ...o.headers },
    responseType: u,
    timeout: o.timeout,
    withCredentials: o.withCredentials
  });
  e.log(k.Trace, `(${t} transport) request complete. Response status: ${f.statusCode}.`);
}
function PR(e) {
  return e === void 0 ? new Df(k.Information) : e === null ? uc.instance : e.log !== void 0 ? e : new Df(e);
}
class AR {
  constructor(t, n) {
    this._subject = t, this._observer = n;
  }
  dispose() {
    const t = this._subject.observers.indexOf(this._observer);
    t > -1 && this._subject.observers.splice(t, 1), this._subject.observers.length === 0 && this._subject.cancelCallback && this._subject.cancelCallback().catch((n) => {
    });
  }
}
class Df {
  constructor(t) {
    this._minLevel = t, this.out = console;
  }
  log(t, n) {
    if (t >= this._minLevel) {
      const r = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${k[t]}: ${n}`;
      switch (t) {
        case k.Critical:
        case k.Error:
          this.out.error(r);
          break;
        case k.Warning:
          this.out.warn(r);
          break;
        case k.Information:
          this.out.info(r);
          break;
        default:
          this.out.log(r);
          break;
      }
    }
  }
}
function Oa() {
  let e = "X-SignalR-User-Agent";
  return je.isNode && (e = "User-Agent"), [e, OR(DR, kR(), LR(), xR())];
}
function OR(e, t, n, r) {
  let i = "Microsoft SignalR/";
  const o = e.split(".");
  return i += `${o[0]}.${o[1]}`, i += ` (${e}; `, t && t !== "" ? i += `${t}; ` : i += "Unknown OS; ", i += `${n}`, r ? i += `; ${r}` : i += "; Unknown Runtime Version", i += ")", i;
}
function kR() {
  if (je.isNode)
    switch (process.platform) {
      case "win32":
        return "Windows NT";
      case "darwin":
        return "macOS";
      case "linux":
        return "Linux";
      default:
        return process.platform;
    }
  else
    return "";
}
function xR() {
  if (je.isNode)
    return process.versions.node;
}
function LR() {
  return je.isNode ? "NodeJS" : "Browser";
}
function Gd(e) {
  return e.stack ? e.stack : e.message ? e.message : `${e}`;
}
function MR() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("could not find global");
}
class UR extends el {
  constructor(t) {
    if (super(), this._logger = t, typeof fetch > "u" || je.isNode) {
      const n = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._jar = new (n("tough-cookie")).CookieJar(), typeof fetch > "u" ? this._fetchType = n("node-fetch") : this._fetchType = fetch, this._fetchType = n("fetch-cookie")(this._fetchType, this._jar);
    } else
      this._fetchType = fetch.bind(MR());
    if (typeof AbortController > "u") {
      const n = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      this._abortControllerType = n("abort-controller");
    } else
      this._abortControllerType = AbortController;
  }
  /** @inheritDoc */
  async send(t) {
    if (t.abortSignal && t.abortSignal.aborted)
      throw new bn();
    if (!t.method)
      throw new Error("No method defined.");
    if (!t.url)
      throw new Error("No url defined.");
    const n = new this._abortControllerType();
    let r;
    t.abortSignal && (t.abortSignal.onabort = () => {
      n.abort(), r = new bn();
    });
    let i = null;
    if (t.timeout) {
      const c = t.timeout;
      i = setTimeout(() => {
        n.abort(), this._logger.log(k.Warning, "Timeout from HTTP request."), r = new E_();
      }, c);
    }
    t.content === "" && (t.content = void 0), t.content && (t.headers = t.headers || {}, co(t.content) ? t.headers["Content-Type"] = "application/octet-stream" : t.headers["Content-Type"] = "text/plain;charset=UTF-8");
    let o;
    try {
      o = await this._fetchType(t.url, {
        body: t.content,
        cache: "no-cache",
        credentials: t.withCredentials === !0 ? "include" : "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          ...t.headers
        },
        method: t.method,
        mode: "cors",
        redirect: "follow",
        signal: n.signal
      });
    } catch (c) {
      throw r || (this._logger.log(k.Warning, `Error from HTTP request. ${c}.`), c);
    } finally {
      i && clearTimeout(i), t.abortSignal && (t.abortSignal.onabort = null);
    }
    if (!o.ok) {
      const c = await Cg(o, "text");
      throw new Qi(c || o.statusText, o.status);
    }
    const s = await Cg(o, t.responseType);
    return new vw(o.status, o.statusText, s);
  }
  getCookieString(t) {
    let n = "";
    return je.isNode && this._jar && this._jar.getCookies(t, (r, i) => n = i.join("; ")), n;
  }
}
function Cg(e, t) {
  let n;
  switch (t) {
    case "arraybuffer":
      n = e.arrayBuffer();
      break;
    case "text":
      n = e.text();
      break;
    case "blob":
    case "document":
    case "json":
      throw new Error(`${t} is not supported.`);
    default:
      n = e.text();
      break;
  }
  return n;
}
class $R extends el {
  constructor(t) {
    super(), this._logger = t;
  }
  /** @inheritDoc */
  send(t) {
    return t.abortSignal && t.abortSignal.aborted ? Promise.reject(new bn()) : t.method ? t.url ? new Promise((n, r) => {
      const i = new XMLHttpRequest();
      i.open(t.method, t.url, !0), i.withCredentials = t.withCredentials === void 0 ? !0 : t.withCredentials, i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), t.content === "" && (t.content = void 0), t.content && (co(t.content) ? i.setRequestHeader("Content-Type", "application/octet-stream") : i.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"));
      const o = t.headers;
      o && Object.keys(o).forEach((a) => {
        i.setRequestHeader(a, o[a]);
      }), t.responseType && (i.responseType = t.responseType), t.abortSignal && (t.abortSignal.onabort = () => {
        i.abort(), r(new bn());
      }), t.timeout && (i.timeout = t.timeout), i.onload = () => {
        t.abortSignal && (t.abortSignal.onabort = null), i.status >= 200 && i.status < 300 ? n(new vw(i.status, i.statusText, i.response || i.responseText)) : r(new Qi(i.response || i.responseText || i.statusText, i.status));
      }, i.onerror = () => {
        this._logger.log(k.Warning, `Error from HTTP request. ${i.status}: ${i.statusText}.`), r(new Qi(i.statusText, i.status));
      }, i.ontimeout = () => {
        this._logger.log(k.Warning, "Timeout from HTTP request."), r(new E_());
      }, i.send(t.content);
    }) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
}
class FR extends el {
  /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
  constructor(t) {
    if (super(), typeof fetch < "u" || je.isNode)
      this._httpClient = new UR(t);
    else if (typeof XMLHttpRequest < "u")
      this._httpClient = new $R(t);
    else
      throw new Error("No usable HttpClient found.");
  }
  /** @inheritDoc */
  send(t) {
    return t.abortSignal && t.abortSignal.aborted ? Promise.reject(new bn()) : t.method ? t.url ? this._httpClient.send(t) : Promise.reject(new Error("No url defined.")) : Promise.reject(new Error("No method defined."));
  }
  getCookieString(t) {
    return this._httpClient.getCookieString(t);
  }
}
class nn {
  static write(t) {
    return `${t}${nn.RecordSeparator}`;
  }
  static parse(t) {
    if (t[t.length - 1] !== nn.RecordSeparator)
      throw new Error("Message is incomplete.");
    const n = t.split(nn.RecordSeparator);
    return n.pop(), n;
  }
}
nn.RecordSeparatorCode = 30;
nn.RecordSeparator = String.fromCharCode(nn.RecordSeparatorCode);
class HR {
  // Handshake request is always JSON
  writeHandshakeRequest(t) {
    return nn.write(JSON.stringify(t));
  }
  parseHandshakeResponse(t) {
    let n, r;
    if (co(t)) {
      const s = new Uint8Array(t), c = s.indexOf(nn.RecordSeparatorCode);
      if (c === -1)
        throw new Error("Message is incomplete.");
      const u = c + 1;
      n = String.fromCharCode.apply(null, Array.prototype.slice.call(s.slice(0, u))), r = s.byteLength > u ? s.slice(u).buffer : null;
    } else {
      const s = t, c = s.indexOf(nn.RecordSeparator);
      if (c === -1)
        throw new Error("Message is incomplete.");
      const u = c + 1;
      n = s.substring(0, u), r = s.length > u ? s.substring(u) : null;
    }
    const i = nn.parse(n), o = JSON.parse(i[0]);
    if (o.type)
      throw new Error("Expected a handshake response from the server.");
    return [r, o];
  }
}
var Ee;
(function(e) {
  e[e.Invocation = 1] = "Invocation", e[e.StreamItem = 2] = "StreamItem", e[e.Completion = 3] = "Completion", e[e.StreamInvocation = 4] = "StreamInvocation", e[e.CancelInvocation = 5] = "CancelInvocation", e[e.Ping = 6] = "Ping", e[e.Close = 7] = "Close", e[e.Ack = 8] = "Ack", e[e.Sequence = 9] = "Sequence";
})(Ee || (Ee = {}));
class YR {
  constructor() {
    this.observers = [];
  }
  next(t) {
    for (const n of this.observers)
      n.next(t);
  }
  error(t) {
    for (const n of this.observers)
      n.error && n.error(t);
  }
  complete() {
    for (const t of this.observers)
      t.complete && t.complete();
  }
  subscribe(t) {
    return this.observers.push(t), new AR(this, t);
  }
}
class VR {
  constructor(t, n, r) {
    this._bufferSize = 1e5, this._messages = [], this._totalMessageCount = 0, this._waitForSequenceMessage = !1, this._nextReceivingSequenceId = 1, this._latestReceivedSequenceId = 0, this._bufferedByteCount = 0, this._reconnectInProgress = !1, this._protocol = t, this._connection = n, this._bufferSize = r;
  }
  async _send(t) {
    const n = this._protocol.writeMessage(t);
    let r = Promise.resolve();
    if (this._isInvocationMessage(t)) {
      this._totalMessageCount++;
      let i = () => {
      }, o = () => {
      };
      co(n) ? this._bufferedByteCount += n.byteLength : this._bufferedByteCount += n.length, this._bufferedByteCount >= this._bufferSize && (r = new Promise((a, s) => {
        i = a, o = s;
      })), this._messages.push(new BR(n, this._totalMessageCount, i, o));
    }
    try {
      this._reconnectInProgress || await this._connection.send(n);
    } catch {
      this._disconnected();
    }
    await r;
  }
  _ack(t) {
    let n = -1;
    for (let r = 0; r < this._messages.length; r++) {
      const i = this._messages[r];
      if (i._id <= t.sequenceId)
        n = r, co(i._message) ? this._bufferedByteCount -= i._message.byteLength : this._bufferedByteCount -= i._message.length, i._resolver();
      else if (this._bufferedByteCount < this._bufferSize)
        i._resolver();
      else
        break;
    }
    n !== -1 && (this._messages = this._messages.slice(n + 1));
  }
  _shouldProcessMessage(t) {
    if (this._waitForSequenceMessage)
      return t.type !== Ee.Sequence ? !1 : (this._waitForSequenceMessage = !1, !0);
    if (!this._isInvocationMessage(t))
      return !0;
    const n = this._nextReceivingSequenceId;
    return this._nextReceivingSequenceId++, n <= this._latestReceivedSequenceId ? (n === this._latestReceivedSequenceId && this._ackTimer(), !1) : (this._latestReceivedSequenceId = n, this._ackTimer(), !0);
  }
  _resetSequence(t) {
    if (t.sequenceId > this._nextReceivingSequenceId) {
      this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
      return;
    }
    this._nextReceivingSequenceId = t.sequenceId;
  }
  _disconnected() {
    this._reconnectInProgress = !0, this._waitForSequenceMessage = !0;
  }
  async _resend() {
    const t = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
    await this._connection.send(this._protocol.writeMessage({ type: Ee.Sequence, sequenceId: t }));
    const n = this._messages;
    for (const r of n)
      await this._connection.send(r._message);
    this._reconnectInProgress = !1;
  }
  _dispose(t) {
    t ?? (t = new Error("Unable to reconnect to server."));
    for (const n of this._messages)
      n._rejector(t);
  }
  _isInvocationMessage(t) {
    switch (t.type) {
      case Ee.Invocation:
      case Ee.StreamItem:
      case Ee.Completion:
      case Ee.StreamInvocation:
      case Ee.CancelInvocation:
        return !0;
      case Ee.Close:
      case Ee.Sequence:
      case Ee.Ping:
      case Ee.Ack:
        return !1;
    }
  }
  _ackTimer() {
    this._ackTimerHandle === void 0 && (this._ackTimerHandle = setTimeout(async () => {
      try {
        this._reconnectInProgress || await this._connection.send(this._protocol.writeMessage({ type: Ee.Ack, sequenceId: this._latestReceivedSequenceId }));
      } catch {
      }
      clearTimeout(this._ackTimerHandle), this._ackTimerHandle = void 0;
    }, 1e3));
  }
}
class BR {
  constructor(t, n, r, i) {
    this._message = t, this._id = n, this._resolver = r, this._rejector = i;
  }
}
const zR = 30 * 1e3, GR = 15 * 1e3, KR = 1e5;
var Ge;
(function(e) {
  e.Disconnected = "Disconnected", e.Connecting = "Connecting", e.Connected = "Connected", e.Disconnecting = "Disconnecting", e.Reconnecting = "Reconnecting";
})(Ge || (Ge = {}));
class S_ {
  /** @internal */
  // Using a public static factory method means we can have a private constructor and an _internal_
  // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
  // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
  // public parameter-less constructor.
  static create(t, n, r, i, o, a, s) {
    return new S_(t, n, r, i, o, a, s);
  }
  constructor(t, n, r, i, o, a, s) {
    this._nextKeepAlive = 0, this._freezeEventListener = () => {
      this._logger.log(k.Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
    }, st.isRequired(t, "connection"), st.isRequired(n, "logger"), st.isRequired(r, "protocol"), this.serverTimeoutInMilliseconds = o ?? zR, this.keepAliveIntervalInMilliseconds = a ?? GR, this._statefulReconnectBufferSize = s ?? KR, this._logger = n, this._protocol = r, this.connection = t, this._reconnectPolicy = i, this._handshakeProtocol = new HR(), this.connection.onreceive = (c) => this._processIncomingData(c), this.connection.onclose = (c) => this._connectionClosed(c), this._callbacks = {}, this._methods = {}, this._closedCallbacks = [], this._reconnectingCallbacks = [], this._reconnectedCallbacks = [], this._invocationId = 0, this._receivedHandshakeResponse = !1, this._connectionState = Ge.Disconnected, this._connectionStarted = !1, this._cachedPingMessage = this._protocol.writeMessage({ type: Ee.Ping });
  }
  /** Indicates the state of the {@link HubConnection} to the server. */
  get state() {
    return this._connectionState;
  }
  /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
   *  in the disconnected state or if the negotiation step was skipped.
   */
  get connectionId() {
    return this.connection && this.connection.connectionId || null;
  }
  /** Indicates the url of the {@link HubConnection} to the server. */
  get baseUrl() {
    return this.connection.baseUrl || "";
  }
  /**
   * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
   * Reconnecting states.
   * @param {string} url The url to connect to.
   */
  set baseUrl(t) {
    if (this._connectionState !== Ge.Disconnected && this._connectionState !== Ge.Reconnecting)
      throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
    if (!t)
      throw new Error("The HubConnection url must be a valid url.");
    this.connection.baseUrl = t;
  }
  /** Starts the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
   */
  start() {
    return this._startPromise = this._startWithStateTransitions(), this._startPromise;
  }
  async _startWithStateTransitions() {
    if (this._connectionState !== Ge.Disconnected)
      return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
    this._connectionState = Ge.Connecting, this._logger.log(k.Debug, "Starting HubConnection.");
    try {
      await this._startInternal(), je.isBrowser && window.document.addEventListener("freeze", this._freezeEventListener), this._connectionState = Ge.Connected, this._connectionStarted = !0, this._logger.log(k.Debug, "HubConnection connected successfully.");
    } catch (t) {
      return this._connectionState = Ge.Disconnected, this._logger.log(k.Debug, `HubConnection failed to start successfully because of error '${t}'.`), Promise.reject(t);
    }
  }
  async _startInternal() {
    this._stopDuringStartError = void 0, this._receivedHandshakeResponse = !1;
    const t = new Promise((n, r) => {
      this._handshakeResolver = n, this._handshakeRejecter = r;
    });
    await this.connection.start(this._protocol.transferFormat);
    try {
      let n = this._protocol.version;
      this.connection.features.reconnect || (n = 1);
      const r = {
        protocol: this._protocol.name,
        version: n
      };
      if (this._logger.log(k.Debug, "Sending handshake request."), await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(r)), this._logger.log(k.Information, `Using HubProtocol '${this._protocol.name}'.`), this._cleanupTimeout(), this._resetTimeoutPeriod(), this._resetKeepAliveInterval(), await t, this._stopDuringStartError)
        throw this._stopDuringStartError;
      (this.connection.features.reconnect || !1) && (this._messageBuffer = new VR(this._protocol, this.connection, this._statefulReconnectBufferSize), this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer), this.connection.features.resend = () => {
        if (this._messageBuffer)
          return this._messageBuffer._resend();
      }), this.connection.features.inherentKeepAlive || await this._sendMessage(this._cachedPingMessage);
    } catch (n) {
      throw this._logger.log(k.Debug, `Hub handshake failed with error '${n}' during start(). Stopping HubConnection.`), this._cleanupTimeout(), this._cleanupPingTimer(), await this.connection.stop(n), n;
    }
  }
  /** Stops the connection.
   *
   * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
   */
  async stop() {
    const t = this._startPromise;
    this.connection.features.reconnect = !1, this._stopPromise = this._stopInternal(), await this._stopPromise;
    try {
      await t;
    } catch {
    }
  }
  _stopInternal(t) {
    if (this._connectionState === Ge.Disconnected)
      return this._logger.log(k.Debug, `Call to HubConnection.stop(${t}) ignored because it is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === Ge.Disconnecting)
      return this._logger.log(k.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    const n = this._connectionState;
    return this._connectionState = Ge.Disconnecting, this._logger.log(k.Debug, "Stopping HubConnection."), this._reconnectDelayHandle ? (this._logger.log(k.Debug, "Connection stopped during reconnect delay. Done reconnecting."), clearTimeout(this._reconnectDelayHandle), this._reconnectDelayHandle = void 0, this._completeClose(), Promise.resolve()) : (n === Ge.Connected && this._sendCloseMessage(), this._cleanupTimeout(), this._cleanupPingTimer(), this._stopDuringStartError = t || new bn("The connection was stopped before the hub handshake could complete."), this.connection.stop(t));
  }
  async _sendCloseMessage() {
    try {
      await this._sendWithProtocol(this._createCloseMessage());
    } catch {
    }
  }
  /** Invokes a streaming hub method on the server using the specified name and arguments.
   *
   * @typeparam T The type of the items returned by the server.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
   */
  stream(t, ...n) {
    const [r, i] = this._replaceStreamingParams(n), o = this._createStreamInvocation(t, n, i);
    let a;
    const s = new YR();
    return s.cancelCallback = () => {
      const c = this._createCancelInvocation(o.invocationId);
      return delete this._callbacks[o.invocationId], a.then(() => this._sendWithProtocol(c));
    }, this._callbacks[o.invocationId] = (c, u) => {
      if (u) {
        s.error(u);
        return;
      } else c && (c.type === Ee.Completion ? c.error ? s.error(new Error(c.error)) : s.complete() : s.next(c.item));
    }, a = this._sendWithProtocol(o).catch((c) => {
      s.error(c), delete this._callbacks[o.invocationId];
    }), this._launchStreams(r, a), s;
  }
  _sendMessage(t) {
    return this._resetKeepAliveInterval(), this.connection.send(t);
  }
  /**
   * Sends a js object to the server.
   * @param message The js object to serialize and send.
   */
  _sendWithProtocol(t) {
    return this._messageBuffer ? this._messageBuffer._send(t) : this._sendMessage(this._protocol.writeMessage(t));
  }
  /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
   *
   * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
   * be processing the invocation.
   *
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
   */
  send(t, ...n) {
    const [r, i] = this._replaceStreamingParams(n), o = this._sendWithProtocol(this._createInvocation(t, n, !0, i));
    return this._launchStreams(r, o), o;
  }
  /** Invokes a hub method on the server using the specified name and arguments.
   *
   * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
   * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
   * resolving the Promise.
   *
   * @typeparam T The expected return type.
   * @param {string} methodName The name of the server method to invoke.
   * @param {any[]} args The arguments used to invoke the server method.
   * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
   */
  invoke(t, ...n) {
    const [r, i] = this._replaceStreamingParams(n), o = this._createInvocation(t, n, !1, i);
    return new Promise((s, c) => {
      this._callbacks[o.invocationId] = (f, l) => {
        if (l) {
          c(l);
          return;
        } else f && (f.type === Ee.Completion ? f.error ? c(new Error(f.error)) : s(f.result) : c(new Error(`Unexpected message type: ${f.type}`)));
      };
      const u = this._sendWithProtocol(o).catch((f) => {
        c(f), delete this._callbacks[o.invocationId];
      });
      this._launchStreams(r, u);
    });
  }
  on(t, n) {
    !t || !n || (t = t.toLowerCase(), this._methods[t] || (this._methods[t] = []), this._methods[t].indexOf(n) === -1 && this._methods[t].push(n));
  }
  off(t, n) {
    if (!t)
      return;
    t = t.toLowerCase();
    const r = this._methods[t];
    if (r)
      if (n) {
        const i = r.indexOf(n);
        i !== -1 && (r.splice(i, 1), r.length === 0 && delete this._methods[t]);
      } else
        delete this._methods[t];
  }
  /** Registers a handler that will be invoked when the connection is closed.
   *
   * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
   */
  onclose(t) {
    t && this._closedCallbacks.push(t);
  }
  /** Registers a handler that will be invoked when the connection starts reconnecting.
   *
   * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
   */
  onreconnecting(t) {
    t && this._reconnectingCallbacks.push(t);
  }
  /** Registers a handler that will be invoked when the connection successfully reconnects.
   *
   * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
   */
  onreconnected(t) {
    t && this._reconnectedCallbacks.push(t);
  }
  _processIncomingData(t) {
    if (this._cleanupTimeout(), this._receivedHandshakeResponse || (t = this._processHandshakeResponse(t), this._receivedHandshakeResponse = !0), t) {
      const n = this._protocol.parseMessages(t, this._logger);
      for (const r of n)
        if (!(this._messageBuffer && !this._messageBuffer._shouldProcessMessage(r)))
          switch (r.type) {
            case Ee.Invocation:
              this._invokeClientMethod(r).catch((i) => {
                this._logger.log(k.Error, `Invoke client method threw error: ${Gd(i)}`);
              });
              break;
            case Ee.StreamItem:
            case Ee.Completion: {
              const i = this._callbacks[r.invocationId];
              if (i) {
                r.type === Ee.Completion && delete this._callbacks[r.invocationId];
                try {
                  i(r);
                } catch (o) {
                  this._logger.log(k.Error, `Stream callback threw error: ${Gd(o)}`);
                }
              }
              break;
            }
            case Ee.Ping:
              break;
            case Ee.Close: {
              this._logger.log(k.Information, "Close message received from server.");
              const i = r.error ? new Error("Server returned an error on close: " + r.error) : void 0;
              r.allowReconnect === !0 ? this.connection.stop(i) : this._stopPromise = this._stopInternal(i);
              break;
            }
            case Ee.Ack:
              this._messageBuffer && this._messageBuffer._ack(r);
              break;
            case Ee.Sequence:
              this._messageBuffer && this._messageBuffer._resetSequence(r);
              break;
            default:
              this._logger.log(k.Warning, `Invalid message type: ${r.type}.`);
              break;
          }
    }
    this._resetTimeoutPeriod();
  }
  _processHandshakeResponse(t) {
    let n, r;
    try {
      [r, n] = this._handshakeProtocol.parseHandshakeResponse(t);
    } catch (i) {
      const o = "Error parsing handshake response: " + i;
      this._logger.log(k.Error, o);
      const a = new Error(o);
      throw this._handshakeRejecter(a), a;
    }
    if (n.error) {
      const i = "Server returned handshake error: " + n.error;
      this._logger.log(k.Error, i);
      const o = new Error(i);
      throw this._handshakeRejecter(o), o;
    } else
      this._logger.log(k.Debug, "Server handshake complete.");
    return this._handshakeResolver(), r;
  }
  _resetKeepAliveInterval() {
    this.connection.features.inherentKeepAlive || (this._nextKeepAlive = (/* @__PURE__ */ new Date()).getTime() + this.keepAliveIntervalInMilliseconds, this._cleanupPingTimer());
  }
  _resetTimeoutPeriod() {
    if ((!this.connection.features || !this.connection.features.inherentKeepAlive) && (this._timeoutHandle = setTimeout(() => this.serverTimeout(), this.serverTimeoutInMilliseconds), this._pingServerHandle === void 0)) {
      let t = this._nextKeepAlive - (/* @__PURE__ */ new Date()).getTime();
      t < 0 && (t = 0), this._pingServerHandle = setTimeout(async () => {
        if (this._connectionState === Ge.Connected)
          try {
            await this._sendMessage(this._cachedPingMessage);
          } catch {
            this._cleanupPingTimer();
          }
      }, t);
    }
  }
  // eslint-disable-next-line @typescript-eslint/naming-convention
  serverTimeout() {
    this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
  }
  async _invokeClientMethod(t) {
    const n = t.target.toLowerCase(), r = this._methods[n];
    if (!r) {
      this._logger.log(k.Warning, `No client method with the name '${n}' found.`), t.invocationId && (this._logger.log(k.Warning, `No result given for '${n}' method and invocation ID '${t.invocationId}'.`), await this._sendWithProtocol(this._createCompletionMessage(t.invocationId, "Client didn't provide a result.", null)));
      return;
    }
    const i = r.slice(), o = !!t.invocationId;
    let a, s, c;
    for (const u of i)
      try {
        const f = a;
        a = await u.apply(this, t.arguments), o && a && f && (this._logger.log(k.Error, `Multiple results provided for '${n}'. Sending error to server.`), c = this._createCompletionMessage(t.invocationId, "Client provided multiple results.", null)), s = void 0;
      } catch (f) {
        s = f, this._logger.log(k.Error, `A callback for the method '${n}' threw error '${f}'.`);
      }
    c ? await this._sendWithProtocol(c) : o ? (s ? c = this._createCompletionMessage(t.invocationId, `${s}`, null) : a !== void 0 ? c = this._createCompletionMessage(t.invocationId, null, a) : (this._logger.log(k.Warning, `No result given for '${n}' method and invocation ID '${t.invocationId}'.`), c = this._createCompletionMessage(t.invocationId, "Client didn't provide a result.", null)), await this._sendWithProtocol(c)) : a && this._logger.log(k.Error, `Result given for '${n}' method but server is not expecting a result.`);
  }
  _connectionClosed(t) {
    this._logger.log(k.Debug, `HubConnection.connectionClosed(${t}) called while in state ${this._connectionState}.`), this._stopDuringStartError = this._stopDuringStartError || t || new bn("The underlying connection was closed before the hub handshake could complete."), this._handshakeResolver && this._handshakeResolver(), this._cancelCallbacksWithError(t || new Error("Invocation canceled due to the underlying connection being closed.")), this._cleanupTimeout(), this._cleanupPingTimer(), this._connectionState === Ge.Disconnecting ? this._completeClose(t) : this._connectionState === Ge.Connected && this._reconnectPolicy ? this._reconnect(t) : this._connectionState === Ge.Connected && this._completeClose(t);
  }
  _completeClose(t) {
    if (this._connectionStarted) {
      this._connectionState = Ge.Disconnected, this._connectionStarted = !1, this._messageBuffer && (this._messageBuffer._dispose(t ?? new Error("Connection closed.")), this._messageBuffer = void 0), je.isBrowser && window.document.removeEventListener("freeze", this._freezeEventListener);
      try {
        this._closedCallbacks.forEach((n) => n.apply(this, [t]));
      } catch (n) {
        this._logger.log(k.Error, `An onclose callback called with error '${t}' threw error '${n}'.`);
      }
    }
  }
  async _reconnect(t) {
    const n = Date.now();
    let r = 0, i = t !== void 0 ? t : new Error("Attempting to reconnect due to a unknown error."), o = this._getNextRetryDelay(r++, 0, i);
    if (o === null) {
      this._logger.log(k.Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt."), this._completeClose(t);
      return;
    }
    if (this._connectionState = Ge.Reconnecting, t ? this._logger.log(k.Information, `Connection reconnecting because of error '${t}'.`) : this._logger.log(k.Information, "Connection reconnecting."), this._reconnectingCallbacks.length !== 0) {
      try {
        this._reconnectingCallbacks.forEach((a) => a.apply(this, [t]));
      } catch (a) {
        this._logger.log(k.Error, `An onreconnecting callback called with error '${t}' threw error '${a}'.`);
      }
      if (this._connectionState !== Ge.Reconnecting) {
        this._logger.log(k.Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
        return;
      }
    }
    for (; o !== null; ) {
      if (this._logger.log(k.Information, `Reconnect attempt number ${r} will start in ${o} ms.`), await new Promise((a) => {
        this._reconnectDelayHandle = setTimeout(a, o);
      }), this._reconnectDelayHandle = void 0, this._connectionState !== Ge.Reconnecting) {
        this._logger.log(k.Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
        return;
      }
      try {
        if (await this._startInternal(), this._connectionState = Ge.Connected, this._logger.log(k.Information, "HubConnection reconnected successfully."), this._reconnectedCallbacks.length !== 0)
          try {
            this._reconnectedCallbacks.forEach((a) => a.apply(this, [this.connection.connectionId]));
          } catch (a) {
            this._logger.log(k.Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${a}'.`);
          }
        return;
      } catch (a) {
        if (this._logger.log(k.Information, `Reconnect attempt failed because of error '${a}'.`), this._connectionState !== Ge.Reconnecting) {
          this._logger.log(k.Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`), this._connectionState === Ge.Disconnecting && this._completeClose();
          return;
        }
        i = a instanceof Error ? a : new Error(a.toString()), o = this._getNextRetryDelay(r++, Date.now() - n, i);
      }
    }
    this._logger.log(k.Information, `Reconnect retries have been exhausted after ${Date.now() - n} ms and ${r} failed attempts. Connection disconnecting.`), this._completeClose();
  }
  _getNextRetryDelay(t, n, r) {
    try {
      return this._reconnectPolicy.nextRetryDelayInMilliseconds({
        elapsedMilliseconds: n,
        previousRetryCount: t,
        retryReason: r
      });
    } catch (i) {
      return this._logger.log(k.Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${t}, ${n}) threw error '${i}'.`), null;
    }
  }
  _cancelCallbacksWithError(t) {
    const n = this._callbacks;
    this._callbacks = {}, Object.keys(n).forEach((r) => {
      const i = n[r];
      try {
        i(null, t);
      } catch (o) {
        this._logger.log(k.Error, `Stream 'error' callback called with '${t}' threw error: ${Gd(o)}`);
      }
    });
  }
  _cleanupPingTimer() {
    this._pingServerHandle && (clearTimeout(this._pingServerHandle), this._pingServerHandle = void 0);
  }
  _cleanupTimeout() {
    this._timeoutHandle && clearTimeout(this._timeoutHandle);
  }
  _createInvocation(t, n, r, i) {
    if (r)
      return i.length !== 0 ? {
        arguments: n,
        streamIds: i,
        target: t,
        type: Ee.Invocation
      } : {
        arguments: n,
        target: t,
        type: Ee.Invocation
      };
    {
      const o = this._invocationId;
      return this._invocationId++, i.length !== 0 ? {
        arguments: n,
        invocationId: o.toString(),
        streamIds: i,
        target: t,
        type: Ee.Invocation
      } : {
        arguments: n,
        invocationId: o.toString(),
        target: t,
        type: Ee.Invocation
      };
    }
  }
  _launchStreams(t, n) {
    if (t.length !== 0) {
      n || (n = Promise.resolve());
      for (const r in t)
        t[r].subscribe({
          complete: () => {
            n = n.then(() => this._sendWithProtocol(this._createCompletionMessage(r)));
          },
          error: (i) => {
            let o;
            i instanceof Error ? o = i.message : i && i.toString ? o = i.toString() : o = "Unknown error", n = n.then(() => this._sendWithProtocol(this._createCompletionMessage(r, o)));
          },
          next: (i) => {
            n = n.then(() => this._sendWithProtocol(this._createStreamItemMessage(r, i)));
          }
        });
    }
  }
  _replaceStreamingParams(t) {
    const n = [], r = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i];
      if (this._isObservable(o)) {
        const a = this._invocationId;
        this._invocationId++, n[a] = o, r.push(a.toString()), t.splice(i, 1);
      }
    }
    return [n, r];
  }
  _isObservable(t) {
    return t && t.subscribe && typeof t.subscribe == "function";
  }
  _createStreamInvocation(t, n, r) {
    const i = this._invocationId;
    return this._invocationId++, r.length !== 0 ? {
      arguments: n,
      invocationId: i.toString(),
      streamIds: r,
      target: t,
      type: Ee.StreamInvocation
    } : {
      arguments: n,
      invocationId: i.toString(),
      target: t,
      type: Ee.StreamInvocation
    };
  }
  _createCancelInvocation(t) {
    return {
      invocationId: t,
      type: Ee.CancelInvocation
    };
  }
  _createStreamItemMessage(t, n) {
    return {
      invocationId: t,
      item: n,
      type: Ee.StreamItem
    };
  }
  _createCompletionMessage(t, n, r) {
    return n ? {
      error: n,
      invocationId: t,
      type: Ee.Completion
    } : {
      invocationId: t,
      result: r,
      type: Ee.Completion
    };
  }
  _createCloseMessage() {
    return { type: Ee.Close };
  }
}
const WR = [0, 2e3, 1e4, 3e4, null];
class Ng {
  constructor(t) {
    this._retryDelays = t !== void 0 ? [...t, null] : WR;
  }
  nextRetryDelayInMilliseconds(t) {
    return this._retryDelays[t.previousRetryCount];
  }
}
class Zi {
}
Zi.Authorization = "Authorization";
Zi.Cookie = "Cookie";
class qR extends el {
  constructor(t, n) {
    super(), this._innerClient = t, this._accessTokenFactory = n;
  }
  async send(t) {
    let n = !0;
    this._accessTokenFactory && (!this._accessToken || t.url && t.url.indexOf("/negotiate?") > 0) && (n = !1, this._accessToken = await this._accessTokenFactory()), this._setAuthorizationHeader(t);
    const r = await this._innerClient.send(t);
    return n && r.statusCode === 401 && this._accessTokenFactory ? (this._accessToken = await this._accessTokenFactory(), this._setAuthorizationHeader(t), await this._innerClient.send(t)) : r;
  }
  _setAuthorizationHeader(t) {
    t.headers || (t.headers = {}), this._accessToken ? t.headers[Zi.Authorization] = `Bearer ${this._accessToken}` : this._accessTokenFactory && t.headers[Zi.Authorization] && delete t.headers[Zi.Authorization];
  }
  getCookieString(t) {
    return this._innerClient.getCookieString(t);
  }
}
var dt;
(function(e) {
  e[e.None = 0] = "None", e[e.WebSockets = 1] = "WebSockets", e[e.ServerSentEvents = 2] = "ServerSentEvents", e[e.LongPolling = 4] = "LongPolling";
})(dt || (dt = {}));
var It;
(function(e) {
  e[e.Text = 1] = "Text", e[e.Binary = 2] = "Binary";
})(It || (It = {}));
let jR = class {
  constructor() {
    this._isAborted = !1, this.onabort = null;
  }
  abort() {
    this._isAborted || (this._isAborted = !0, this.onabort && this.onabort());
  }
  get signal() {
    return this;
  }
  get aborted() {
    return this._isAborted;
  }
};
class Ig {
  // This is an internal type, not exported from 'index' so this is really just internal.
  get pollAborted() {
    return this._pollAbort.aborted;
  }
  constructor(t, n, r) {
    this._httpClient = t, this._logger = n, this._pollAbort = new jR(), this._options = r, this._running = !1, this.onreceive = null, this.onclose = null;
  }
  async connect(t, n) {
    if (st.isRequired(t, "url"), st.isRequired(n, "transferFormat"), st.isIn(n, It, "transferFormat"), this._url = t, this._logger.log(k.Trace, "(LongPolling transport) Connecting."), n === It.Binary && typeof XMLHttpRequest < "u" && typeof new XMLHttpRequest().responseType != "string")
      throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
    const [r, i] = Oa(), o = { [r]: i, ...this._options.headers }, a = {
      abortSignal: this._pollAbort.signal,
      headers: o,
      timeout: 1e5,
      withCredentials: this._options.withCredentials
    };
    n === It.Binary && (a.responseType = "arraybuffer");
    const s = `${t}&_=${Date.now()}`;
    this._logger.log(k.Trace, `(LongPolling transport) polling: ${s}.`);
    const c = await this._httpClient.get(s, a);
    c.statusCode !== 200 ? (this._logger.log(k.Error, `(LongPolling transport) Unexpected response code: ${c.statusCode}.`), this._closeError = new Qi(c.statusText || "", c.statusCode), this._running = !1) : this._running = !0, this._receiving = this._poll(this._url, a);
  }
  async _poll(t, n) {
    try {
      for (; this._running; )
        try {
          const r = `${t}&_=${Date.now()}`;
          this._logger.log(k.Trace, `(LongPolling transport) polling: ${r}.`);
          const i = await this._httpClient.get(r, n);
          i.statusCode === 204 ? (this._logger.log(k.Information, "(LongPolling transport) Poll terminated by server."), this._running = !1) : i.statusCode !== 200 ? (this._logger.log(k.Error, `(LongPolling transport) Unexpected response code: ${i.statusCode}.`), this._closeError = new Qi(i.statusText || "", i.statusCode), this._running = !1) : i.content ? (this._logger.log(k.Trace, `(LongPolling transport) data received. ${fc(i.content, this._options.logMessageContent)}.`), this.onreceive && this.onreceive(i.content)) : this._logger.log(k.Trace, "(LongPolling transport) Poll timed out, reissuing.");
        } catch (r) {
          this._running ? r instanceof E_ ? this._logger.log(k.Trace, "(LongPolling transport) Poll timed out, reissuing.") : (this._closeError = r, this._running = !1) : this._logger.log(k.Trace, `(LongPolling transport) Poll errored after shutdown: ${r.message}`);
        }
    } finally {
      this._logger.log(k.Trace, "(LongPolling transport) Polling complete."), this.pollAborted || this._raiseOnClose();
    }
  }
  async send(t) {
    return this._running ? hw(this._logger, "LongPolling", this._httpClient, this._url, t, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  async stop() {
    this._logger.log(k.Trace, "(LongPolling transport) Stopping polling."), this._running = !1, this._pollAbort.abort();
    try {
      await this._receiving, this._logger.log(k.Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
      const t = {}, [n, r] = Oa();
      t[n] = r;
      const i = {
        headers: { ...t, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      };
      let o;
      try {
        await this._httpClient.delete(this._url, i);
      } catch (a) {
        o = a;
      }
      o ? o instanceof Qi && (o.statusCode === 404 ? this._logger.log(k.Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.") : this._logger.log(k.Trace, `(LongPolling transport) Error sending a DELETE request: ${o}`)) : this._logger.log(k.Trace, "(LongPolling transport) DELETE request accepted.");
    } finally {
      this._logger.log(k.Trace, "(LongPolling transport) Stop finished."), this._raiseOnClose();
    }
  }
  _raiseOnClose() {
    if (this.onclose) {
      let t = "(LongPolling transport) Firing onclose event.";
      this._closeError && (t += " Error: " + this._closeError), this._logger.log(k.Trace, t), this.onclose(this._closeError);
    }
  }
}
class XR {
  constructor(t, n, r, i) {
    this._httpClient = t, this._accessToken = n, this._logger = r, this._options = i, this.onreceive = null, this.onclose = null;
  }
  async connect(t, n) {
    return st.isRequired(t, "url"), st.isRequired(n, "transferFormat"), st.isIn(n, It, "transferFormat"), this._logger.log(k.Trace, "(SSE transport) Connecting."), this._url = t, this._accessToken && (t += (t.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`), new Promise((r, i) => {
      let o = !1;
      if (n !== It.Text) {
        i(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
        return;
      }
      let a;
      if (je.isBrowser || je.isWebWorker)
        a = new this._options.EventSource(t, { withCredentials: this._options.withCredentials });
      else {
        const s = this._httpClient.getCookieString(t), c = {};
        c.Cookie = s;
        const [u, f] = Oa();
        c[u] = f, a = new this._options.EventSource(t, { withCredentials: this._options.withCredentials, headers: { ...c, ...this._options.headers } });
      }
      try {
        a.onmessage = (s) => {
          if (this.onreceive)
            try {
              this._logger.log(k.Trace, `(SSE transport) data received. ${fc(s.data, this._options.logMessageContent)}.`), this.onreceive(s.data);
            } catch (c) {
              this._close(c);
              return;
            }
        }, a.onerror = (s) => {
          o ? this._close() : i(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
        }, a.onopen = () => {
          this._logger.log(k.Information, `SSE connected to ${this._url}`), this._eventSource = a, o = !0, r();
        };
      } catch (s) {
        i(s);
        return;
      }
    });
  }
  async send(t) {
    return this._eventSource ? hw(this._logger, "SSE", this._httpClient, this._url, t, this._options) : Promise.reject(new Error("Cannot send until the transport is connected"));
  }
  stop() {
    return this._close(), Promise.resolve();
  }
  _close(t) {
    this._eventSource && (this._eventSource.close(), this._eventSource = void 0, this.onclose && this.onclose(t));
  }
}
class JR {
  constructor(t, n, r, i, o, a) {
    this._logger = r, this._accessTokenFactory = n, this._logMessageContent = i, this._webSocketConstructor = o, this._httpClient = t, this.onreceive = null, this.onclose = null, this._headers = a;
  }
  async connect(t, n) {
    st.isRequired(t, "url"), st.isRequired(n, "transferFormat"), st.isIn(n, It, "transferFormat"), this._logger.log(k.Trace, "(WebSockets transport) Connecting.");
    let r;
    return this._accessTokenFactory && (r = await this._accessTokenFactory()), new Promise((i, o) => {
      t = t.replace(/^http/, "ws");
      let a;
      const s = this._httpClient.getCookieString(t);
      let c = !1;
      if (je.isNode || je.isReactNative) {
        const u = {}, [f, l] = Oa();
        u[f] = l, r && (u[Zi.Authorization] = `Bearer ${r}`), s && (u[Zi.Cookie] = s), a = new this._webSocketConstructor(t, void 0, {
          headers: { ...u, ...this._headers }
        });
      } else
        r && (t += (t.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(r)}`);
      a || (a = new this._webSocketConstructor(t)), n === It.Binary && (a.binaryType = "arraybuffer"), a.onopen = (u) => {
        this._logger.log(k.Information, `WebSocket connected to ${t}.`), this._webSocket = a, c = !0, i();
      }, a.onerror = (u) => {
        let f = null;
        typeof ErrorEvent < "u" && u instanceof ErrorEvent ? f = u.error : f = "There was an error with the transport", this._logger.log(k.Information, `(WebSockets transport) ${f}.`);
      }, a.onmessage = (u) => {
        if (this._logger.log(k.Trace, `(WebSockets transport) data received. ${fc(u.data, this._logMessageContent)}.`), this.onreceive)
          try {
            this.onreceive(u.data);
          } catch (f) {
            this._close(f);
            return;
          }
      }, a.onclose = (u) => {
        if (c)
          this._close(u);
        else {
          let f = null;
          typeof ErrorEvent < "u" && u instanceof ErrorEvent ? f = u.error : f = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.", o(new Error(f));
        }
      };
    });
  }
  send(t) {
    return this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN ? (this._logger.log(k.Trace, `(WebSockets transport) sending data. ${fc(t, this._logMessageContent)}.`), this._webSocket.send(t), Promise.resolve()) : Promise.reject("WebSocket is not in the OPEN state");
  }
  stop() {
    return this._webSocket && this._close(void 0), Promise.resolve();
  }
  _close(t) {
    this._webSocket && (this._webSocket.onclose = () => {
    }, this._webSocket.onmessage = () => {
    }, this._webSocket.onerror = () => {
    }, this._webSocket.close(), this._webSocket = void 0), this._logger.log(k.Trace, "(WebSockets transport) socket closed."), this.onclose && (this._isCloseEvent(t) && (t.wasClean === !1 || t.code !== 1e3) ? this.onclose(new Error(`WebSocket closed with status code: ${t.code} (${t.reason || "no reason given"}).`)) : t instanceof Error ? this.onclose(t) : this.onclose());
  }
  _isCloseEvent(t) {
    return t && typeof t.wasClean == "boolean" && typeof t.code == "number";
  }
}
const Dg = 100;
class QR {
  constructor(t, n = {}) {
    if (this._stopPromiseResolver = () => {
    }, this.features = {}, this._negotiateVersion = 1, st.isRequired(t, "url"), this._logger = PR(n.logger), this.baseUrl = this._resolveUrl(t), n = n || {}, n.logMessageContent = n.logMessageContent === void 0 ? !1 : n.logMessageContent, typeof n.withCredentials == "boolean" || n.withCredentials === void 0)
      n.withCredentials = n.withCredentials === void 0 ? !0 : n.withCredentials;
    else
      throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
    n.timeout = n.timeout === void 0 ? 100 * 1e3 : n.timeout;
    let r = null, i = null;
    if (je.isNode && typeof require < "u") {
      const o = typeof __webpack_require__ == "function" ? __non_webpack_require__ : require;
      r = o("ws"), i = o("eventsource");
    }
    !je.isNode && typeof WebSocket < "u" && !n.WebSocket ? n.WebSocket = WebSocket : je.isNode && !n.WebSocket && r && (n.WebSocket = r), !je.isNode && typeof EventSource < "u" && !n.EventSource ? n.EventSource = EventSource : je.isNode && !n.EventSource && typeof i < "u" && (n.EventSource = i), this._httpClient = new qR(n.httpClient || new FR(this._logger), n.accessTokenFactory), this._connectionState = "Disconnected", this._connectionStarted = !1, this._options = n, this.onreceive = null, this.onclose = null;
  }
  async start(t) {
    if (t = t || It.Binary, st.isIn(t, It, "transferFormat"), this._logger.log(k.Debug, `Starting connection with transfer format '${It[t]}'.`), this._connectionState !== "Disconnected")
      return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
    if (this._connectionState = "Connecting", this._startInternalPromise = this._startInternal(t), await this._startInternalPromise, this._connectionState === "Disconnecting") {
      const n = "Failed to start the HttpConnection before stop() was called.";
      return this._logger.log(k.Error, n), await this._stopPromise, Promise.reject(new bn(n));
    } else if (this._connectionState !== "Connected") {
      const n = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
      return this._logger.log(k.Error, n), Promise.reject(new bn(n));
    }
    this._connectionStarted = !0;
  }
  send(t) {
    return this._connectionState !== "Connected" ? Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State.")) : (this._sendQueue || (this._sendQueue = new m_(this.transport)), this._sendQueue.send(t));
  }
  async stop(t) {
    if (this._connectionState === "Disconnected")
      return this._logger.log(k.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnected state.`), Promise.resolve();
    if (this._connectionState === "Disconnecting")
      return this._logger.log(k.Debug, `Call to HttpConnection.stop(${t}) ignored because the connection is already in the disconnecting state.`), this._stopPromise;
    this._connectionState = "Disconnecting", this._stopPromise = new Promise((n) => {
      this._stopPromiseResolver = n;
    }), await this._stopInternal(t), await this._stopPromise;
  }
  async _stopInternal(t) {
    this._stopError = t;
    try {
      await this._startInternalPromise;
    } catch {
    }
    if (this.transport) {
      try {
        await this.transport.stop();
      } catch (n) {
        this._logger.log(k.Error, `HttpConnection.transport.stop() threw error '${n}'.`), this._stopConnection();
      }
      this.transport = void 0;
    } else
      this._logger.log(k.Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
  }
  async _startInternal(t) {
    let n = this.baseUrl;
    this._accessTokenFactory = this._options.accessTokenFactory, this._httpClient._accessTokenFactory = this._accessTokenFactory;
    try {
      if (this._options.skipNegotiation)
        if (this._options.transport === dt.WebSockets)
          this.transport = this._constructTransport(dt.WebSockets), await this._startTransport(n, t);
        else
          throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
      else {
        let r = null, i = 0;
        do {
          if (r = await this._getNegotiationResponse(n), this._connectionState === "Disconnecting" || this._connectionState === "Disconnected")
            throw new bn("The connection was stopped during negotiation.");
          if (r.error)
            throw new Error(r.error);
          if (r.ProtocolVersion)
            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
          if (r.url && (n = r.url), r.accessToken) {
            const o = r.accessToken;
            this._accessTokenFactory = () => o, this._httpClient._accessToken = o, this._httpClient._accessTokenFactory = void 0;
          }
          i++;
        } while (r.url && i < Dg);
        if (i === Dg && r.url)
          throw new Error("Negotiate redirection limit exceeded.");
        await this._createTransport(n, this._options.transport, r, t);
      }
      this.transport instanceof Ig && (this.features.inherentKeepAlive = !0), this._connectionState === "Connecting" && (this._logger.log(k.Debug, "The HttpConnection connected successfully."), this._connectionState = "Connected");
    } catch (r) {
      return this._logger.log(k.Error, "Failed to start the connection: " + r), this._connectionState = "Disconnected", this.transport = void 0, this._stopPromiseResolver(), Promise.reject(r);
    }
  }
  async _getNegotiationResponse(t) {
    const n = {}, [r, i] = Oa();
    n[r] = i;
    const o = this._resolveNegotiateUrl(t);
    this._logger.log(k.Debug, `Sending negotiation request: ${o}.`);
    try {
      const a = await this._httpClient.post(o, {
        content: "",
        headers: { ...n, ...this._options.headers },
        timeout: this._options.timeout,
        withCredentials: this._options.withCredentials
      });
      if (a.statusCode !== 200)
        return Promise.reject(new Error(`Unexpected status code returned from negotiate '${a.statusCode}'`));
      const s = JSON.parse(a.content);
      return (!s.negotiateVersion || s.negotiateVersion < 1) && (s.connectionToken = s.connectionId), s.useStatefulReconnect && this._options._useStatefulReconnect !== !0 ? Promise.reject(new bg("Client didn't negotiate Stateful Reconnect but the server did.")) : s;
    } catch (a) {
      let s = "Failed to complete negotiation with the server: " + a;
      return a instanceof Qi && a.statusCode === 404 && (s = s + " Either this is not a SignalR endpoint or there is a proxy blocking the connection."), this._logger.log(k.Error, s), Promise.reject(new bg(s));
    }
  }
  _createConnectUrl(t, n) {
    return n ? t + (t.indexOf("?") === -1 ? "?" : "&") + `id=${n}` : t;
  }
  async _createTransport(t, n, r, i) {
    let o = this._createConnectUrl(t, r.connectionToken);
    if (this._isITransport(n)) {
      this._logger.log(k.Debug, "Connection was provided an instance of ITransport, using that directly."), this.transport = n, await this._startTransport(o, i), this.connectionId = r.connectionId;
      return;
    }
    const a = [], s = r.availableTransports || [];
    let c = r;
    for (const u of s) {
      const f = this._resolveTransportOrError(u, n, i, (c == null ? void 0 : c.useStatefulReconnect) === !0);
      if (f instanceof Error)
        a.push(`${u.transport} failed:`), a.push(f);
      else if (this._isITransport(f)) {
        if (this.transport = f, !c) {
          try {
            c = await this._getNegotiationResponse(t);
          } catch (l) {
            return Promise.reject(l);
          }
          o = this._createConnectUrl(t, c.connectionToken);
        }
        try {
          await this._startTransport(o, i), this.connectionId = c.connectionId;
          return;
        } catch (l) {
          if (this._logger.log(k.Error, `Failed to start the transport '${u.transport}': ${l}`), c = void 0, a.push(new NR(`${u.transport} failed: ${l}`, dt[u.transport])), this._connectionState !== "Connecting") {
            const v = "Failed to select transport before stop() was called.";
            return this._logger.log(k.Debug, v), Promise.reject(new bn(v));
          }
        }
      }
    }
    return a.length > 0 ? Promise.reject(new IR(`Unable to connect to the server with any of the available transports. ${a.join(" ")}`, a)) : Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
  }
  _constructTransport(t) {
    switch (t) {
      case dt.WebSockets:
        if (!this._options.WebSocket)
          throw new Error("'WebSocket' is not supported in your environment.");
        return new JR(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
      case dt.ServerSentEvents:
        if (!this._options.EventSource)
          throw new Error("'EventSource' is not supported in your environment.");
        return new XR(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
      case dt.LongPolling:
        return new Ig(this._httpClient, this._logger, this._options);
      default:
        throw new Error(`Unknown transport: ${t}.`);
    }
  }
  _startTransport(t, n) {
    return this.transport.onreceive = this.onreceive, this.features.reconnect ? this.transport.onclose = async (r) => {
      let i = !1;
      if (this.features.reconnect)
        try {
          this.features.disconnected(), await this.transport.connect(t, n), await this.features.resend();
        } catch {
          i = !0;
        }
      else {
        this._stopConnection(r);
        return;
      }
      i && this._stopConnection(r);
    } : this.transport.onclose = (r) => this._stopConnection(r), this.transport.connect(t, n);
  }
  _resolveTransportOrError(t, n, r, i) {
    const o = dt[t.transport];
    if (o == null)
      return this._logger.log(k.Debug, `Skipping transport '${t.transport}' because it is not supported by this client.`), new Error(`Skipping transport '${t.transport}' because it is not supported by this client.`);
    if (ZR(n, o))
      if (t.transferFormats.map((s) => It[s]).indexOf(r) >= 0) {
        if (o === dt.WebSockets && !this._options.WebSocket || o === dt.ServerSentEvents && !this._options.EventSource)
          return this._logger.log(k.Debug, `Skipping transport '${dt[o]}' because it is not supported in your environment.'`), new bR(`'${dt[o]}' is not supported in your environment.`, o);
        this._logger.log(k.Debug, `Selecting transport '${dt[o]}'.`);
        try {
          return this.features.reconnect = o === dt.WebSockets ? i : void 0, this._constructTransport(o);
        } catch (s) {
          return s;
        }
      } else
        return this._logger.log(k.Debug, `Skipping transport '${dt[o]}' because it does not support the requested transfer format '${It[r]}'.`), new Error(`'${dt[o]}' does not support ${It[r]}.`);
    else
      return this._logger.log(k.Debug, `Skipping transport '${dt[o]}' because it was disabled by the client.`), new CR(`'${dt[o]}' is disabled by the client.`, o);
  }
  _isITransport(t) {
    return t && typeof t == "object" && "connect" in t;
  }
  _stopConnection(t) {
    if (this._logger.log(k.Debug, `HttpConnection.stopConnection(${t}) called while in state ${this._connectionState}.`), this.transport = void 0, t = this._stopError || t, this._stopError = void 0, this._connectionState === "Disconnected") {
      this._logger.log(k.Debug, `Call to HttpConnection.stopConnection(${t}) was ignored because the connection is already in the disconnected state.`);
      return;
    }
    if (this._connectionState === "Connecting")
      throw this._logger.log(k.Warning, `Call to HttpConnection.stopConnection(${t}) was ignored because the connection is still in the connecting state.`), new Error(`HttpConnection.stopConnection(${t}) was called while the connection is still in the connecting state.`);
    if (this._connectionState === "Disconnecting" && this._stopPromiseResolver(), t ? this._logger.log(k.Error, `Connection disconnected with error '${t}'.`) : this._logger.log(k.Information, "Connection disconnected."), this._sendQueue && (this._sendQueue.stop().catch((n) => {
      this._logger.log(k.Error, `TransportSendQueue.stop() threw error '${n}'.`);
    }), this._sendQueue = void 0), this.connectionId = void 0, this._connectionState = "Disconnected", this._connectionStarted) {
      this._connectionStarted = !1;
      try {
        this.onclose && this.onclose(t);
      } catch (n) {
        this._logger.log(k.Error, `HttpConnection.onclose(${t}) threw error '${n}'.`);
      }
    }
  }
  _resolveUrl(t) {
    if (t.lastIndexOf("https://", 0) === 0 || t.lastIndexOf("http://", 0) === 0)
      return t;
    if (!je.isBrowser)
      throw new Error(`Cannot resolve '${t}'.`);
    const n = window.document.createElement("a");
    return n.href = t, this._logger.log(k.Information, `Normalizing '${t}' to '${n.href}'.`), n.href;
  }
  _resolveNegotiateUrl(t) {
    const n = new URL(t);
    n.pathname.endsWith("/") ? n.pathname += "negotiate" : n.pathname += "/negotiate";
    const r = new URLSearchParams(n.searchParams);
    return r.has("negotiateVersion") || r.append("negotiateVersion", this._negotiateVersion.toString()), r.has("useStatefulReconnect") ? r.get("useStatefulReconnect") === "true" && (this._options._useStatefulReconnect = !0) : this._options._useStatefulReconnect === !0 && r.append("useStatefulReconnect", "true"), n.search = r.toString(), n.toString();
  }
}
function ZR(e, t) {
  return !e || (t & e) !== 0;
}
class m_ {
  constructor(t) {
    this._transport = t, this._buffer = [], this._executing = !0, this._sendBufferedData = new su(), this._transportResult = new su(), this._sendLoopPromise = this._sendLoop();
  }
  send(t) {
    return this._bufferData(t), this._transportResult || (this._transportResult = new su()), this._transportResult.promise;
  }
  stop() {
    return this._executing = !1, this._sendBufferedData.resolve(), this._sendLoopPromise;
  }
  _bufferData(t) {
    if (this._buffer.length && typeof this._buffer[0] != typeof t)
      throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof t}`);
    this._buffer.push(t), this._sendBufferedData.resolve();
  }
  async _sendLoop() {
    for (; ; ) {
      if (await this._sendBufferedData.promise, !this._executing) {
        this._transportResult && this._transportResult.reject("Connection stopped.");
        break;
      }
      this._sendBufferedData = new su();
      const t = this._transportResult;
      this._transportResult = void 0;
      const n = typeof this._buffer[0] == "string" ? this._buffer.join("") : m_._concatBuffers(this._buffer);
      this._buffer.length = 0;
      try {
        await this._transport.send(n), t.resolve();
      } catch (r) {
        t.reject(r);
      }
    }
  }
  static _concatBuffers(t) {
    const n = t.map((o) => o.byteLength).reduce((o, a) => o + a), r = new Uint8Array(n);
    let i = 0;
    for (const o of t)
      r.set(new Uint8Array(o), i), i += o.byteLength;
    return r.buffer;
  }
}
class su {
  constructor() {
    this.promise = new Promise((t, n) => [this._resolver, this._rejecter] = [t, n]);
  }
  resolve() {
    this._resolver();
  }
  reject(t) {
    this._rejecter(t);
  }
}
const eP = "json";
class tP {
  constructor() {
    this.name = eP, this.version = 2, this.transferFormat = It.Text;
  }
  /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
   *
   * @param {string} input A string containing the serialized representation.
   * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
   */
  parseMessages(t, n) {
    if (typeof t != "string")
      throw new Error("Invalid input for JSON hub protocol. Expected a string.");
    if (!t)
      return [];
    n === null && (n = uc.instance);
    const r = nn.parse(t), i = [];
    for (const o of r) {
      const a = JSON.parse(o);
      if (typeof a.type != "number")
        throw new Error("Invalid payload.");
      switch (a.type) {
        case Ee.Invocation:
          this._isInvocationMessage(a);
          break;
        case Ee.StreamItem:
          this._isStreamItemMessage(a);
          break;
        case Ee.Completion:
          this._isCompletionMessage(a);
          break;
        case Ee.Ping:
          break;
        case Ee.Close:
          break;
        case Ee.Ack:
          this._isAckMessage(a);
          break;
        case Ee.Sequence:
          this._isSequenceMessage(a);
          break;
        default:
          n.log(k.Information, "Unknown message type '" + a.type + "' ignored.");
          continue;
      }
      i.push(a);
    }
    return i;
  }
  /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
   *
   * @param {HubMessage} message The message to write.
   * @returns {string} A string containing the serialized representation of the message.
   */
  writeMessage(t) {
    return nn.write(JSON.stringify(t));
  }
  _isInvocationMessage(t) {
    this._assertNotEmptyString(t.target, "Invalid payload for Invocation message."), t.invocationId !== void 0 && this._assertNotEmptyString(t.invocationId, "Invalid payload for Invocation message.");
  }
  _isStreamItemMessage(t) {
    if (this._assertNotEmptyString(t.invocationId, "Invalid payload for StreamItem message."), t.item === void 0)
      throw new Error("Invalid payload for StreamItem message.");
  }
  _isCompletionMessage(t) {
    if (t.result && t.error)
      throw new Error("Invalid payload for Completion message.");
    !t.result && t.error && this._assertNotEmptyString(t.error, "Invalid payload for Completion message."), this._assertNotEmptyString(t.invocationId, "Invalid payload for Completion message.");
  }
  _isAckMessage(t) {
    if (typeof t.sequenceId != "number")
      throw new Error("Invalid SequenceId for Ack message.");
  }
  _isSequenceMessage(t) {
    if (typeof t.sequenceId != "number")
      throw new Error("Invalid SequenceId for Sequence message.");
  }
  _assertNotEmptyString(t, n) {
    if (typeof t != "string" || t === "")
      throw new Error(n);
  }
}
const nP = {
  trace: k.Trace,
  debug: k.Debug,
  info: k.Information,
  information: k.Information,
  warn: k.Warning,
  warning: k.Warning,
  error: k.Error,
  critical: k.Critical,
  none: k.None
};
function rP(e) {
  const t = nP[e.toLowerCase()];
  if (typeof t < "u")
    return t;
  throw new Error(`Unknown log level: ${e}`);
}
class iP {
  configureLogging(t) {
    if (st.isRequired(t, "logging"), oP(t))
      this.logger = t;
    else if (typeof t == "string") {
      const n = rP(t);
      this.logger = new Df(n);
    } else
      this.logger = new Df(t);
    return this;
  }
  withUrl(t, n) {
    return st.isRequired(t, "url"), st.isNotEmpty(t, "url"), this.url = t, typeof n == "object" ? this.httpConnectionOptions = { ...this.httpConnectionOptions, ...n } : this.httpConnectionOptions = {
      ...this.httpConnectionOptions,
      transport: n
    }, this;
  }
  /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
   *
   * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
   */
  withHubProtocol(t) {
    return st.isRequired(t, "protocol"), this.protocol = t, this;
  }
  withAutomaticReconnect(t) {
    if (this.reconnectPolicy)
      throw new Error("A reconnectPolicy has already been set.");
    return t ? Array.isArray(t) ? this.reconnectPolicy = new Ng(t) : this.reconnectPolicy = t : this.reconnectPolicy = new Ng(), this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withServerTimeout(t) {
    return st.isRequired(t, "milliseconds"), this._serverTimeoutInMilliseconds = t, this;
  }
  /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withKeepAliveInterval(t) {
    return st.isRequired(t, "milliseconds"), this._keepAliveIntervalInMilliseconds = t, this;
  }
  /** Enables and configures options for the Stateful Reconnect feature.
   *
   * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
   */
  withStatefulReconnect(t) {
    return this.httpConnectionOptions === void 0 && (this.httpConnectionOptions = {}), this.httpConnectionOptions._useStatefulReconnect = !0, this._statefulReconnectBufferSize = t == null ? void 0 : t.bufferSize, this;
  }
  /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
   *
   * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
   */
  build() {
    const t = this.httpConnectionOptions || {};
    if (t.logger === void 0 && (t.logger = this.logger), !this.url)
      throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
    const n = new QR(this.url, t);
    return S_.create(n, this.logger || uc.instance, this.protocol || new tP(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
  }
}
function oP(e) {
  return e.log !== void 0;
}
const Ta = Symbol.for("connections"), Gr = Symbol.for("subscriptions"), $i = Symbol.for("subscriptions-handlers");
function aP() {
  window[Ta] ?? (window[Ta] = /* @__PURE__ */ new Map()), window[Gr] ?? (window[Gr] = []), window[$i] ?? (window[$i] = []);
}
function _w() {
  return crypto.randomUUID();
}
function Kd(e, t = "[socket-error] Error: Failed to connect to socket.") {
  const n = new ErrorEvent("error", { error: e, message: t });
  window.dispatchEvent(n);
}
function Rg(e) {
  const t = window[Ta].get(e);
  if (!t) throw new Error("There is no hub connected at the provided url: " + e);
  return {
    async subscribe(n) {
      await t.send("Subscribe", n);
      const r = _w();
      return window[Gr].push({ subscriptionId: r, resource: n, url: e }), r;
    },
    reSubscribeAll() {
      return window[Gr].map((n) => t.send("Subscribe", n.resource));
    },
    async unsubscribe(n) {
      const r = window[Gr].findIndex((i) => i.subscriptionId === n);
      await t.send("Subscribe", window[Gr][r]), window[Gr].splice(r, 1);
    }
  };
}
function Pg() {
  return {
    addHandler(e, t, n) {
      const r = _w();
      return window[$i].push({
        subscriptionId: e,
        handlerId: r,
        handler: t,
        isMatching: (i) => (!n.resourceId || i.resourceId === n.resourceId) && (!n.resourcePath || i.resourcePath === n.resourcePath) && (!n.action || i.action === n.action)
      }), r;
    },
    removeHandlers(e) {
      const t = () => {
        const r = window[$i].findIndex((i) => i.subscriptionId === e);
        return r > -1 ? (window[$i].splice(r, 1), !0) : !1;
      };
      let n = t();
      for (; n; )
        n = t();
    },
    messageDispatcher(e) {
      console.log(e), window[$i].forEach((t) => {
        t.isMatching(e) && t.handler(e);
      });
    }
  };
}
let yt;
function EP() {
  return aP(), {
    setup(e, t) {
      if (yt = window[Ta].get(e), !yt) {
        yt = new iP().withUrl(e, t).withAutomaticReconnect([0, 2, 2, 2, 5, 5, 5, 5, 5, 5, 5, 10, 10, 10, 10, 30, 30, 30, 30, 30]).build();
        const { messageDispatcher: n } = Pg();
        yt.on("Message", (r) => n(r)), yt.onreconnected(() => {
          const { reSubscribeAll: r } = Rg(e);
          r();
        }), window[Ta].set(e, yt);
      }
    },
    isConnectionActive: () => !!yt,
    ensureConnection: () => new Promise((e) => {
      yt.state === "Disconnected" ? yt.start().then(() => e()).catch((t) => {
        t.name = "RealTimeClientConnection", Kd(t, "[connection.start] Error: Failed to complete negotiation with the server.");
      }) : e();
    }),
    onReceiveMessage: (e, t) => {
      yt.state === "Connected" ? yt.on(e, (n) => {
        t(n);
      }) : console.warn("[connection.on] Error: Failed to complete negotiation with the server.");
    },
    offReceiveMessage: (e) => {
      yt.state === "Connected" ? yt.off(e) : console.warn("[connection.off] Error: Failed to complete negotiation with the server.");
    },
    invokeMethod: (e, t, n, r) => new Promise((i) => {
      yt.state === "Connected" ? yt.invoke(n, e, t).then((o) => {
        r(o);
      }).catch((o) => {
        o.name = n, Kd(o, "[connection.invoke] Error: Failed to complete negotiation with the server.");
      }) : i();
    }),
    dropConnection: () => new Promise((e) => {
      yt.state === "Connected" ? yt.stop().then(() => e()).catch((t) => {
        t.name = "RealTimeClientDropConnection", Kd(t, "[connection.stop] Error: Failed to complete negotiation with the server.");
      }) : e();
    }),
    async subscribeConnection(e, t) {
      const { subscribe: n, unsubscribe: r } = Rg(e), { removeHandlers: i, addHandler: o } = Pg(), a = await n(t);
      return {
        subscriptionId: a,
        unsubscribe() {
          return i(a), r(a);
        },
        onMessage(s) {
          o(a, s, t);
        }
      };
    }
  };
}
const Oi = Symbol.for("AppStore");
function SP() {
  return window[Oi] ?? (window[Oi] = kf({
    systemId: null,
    langIsoCode: "en-US"
  })), {
    setSystemId(e) {
      window[Oi].systemId = e;
    },
    setLangIsoCode(e) {
      window[Oi].langIsoCode = e;
    }
  };
}
function mP() {
  return {
    systemId: Ke(() => window[Oi].systemId),
    langIsoCode: Ke(() => window[Oi].langIsoCode)
  };
}
const eo = Symbol.for("EndpointsStore");
function pw() {
  window[eo] ?? (window[eo] = kf({
    localBackend: "",
    agent4D: ""
  }));
}
function wP() {
  return pw(), {
    setLocalBackend(e) {
      window[eo].localBackend = e;
    },
    setAgent4D(e) {
      window[eo].agent4D = e;
    }
  };
}
function yP() {
  return pw(), {
    cloudBackend: Ke(() => lT().cloudBackendUrl.value),
    localBackend: Ke(() => window[eo].localBackend),
    agent4D: Ke(() => window[eo].agent4D)
  };
}
const dn = Symbol.for("defined-functions");
function TP(e, t) {
  window[dn] ?? (window[dn] = {}), window[dn][e] = t;
}
function bP() {
  var e;
  if (!((e = window[dn]) != null && e.useCloudBackend))
    throw new Error("useCloudBackend was not implemented at Shell-App level scope");
  return window[dn].useCloudBackend();
}
function CP() {
  var e;
  if (!((e = window[dn]) != null && e.useLocalBackend))
    throw new Error("useLocalBackend was not implemented at Shell-App level scope");
  return window[dn].useLocalBackend();
}
function NP() {
  var e;
  if (!((e = window[dn]) != null && e.use4DAgent))
    throw new Error("use4DAgent was not implemented at Shell-App level scope");
  return window[dn].use4DAgent();
}
function IP() {
  var e;
  if (!((e = window[dn]) != null && e.useAuthentication))
    throw new Error("useAuthentication was not implemented at Shell-App level scope");
  return window[dn].useAuthentication();
}
export {
  uP as createTranslations,
  TP as defineImplementation,
  lP as getModuleInstance,
  dP as loadRemoteModule,
  fP as registerModule,
  NP as use4DAgent,
  lT as useAppSettings,
  cP as useAppSettingsManager,
  mP as useAppStore,
  SP as useAppStoreManager,
  IP as useAuthentication,
  bP as useCloudBackend,
  yP as useEndpointsStore,
  wP as useEndpointsStoreManager,
  CP as useLocalBackend,
  hP as useObservability,
  vP as useObservabilityManager,
  pP as useSecurity,
  _P as useSecurityManager,
  EP as useSocketClient
};
//# sourceMappingURL=index.js.map
